angular.module('RessieApp.templates', ['views/404', 'views/backend', 'views/booking/bundleModal', 'views/booking/contactModal', 'views/booking/form', 'views/bootbox/appUser', 'views/bootbox/cancel', 'views/bootbox/note', 'views/bootbox/noteForm', 'views/bs/datepicker/day', 'views/bs/datepicker/month', 'views/bs/datepicker/year', 'views/bs/rating/rating', 'views/bugs/modal', 'views/calendar', 'views/contacts/contacts', 'views/contacts/employees', 'views/contacts/form', 'views/contacts/forms/concierge', 'views/contacts/forms/conciergeModal', 'views/contacts/forms/employee', 'views/contacts/forms/hotel', 'views/contacts/forms/hotelModal', 'views/contacts/forms/partner', 'views/contacts/forms/travelAgentModal', 'views/contacts/hotels', 'views/contacts/partners', 'views/contacts/verify', 'views/day/balloons', 'views/day/bookings', 'views/day/day', 'views/day/pickups', 'views/flights/edit', 'views/flights/photos', 'views/gifts', 'views/gifts/form', 'views/gifts/list', 'views/home', 'views/login', 'views/notifications', 'views/overrides/daterangepicker', 'views/pricing/discount', 'views/pricing/editRetail', 'views/pricing/modal', 'views/pricing/panel', 'views/pricing/payment', 'views/pricing/retail', 'views/reports', 'views/reports/batch', 'views/reports/billto', 'views/reports/commissions', 'views/reports/email', 'views/reports/glance', 'views/reports/itsheet', 'views/reports/mdse', 'views/reports/oldSales', 'views/reports/pickups', 'views/reports/sales', 'views/reports/salesSlip', 'views/reports/tips', 'views/search', 'views/settings/admin', 'views/settings/dash', 'views/settings/forms/balloons', 'views/settings/forms/packages', 'views/settings/forms/product', 'views/settings/forms/template', 'views/settings/forms/zones', 'views/settings/me', 'views/settings/tabs/cancellations', 'views/settings/tabs/company', 'views/settings/tabs/emailTemplates', 'views/settings/tabs/merchant', 'views/settings/tabs/packages', 'views/settings/tabs/products', 'views/settings/tabs/resources', 'views/settings/tabs/zones']);

angular.module("views/404", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/404",
    "Page Not Found");
}]);

angular.module("views/backend", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/backend",
    "<header class=\"header navbar navbar-inverse\" ng-class=\"{\n" +
    "  'bg-black': user.activeCompany().scheme === 'default',\n" +
    "  'bg-info': user.activeCompany().scheme === 'blue',\n" +
    "  'bg-danger': user.activeCompany().scheme === 'red',\n" +
    "  'bg-warning': user.activeCompany().scheme === 'orange',\n" +
    "  'bg-success': user.activeCompany().scheme === 'green'\n" +
    "}\">\n" +
    "\n" +
    "  <div class=\"navbar-header nav-bar\" style=\"margin-right: 10px;\">\n" +
    "    <a class=\"btn btn-link visible-xs\" ng-click=\"offscreen()\">\n" +
    "      <i ng-if=\"!sidebar.offscreen\" class=\"fa fa-caret-square-o-right\"></i>\n" +
    "      <i ng-if=\"sidebar.offscreen\" class=\"fa fa-caret-square-o-left\"></i>\n" +
    "    </a>\n" +
    "    <a class=\"nav-brand\" href=\"/\">{{ user.activeCompany().name }}</a>\n" +
    "    <a class=\"btn btn-link visible-xs\" ui-sref=\"booking({ action: 'add', day: (date | readTime:'MM-DD-YY') })\">\n" +
    "      <i class=\"fa fa-plus\"></i>\n" +
    "    </a>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"collapse navbar-collapse pull-in\" header></div>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<section class=\"hbox\" id=\"content\">\n" +
    "\n" +
    "  <aside\n" +
    "    sidebar\n" +
    "    id=\"nav\"\n" +
    "    ng-class=\"{ 'nav-vertical' : !sidebar.expanded, 'nav-off-screen' : sidebar.offscreen }\"\n" +
    "    class=\"bg-light aside-md\">\n" +
    "  </aside>\n" +
    "\n" +
    "  <section class=\"slide\">\n" +
    "\n" +
    "    <div ng-if=\"fetch.shown\" class=\"header b-b bg-white-only\" fetch></div>\n" +
    "    <section class=\"scrollable wrapper\">\n" +
    "      <div class=\"loader img-circle\" ng-if=\"spinner.active\" class=\"fadeIn\">\n" +
    "        <div spin=\"spinner.config\" spin-if=\"spinner.active\"></div>\n" +
    "      </div>\n" +
    "      <ui-view class=\"\"></ui-view>\n" +
    "    </section>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "</section>\n" +
    "\n" +
    "<div class=\"cover\" ng-class=\"{ 'shown' : showCover }\" ng-click=\"showCover = !showCover\"></div>\n" +
    "");
}]);

angular.module("views/booking/bundleModal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/booking/bundleModal",
    "<form name=\"HotelModal\" ng-controller=\"contactsCtrl\">\n" +
    "\n" +
    "  <div class=\"modal-header\">\n" +
    "    <h3 ng-if=\"new._id\">Changing assigned Bundle</h3>\n" +
    "    <h3 ng-if=\"!new._id\">Clearing assigned Bundle</h3>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal-body\">\n" +
    "\n" +
    "    <div ng-if=\"new._id\">\n" +
    "      <p>\n" +
    "        <strong>Warning!</strong> You're about to change the assigned bundle for this reservation!\n" +
    "      </p>\n" +
    "      <p>\n" +
    "        How would you like to proceed?\n" +
    "        <ul class=\"list\">\n" +
    "          <li>Clear <strong>{{ old.name }}</strong> and add new data from <strong>{{ new.name }}</strong></li>\n" +
    "          <li>\n" +
    "            Keep data from <strong>{{ old.name }}</strong> and assign new data from <strong>{{ new.name }}</strong>.<br>\n" +
    "            The bundle assignment will be <strong>{{ new.name }}</strong>, but existing data like items, package, hotel, concierge, and discount will remain, unless overwritten by the new bundle.<br>\n" +
    "            <small class=\"text-danger\">Overlapping items like discount and item assignments will be reassigned.</small>\n" +
    "          </li>\n" +
    "          <li>\n" +
    "            Cancel the change and use the existing bundle.\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "  \n" +
    "      </p>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!new._id\">\n" +
    "      <p><strong>Warning!</strong> You are removing <strong>{{ old.name }}</strong> as the assigned bundle.</p>\n" +
    "      <p><strong>Note</strong> Any package, hotel, or concierge assignments will remain unchanged.</p>\n" +
    "      <p>\n" +
    "        How would you like to proceed?\n" +
    "        <ul class=\"list\">\n" +
    "          <li>Clear <strong>{{ old.name }}</strong> and all bundle assignments</li>\n" +
    "          <li>\n" +
    "            Keep data from <strong>{{ old.name }}</strong> but remove the bundle assignment.<br>\n" +
    "            <small class=\"text-danger\">All data assigned from <strong>{{ old.name }} will remain, but not as part of the bundle.</strong>.</small>\n" +
    "          </li>\n" +
    "          <li>\n" +
    "            Cancel the change and keep the existing bundle.\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "  \n" +
    "      </p>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-danger\" ng-click=\"clear()\">Clear</button>\n" +
    "    <button class=\"btn btn-info\" ng-click=\"keep()\">Keep</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button>\n" +
    "  </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/booking/contactModal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/booking/contactModal",
    "<form name=\"HotelModal\" ng-controller=\"contactsCtrl\">\n" +
    "\n" +
    "  <div class=\"modal-header\">\n" +
    "    <h3 ng-if=\"type === 'hotel'\">Location Details</h3>\n" +
    "    <h3 ng-if=\"type === 'concierge'\">Link a Concierge or Travel Agent</span></h3>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal-body\">\n" +
    "\n" +
    "    <!-- Hotel Form -->\n" +
    "    <div ng-if=\"type === 'hotel'\">\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input type=\"text\" class=\"form-control input-lg\"\n" +
    "        placeholder=\"Other Location\"\n" +
    "        ng-model=\"booking.accommodations.other\"\n" +
    "        ng-disabled=\"contact.name || contact.phone\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"divider\"><span>or</span></div>\n" +
    "\n" +
    "      <div>\n" +
    "        <h4>Create a new Hotel</h4>\n" +
    "        <div ng-include=\"'views/contacts/forms/hotelModal'\"></div>\n" +
    "        <div ng-show=\"creatingContact\" class=\"alert alert-block alert-info\" style=\"margin-bottom: 0;\">\n" +
    "          <span\n" +
    "          style=\"display: inline-block; top: -8px; margin-right: 10px; position: relative;\"\n" +
    "          spin=\"$parent.spinnerConf\"></span>\n" +
    "          <span>Creating New Hotel, standby ... </span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- # Hotel Form -->\n" +
    "\n" +
    "    <!-- Concierge Form -->\n" +
    "    <div ng-if=\"type === 'concierge'\" class=\"tabbable\">\n" +
    "\n" +
    "      <ul class=\"nav nav-tabs\" style=\"margin-bottom: 10px;\">\n" +
    "        <li ng-click=\"type = 'concierge'\"\n" +
    "          ng-class=\"{ 'active': type === 'concierge' }\">\n" +
    "          <a href=\"#\">Concierge</a>\n" +
    "        </li>\n" +
    "        <li ng-click=\"type = 'partner'\"\n" +
    "          ng-class=\"{ 'active': type === 'partner' }\">\n" +
    "          <a href=\"#\">Travel Agent</a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "\n" +
    "      <div ng-show=\"type === 'concierge'\">\n" +
    "\n" +
    "        <ui-select\n" +
    "          ng-model=\"booking.accommodations.concierge\"\n" +
    "          name=\"concierge\"\n" +
    "          class=\"form-control input-lg\"\n" +
    "          style=\"border: none;\">\n" +
    "          <ui-select-match placeholder=\"Select a Concierge\">\n" +
    "            <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "          </ui-select-match>\n" +
    "          <ui-select-choices\n" +
    "            repeat=\"concierge in concierges | orderBy:'name' | filter: $select.search\" ng-hide=\"\">\n" +
    "            {{ concierge.name }}\n" +
    "          </ui-select-choices>\n" +
    "        </ui-select>\n" +
    "\n" +
    "        <div class=\"divider\"><span>or</span></div>\n" +
    "        <div ng-include=\"'views/contacts/forms/conciergeModal'\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-if=\"type === 'partner'\">\n" +
    "\n" +
    "        <ui-select\n" +
    "          ng-model=\"booking.agent\"\n" +
    "          name=\"travelagent\"\n" +
    "          class=\"form-control input-lg\"\n" +
    "          style=\"border: none;\">\n" +
    "          <ui-select-match placeholder=\"Select an Agent\">\n" +
    "            <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "          </ui-select-match>\n" +
    "          <ui-select-choices\n" +
    "            repeat=\"agent in agents | orderBy:'name' | filter: $select.search\" ng-hide=\"\">\n" +
    "            {{ agent.name }}\n" +
    "          </ui-select-choices>\n" +
    "        </ui-select>\n" +
    "\n" +
    "        <div class=\"divider\"><span>or</span></div>\n" +
    "\n" +
    "        <div ng-include=\"'views/contacts/forms/travelAgentModal'\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- # Concierge Form -->\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"update(booking, contact)\">Save</button>\n" +
    "  </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/booking/form", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/booking/form",
    "<header class=\"clearfix\" style=\"margin-bottom: 20px\" ng-init=\"toggleIds = false;\">\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-md-9\">\n" +
    "      <h2 class=\"pull-left\" ng-dblclick=\"toggleIds = !toggleIds\">\n" +
    "        <span ng-show=\"!reservation._id\">\n" +
    "          New Booking:\n" +
    "          <small ng-if=\"date\">{{ date | readTime:'long date' }}</small>\n" +
    "          <small ng-if=\"!date\">Choose Date</small>\n" +
    "        </span>\n" +
    "\n" +
    "        <span ng-show=\"reservation._id\">\n" +
    "          <div ng-if=\"!toggleIds\">\n" +
    "            Editing Booking:\n" +
    "            <span ng-if=\"reservation.status != 'pending'\">\n" +
    "              <small ng-if=\"!reservation.legacy\" ng-class=\"{ 'strike': reservation.status === 'cancelled' }\">\n" +
    "                {{ user.activeCompany().nickname }}<input class=\"plain\"\n" +
    "                  ng-class=\"{ 'strike': reservation.status === 'cancelled' }\" ng-model=\"reservation.confirmation\" />\n" +
    "              </small>\n" +
    "              <small ng-if=\"reservation.legacy\">\n" +
    "                <a style=\"color: #0198d4\"\n" +
    "                  ng-href=\"https://reservations.napavalleyballoons.com/reservations/{{ reservation.legacy }}\"\n" +
    "                  target=\"_blank\">\n" +
    "                  {{ reservation.legacy }}\n" +
    "                </a>\n" +
    "              </small>\n" +
    "            </span>\n" +
    "            <small ng-if=\"reservation.status == 'pending'\">Pending</small>\n" +
    "          </div>\n" +
    "          <span ng-if=\"toggleIds\">\n" +
    "            <span title=\"ID of day/event\">\n" +
    "              {{ reservation.event }}:\n" +
    "            </span>\n" +
    "            <small title=\"ID of reservation\">{{ reservation._id }}</small>\n" +
    "          </span>\n" +
    "        </span>\n" +
    "      </h2>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-3\" style=\"margin-top: 20px\">\n" +
    "      <div class=\"pull-right\">\n" +
    "\n" +
    "        <div class=\"checkbox pull-left\" style=\"margin: 8px 10px 0 0\"><label><input type=\"checkbox\"\n" +
    "              ng-model=\"reservation.waiting\" /> Waitlist</label></div>\n" +
    "\n" +
    "        <button ng-disabled=\"saving\" ui-sref=\"day.bookings({ day: dateUri() })\" class=\"btn btn-link pull-right\">\n" +
    "          Close\n" +
    "        </button>\n" +
    "\n" +
    "        <div class=\"btn-group pull-right\" ng-init=\"isNew = reservation._id === undefined\">\n" +
    "\n" +
    "          <approve ng-if=\"!isNew && reservation.status === 'pending'\" class=\"pull-left\" booking=\"reservation\"\n" +
    "            full-update=\"true\" wait=\"go('day.bookings', { day: dateUri() })\"\n" +
    "            then=\"go('day.bookings', { day: dateUri() })\">\n" +
    "            <button type=\"button\" class=\"btn bg-success\" ng-disabled=\"!BookingForm.$valid || saving\">\n" +
    "              Approve\n" +
    "            </button>\n" +
    "          </approve>\n" +
    "\n" +
    "          <button ng-if=\"reservation.status !== 'pending' || isNew\" ng-disabled=\"!BookingForm.$valid || saving\"\n" +
    "            class=\"btn bg-success\" ng-click=\"submit(true, reservation.waiting ? 'waiting': reservation.status)\"\n" +
    "            ng-class=\"\">\n" +
    "            <span ng-if=\"!reservation._id\">\n" +
    "              <span>Save<span ng-if=\"!cardError\" class=\"hidden-sm\"> Booking </span>\n" +
    "                <span ng-if=\"cardError\">without Card</span>\n" +
    "              </span>\n" +
    "            </span>\n" +
    "            <span style=\"min-width: 135px;\" ng-if=\"reservation._id\">Save Changes</span>\n" +
    "          </button>\n" +
    "\n" +
    "          <button ng-if=\"reservation.waiting && dateChanged\" ng-disabled=\"!BookingForm.$valid || saving\"\n" +
    "            class=\"btn bg-warning\" ng-click=\"prepClone(); submit(true, 'waiting')\">\n" +
    "            <span style=\"min-width: 135px;\">Clone</span>\n" +
    "          </button>\n" +
    "\n" +
    "\n" +
    "          <button type=\"button\" class=\"bg-danger btn lt\" ng-if=\"reservation.status === 'active'\"\n" +
    "            ng-click=\"cancel(reservation, true)\">Cancel</button>\n" +
    "\n" +
    "          <button type=\"button\" class=\"btn bg-info\" ng-if=\"reservation.status === 'cancelled'\"\n" +
    "            ng-disabled=\"!BookingForm.$valid || saving\" ng-click=\"submit(true, 'active')\">\n" +
    "            Rebook\n" +
    "          </button>\n" +
    "\n" +
    "          <button ng-disabled=\"reservation.waiting || !BookingForm.$valid || saving\" type=\"button\"\n" +
    "            ng-if=\"!reservation._id || reservation.status == 'pending'\" class=\"btn bg-info\"\n" +
    "            ng-click=\"submit(true, 'pending')\">\n" +
    "            <span>Pending</span>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"col-md-12\">\n" +
    "      <span style=\"color: gray; font-size: 1.3em;\" class=\"pull-left\">\n" +
    "        <small ng-if=\"!reservation.needs_pickup\">Meeting Time: {{ reservation.day | readTime: 'dddd':\"true\"}} at {{\n" +
    "          meetingTime }}</small>\n" +
    "        <small ng-if=\"reservation.needs_pickup\">Pickup time: {{ reservation.day | readTime: 'dddd':\"true\"}} at {{\n" +
    "          reservation.pickup.time }}</small>\n" +
    "      </span>\n" +
    "\n" +
    "      <small class=\"pull-right\" style=\"margin-right: 20px; margin-top: 10px;\" ng-show=\"reservation._id\">\n" +
    "        <span class=\"text-muted\" style=\"margin-right: 10px;\"><i class=\"fa fa-eye\"></i></span>\n" +
    "        <span ng-repeat=\"u in viewing(reservation) track by u._id\" class=\"text-muted ngFadeInOut\">\n" +
    "          <span ng-if=\"u._id === user._id\">You</span>\n" +
    "          <span ng-if=\"u._id !== user._id\">{{ u.name }}</span>\n" +
    "          <span ng-if=\"!$last\">, </span>\n" +
    "        </span>\n" +
    "      </small>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<section class=\"row\" id=\"resForm\" ng-class=\"{ 'small-screen': responsive.screen_size === 'sm' }\">\n" +
    "\n" +
    "  <div class=\"col-lg-7 col-md-6\">\n" +
    "    <form action=\"\" name=\"BookingForm\">\n" +
    "      <!-- First Row -->\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"col-md-3 col-xs-6 col-sm-3 input-group input-group-lg\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" tabindex=\"1\" date-entry=\"\" ng-model=\"reservation.day\"\n" +
    "            ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 250, 'blur': 0 } }\" name=\"date\"\n" +
    "            id=\"bookingDate\" ng-required=\"true\" />\n" +
    "\n" +
    "          <span class=\"input-group-btn\">\n" +
    "            <button type=\"button\" class=\"btn bg-light btn-icon\" ng-click=\"showCal = !showCal\">\n" +
    "              <i class=\"fa fa-calendar\">&nbsp;</i>\n" +
    "            </button>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-show=\"showCal\" class=\"dropdown-menu\"\n" +
    "          style=\"display: block; top: 55px !important; left: 10px !important;\">\n" +
    "          <datepicker show-weeks=\"false\" ng-model=\"calday\" ng-change=\"setDate(calday)\" min=\"calendar.today\"\n" +
    "            format-day=\"dd\" format-month=\"MM\" format-year=\"yyyy\"></datepicker>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-5 col-sm-3\" style=\"position: relative;\">\n" +
    "          <div class=\"no-pad input-group input-group-lg\" style=\"width: 100%\">\n" +
    "            <select id=\"reservationPackage\" tabindex=\"2\" class=\"input-lg no-pad\"\n" +
    "              ui-select2=\"{ width: '100%', formatSelection: selectFormat }\" ng-model=\"reservation._package\"\n" +
    "              ng-attr-placeholder=\"{{ reservation.package.name || 'Select a Package' }}\" name=\"_package\">\n" +
    "              <option value=\"\"></option>\n" +
    "              <option ng-repeat=\"package in packages | orderBy:'-active'\" value=\"{{ package._id }}\"\n" +
    "                ng-disabled=\"!package.active\" ng-selected=\"{{ reservation.package._id == package._id }}\">{{ package.name\n" +
    "                }}</option>\n" +
    "            </select>\n" +
    "\n" +
    "            <div class=\"input-group-btn no-pad\">\n" +
    "              <button tabindex=\"3\" type=\"button\" class=\"btn btn-icon bg-light\" ng-click=\"modifiers = !modifiers\"><i\n" +
    "                  class=\"fa fa-plus\"></i></button>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-12 modifiers bg-light\" ng-show=\"modifiers\" style=\"width: calc(100% - 10px)\">\n" +
    "\n" +
    "            <div class=\"checkbox-inline\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"reservation.vip\">\n" +
    "                VIP\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"checkbox-inline\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"reservation.hotel\"\n" +
    "                  ng-click=\"reservation.needs_pickup = reservation.hotel\">\n" +
    "                Hotel Package\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"checkbox-inline\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"reservation.group\">\n" +
    "                Group\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"checkbox-inline\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"reservation.meta.no_brunch\">\n" +
    "                Skip Brunch\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"checkbox-inline\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"reservation.meta.free_pickup\">\n" +
    "                Free Pickup\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-2 col-xs-6 col-sm-2 input-group\">\n" +
    "          <input tabindex=\"4\" class=\"form-control input-lg\" ng-model=\"reservation.adults\" placeholder=\"Adults\"\n" +
    "            name=\"adults\" type=\"number\" min=\"0\" required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-2 col-xs-6 col-sm-2 input-group\">\n" +
    "          <input tabindex=\"5\" class=\"form-control input-lg\" ng-model=\"reservation.children\" name=\"children\"\n" +
    "            placeholder=\"Children\" type=\"number\" min=\"0\" ng-disabled=\"getPackage().adults\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !First Row -->\n" +
    "      <div class=\"row\"\n" +
    "        ng-if=\"(user.activeCompany().weights || getPackage().require_weights) && ((reservation.adults || 0) + (reservation.children || 0)) > 0\"\n" +
    "        style=\"margin-bottom: 0;\">\n" +
    "\n" +
    "        <div class=\"col-md-3 col-sm-3\" ng-repeat=\"weight in reservation.meta.weights | toObject\">\n" +
    "          <div class=\"input-group input-group-lg no-pad\" style=\"margin-bottom: 10px;\">\n" +
    "            <input type=\"text\" ng-model=\"reservation.meta.weights[$index]\" name=\"guestWeight{{$index}}\"\n" +
    "              placeholder=\"Guest Weight\" class=\"form-control input-lg\" ng-required=\"true\">\n" +
    "\n" +
    "            <div class=\"input-group-btn\">\n" +
    "              <button type=\"button\" class=\"btn btn-icon bg-light\" ng-click=\"removeWeight($index)\"><i\n" +
    "                  class=\"fa fa-minus\"></i></button>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" ng-if=\"false\" style=\"margin-bottom: 0;\">\n" +
    "        <strong class=\"col-md-12\">Child Ages</strong>\n" +
    "        <div class=\"col-md-3 col-sm-3\" ng-repeat=\"age in reservation.meta.child_ages | toObject\">\n" +
    "          <div class=\"input-group input-group-lg no-pad\" style=\"margin-bottom: 10px;\">\n" +
    "            <input type=\"text\" ng-model=\"reservation.meta.child_ages[$index]\" name=\"childAge{{$index}}\"\n" +
    "              placeholder=\"Child Age\" class=\"form-control input-lg\" ng-required=\"false\">\n" +
    "\n" +
    "            <div class=\"input-group-btn\">\n" +
    "              <button type=\"button\" class=\"btn btn-icon bg-light\" ng-click=\"removeAge($index)\"><i\n" +
    "                  class=\"fa fa-minus\"></i></button>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <!-- Second Row -->\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"input-group col-xs-6 col-md-6\">\n" +
    "          <input tabindex=\"6\" type=\"text\" class=\"form-control input-lg\" ng-model=\"reservation.first_name\"\n" +
    "            placeholder=\"First Name\" name=\"first_name\" required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-xs-6 col-md-6\">\n" +
    "          <input tabindex=\"7\" type=\"text\" class=\"form-control input-lg\" ng-model=\"reservation.last_name\"\n" +
    "            placeholder=\"Last Name\" name=\"last_name\" required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-xs-12 col-md-12\" ng-if=\"reservation.group\" style=\"margin-top: 10px;\">\n" +
    "          <input tabindex=\"8\" type=\"text\" class=\"form-control input-lg\" ng-model=\"reservation.group_name\"\n" +
    "            name=\"group_name\" placeholder=\"Group Name\" required />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Second Row -->\n" +
    "\n" +
    "      <!-- Third Row -->\n" +
    "      <div class=\"row\" ng-init=\"moreEmails = false;\">\n" +
    "\n" +
    "        <div class=\"input-group input-group-lg col-md-6 col-xs-6\">\n" +
    "          <input tabindex=\"8\" type=\"text\" class=\"form-control input-lg\" ng-model=\"reservation.phone\"\n" +
    "            placeholder=\"Phone Number\" name=\"phone\" required />\n" +
    "          <div class=\"input-group-btn no-pad\">\n" +
    "            <label class=\"\">\n" +
    "              <button type=\"button\" style=\"padding: 12px 15px;\"\n" +
    "                ng-click=\"reservation.sms_opt_in = !reservation.sms_opt_in\" class=\"btn bg-light btn-block\">\n" +
    "                <i ng-click=\"reservation.sms_opt_in = !reservation.sms_opt_in\" class=\"fa fa-square\"\n" +
    "                  ng-if=\"!reservation.sms_opt_in\"></i>\n" +
    "                <i ng-click=\"reservation.sms_opt_in = !reservation.sms_opt_in\" class=\"fa fa-check-square\"\n" +
    "                  ng-if=\"reservation.sms_opt_in\"></i>\n" +
    "                <input class=\"hide\" name=\"sms_opt_in\" type=\"checkbox\" ng-model=\"reservation.sms_opt_in\"> SMS Opt-In\n" +
    "              </button>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"input-group col-md-6 col-xs-6\" style=\"padding-right: 50px;\">\n" +
    "          <input tabindex=\"9\" type=\"text\" name=\"email\" ng-model=\"reservation.email\"\n" +
    "            ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }\" autocomplete=\"off\"\n" +
    "            class=\"form-control input-lg\" placeholder=\"Email\"\n" +
    "            ng-required=\"!reservation.accommodations.concierge.meta.confirmation && !reservation.agent.meta.commissions\"\n" +
    "            ui-validate-watch=\"'reservation.accommodations.concierge.meta.confirmation'\"\n" +
    "            ui-validate=\"{ email: 'validate.checkEmail($value)'}\" />\n" +
    "          <button type=\"button\" ng-click=\"moreEmails = !moreEmails\" class=\"btn-link\"\n" +
    "            style=\"width: 50px;height: 45px;position: absolute;right: 0;\"><i class=\"fa\"\n" +
    "              ng-class=\"{ 'fa-caret-left' : !moreEmails, 'fa-caret-down': moreEmails }\"></i></button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" ng-if=\"moreEmails\">\n" +
    "        <div class=\"row\" style=\"margin-top: 0;\">\n" +
    "          <div class=\"col-md-6\">\n" +
    "            <span class=\"text-muted pull-right\" style=\"margin-top: 15px;\">Photo Email</span>\n" +
    "          </div>\n" +
    "          <div class=\"input-group col-md-6 col-xs-6\">\n" +
    "            <input tabindex=\"9\" type=\"text\" name=\"photo_email\" ng-model=\"reservation.photo_email\" autocomplete=\"off\"\n" +
    "              class=\"form-control input-lg\" placeholder=\"Photo Email\"\n" +
    "              ui-validate=\"{ photo_email: 'validate.checkEmail($value, true)'}\" />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-md-6\">\n" +
    "            <span class=\"text-muted pull-right\" style=\"margin-top: 15px;\">Receipt Email</span>\n" +
    "          </div>\n" +
    "          <div class=\"input-group col-md-6 col-xs-6\">\n" +
    "            <input tabindex=\"9\" type=\"text\" name=\"receipt_email\" ng-model=\"reservation.receipt_email\" autocomplete=\"off\"\n" +
    "              class=\"form-control input-lg\" placeholder=\"Receipt Email\"\n" +
    "              ui-validate=\"{ receipt_email: 'validate.checkEmail($value)'}\" />\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <!-- !Third Row -->\n" +
    "\n" +
    "      <!-- Fourth Row -->\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"col-md-3 col-sm-3\" style=\"position: relative;\">\n" +
    "\n" +
    "          <div class=\"no-pad\" style=\"width: 100%\">\n" +
    "\n" +
    "            <ui-select ng-model=\"reservation.bundle\" name=\"bundle\" class=\"form-control input-lg\" style=\"border: none;\">\n" +
    "              <ui-select-match placeholder=\"Add a Bundle\">\n" +
    "                <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "              </ui-select-match>\n" +
    "\n" +
    "              <ui-select-choices repeat=\"bundle in bundles | orderBy:'name' | filter: $select.search\">\n" +
    "                {{ bundle.name }}\n" +
    "              </ui-select-choices>\n" +
    "\n" +
    "            </ui-select>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Hotel Select -->\n" +
    "        <div class=\"input-group col-md-4 col-xs-5 input-group-lg select2-bootstrap-append\">\n" +
    "          <ui-select tabindex=\"10\" ng-model=\"reservation.accommodations.hotel\" ng-required=\"reservation.hotel\"\n" +
    "            name=\"hotel\" class=\"form-control input-lg\" style=\"border: none;\">\n" +
    "            <ui-select-match placeholder=\"Select a Hotel\">\n" +
    "              <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "            </ui-select-match>\n" +
    "\n" +
    "            <ui-select-choices repeat=\"hotel in filterHotels() | orderBy:'name' | filter: $select.search\"\n" +
    "              ng-hide=\"(p.concierges | toArray).length === 0\">\n" +
    "              {{ hotel.name }}\n" +
    "            </ui-select-choices>\n" +
    "\n" +
    "          </ui-select>\n" +
    "\n" +
    "          <div class=\"input-group-btn no-pad\">\n" +
    "            <button type=\"button\" class=\"btn bg-light\" ng-click=\"contactModal('hotel')\"><i\n" +
    "                class=\"fa fa-plus\"></i></button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- # Hotel Select -->\n" +
    "\n" +
    "        <!-- Concierge Select -->\n" +
    "        <div class=\"input-group col-xl-4 col-md-3 col-xs-5 input-group-lg select2-bootstrap-append\">\n" +
    "\n" +
    "          <ui-select tabindex=\"11\" ng-model=\"reservation.accommodations.concierge\" name=\"concierge\"\n" +
    "            ng-disabled=\"!reservation.accommodations.hotel\" class=\"form-control input-lg\" style=\"border: none;\">\n" +
    "            <ui-select-match placeholder=\"Choose a Concierge\">\n" +
    "              <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "            </ui-select-match>\n" +
    "            <ui-select-choices\n" +
    "              repeat=\"concierge in getConciergeList(reservation.accommodations.hotel) | orderBy:'name' | filter: $select.search\"\n" +
    "              ng-hide=\"\">\n" +
    "              {{ concierge.name }}\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "\n" +
    "          <div class=\"input-group-btn no-pad\">\n" +
    "            <button type=\"button\" class=\"btn bg-light\" ng-click=\"contactModal('concierge')\"><i\n" +
    "                class=\"fa fa-plus\"></i></button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- # Concierge Select -->\n" +
    "\n" +
    "        <label class=\"col-md-2 col-xs-2 col-xl-1\">\n" +
    "          <button type=\"button\" style=\"padding: 12px 15px;\" tabindex=\"12\"\n" +
    "            ng-click=\"reservation.needs_pickup = !reservation.needs_pickup\" class=\"btn bg-light btn-block\"\n" +
    "            ng-disabled=\"!reservation.accommodations.hotel\">\n" +
    "            <i ng-click=\"reservation.needs_pickup = !reservation.needs_pickup\" class=\"fa fa-square\"\n" +
    "              ng-if=\"!reservation.needs_pickup\"></i>\n" +
    "            <i ng-click=\"reservation.needs_pickup = !reservation.needs_pickup\" class=\"fa fa-check-square\"\n" +
    "              ng-if=\"reservation.needs_pickup\"></i>\n" +
    "            <input class=\"hide\" name=\"pickup\" ng-disabled=\"!reservation.accommodations.hotel\" type=\"checkbox\"\n" +
    "              ng-model=\"reservation.needs_pickup\"> Pick Up\n" +
    "          </button>\n" +
    "        </label>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Fourth Row -->\n" +
    "\n" +
    "      <!-- Fifth Row -->\n" +
    "      <div class=\"row\" ng-if=\"reservation.needs_pickup\">\n" +
    "\n" +
    "        <div class=\"col-md-4 col-sm-6 input-group input-group-lg\">\n" +
    "\n" +
    "          <input type=\"text\" tabindex=\"13\" name=\"pickup_time\" class=\"form-control input-lg\"\n" +
    "            ng-model=\"reservation.pickup.time\" placeholder=\"Pickup Time\" time=\"{ hours: 1, minutes: 5 }\" />\n" +
    "\n" +
    "          <div class=\"input-group-btn\" dropdown is-open=\"status.isopen\">\n" +
    "            <button type=\"button\" class=\"btn bg-light dropdown-toggle btn-icon\" ng-click=\"getPickups()\"\n" +
    "              ng-disabled=\"disabled\">\n" +
    "              <span class=\"fa fa-info\"></span>\n" +
    "            </button>\n" +
    "            <ul class=\"dropdown-menu container\" role=\"menu\" style=\"width: 375px;\">\n" +
    "              <li ng-if=\"pickups == 'active'\">\n" +
    "                <h5 style=\"text-align: center;\">Loading Pickups</h5>\n" +
    "              </li>\n" +
    "              <li ng-if=\"pickups !== 'active'\">\n" +
    "                <h5 style=\"text-align: center;\">Pickups scheduled for this day.</h5>\n" +
    "              </li>\n" +
    "              <li ng-if=\"pickups !== 'active'\" class=\"divider\"></li>\n" +
    "              <li ng-if=\"pickups !== 'active'\">\n" +
    "                <table class=\"table table-condensed table-striped\">\n" +
    "                  <thead>\n" +
    "                    <tr>\n" +
    "                      <th>Zone</th>\n" +
    "                      <th>Time</th>\n" +
    "                      <th>Count</th>\n" +
    "                      <th>Hotel</th>\n" +
    "                    </tr>\n" +
    "                  </thead>\n" +
    "                  <tbody>\n" +
    "                    <tr ng-repeat=\"booking in pickups\">\n" +
    "                      <td>{{ booking.accommodations.hotel.zone.zone || \"-\" }}</td>\n" +
    "                      <td>{{ booking.pickup.time | readTime:'hh:mmA' }}</td>\n" +
    "                      <td>{{ booking.adults + (booking.children || 0) }}</td>\n" +
    "                      <td>{{ booking.accommodations.hotel.name }}</td>\n" +
    "                    </tr>\n" +
    "                  </tbody>\n" +
    "                </table>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div class=\"col-md-8 col-sm-6 input-group\">\n" +
    "          <textarea tabindex=\"14\" style=\"height: 44px;\" name=\"driver_notes\" ng-model=\"reservation.pickup.notes\"\n" +
    "            placeholder=\"Notes for Driver\" class=\"form-control input-lg\"></textarea>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Fifth Row -->\n" +
    "\n" +
    "      <!-- Sixth Row -->\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"input-group col-md-4 col-xs-4\">\n" +
    "          <input tabindex=\"21\" type=\"text\" name=\"occasion_notes\" class=\"form-control input-lg\"\n" +
    "            ng-model=\"reservation.notes.occasion\" placeholder=\"Occasion\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-4 col-xs-4\">\n" +
    "          <input tabindex=\"22\" type=\"text\" name=\"instructions\" class=\"form-control input-lg\"\n" +
    "            ng-model=\"reservation.notes.instructions\" placeholder=\"Special Instructions\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-4 col-xs-4\">\n" +
    "          <input tabindex=\"23\" type=\"text\" name=\"memo\" class=\"form-control input-lg\" ng-model=\"reservation.notes.memo\"\n" +
    "            placeholder=\"Memo\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Sixth Row -->\n" +
    "\n" +
    "      <!-- Seventh Row -->\n" +
    "      <div class=\"\">\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "\n" +
    "          <div class=\"input-group col-md-4 col-xs-6\">\n" +
    "            <input tabindex=\"25\" type=\"text\" name=\"source\" ng-model=\"reservation.source\" class=\"form-control input-lg\"\n" +
    "              placeholder=\"Source\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"input-group col-md-4 col-xs-6\">\n" +
    "            <!-- If no balloon, show the empty field  -->\n" +
    "            <div ng-if=\"!reservation.flight || !reservation.flight.length\">\n" +
    "              <input type=\"text\" class=\"input-lg form-control\" disabled=\"disabled\" placeholder=\"Balloon Assignment\" />\n" +
    "            </div>\n" +
    "            <div ng-repeat=\"flight in reservation.flight\" ng-init=\"balloon = flight.flight.balloon\">\n" +
    "              <input type=\"text\" class=\"input-lg form-control\" disabled=\"disabled\" ng-model=\"balloon.name\" />\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"input-group col-md-4 col-xs-12 confButton\">\n" +
    "            <button tabindex=\"26\" type=\"button\" class=\"btn btn-block btn-lg bg-light\"\n" +
    "              ng-click=\"toggles.emailTemplate = !toggles.emailTemplate\"\n" +
    "              ng-disabled=\"!reservation.communication.template\">\n" +
    "              <i ng-if=\"!toggles.emailTemplate\" class=\"fa fa-caret-right pull-left\"></i>\n" +
    "              <i ng-if=\"toggles.emailTemplate\" class=\"fa fa-caret-down pull-left\"></i>\n" +
    "              Confirmation Email\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "\n" +
    "          <button type=\"button\" ng-show=\"activeMessage && activeMessage.template !== activeMessage.newTemplate\"\n" +
    "            class=\"animated fadeInOut btn btn-lg bg-info pull-right\"\n" +
    "            style=\"z-index: 1; position: relative; margin: 5px 10px;\" ng-click=\"resendConf(activeMessage)\">\n" +
    "            <i class=\"fa fa-envelope\"></i> Send Update\n" +
    "          </button>\n" +
    "\n" +
    "          <div class=\"col-md-12\" ng-if=\"activeMessage\">\n" +
    "            <div style=\"padding: 10px;\" class=\"panel\"\n" +
    "              hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\"\n" +
    "              ng-model=\"activeMessage.newTemplate\"></div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-12\" ng-if=\"toggles.emailTemplate\">\n" +
    "            <div style=\"padding: 10px;\" class=\"panel\"\n" +
    "              hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\"\n" +
    "              ng-model=\"reservation.communication.template\"></div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Seventh Row -->\n" +
    "\n" +
    "      <!-- Eighth Row -->\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"input-group col-md-12 col-xs-12\">\n" +
    "          <textarea tabindex=\"24\" rows=\"10\" name=\"internal_notes\" class=\"form-control input-lg\"\n" +
    "            ng-model=\"reservation.notes.internal\" placeholder=\"Internal Notes\"></textarea>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Eighth Row -->\n" +
    "\n" +
    "    </form>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <h4>Waivers</h4>\n" +
    "      </div>\n" +
    "      <div class=\"col-md-4\" ng-repeat=\"waiver in reservation.smartWaiver\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-md-12\">\n" +
    "            <a ng-href=\"https://app.smartwaiver.com/api/waivers/{{waiver.id}}/download?inline\" target=\"_blank\">\n" +
    "              <i class=\"fa fa-download\"></i> Download\n" +
    "            </a>\n" +
    "            <ul class=\"list-unstyled\">\n" +
    "              <li ng-repeat=\"participant in waiver.data.participants\">\n" +
    "                {{ participant.firstName + ' ' + participant.lastName }}, {{ age(participant.dob)}} years old, {{\n" +
    "                getWaiverWeight(participant) }}\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-12\" ng-if=\"user.activeCompany().meta.waiverId\">\n" +
    "        <a target=\"_blank\"\n" +
    "          ng-href=\"https://waiver.smartwaiver.com/w/{{ user.activeCompany().meta.waiverId }}/web/?auto_tag={{ reservation.company.nickname }}{{reservation.confirmation}}\"\n" +
    "          class=\"btn btn-danger\">\n" +
    "          Sign Waiver\n" +
    "        </a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"col-lg-5 col-md-6 col-sm-12\" style=\"padding-left: 15px;\">\n" +
    "\n" +
    "    <!-- Only show if company has bank account -->\n" +
    "    <div>\n" +
    "\n" +
    "      <!-- Credit Card Entry -->\n" +
    "      <div class=\"row\" ng-repeat=\"card in reservation.payment.cards\">\n" +
    "        <input type=\"text\" class=\"hide\" ng-model=\"card.id\" />\n" +
    "        <div class=\"col-md-5 col-sm-3\" ng-init=\"card.showId = false\">\n" +
    "          <div class=\"label label-block label-lg bg-light lter\" style=\"padding: 12px;\">\n" +
    "            <div ng-show=\"!card.showId\" ng-dblclick=\"card.showId = true\">\n" +
    "              {{ card.type | cardName }} <span class=\"visible-lg-inline\">ending </span>{{ card.masked }}\n" +
    "              <span ng-if=\"card.status == 'pending'\" class=\"label bg-info pull-right\">Valid</span>\n" +
    "              <span ng-if=\"card.status == 'valid'\" class=\"label label-success pull-right\">Charged</span>\n" +
    "              <span ng-if=\"card.status == 'failed'\" class=\"label label-danger pull-right\">Declined</span>\n" +
    "              <span ng-if=\"card.status == 'error'\" title=\"\" class=\"label label-danger pull-right\"> Error</span>\n" +
    "            </div>\n" +
    "            <div class=\"\" ng-show=\"card.showId\" style=\"margin-bottom: 0px;position: relative;margin-right: 36px;\">\n" +
    "              <input type=\"text\" name=\"card{{$index}}_id\" class=\"plain\" disabled=\"true\" value=\"{{card.id}}\"\n" +
    "                style=\"width: 100%\"><br>\n" +
    "              <button type=\"button\" class=\"btn btn-xs bg-info lter pull-right\" ng-click=\"card.showId = false\"\n" +
    "                style=\"position: absolute;right: -37px;top: 0;\">hide</button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-lg-4 col-md-5 col-sm-6 input-group\">\n" +
    "          <label class=\"input-group-addon\" style=\"cursor: pointer;\">$</label>\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" style=\"width: 60%\" name=\"card{{$index}}_amount\"\n" +
    "            ng-model=\"card.amount\" placeholder=\"0.00\" />\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" style=\"width: 40%; border-left: 0;\" name=\"card{{$index}}_tip\"\n" +
    "            ng-model=\"card.tip\" placeholder=\"Tip\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-lg-3 col-md-2 col-xs-12 col-sm-3\">\n" +
    "          <button style=\"font-size: 1.1em;\" type=\"button\" ng-click=\"card.charge(reservation.customerId, 'reservation')\"\n" +
    "            ng-disabled=\"card.charging || !card.amount || card.amount == 0 || card.amount > reservation.payment.balance \"\n" +
    "            class=\"btn btn-lg bg-success lter btn-block\">\n" +
    "\n" +
    "            <span ng-if=\"!card.charging\">\n" +
    "              <span class=\"visible-lg\">Charge</span>\n" +
    "              <span class=\"visible-md visible-sm visible-xs\"><i class=\"fa fa-check\"></i></span>\n" +
    "            </span>\n" +
    "            <span ng-if=\"card.charging\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "              lines: 17,\n" +
    "              length: 0,\n" +
    "              width: 4,\n" +
    "              radius: 4,\n" +
    "              corners: 1,\n" +
    "              rotate: 0,\n" +
    "              direction: 1,\n" +
    "              color: '#fff',\n" +
    "              speed: 1.2,\n" +
    "              trail: 36,\n" +
    "              shadow: false,\n" +
    "              hwaccel: false,\n" +
    "              className: 'spinner',\n" +
    "              zIndex: 2e9,\n" +
    "              top: '-5px',\n" +
    "              left: 'auto'\n" +
    "            }\"></span>\n" +
    "\n" +
    "          </button>\n" +
    "        </div>\n" +
    "\n" +
    "        <span class=\"alert alert-danger col-md-12 col-sm-12\" ng-if=\"card.errors && card.errors.length\"\n" +
    "          style=\"padding: 5px; margin: 10px 0 5px;\">\n" +
    "          {{ card.errors }}\n" +
    "        </span>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-show=\"reservation.payment.cards.length < 1 || showCardEntry\">\n" +
    "\n" +
    "        <div class=\"row\" style=\"position: relative;\">\n" +
    "\n" +
    "          <span ng-show=\"!card.readyForEntry() && (card.number && card.expiration && card.cvv)\"\n" +
    "            class=\"label label-danger\" style=\"position: absolute;top: -20px;left: 5px;\">\n" +
    "            Guest data is missing. You must fill out all required details before you will be able to validate the\n" +
    "            card.</span>\n" +
    "\n" +
    "          <div class=\"col-md-6 col-xs-10 col-sm-8 input-group\">\n" +
    "            <span ng-show=\"card.errors.number || card.errors.expiration || card.errors.cvv\"\n" +
    "              class=\"label bg-danger pull-right\" style=\"position: absolute; right: 20px; top: 33%;\">Invalid</span>\n" +
    "            <input tabindex=\"15\" name=\"card_number\" type=\"text\" class=\"form-control input-lg\" ng-model=\"card.number\"\n" +
    "              placeholder=\"Credit Card Number\" ng-class=\"{ 'ng-invalid' : card.errors.number }\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"input-group col-md-3 col-sm-2\">\n" +
    "\n" +
    "            <input type=\"text\" tabindex=\"16\" style=\"text-align: center; font-size: 1.1em;\" name=\"cardExpiration\"\n" +
    "              ng-model=\"card.expiration\" name=\"card_expiration\" ui-mask=\"99/99\"\n" +
    "              ui-validate=\"'validate.expiration($value)'\" class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"input-group col-md-3 col-sm-2\">\n" +
    "\n" +
    "            <input type=\"text\" tabindex=\"17\" style=\"text-align: center;\" name=\"cardCVV\" ng-model=\"card.cvv\"\n" +
    "              placeholder=\"CVV\" ng-class=\"{ 'ng-invalid' : card.errors.cvv }\" class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- !Credit Card Entry -->\n" +
    "\n" +
    "        <!-- Second Row -->\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-md-6 col-xs-6 col-sm-6 input-group\">\n" +
    "            <input tabindex=\"18\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Billing Address\"\n" +
    "              ng-model=\"card.billing\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-3 col-xs-6 col-sm-4 input-group\">\n" +
    "            <input tabindex=\"19\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Zip\" ng-model=\"card.zip\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-3 col-xs-12 col-sm-2\">\n" +
    "            <button tabindex=\"20\" class=\"btn bg-info lter btn-block btn-lg\" type=\"button\"\n" +
    "              ng-disabled=\"saving || !card.readyForEntry() || !card.number || !card.expiration || !card.cvv\"\n" +
    "              ng-click=\"card.verify()\">Validate</button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- !Second Row -->\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <button class=\"btn btn-link btn-block\" ng-click=\"showCardEntry = !showCardEntry\">\n" +
    "        <span ng-show=\"!showCardEntry\"><i class=\"fa fa-plus\"></i> Add a Card</span>\n" +
    "        <span ng-show=\"showCardEntry\"><i class=\"fa fa-minus\"></i> Hide Fields</span>\n" +
    "      </button>\n" +
    "      <!-- Forth Row -->\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- End of Credit Card -->\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <!-- #Pricing Table -->\n" +
    "      <div pricing ng-model=\"reservation\"></div>\n" +
    "      <!-- !Pricing Table -->\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Forth Row -->\n" +
    "\n" +
    "    <div class=\"row\" style=\"margin-top: -5px\">\n" +
    "\n" +
    "      <tabset class=\"col-md-12 light tabbable\" justified=\"true\">\n" +
    "        <tab heading=\"Attachments\">\n" +
    "          {{ reservation.attachments = reservation.attachments || [];\"\" }}\n" +
    "          <div ng-controller=\"filesCtrl\">\n" +
    "            <ul class=\"list-unstyled\">\n" +
    "              <li ng-repeat=\"f in files\">{{ f.name }}</li>\n" +
    "              <li ng-repeat=\"f in reservation.attachments\" ng-show=\"!f.removed\">\n" +
    "                <button type=\"button\" class=\"btn btn-link\" ng-click=\"removeFile(f)\"><i class=\"fa fa-trash\"></i></button>\n" +
    "                <a ng-href=\"{{ f.path }}\" class=\"btn btn-link\" target=\"_blank\">{{ f.key }}</a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "            <button class=\"btn bg-info lt\" type=\"file\" ngf-select=\"upload($files, reservation.attachments, true)\"\n" +
    "              ngf-multiple=\"true\" accept=\"image/*, application/pdf\" ngf-accept=\"'*'\"><i\n" +
    "                class=\"fa fa-paperclip\"></i></i></button>\n" +
    "          </div>\n" +
    "          <input id=\"Upload\" class=\"hide\" type=\"file\" ng-file-select=\"selectFiles($files)\" />\n" +
    "        </tab>\n" +
    "\n" +
    "        <tab heading=\"Messaging History\">\n" +
    "\n" +
    "          <div class=\"row\">\n" +
    "            <button class=\"btn bg-info bg-lt btn-justified\" type=\"button\" ng-disabled=\"reservation.working\"\n" +
    "              ng-click=\"sendConf(reservation)\">\n" +
    "              Send Confirmation Email\n" +
    "              <span ng-if=\"reservation.working\"\n" +
    "                style=\"display: inline-block; top: -8px; position: relative; margin-left: 10px; \"\n" +
    "                spin=\"spinnerConf\"></span>\n" +
    "            </button>\n" +
    "\n" +
    "            <button class=\"btn bg-info bg-lt btn-justified\" type=\"button\" ng-click=\"sendReceipt(reservation)\">\n" +
    "              Send Receipt\n" +
    "              <span ng-if=\"reservation.sending_receipt\"\n" +
    "                style=\"display: inline-block; top: -8px; position: relative; margin-left: 10px; \"\n" +
    "                spin=\"spinnerConf\"></span>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "          <table ng-show=\"reservation.messages.length > 0\" class=\"table table-condensed\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th style=\"width: 130px;\">Date</th>\n" +
    "                <th style=\"width: 25px;\">&nbsp;</th>\n" +
    "                <th>Sender</th>\n" +
    "                <th></th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "              <tr ng-repeat=\"message in reservation.messages | orderBy:'-created'\"\n" +
    "                ng-class=\"{ 'text-muted': message.working, 'active' : activeMessage._id == message._id }\">\n" +
    "                <td ng-click=\"setEmailTemplate(message)\" class=\"point\">{{ message.created | readTime:'MM/DD/YY\n" +
    "                  hh:mma':false:true }}\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                  <i ng-show=\"message.type === 'sms'\" class=\"fa fa-commenting-o\"></i>\n" +
    "                  <i ng-show=\"message.type === 'email'\" class=\"fa fa-envelope\"></i>\n" +
    "                </td>\n" +
    "                <td ng-click=\"setEmailTemplate(message)\" class=\"point\">\n" +
    "                  <span ng-show=\"message.user\">{{ message.user.nickname || message.user.name }}</span>\n" +
    "                  <span ng-if=\"message.type === 'sms'\">\n" +
    "                    <span ng-switch=\"message.meta.direction\" class=\"pull-left\" style=\"margin-right: 10px;\">\n" +
    "                      <span ng-switch-when=\"inbound\"><i class=\"fa fa-arrow-right\"></i></span>\n" +
    "                      <span ng-switch-when=\"outbound\"><i class=\"fa fa-arrow-left\"></i></span>\n" +
    "                    </span>\n" +
    "                    <span ng-show=\"message.meta.direction === 'inbound'\">\n" +
    "                      <!-- Show group name if it exists -->\n" +
    "                      <span ng-if=\"reservation.group_name\">{{ reservation.group_name }}</span>\n" +
    "                      <!-- Otherwise show guest name -->\n" +
    "                      <span ng-if=\"!reservation.group_name\">\n" +
    "                        {{ reservation.first_name + ' ' + reservation.last_name }}\n" +
    "                      </span>\n" +
    "                    </span>\n" +
    "                    - {{ message.compiled }}\n" +
    "                  </span>\n" +
    "                </td>\n" +
    "                <td style=\"width:85px\">\n" +
    "                  <div class=\"btn-group pull-right\">\n" +
    "                    <button class=\"btn btn-link\" type=\"button\" tooltip=\"Resend this Email\"\n" +
    "                      ng-click=\"resendConf(message)\" ng-disabled=\"message.working\"><i class=\"fa fa-share\"></i></button>\n" +
    "                    <button class=\"btn btn-link\" type=\"button\" tooltip=\"Resend Text only Email\"\n" +
    "                      ng-click=\"resendConf(message, true)\" ng-disabled=\"message.working\"><i\n" +
    "                        class=\"fa fa-file-text\"></i></button>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "        </tab>\n" +
    "        <tab heading=\"Reservation History\">\n" +
    "\n" +
    "          <table ng-show=\"reservation.user\" class=\"table table-condensed\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th style=\"width: 130px;\">Date</th>\n" +
    "                <th>Agent</th>\n" +
    "                <th>Action</th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody ng-repeat=\"history in reservation.trace | filter: showHistory | orderBy:'-date'\"\n" +
    "              ng-init=\"history.expand = false; $traceIndex = $index\">\n" +
    "              <tr ng-click=\"history.expand = !history.expand\">\n" +
    "                <td ng-class=\"{ 'text-muted': history.diff.length === 0, 'point': history.diff.length }\">{{ history.date\n" +
    "                  | date: 'mediumDate' }}</td>\n" +
    "                <td ng-class=\"{ 'text-muted': history.diff.length === 0, 'point': history.diff.length }\">{{\n" +
    "                  history.user.name }}</td>\n" +
    "                <td ng-class=\"{ 'text-muted': history.diff.length === 0, 'point': history.diff.length }\">{{\n" +
    "                  history.reason }}</td>\n" +
    "              </tr>\n" +
    "              <tr ng-show=\"history.expand && history.diff.length\" class=\"active\">\n" +
    "                <td></td>\n" +
    "                <td colspan=\"2\">\n" +
    "\n" +
    "                  <table class=\"table table-condensed transparent\" style=\"margin-bottom: 0;\">\n" +
    "                    <thead>\n" +
    "                      <tr>\n" +
    "                        <th width=\"33%\">Field</th>\n" +
    "                        <th width=\"33%\">Previously</th>\n" +
    "                        <th width=\"33%\">Changed To</th>\n" +
    "                      </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                      <tr ng-repeat=\"change in history.diff | filter: excludeDiffs\">\n" +
    "                        <td>\n" +
    "                          <em ng-if=\"change.path === 'line_items' && change.old_value === ''\">\n" +
    "                            adding\n" +
    "                          </em>\n" +
    "                          {{ change.path }}\n" +
    "                        </td>\n" +
    "                        <td ng-switch=\"change.path\">\n" +
    "                          <span ng-switch-when=\"day\">\n" +
    "                            {{ change.old_value | readTime: 'MM/DD/YYYY ':true }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-when=\"pickup.time\">\n" +
    "                            {{ change.old_value | readTime: 'h:mma':true }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-when=\"phone\">\n" +
    "                            {{ change.old_value | phone }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-default>\n" +
    "                            <span ng-if=\"change.old_value === ''\"><em>empty</em></span>\n" +
    "                            {{ change.old_value }}\n" +
    "                          </span>\n" +
    "                        </td>\n" +
    "                        <td ng-switch=\"change.path\">\n" +
    "                          <span ng-switch-when=\"day\">\n" +
    "                            {{ change.new_value | readTime: 'MM/DD/YYYY':true }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-when=\"pickup.time\">\n" +
    "                            {{ change.new_value | readTime: 'h:mma':true }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-when=\"phone\">\n" +
    "                            {{ change.new_value | phone }}\n" +
    "                          </span>\n" +
    "                          <span ng-switch-default>\n" +
    "                            <script type=\"text/ng-template\" id=\"nestedTemplate\">\n" +
    "                              <ul ng-if=\"typeof(item) === 'object'\" class=\"list-unstyled\">\n" +
    "                                <li ng-repeat=\"(key, val) in (item | excludeKeys:'_id')\">\n" +
    "                                  <span ng-if=\"typeof(val) !== 'object'\">\n" +
    "                                    <strong>{{ key }}</strong>: {{ val }}\n" +
    "                                  </span>\n" +
    "                                  <span ng-if=\"typeof(val) === 'object'\">\n" +
    "                                    <strong>{{ key }}</strong>: \n" +
    "                                    <div style=\"padding-left: 5px;\" ng-include=\"'nestedTemplate'\" ng-init=\"item = val\"></div> \n" +
    "                                  </span>\n" +
    "                                </li>\n" +
    "                              </ul>\n" +
    "                              <span ng-if=\"typeof(item) !== 'object'\">\n" +
    "                                {{ item }}\n" +
    "                              </span>  \n" +
    "                            </script>\n" +
    "                            <span ng-include=\"'nestedTemplate'\" ng-init=\"item = change.new_value\"></span>\n" +
    "                          </span>\n" +
    "                        </td>\n" +
    "                      </tr>\n" +
    "                    </tbody>\n" +
    "                  </table>\n" +
    "\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "\n" +
    "        </tab>\n" +
    "      </tabset>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-init=\"smsTemplates = smsMessages()\">\n" +
    "      <div class=\"col-md-12\">\n" +
    "\n" +
    "        <div class=\"\">\n" +
    "          <span class=\"text-danger\" ng-if=\"!reservation.sms_opt_in\">Guest has not opted into text message\n" +
    "            communication.</span>\n" +
    "          <div class=\"panel-heading bg-light\">\n" +
    "            <select id=\"smsTemplates\" class=\"input-lg no-pad\" ui-select2=\"{ width: '100%' }\" ng-model=\"selected_sms\"\n" +
    "              ng-attr-placeholder=\"{{ 'Select a Text Message' }}\" name=\"_sms\">\n" +
    "              <option value=\"\"></option>\n" +
    "              <option ng-repeat=\"message in smsTemplates\" value=\"{{ message.template }}\">{{ message.name }}</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "          <div class=\"clearfix\" style=\"padding: 15px; border: 2px solid #ebeef5;\">\n" +
    "            <textarea rows=\"10\" name=\"smsLength\" class=\"form-control\" ng-model=\"smsMessageBody\"></textarea>\n" +
    "          </div>\n" +
    "          <div class=\"panel-footer bg-light clearfix\">\n" +
    "            <button type=\"button\" ng-disabled=\"sms_working || !reservation.sms_opt_in\" class=\"btn bg-info pull-right\"\n" +
    "              ng-click=\"sendSms(reservation, smsMessageBody)\">Send Message</button>\n" +
    "            <button type=\"button\" ng-disabled=\"sms_working\" class=\"btn bg-danger pull-right\"\n" +
    "              ng-click=\"smsMessageBody = ''\" style=\"margin-right: 10px;\">Clear</button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("views/bootbox/appUser", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bootbox/appUser",
    "<div class=\"row\">\n" +
    "  <div class=\"col-md-6 no-pad-rt\">\n" +
    "    \n" +
    "    <div class=\"form-group\">\n" +
    "      <input class=\"form-control\" type=\"email\" ng-model=\"appUser.email\" placeholder=\"Email\" ng-required=\"true\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group\">\n" +
    "      <input class=\"form-control\" type=\"text\" ng-model=\"appUser.name\" placeholder=\"Name\" ng-required=\"true\" />\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"col-md-6\">\n" +
    "    <div class=\"form-group\">\n" +
    "      <input class=\"form-control\" type=\"text\" ng-model=\"appUser.password\" placeholder=\"Password\" required />\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("views/bootbox/cancel", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bootbox/cancel",
    "<!-- !! DEPRECATED !! -->\n" +
    "\n" +
    "<p ng-show=\"!_booking.payment.cardCharges || _booking.payment.cardCharges == 0\">\n" +
    "  <strong>Choose reason for canceling</strong>\n" +
    "</p>\n" +
    "\n" +
    "<div ng-show=\"_booking.payment.cardCharges && _booking.payment.cardCharges > 0\">\n" +
    "  <p>\n" +
    "    <strong>This booking has been charged a total amount of {{ _booking.payment.cardCharges | currency }}</strong>\n" +
    "  </p>\n" +
    "  <p>Please choose whether to Refund all charges before cancelling, or to cancel without refunding by clicking <code>Proceed</code></p>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-init=\"cancellationReason = getDefaultCancellation()._id\"></div>\n" +
    "\n" +
    "<select class=\"input\"\n" +
    "  ui-select2=\"{ width: '100%' }\"\n" +
    "  ng-model=\"cancellationReason\"\n" +
    "  data-placeholder=\"Why are you cancelling?\"\n" +
    "  name=\"cancellationReason\">\n" +
    "  <option\n" +
    "    ng-repeat=\"can in user.activeCompany().cancellations\"\n" +
    "    value=\"{{ can._id }}\"\n" +
    "    ng-selected=\"{{ can.default }}\">{{ can.name }}</option>\n" +
    "</select>\n" +
    "");
}]);

angular.module("views/bootbox/note", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bootbox/note",
    "<div class=\"row\">\n" +
    "\n" +
    "  <div class=\"col-md-12\">\n" +
    "    <dl class=\"dl-horizontal\">\n" +
    "      <dt>Created By:</dt>\n" +
    "      <dd>{{ note.user.nickname || note.user.name }}</dd>\n" +
    "      <dt>For Date:</dt>\n" +
    "      <dd>{{ note.day }}</dd>\n" +
    "      <dt>On:</dt>\n" +
    "      <dd>{{ note.created | readTime: 'M/DD [@] h:mm:a' }}</dd>\n" +
    "    </dl>\n" +
    "    {{ note.body }}\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("views/bootbox/noteForm", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bootbox/noteForm",
    "<div class=\"row\">\n" +
    "\n" +
    "  <div class=\"col-md-5 input-group input-group-lg\">\n" +
    "\n" +
    "    <input type=\"text\" class=\"form-control input-lg\"\n" +
    "      date-entry=\"\"\n" +
    "      ng-model=\"note.day\"\n" +
    "      ng-required=\"true\"/>\n" +
    "\n" +
    "    <div class=\"input-group-btn\">\n" +
    "      <button\n" +
    "        type=\"button\"\n" +
    "        class=\"btn bg-light btn-icon\"\n" +
    "        ng-click=\"showCal = !showCal\">\n" +
    "        <i class=\"fa fa-calendar\"></i>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"col-md-12 form-group\" style=\"overflow: hidden; position: relative; top: 10px;\">\n" +
    "    <textarea class=\"form-control\" rows=\"5\" ng-model=\"note.body\"></textarea>\n" +
    "  </div>\n" +
    "\n" +
    "  <div style=\"width: 325px;position: absolute;background: #fff;padding: 5px;box-sizing: content-box;border-radius: 5px; top: 70px\" ng-show=\"showCal\">\n" +
    "    <datepicker show-weeks=\"false\"\n" +
    "      ng-model=\"note._day\"\n" +
    "      ng-change=\"showCal = false\"\n" +
    "      min=\"calendar.today\"\n" +
    "      format-day=\"dd\" format-month=\"MM\" format-year=\"yyyy\"></datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("views/bs/datepicker/day", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bs/datepicker/day",
    "<table class=\"table table-condensed\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>\n" +
    "        {{ }}\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-left\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th>\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-right\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-link btn-sm\" ng-class=\"dayBtnClass(dt)\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\">\n" +
    "          <span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current }\">{{::dt.label}}</span>\n" +
    "        </button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>");
}]);

angular.module("views/bs/datepicker/month", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bs/datepicker/month",
    "<table class=\"table table-condensed\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-left\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "      <th>\n" +
    "        <button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\">\n" +
    "          <strong>{{title}}</strong>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "      <th>\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-right\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-link\" \n" +
    "          ng-class=\"{'bg-info': dt.selected, active: isActive(dt)}\" \n" +
    "          ng-click=\"select(dt.date)\" \n" +
    "          ng-disabled=\"dt.disabled\" \n" +
    "          tabindex=\"-1\">\n" +
    "            <span>{{::dt.label}}</span>\n" +
    "          </button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>");
}]);

angular.module("views/bs/datepicker/year", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bs/datepicker/year",
    "<table class=\"table table-condensed\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-left\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-link btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th>\n" +
    "        <button type=\"button\" class=\"btn btn-link btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\">\n" +
    "          <i class=\"fa fa-chevron-right\"></i>\n" +
    "        </button>\n" +
    "      </th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-link\" ng-class=\"{'bg-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span>{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>");
}]);

angular.module("views/bs/rating/rating", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bs/rating/rating",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"fa\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\" aria-valuetext=\"{{r.title}}\"></i>\n" +
    "</span>");
}]);

angular.module("views/bugs/modal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/bugs/modal",
    "<form name=\"BugModal\" ng-controller=\"bugsController\">\n" +
    "\n" +
    "  <div class=\"modal-header\">\n" +
    "    <h3>Report a Bug</h3>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"modal-body\">\n" +
    "    <div class=\"form-group\">\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Brief Description (roughly 100 chars)\" max=\"100\" ng-model=\"bug.description\" ng-disabled=\"!canEdit()\" />\n" +
    "    </div>\n" +
    "    <h5>Steps to reproduce</h5>\n" +
    "    <ol>\n" +
    "      <li ng-repeat=\"step in bug.steps\" class=\"form-group\">\n" +
    "        <input type=\"text\" class=\"form-control\" style=\"display: inline-block\" placeholder=\"How to reproduce\" ng-model=\"step.value\" ng-disabled=\"!canEdit()\"/>\n" +
    "      </li>\n" +
    "    </ol>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"bug.seconded && bug.seconded.length !== 0\">\n" +
    "      <hr>\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <ul class=\"list-unstyled\">\n" +
    "          <li><strong class=\"text-success\">Seconded By:</strong>\n" +
    "            <span ng-repeat=\"user in bug.seconded\">\n" +
    "              <span>{{ user.name }}</span>\n" +
    "              <span ng-show=\"!$last\"> / </span>\n" +
    "            </span>\n" +
    "          </li>\n" +
    "          <li ng-show=\"bug.voters.length !== 0\"><strong class=\"text-warning\">Voters: </strong>\n" +
    "            <span ng-repeat=\"user in bug.voters\">\n" +
    "              <span>{{ user.name }}</span>\n" +
    "              <span ng-show=\"!$last\"> / </span>\n" +
    "            </span>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-link\" ng-click=\"close();\">Close</button>\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"save(bug)\" ng-if=\"!bug._id\">Submit</button>\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"update(bug)\" ng-if=\"canEdit()\">Update</button>\n" +
    "    <button type=\"button\" class=\"btn bg-warning\" ng-if=\"!canEdit() && bug.seconded.length === 0\" ng-click=\"second(bug)\">I Second This</button>\n" +
    "    <button type=\"button\" class=\"btn bg-success\" ng-if=\"!canEdit() && bug.seconded.length !== 0 && !alreadyVoted(bug)\" ng-click=\"vote(bug)\">I want this addressed too!</button>\n" +
    "  </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/calendar", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/calendar",
    "\n" +
    "<div class=\"col-md-12\">\n" +
    "\n" +
    "  <div calendar\n" +
    "    for=\"startMonth\"\n" +
    "    events=\"events\"\n" +
    "    on-click=\"gotoDay({ day: day })\"\n" +
    "    active-day=\"isToday({ month: month, day: day, year: year })\">\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/contacts/contacts", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/contacts",
    "<header class=\"day clearfix\">\n" +
    "\n" +
    "  <h2 class=\"pull-left noselect\" style=\"margin-bottom: 20px;\">Contacts: <small style=\"text-transform: capitalize;\">{{ state.tab }}</small></h2>\n" +
    "\n" +
    "  <button ng-if=\"state.tab == 'hotels'\" class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\"  ui-sref=\"contactEdit({ id: 'hotel' })\">\n" +
    "    <span>Add New</span>\n" +
    "  </button>\n" +
    "\n" +
    "  <button ng-if=\"state.tab == 'employees'\" class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\"  ui-sref=\"employeeEdit({ id: 'new' })\">\n" +
    "    <span>Add New</span>\n" +
    "  </button>\n" +
    "\n" +
    "  <button ng-if=\"state.tab == 'partners'\" class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\"  ui-sref=\"contactEdit({ id: 'partner' })\">\n" +
    "    <span>Add New</span>\n" +
    "  </button>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<section class=\"pos-rlt\">\n" +
    "  <div class=\"tabbable\">\n" +
    "    <ul class=\"nav nav-tabs\">\n" +
    "      <li ng-repeat=\"(key,tab) in tabs.contacts\" ng-class=\"{'active': tab.active}\" ng-click=\"gotoContacts(tab)\">\n" +
    "        <a href=\"\">{{ tab.heading }}</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div ng-repeat=\"(key,tab) in tabs.contacts\" ng-if=\"tab.active\">\n" +
    "    <div ng-include=\"'views/contacts/' + tab.tab\"></div>\n" +
    "  </div>\n" +
    "</section>\n" +
    "");
}]);

angular.module("views/contacts/employees", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/employees",
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <button type=\"button\" ng-disabled=\"state.page == 1\" ui-sref=\"contacts({ tab: state.tab, page: (state.page - 1)})\" class=\"btn bg-light lt\">Previous Page</button>\n" +
    "  \n" +
    "  <div class=\"btn-group\">\n" +
    "    <button\n" +
    "      type=\"button\"\n" +
    "      class=\"btn bg-light lt\"\n" +
    "      ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: page})\"\n" +
    "      ng-disabled=\"state.page == page\"\n" +
    "      ng-repeat=\"(page, count) in pages\"\n" +
    "      tooltip=\"{{count}}\">{{ page }}</button>\n" +
    "  </div>\n" +
    "  <button type=\"button\" ng-disabled=\"!pages[state.page + 1]\" ui-sref=\"contacts({ tab: state.tab, page: (state.page + 1)})\" class=\"btn bg-light lt\">Next Page</button>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <div class=\"col-md-12\">\n" +
    "    \n" +
    "    <div class=\"btn-group btn-group-xs\">\n" +
    "      <button type=\"button\" \n" +
    "        ng-disabled=\"state.filter === 'all'\" ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: 1 })\" \n" +
    "        class=\"btn btn-xs bg-light lt\"\n" +
    "        ng-class=\"{\n" +
    "          'bg-light': state.filter !== 'all',\n" +
    "          'bg-info': state.filter === 'all'\n" +
    "        }\">\n" +
    "        All\n" +
    "      </button>\n" +
    "      <button\n" +
    "        type=\"button\"\n" +
    "        class=\"btn btn-xs lt\"\n" +
    "        ng-class=\"{ \n" +
    "          'bg-light' : state.filter !== page || (state.filter !== 'numbers' && page !== '0-9'), \n" +
    "          'bg-info':  state.filter === page || (state.filter === 'numbers' && page === '0-9')\n" +
    "        }\"\n" +
    "        ui-sref=\"contacts({ tab: state.tab, filter: page === '0-9' ? 'numbers' : page, page: '1'})\"\n" +
    "        ng-repeat=\"(page, count) in alphabetize\"\n" +
    "        ng-disabled=\"count === 0 || state.filter === page\"\n" +
    "        tooltip=\"{{count}}\"\n" +
    "        tooltip-append-to-body=\"true\"\n" +
    "        style=\"text-transform: uppercase\">\n" +
    "          {{ page }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<table class=\"table half-fade\" ng-class=\"{ 'in': !contactsWorking, 'out': contactsWorking }\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th style=\"width: 28px\"></th>\n" +
    "      <th>Role</th>\n" +
    "      <th><input type=\"text\" ng-model=\"employeesearch.$\" placeholder=\"Name\"></th>\n" +
    "      <th>Email</th>\n" +
    "      <th>Phone</th>\n" +
    "      <th></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"employee in contacts | filter:employeesearch | orderBy:'name'\" ng-hide=\"employee.removed || employee.meta.mobile \">\n" +
    "      <td ui-sref=\"employeeEdit({ id: employee._id })\">\n" +
    "        <span><i class=\"fa\" ng-class=\"{ 'fa-unlock text-success' : employee.api_key, 'fa-lock text-muted' : !employee.api_key }\"></i></span>\n" +
    "      </td>\n" +
    "      <td ui-sref=\"employeeEdit({ id: employee._id })\">\n" +
    "        <span ng-if=\"employee.pending\" class=\"text-info text-em\">Pending</span>\n" +
    "        <span ng-if=\"!employee.groups\">--</span>\n" +
    "        <span ng-if=\"employee.groups\" ng-repeat=\"role in employee.groups | filter: user.Company()\" ng-if=\"\">{{ role.name }}<span ng-if=\"!$last\">,</span> </span>\n" +
    "      </td>\n" +
    "      <td ui-sref=\"employeeEdit({ id: employee._id })\">{{ employee.name }}</td>\n" +
    "      <td ui-sref=\"employeeEdit({ id: employee._id })\">{{ employee.email }}</td>\n" +
    "      <td ui-sref=\"employeeEdit({ id: employee._id })\">{{ employee.phone }}</td>\n" +
    "      <td><button class=\"btn btn-link lt pull-right\" ng-click=\"remove(employee, true)\"><i class=\"fa fa-times\"></i></button></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("views/contacts/form", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/form",
    "<div ng-init=\"contact = contacts\">\n" +
    "  \n" +
    "  <section class=\"row\" id=\"contactForm\" ng-if=\"contact.meta.type == 'hotel'\" ng-include=\"'views/contacts/forms/hotel'\"></section>\n" +
    "\n" +
    "  <section class=\"row\" id=\"contactForm\" ng-if=\"contact.meta.type == 'concierge'\" ng-include=\"'views/contacts/forms/concierge'\"></section>\n" +
    "\n" +
    "  <section class=\"row\" id=\"contactForm\" ng-if=\"contact.meta.type == 'partner'\" ng-include=\"'views/contacts/forms/partner'\"></section>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/contacts/forms/concierge", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/concierge",
    "<header class=\"day clearfix\">\n" +
    "\n" +
    "  <h2 class=\"pull-left noselect\" style=\"margin-bottom: 20px;\">Contact: <small style=\"text-transform: capitalize;\">{{ contact.meta.type }}</small></h2>\n" +
    "\n" +
    "  <button class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\" ng-click=\"save(contact)\" ng-disabled=\"!ConciergeForm.$valid\">\n" +
    "    <span ng-if=\"!contact.saving\">\n" +
    "      <span ng-if=\"contact.isNew\">Save</span>\n" +
    "      <span ng-if=\"!contact.isNew\">Update</span>\n" +
    "    </span>\n" +
    "    <span ng-if=\"contact.saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#fff',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "\n" +
    "  </button>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<form action=\"\" name=\"ConciergeForm\">\n" +
    "    <!-- Contact Column -->\n" +
    "    <div class=\"col-md-4 col-md-offset-2\">\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-4 no-pad-lft\">\n" +
    "          <div class=\"input-group\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.code\" placeholder=\"Unique Code\" type=\"text\" />\n" +
    "            <div class=\"input-group-btn\">\n" +
    "              <button type=\"button\" ng-click=\"setCode()\" class=\"btn bg-light btn-lg\" tooltip=\"Set Code\">\n" +
    "                <i class=\"fa fa-barcode\"></i>\n" +
    "              </button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"padding: 0 10px;\">\n" +
    "\n" +
    "        <div class=\"form-group col-md-8\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"contact.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-4\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.email\" ng-required=\"contact.meta.confirmation\" placeholder=\"Email Address\" type=\"email\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- Contact Column -->\n" +
    "\n" +
    "    <!-- Meta Column -->\n" +
    "    <div class=\"col-md-4\">\n" +
    "\n" +
    "      <div class=\"input-group form-group\">\n" +
    "\n" +
    "          <ui-select\n" +
    "            ng-model=\"contact.parentId\"\n" +
    "            name=\"parentHotel\"\n" +
    "            class=\"form-control input-lg\"\n" +
    "            style=\"border: none;\">\n" +
    "\n" +
    "            <ui-select-match placeholder=\"Select a Hotel\">\n" +
    "              <span ng-bind-html=\"$select.selected.name || contact.extras.hotels[contact.parentId].name\"></span>\n" +
    "            </ui-select-match>\n" +
    "\n" +
    "            <ui-select-choices\n" +
    "              repeat=\"hotel in (contact.extras.hotels | toArray) | orderBy:'name' | filter: $select.search track by hotel._id\">\n" +
    "              {{ hotel.name }}\n" +
    "            </ui-select-choices>\n" +
    "\n" +
    "          </ui-select>\n" +
    "\n" +
    "\n" +
    "        <div class=\"input-group-btn\">\n" +
    "          <button\n" +
    "            type=\"button\"\n" +
    "            ui-sref=\"contactEdit({ id: contact.parentId })\"\n" +
    "            class=\"btn bg-light btn-lg\"\n" +
    "            tooltip=\"Open Hotel\">\n" +
    "            <i class=\"fa fa-arrow-right\"></i>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.commission_ach\"> Commission by ACH\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.commission_check\"> Commission by Check\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-disabled=\"!contact.email || contact.email == ''\" ng-model=\"contact.meta.confirmation\"> Send confirmation email\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.commissions\"> Accepts Commissions\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group pull-right col-md-3\" style=\"margin-top: -35px;\" ng-show=\"contact.meta.commissions\">\n" +
    "          <input class=\"form-control input-sm\" ng-model=\"contact.meta.commission_amount\" placeholder=\"Amount\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\" ng-show=\"contact.meta.commissions\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.hold_commissions\"> Hold Commission\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_view\"> Concierge can view all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_edit\"> Concierge can edit all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.marketing\"> Send Email Marketing\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- Meta Column -->\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/conciergeModal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/conciergeModal",
    "<form action=\"\" name=\"ConciergeForm\">\n" +
    "\n" +
    "    <div class=\"row\" ng-init=\"contact.meta = {}; contact.parentId = $parent.booking.accommodations.hotel._id; contact.meta.type = 'concierge'; contact.meta.agent = false\">\n" +
    "\n" +
    "        <input type=\"hidden\" ng-model=\"contact.parentId\" />\n" +
    "\n" +
    "        <!-- Contact Column -->\n" +
    "        <div class=\"col-md-6\">\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" style=\"\">\n" +
    "\n" +
    "                <div class=\"form-group col-md-8\">\n" +
    "                    <input class=\"form-control input-lg\" ng-model=\"contact.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-group col-md-4 no-pad-lft\">\n" +
    "                    <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.email\" ng-required=\"contact.meta.confirmation\" placeholder=\"Email Address\" type=\"email\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- Contact Column -->\n" +
    "\n" +
    "        <!-- Meta Column -->\n" +
    "        <div class=\"col-md-6\">\n" +
    "\n" +
    "            <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.commission_ach\"> Commission by ACH\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.commission_check\"> Commission by Check\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-disabled=\"!contact.email || contact.email == ''\" ng-model=\"contact.meta.confirmation\"> Send confirmation email\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.commissions\"> Accepts Commissions\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-group pull-right col-md-3\"\n" +
    "                    style=\"margin-top: -35px; max-width: 75px;\"\n" +
    "                    ng-show=\"contact.meta.commissions\">\n" +
    "                    <input class=\"form-control input-sm\" ng-model=\"contact.meta.commission_amount\" placeholder=\"Amount\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                  <label>\n" +
    "                    <input type=\"checkbox\" ng-disabled=\"!contact.meta.commissions\" ng-model=\"contact.meta.hold_commissions\"> Hold Commission\n" +
    "                  </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_view\"> Can view hotel's bookings\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_edit\"> Can edit hotel's bookings\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.marketing\"> Send Email Marketing\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- Meta Column -->\n" +
    "    </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/employee", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/employee",
    "<form action=\"\" name=\"userForm\" ng-init=\"listUsers()\">\n" +
    "  <header class=\"day clearfix\">\n" +
    "\n" +
    "    <h2 class=\"pull-left noselect\" style=\"margin-bottom: 20px;\">Employee: <small style=\"text-transform: capitalize;\">{{\n" +
    "        contact.name || contact.existing.name }}</small></h2>\n" +
    "\n" +
    "    <button class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\" ng-click=\"submit(contact)\"\n" +
    "      ng-disabled=\"userForm.$invalid\">\n" +
    "      <span ng-if=\"!contact.saving\">\n" +
    "        <span ng-if=\"!contact.isNew\">Update</span>\n" +
    "        <span ng-if=\"contact.isNew\">Save</span>\n" +
    "      </span>\n" +
    "      <span ng-if=\"contact.saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "        lines: 17,\n" +
    "        length: 0,\n" +
    "        width: 4,\n" +
    "        radius: 4,\n" +
    "        corners: 1,\n" +
    "        rotate: 0,\n" +
    "        direction: 1,\n" +
    "        color: '#fff',\n" +
    "        speed: 1.2,\n" +
    "        trail: 36,\n" +
    "        shadow: false,\n" +
    "        hwaccel: false,\n" +
    "        className: 'spinner',\n" +
    "        zIndex: 2e9,\n" +
    "        top: '-5px',\n" +
    "        left: 'auto'\n" +
    "      }\"></span>\n" +
    "\n" +
    "    </button>\n" +
    "\n" +
    "  </header>\n" +
    "\n" +
    "  <hr>\n" +
    "\n" +
    "  <section class=\"row\" id=\"contactForm\">\n" +
    "\n" +
    "\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <!-- Contact Column -->\n" +
    "      <div class=\"col-md-4\">\n" +
    "\n" +
    "        <div class=\"form-group col-md-12 no-pad\" ng-if=\"contact.isNew\">\n" +
    "          <ui-select ng-model=\"contact.existing\" class=\"input input-lg\" style=\"width: 100%\">\n" +
    "            <ui-select-match placeholder=\"Choose Existing User\">{{ $select.selected.name }}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"user in users track by $index\" ng-hide=\"\">{{ user.name }}</ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div ng-if=\"!contact.existing\">\n" +
    "\n" +
    "          <div class=\"divider\" ng-if=\"contact.isNew\"><span>or</span></div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-8 no-pad-lft\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4 no-pad-rt\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.nickname\" placeholder=\"Nickname\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\"\n" +
    "              type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\" style=\"margin-bottom: 15px; padding: 0 10px;\">\n" +
    "\n" +
    "            <div class=\"input-group col-md-8\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"input-group col-md-4\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\"\n" +
    "                type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\" style=\"margin-bottom: 15px; padding: 0 10px;\">\n" +
    "            <div class=\"form-group col-md-8\">\n" +
    "\n" +
    "              <!-- Allow lookup of existing user by email only if new user -->\n" +
    "              <input ng-if=\"!contact._id\" class=\"form-control input-lg\" ng-model=\"contact.email\"\n" +
    "                placeholder=\"Email Address\" type=\"email\" ui-event=\"{ blur : 'checkEmail($event, contact)' }\" required />\n" +
    "\n" +
    "              <!-- Dont check for existing email if updating existing user -->\n" +
    "              <input ng-if=\"contact._id\" class=\"form-control input-lg\" ng-model=\"contact.email\"\n" +
    "                placeholder=\"Email Address\" type=\"email\" required />\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group col-md-4\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.pin\" placeholder=\"Mobile Pin\" type=\"text\"\n" +
    "                ng-pattern=\"/^[0-9]{4}|''$/\" />\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\" style=\"margin-bottom: 15px; padding: 0 10px;\">\n" +
    "\n" +
    "            <div class=\"input-group col-md-8\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.role\" placeholder=\"Role\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"input-group col-md-4\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.birthday\" placeholder=\"Birthday\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"well\" style=\"padding: 5px 15px; overflow: auto;\">\n" +
    "\n" +
    "            <h6>Assign Employee Duties</h6>\n" +
    "\n" +
    "            <div class=\"checkbox-inline label\" ng-repeat=\"(label, action) in contact.type\">\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"contact.type[label]\" /> {{ label }}\n" +
    "              </label>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- Contact Column -->\n" +
    "\n" +
    "      <!-- Meta Column -->\n" +
    "      <div class=\"col-md-3\" ng-show=\"!contact.existing\">\n" +
    "\n" +
    "          <div class=\"row\" style=\"margin-bottom: 15px; padding: 0 10px;\">\n" +
    "          \n" +
    "            <div class=\"input-group col-md-12\">\n" +
    "              <input class=\"form-control input-lg\" ng-model=\"contact.meta.square_id\" placeholder=\"Square User ID\" type=\"text\" />\n" +
    "            </div>\n" +
    "                    \n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "        <div class=\"well\" style=\"padding: 5px 15px; overflow: auto;\"\n" +
    "          ng-show=\"setPassword || contact.is_user || contact.pending\">\n" +
    "\n" +
    "          <h6>Assign Security Groups</h6>\n" +
    "\n" +
    "          <div class=\"checkbox-inline label\" ng-repeat=\"(index, group) in groups\"\n" +
    "            ng-init=\"group.selected = hasGroup(group)\" ng-if=\"group.company == user.Company()\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"group.selected\" ng-change=\"changeGroup(group)\"> {{ group.name }}\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"well\" style=\"padding: 5px 15px; overflow: auto;\">\n" +
    "\n" +
    "          <h6>Extras</h6>\n" +
    "\n" +
    "          <div class=\"checkbox\" ng-if=\"contact.type.pilot\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meta.pilot_commissions\"> Receives Pilot Commission\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group pull-right col-md-3\" style=\"margin-top: -35px;\"\n" +
    "            ng-show=\"contact.meta.pilot_commissions\">\n" +
    "            <input class=\"form-control input-sm\" ng-model=\"contact.meta.pilot_commission_amount\" placeholder=\"Amount\"\n" +
    "              type=\"number\" max=\"1\" min=\"0.001\" step=\"0.01\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meta.commissions\"> Receives Commission\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group pull-right col-md-3\" style=\"margin-top: -35px;\" ng-show=\"contact.meta.commissions\">\n" +
    "            <input class=\"form-control input-sm\" ng-model=\"contact.meta.commission_amount\" placeholder=\"Amount\"\n" +
    "              type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meta.hold_commissions\"> Hold Commissions\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"checkbox\" ng-show=\"contact.meta.commissions\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meta.hold_commissions\"> Hold Commission\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meta.tip_eligible\"> Eligible for Tips\n" +
    "            </label>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <button class=\"btn btn-block btn-lg bg-info\" type=\"button\" ng-show=\"!contact.is_user && !contact.pending\"\n" +
    "          ng-click=\"setPassword = !setPassword\">\n" +
    "          <span ng-if=\"!setPassword\">Promote to App User</span>\n" +
    "          <span ng-if=\"setPassword\">Cancel User Promotion</span>\n" +
    "        </button>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Meta Column -->\n" +
    "\n" +
    "      <!-- User Auth -->\n" +
    "      <div class=\"col-md-5\" style=\"padding: 0 25px;\">\n" +
    "\n" +
    "        <div ng-if=\"setPassword\">\n" +
    "\n" +
    "          <div class=\"form-group col-md-12\">\n" +
    "            <label for=\"password1\">Assign a Password</label>\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"contact.password\" id=\"password1\" placeholder=\"Password\"\n" +
    "              type=\"password\" ng-required=\"!contact.invite\" ng-disabled=\"contact.invite\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-12\">\n" +
    "            <input ui-validate=\"'$value==contact.password'\" ui-validate-watch=\"'contact.password'\"\n" +
    "              class=\"form-control input-lg\" ng-model=\"contact.passwordConf\" id=\"password2\" placeholder=\"Password Again\"\n" +
    "              type=\"password\" ng-required=\"!contact.invite\" ng-disabled=\"contact.invite\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <label class=\"checkbox\">\n" +
    "            <input type=\"checkbox\" class=\"checkbox\" ng-model=\"contact.invite\"> Or you can Send an Invitation\n" +
    "          </label>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <table class=\"table table-compact\" ng-if=\"setPassword || contact.is_user || contact.pending\">\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "              <th colspan=\"3\">\n" +
    "                <h5>Permission Overrides <small class=\"pull-right\">Security groups are advised.</small></h5>\n" +
    "              </th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr ng-repeat=\"role in roles\">\n" +
    "              <td>{{ role.name }}</td>\n" +
    "              <td><input type=\"checkbox\" ng-model=\"all[role.name]\" ng-change=\"checkAll(role.name)\" /></td>\n" +
    "              <td>\n" +
    "                <label style=\"padding: 10px 10px;\" class=\"checkbox-inline label\" ng-class=\"{\n" +
    "                    'assigned' : contact._roles[role.name][action],\n" +
    "                    'unassigned' : !contact._roles[role.name][action] && !indeterminate,\n" +
    "                    'indeterminate': indeterminate }\" ng-repeat=\"(index, action) in role.actions\"\n" +
    "                  for=\"{{ role.name }}_{{ action }}\" ng-init=\"indeterminate = inheritsRole(role.name, action)\">\n" +
    "                  <input id=\"{{ role.name }}_{{ action }}\" ng-model=\"contact._roles[role.name][action]\" type=\"checkbox\"\n" +
    "                    ui-indeterminate=\"inheritsRole(role.name, action)\" /> {{ action }}\n" +
    "                </label>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "\n" +
    "        <div ng-if=\"contact.is_user\">\n" +
    "          <button type=\"button\" class=\"btn btn-danger btn-block lter btn-sm\"\n" +
    "            ng-click=\"resetPass({ _id: contact._id })\">Send Reset Link</button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !User Auth -->\n" +
    "    </div>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/hotel", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/hotel",
    "<header class=\"day clearfix\">\n" +
    "\n" +
    "  <h2 class=\"pull-left noselect\" style=\"margin-bottom: 20px;\">Contact: <small style=\"text-transform: capitalize;\">{{ contact.meta.type }}</small></h2>\n" +
    "\n" +
    "  <button class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\" ng-click=\"save(contact)\">\n" +
    "    <span ng-if=\"!contact.saving\">\n" +
    "      <span ng-if=\"contact.isNew\">Save</span>\n" +
    "      <span ng-if=\"!contact.isNew\">Update</span>\n" +
    "    </span>\n" +
    "    <span ng-if=\"contact.saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#fff',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "\n" +
    "  </button>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<form action=\"\">\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "    <!-- Contact Column -->\n" +
    "    <div class=\"col-md-4\">\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-bottom: 15px; padding: 0 10px;\">\n" +
    "\n" +
    "        <div class=\"input-group col-md-4\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-8\">\n" +
    "\n" +
    "          <select class=\"input-lg\"\n" +
    "            ui-select2=\"{ width: '100%' }\"\n" +
    "            ng-model=\"contact.zone\"\n" +
    "            data-placeholder=\"Select a Zone\">\n" +
    "            <option value=\"\"></option>\n" +
    "            <option\n" +
    "              ng-repeat=\"zone in contact.extras.zones\"\n" +
    "              value=\"{{ zone._id }}\"\n" +
    "              ng-selected=\"{{ contact.zone == zone._id }}\">{{ zone.name }}</option>\n" +
    "          </select>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.email\" placeholder=\"Email Address\" type=\"email\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" required=true type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- Contact Column -->\n" +
    "\n" +
    "    <!-- Meta Column -->\n" +
    "    <div class=\"col-md-3\">\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.public\"> Public <small class=\"label bg-light\">Appears on the public form</small>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\">\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.pickup\"> Pickup Location <small class=\"label bg-light\">If checked, hotel appears as a pickup location</small>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\">\n" +
    "          <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "              <input type=\"checkbox\" ng-model=\"contact.meeting\"> Meeting Location <small class=\"label bg-light\">If checked, hotel appears as a meeting location</small>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.partner\"> Billing Partner\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.hotel_confirmation\" ng-disabled=\"!contact.email\"> Send confirmation to hotel\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.hotel_commission\"> Send Commission to Hotel\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.concierge_commission\"> Send commission to concierge\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_view\"> Concierges can view all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.concierge_can_edit\"> Concierges can edit all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.marketing\"> Send Email Marketing\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <a class=\"btn btn-block btn-lg bg-info\"\n" +
    "        ng-href=\"/contact/concierge/{{contact._id}}\">Add a Concierge</a>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Meta Column -->\n" +
    "\n" +
    "    <!-- Banking Column -->\n" +
    "    <div class=\"col-md-5\" style=\"padding: 0 25px;\">\n" +
    "\n" +
    "      <div class=\"row\" ng-repeat=\"card in contact.cards\" style=\"margin-bottom: 5px;\">\n" +
    "\n" +
    "        <input type=\"text\" class=\"hide\" ng-model=\"card.id\" />\n" +
    "\n" +
    "        <div class=\"col-md-12 input-group\">\n" +
    "          <div class=\"label label-block label-lg bg-light lter\" style=\"padding: 12px;\">\n" +
    "            <label style=\"display: block;\">\n" +
    "              <input type=\"radio\" ng-model=\"card.primary\" ng-value=\"true\" name=\"isPrimary\" class=\"pull-left\" ng-change=\"setOthers($index)\">\n" +
    "              {{ card.type }} ending in {{ card.masked }}\n" +
    "              <span ng-if=\"card.status == 'valid'\" class=\"label label-success pull-right\">valid</span>\n" +
    "              <span ng-if=\"card.status == 'pending'\" class=\"label label-default pull-right\">pending</span>\n" +
    "              <span ng-if=\"card.status == 'failed'\" class=\"label label-danger pull-right\">failed</span>\n" +
    "            </label>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-top: 0;\">\n" +
    "\n" +
    "        <div class=\"col-md-8 col-xs-10 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" ng-model=\"card.number\" placeholder=\"Credit Card Number\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-2\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            style=\"text-align: center; font-size: 1.1em;\"\n" +
    "            name=\"cardExpiration\"\n" +
    "            ng-model=\"card.expiration\"\n" +
    "            ui-mask=\"99/99\"\n" +
    "            ui-validate=\"'validate.expiration($value)'\"\n" +
    "            class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-2\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            style=\"text-align: center;\"\n" +
    "            name=\"cardCVV\"\n" +
    "            ng-model=\"card.cvv\"\n" +
    "            placeholder=\"CVV\"\n" +
    "            class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-top: 10px;\">\n" +
    "\n" +
    "        <div class=\"col-md-6 col-xs-6 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Billing Address\" ng-model=\"card.billing\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-3 col-xs-6 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Zip\" ng-model=\"card.zip\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-3 col-xs-12\">\n" +
    "          <button class=\"btn bg-info lter btn-block btn-lg\" type=\"button\" ng-click=\"verifyCard()\">Add Card</button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <hr>\n" +
    "      <!-- Bank Accounts -->\n" +
    "      <div class=\"row\" ng-repeat=\"bank in contact.banks\" style=\"margin-bottom: 5px;\">\n" +
    "\n" +
    "        <input type=\"text\" class=\"hide\" ng-model=\"bank.id\" />\n" +
    "\n" +
    "        <div class=\"col-md-12 input-group\">\n" +
    "          <div class=\"label label-block label-lg bg-light lter\" style=\"padding: 12px;\">\n" +
    "            {{ bank.bank }} ending in {{ bank.masked }}\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Bank Accounts -->\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-top: 10px;\">\n" +
    "        <div class=\"col-md-12 col-xs-6 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Account Holders Name\" ng-model=\"bank.name\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-top: 10px;\">\n" +
    "\n" +
    "        <div class=\"col-md-5 col-xs-6 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Account Number\" ng-model=\"bank.account\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-4 col-xs-6 input-group\">\n" +
    "          <input type=\"text\" class=\"form-control input-lg\" placeholder=\"Routing Number\" ng-model=\"bank.routing\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-3 col-xs-12 input-group\">\n" +
    "          <button class=\"btn bg-info lter btn-block btn-lg\" type=\"button\" ng-click=\"verifyBank()\">Add ACH</button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Banking Column -->\n" +
    "  </div>\n" +
    "\n" +
    "  <hr>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"col-md-6\">\n" +
    "      <table class=\"table\">\n" +
    "        <thead>\n" +
    "          <tr>\n" +
    "            <th>Concierge Name</th>\n" +
    "            <th>Email</th>\n" +
    "            <th>Commission</th>\n" +
    "            <th> <!-- Action --> </th>\n" +
    "          </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "          <tr ng-repeat=\"concierge in contact.children\" ng-if=\"!concierge.removed\">\n" +
    "            <td class=\"point\" ui-sref=\"contactEdit({ id: concierge._id })\">{{ concierge.name }}</td>\n" +
    "            <td class=\"point\" ui-sref=\"contactEdit({ id: concierge._id })\">{{ concierge.email }}</td>\n" +
    "            <td class=\"point\" ui-sref=\"contactEdit({ id: concierge._id })\">{{ concierge.meta.commission_amount || concierge.commission }}</td>\n" +
    "            <td>\n" +
    "              <button type=\"button\" class=\"btn btn-link lt cancel\" ng-click=\"removeConfirm(concierge, 'contact')\"><i class=\"fa fa-trash-o\"></i></button>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </tbody>\n" +
    "      </table>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/hotelModal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/hotelModal",
    "<form name=\"hotelContact\">\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "    <!-- Contact Column -->\n" +
    "    <div class=\"col-md-6\">\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.name\" ng-disabled=\"$parent.booking.accommodations.other\" placeholder=\"Name\" type=\"text\" ng-required=\"!$parent.booking.accommodations.other\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" ng-disabled=\"$parent.booking.accommodations.other\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-bottom: 15px;\">\n" +
    "\n" +
    "        <div class=\"form-group col-md-4 no-pad-rt\">\n" +
    "          <input class=\"form-control input-lg\"\n" +
    "          ng-model=\"contact.address.postal\"\n" +
    "          ng-disabled=\"$parent.booking.accommodations.other\"\n" +
    "          placeholder=\"Zipcode\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-8\">\n" +
    "\n" +
    "          <select class=\"input-lg\"\n" +
    "            ui-select2=\"{ width: '100%' }\"\n" +
    "            ng-model=\"contact.zone\"\n" +
    "						ng-required=\"!$parent.booking.accommodations.other\" \n" +
    "            ng-disabled=\"$parent.booking.accommodations.other\"\n" +
    "            data-placeholder=\"Select a Zone\">\n" +
    "            <option value=\"\"></option>\n" +
    "            <option\n" +
    "              ng-repeat=\"zone in contact.extras.zones\"\n" +
    "              value=\"{{ zone._id }}\"\n" +
    "              ng-selected=\"{{ contact.zone == zone._id }}\">{{ zone.name }}</option>\n" +
    "          </select>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\"\n" +
    "          ng-model=\"contact.email\"\n" +
    "          ng-disabled=\"$parent.booking.accommodations.other\"\n" +
    "          placeholder=\"Email Address\" type=\"email\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\"\n" +
    "        ng-model=\"contact.phone\" placeholder=\"Phone Number\" ng-required=\"!$parent.booking.accommodations.other\"\n" +
    "        ng-disabled=\"$parent.booking.accommodations.other\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- Contact Column -->\n" +
    "\n" +
    "    <!-- Meta Column -->\n" +
    "    <div class=\"col-md-6\">\n" +
    "      <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "            ng-model=\"contact.meta.hotel_confirmation\"\n" +
    "            ng-disabled=\"!contact.email\"> Send confirmation to hotel\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "              ng-model=\"contact.meta.hotel_commission\"\n" +
    "              ng-disabled=\"$parent.booking.accommodations.other\"> Send Commission to Hotel\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "              ng-model=\"contact.meta.concierge_commission\"\n" +
    "              ng-disabled=\"$parent.booking.accommodations.other\"> Send commission to concierge\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "              ng-model=\"contact.meta.concierge_can_view\"\n" +
    "              ng-disabled=\"$parent.booking.accommodations.other\"> Concierges can view all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "              ng-model=\"contact.meta.concierge_can_edit\"\n" +
    "              ng-disabled=\"$parent.booking.accommodations.other\"> Concierges can edit all hotel's bookings\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\"\n" +
    "              ng-model=\"contact.meta.marketing\"\n" +
    "              ng-disabled=\"$parent.booking.accommodations.other\"> Send Email Marketing\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Meta Column -->\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/partner", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/partner",
    "<header class=\"day clearfix\">\n" +
    "\n" +
    "  <h2 class=\"pull-left noselect\" style=\"margin-bottom: 20px;\">Contact: <small style=\"text-transform: capitalize;\">{{ contact.meta.type }}</small></h2>\n" +
    "\n" +
    "  <button class=\"btn btn-lg pull-right bg-success\" type=\"button\" style=\"margin-top: 10px;\" ng-click=\"save(contact)\" ng-disabled=\"!PartnerForm.$valid\">\n" +
    "    <span ng-if=\"!contact.saving\">\n" +
    "      <span ng-if=\"contact.isNew\">Save</span>\n" +
    "      <span ng-if=\"!contact.isNew\">Update</span>\n" +
    "    </span>\n" +
    "    <span ng-if=\"contact.saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#fff',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "\n" +
    "  </button>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<form action=\"\" name=\"PartnerForm\">\n" +
    "    <!-- Contact Column -->\n" +
    "    <div class=\"col-md-8\">\n" +
    "\n" +
    "      <div class=\"form-group col-md-6\" style=\"padding-left: 0;\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"input-group form-group col-md-6\" style=\"padding-right: 0;\">\n" +
    "\n" +
    "        <select tabindex=\"10\" class=\"input-lg\" ui-select2=\"{ width: '100%', allowClear: true }\"\n" +
    "          ng-model=\"contact.meta.package\" data-placeholder=\"Package\">\n" +
    "          <option value=\"\"></option>\n" +
    "          <option\n" +
    "            value=\"{{ package._id }}\"\n" +
    "            ng-repeat=\"package in contact.extras.packages\"\n" +
    "            ng-selected=\"contact.meta.package == package._id\">{{ package.name }}</option>\n" +
    "        </select>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"padding: 0 10px;\">\n" +
    "\n" +
    "        <div class=\"form-group col-md-8\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"contact.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"input-group col-md-4\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-6\" style=\"padding-left: 0;\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.email\" ng-required=\"contact.meta.confirmation\" placeholder=\"Email Address\" type=\"email\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-6\" style=\"padding-right: 0;\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- Contact Column -->\n" +
    "\n" +
    "    <!-- Meta Column -->\n" +
    "    <div class=\"col-md-3\">\n" +
    "      <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.partner\"> Billing Partner\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.agent\"> Travel Agent\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"contact.meta.confirmation\"> Send confirmation emails\n" +
    "            </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"contact.meta.commissions\"> Accepts Commissions\n" +
    "            </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"checkbox\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"contact.meta.not_pilot_commission_eligible\"> Not Pilot Commission Eligible\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group pull-right col-md-3\" style=\"margin-top: -35px;\" ng-show=\"contact.meta.commissions\">\n" +
    "            <input class=\"form-control input-sm\" ng-model=\"contact.meta.commission_amount\" placeholder=\"Amount\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Meta Column -->\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/forms/travelAgentModal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/forms/travelAgentModal",
    "<form action=\"\" name=\"ConciergeForm\">\n" +
    "\n" +
    "    <div class=\"row\" ng-init=\"contact.parentId = undefined; contact.meta = {}; contact.meta.type = 'partner'; contact.meta.agent = true\">\n" +
    "\n" +
    "        <!-- Contact Column -->\n" +
    "        <div class=\"col-md-6\">\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\"\n" +
    "                  ng-model=\"contact.email\"\n" +
    "                  placeholder=\"Email\"\n" +
    "                  type=\"email\" ng-required=\"contact.meta.confirmation\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" style=\"\">\n" +
    "\n" +
    "                <div class=\"form-group col-md-8\">\n" +
    "                    <input class=\"form-control input-lg\" ng-model=\"contact.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-group col-md-4 no-pad-lft\">\n" +
    "                    <input class=\"form-control input-lg\" ng-model=\"contact.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <input class=\"form-control input-lg\" ng-model=\"contact.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- Contact Column -->\n" +
    "\n" +
    "        <!-- Meta Column -->\n" +
    "        <div class=\"col-md-6\">\n" +
    "\n" +
    "            <div class=\"well\" style=\"padding: 5px 15px;\">\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.partner\" />\n" +
    "                        Billing Partner\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.confirmation\"> Send confirmation emails\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input type=\"checkbox\" ng-model=\"contact.meta.commissions\" />\n" +
    "                        Accepts Commissions\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-group pull-right col-md-4 no-pad-rt\"\n" +
    "                    style=\"margin-top: -35px;\"\n" +
    "                    ng-show=\"contact.meta.commissions\">\n" +
    "                    <input class=\"form-control input-sm\" ng-model=\"contact.meta.commission_amount\" placeholder=\"Amount\" type=\"text\" />\n" +
    "                </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- Meta Column -->\n" +
    "    </div>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/contacts/hotels", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/hotels",
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <button type=\"button\" ng-disabled=\"state.page == 1\" ui-sref=\"contacts({ tab: state.tab, page: (state.page - 1)})\" class=\"btn bg-light lt\">Previous Page</button>\n" +
    "  \n" +
    "  <div class=\"btn-group\">\n" +
    "    <button\n" +
    "      type=\"button\"\n" +
    "      class=\"btn bg-light lt\"\n" +
    "      ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: page})\"\n" +
    "      ng-disabled=\"state.page == page\"\n" +
    "      ng-repeat=\"(page, count) in pages\"\n" +
    "      tooltip=\"{{count}}\">{{ page }}</button>\n" +
    "  </div>\n" +
    "  <button type=\"button\" ng-disabled=\"!pages[state.page + 1]\" ui-sref=\"contacts({ tab: state.tab, page: (state.page + 1)})\" class=\"btn bg-light lt\">Next Page</button>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <div class=\"col-md-12\">\n" +
    "    \n" +
    "    <div class=\"btn-group btn-group-xs\">\n" +
    "      <button type=\"button\" \n" +
    "        ng-disabled=\"state.filter === 'all'\" ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: 1 })\" \n" +
    "        class=\"btn btn-xs bg-light lt\"\n" +
    "        ng-class=\"{\n" +
    "          'bg-light': state.filter !== 'all',\n" +
    "          'bg-info': state.filter === 'all'\n" +
    "        }\">\n" +
    "        All\n" +
    "      </button>\n" +
    "      <button\n" +
    "        type=\"button\"\n" +
    "        class=\"btn btn-xs lt\"\n" +
    "        ng-class=\"{ \n" +
    "          'bg-light' : state.filter !== page || (state.filter !== 'numbers' && page !== '0-9'), \n" +
    "          'bg-info':  state.filter === page || (state.filter === 'numbers' && page === '0-9')\n" +
    "        }\"\n" +
    "        ui-sref=\"contacts({ tab: state.tab, filter: page === '0-9' ? 'numbers' : page, page: '1'})\"\n" +
    "        ng-repeat=\"(page, count) in alphabetize\"\n" +
    "        ng-disabled=\"count === 0 || state.filter === page\"\n" +
    "        tooltip=\"{{count}}\"\n" +
    "        tooltip-append-to-body=\"true\"\n" +
    "        style=\"text-transform: uppercase\">\n" +
    "          {{ page }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<table class=\"contacts table table-body-hover half-fade\" ng-class=\"{ 'in': !contactsWorking, 'out': contactsWorking }\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th style=\"width: 42px;\"></th>\n" +
    "      <th><input type=\"text\" ng-model=\"hotelsearch.$\" placeholder=\"Hotel Name\"></th>\n" +
    "      <th>Zone</th>\n" +
    "      <th>Phone</th>\n" +
    "      <th></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody ng-repeat=\"contact in contacts | orderBy:'name' | filter:hotelsearch\" ng-hide=\"contact.removed || !contact._id\">\n" +
    "\n" +
    "    <tr>\n" +
    "      <td ng-click=\"contact.showChildren = !contact.showChildren\">\n" +
    "        <i style=\"font-size: 0.8em; color: #aaa\" ng-if=\"!contact.showChildren\" class=\"fa fa-plus\"></i>\n" +
    "        <i style=\"font-size: 0.8em; color: #aaa\" ng-if=\"contact.showChildren\" class=\"fa fa-minus\"></i>\n" +
    "      </td>\n" +
    "      <td ng-click=\"contact.showChildren = !contact.showChildren\">\n" +
    "        <span style=\"margin-right: 20px;\">{{ contact.name }}</span>\n" +
    "        <span class=\"label bg-success\" ng-if=\"contact.meta.partner\">billable</span>\n" +
    "        <span class=\"label bg-info\" ng-if=\"contact.public\">public</span>\n" +
    "        <span class=\"label bg-light\" ng-if=\"contact.pickup\">pickup</span>\n" +
    "      </td>\n" +
    "      <td ng-click=\"contact.showChildren = !contact.showChildren\">{{ contact.zone.zone }}</td>\n" +
    "      <td ng-click=\"contact.showChildren = !contact.showChildren\">{{ contact.phone | phone }}</td>\n" +
    "      <td>\n" +
    "        <div class=\"pull-right\">\n" +
    "          <button class=\"btn btn-link lt cancel\" ng-click=\"removeConfirm(contact, 'contact')\"><i class=\"fa fa-times\"></i></button>\n" +
    "          <button class=\"btn btn-link lt instructions\" type=\"button\" ui-sref=\"contactEdit({ id: contact._id })\"><i class=\"fa fa-pencil-square-o\"></i></button>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "\n" +
    "    <tr ng-show=\"contact.showChildren\">\n" +
    "      <td colspan=\"5\" style=\"padding: 0;\">\n" +
    "        <table class=\"table table-condensed table-hover\" style=\"margin-bottom: 0;\">\n" +
    "          <tbody>\n" +
    "            <tr class=\"point\" ng-repeat=\"concierge in contact.children\" ui-sref=\"contactEdit({ id: concierge._id })\">\n" +
    "              <td colspan=\"2\">{{ concierge.name }}</td>\n" +
    "              <td colspan=\"2\">{{ concierge.email }}</td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "\n" +
    "  </tbody>\n" +
    "\n" +
    "</table>\n" +
    "");
}]);

angular.module("views/contacts/partners", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/partners",
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <button type=\"button\" ng-disabled=\"state.page == 1\" ui-sref=\"contacts({ tab: state.tab, page: (state.page - 1)})\" class=\"btn bg-light lt\">Previous Page</button>\n" +
    "  \n" +
    "  <div class=\"btn-group\">\n" +
    "    <button\n" +
    "      type=\"button\"\n" +
    "      class=\"btn bg-light lt\"\n" +
    "      ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: page})\"\n" +
    "      ng-disabled=\"state.page == page\"\n" +
    "      ng-repeat=\"(page, count) in pages\"\n" +
    "      tooltip=\"{{count}}\">{{ page }}</button>\n" +
    "  </div>\n" +
    "  <button type=\"button\" ng-disabled=\"!pages[state.page + 1]\" ui-sref=\"contacts({ tab: state.tab, page: (state.page + 1)})\" class=\"btn bg-light lt\">Next Page</button>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row text-center\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "  <div class=\"col-md-12\">\n" +
    "    \n" +
    "    <div class=\"btn-group btn-group-xs\">\n" +
    "      <button type=\"button\" \n" +
    "        ng-disabled=\"state.filter === 'all'\" ui-sref=\"contacts({ tab: state.tab, filter: 'all', page: 1 })\" \n" +
    "        class=\"btn btn-xs bg-light lt\"\n" +
    "        ng-class=\"{\n" +
    "          'bg-light': state.filter !== 'all',\n" +
    "          'bg-info': state.filter === 'all'\n" +
    "        }\">\n" +
    "        All\n" +
    "      </button>\n" +
    "      <button\n" +
    "        type=\"button\"\n" +
    "        class=\"btn btn-xs lt\"\n" +
    "        ng-class=\"{ \n" +
    "          'bg-light' : state.filter !== page || (state.filter !== 'numbers' && page !== '0-9'), \n" +
    "          'bg-info':  state.filter === page || (state.filter === 'numbers' && page === '0-9')\n" +
    "        }\"\n" +
    "        ui-sref=\"contacts({ tab: state.tab, filter: page === '0-9' ? 'numbers' : page, page: '1'})\"\n" +
    "        ng-repeat=\"(page, count) in alphabetize\"\n" +
    "        ng-disabled=\"count === 0 || state.filter === page\"\n" +
    "        tooltip=\"{{count}}\"\n" +
    "        tooltip-append-to-body=\"true\"\n" +
    "        style=\"text-transform: uppercase\">\n" +
    "          {{ page }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "<table class=\"contacts table table-hover half-fade\" ng-class=\"{ 'in': !contactsWorking, 'out': contactsWorking }\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><input type=\"text\" ng-model=\"search.$\" placeholder=\"Partner Name\"></th>\n" +
    "      <th>Package</th>\n" +
    "      <th>Phone</th>\n" +
    "      <th></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "\n" +
    "    <tr ng-repeat=\"contact in contacts | orderBy:'name' | filter:search\" ng-hide=\"contact.removed\" ng-if=\"contact._id\" class=\"animated slideInRight\">\n" +
    "      <td ui-sref=\"contactEdit({ id: contact._id })\">{{ contact.name }}<span class=\"label bg-success\" ng-if=\"contact.meta.partner\" style=\"margin-left: 20px;\">billable</span></td>\n" +
    "      <td ui-sref=\"contactEdit({ id: contact._id })\">{{ contact.meta.package.name }}</td>\n" +
    "      <td ui-sref=\"contactEdit({ id: contact._id })\">{{ contact.phone }}</td>\n" +
    "      <td><button class=\"btn btn-link lt pull-right\" ng-click=\"removeConfirm(contact, 'contact')\"><i class=\"fa fa-times\"></i></button></td>\n" +
    "    </tr>\n" +
    "\n" +
    "  </tbody>\n" +
    "\n" +
    "</table>\n" +
    "");
}]);

angular.module("views/contacts/verify", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/contacts/verify",
    "<section id=\"content\" class=\"m-t-lg wrapper-md\">\n" +
    "\n" +
    "  <div class=\"row m-n\">\n" +
    "    <div class=\"col-md-3 m-t-lg\" style=\"position: absolute; left: 50%; margin-left: -14%; margin-top: 10%\">\n" +
    "      <section>\n" +
    "\n" +
    "        <header class=\"\" style=\"margin-bottom: 20px;\" ng-if=\"state.action == 'verify'\">\n" +
    "          <h2 style=\"text-transform: none;\">Create Password</h2>\n" +
    "          <div class=\"alert-info\" style=\"padding: 10px\">\n" +
    "            <p>Hi there <strong>{{ contact.name }}</strong>, you've been invited to use the RezFlow system!</p>\n" +
    "            <p>Please provide a password below to get rolling.</p>\n" +
    "          </div>\n" +
    "        </header>\n" +
    "      \n" +
    "        <header class=\"\" style=\"margin-bottom: 20px;\" ng-if=\"state.action == 'reset'\">\n" +
    "          <h2 style=\"text-transform: none;\">Reset Password</h2>\n" +
    "          <div class=\"alert-info\" style=\"padding: 10px\">\n" +
    "            <p>Hi there <strong>{{ contact.name }}</strong>, fill out your new password below!</p>\n" +
    "          </div>\n" +
    "        </header>\n" +
    "      \n" +
    "        <form id=\"verifyUser\" name=\"verifyUser\" class=\"\">\n" +
    "          <div class=\"form-group\" ng-class=\"{ 'has-error' : verifyUser.passConf.$touched && verifyUser.passConf.$invalid }\">\n" +
    "\n" +
    "            <input type=\"password\"\n" +
    "              ng-model=\"user.password\" \n" +
    "              placeholder=\"Password\" \n" +
    "              class=\"form-control input-lg\" required>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\" ng-class=\"{ 'has-error' : verifyUser.passConf.$touched && verifyUser.passConf.$invalid }\">\n" +
    "\n" +
    "            <input type=\"password\"\n" +
    "              ui-validate=\"'$value==user.password'\"\n" +
    "              ui-validate-watch=\"'user.password'\"\n" +
    "              ng-model=\"user.password_confirm\" \n" +
    "              ng-model-options=\"{ 'debounce': 250 }\"\n" +
    "              id=\"inputPassword\" \n" +
    "              name=\"passConf\"\n" +
    "              placeholder=\"Password Again\"\n" +
    "              class=\"form-control input-lg\" required>\n" +
    "\n" +
    "              <span ng-if=\"verifyUser.passConf.$touched && verifyUser.passConf.$invalid\" class=\"help-block\">Passwords do not match, try again.</span>\n" +
    "\n" +
    "          </div>\n" +
    "          \n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "              <button type=\"submit\" class=\"btn bg-info dker btn-lg\" ng-disabled=\"verifyUser.$invalid\" ng-click=\"setPass(user)\">\n" +
    "                <span ng-if=\"state.action == 'verify'\">Verify</span>\n" +
    "                <span ng-if=\"state.action == 'reset'\">Reset Password</span>\n" +
    "              </button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </form> \n" +
    "      </section>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("views/day/balloons", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/day/balloons",
    "<div class=\"row\">\n" +
    "\n" +
    "  <div class=\"col-md-12\">\n" +
    "\n" +
    "    <form name=\"newBalloon\" style=\"margin-top: 50px; overflow: hidden;\">\n" +
    "\n" +
    "      <div style=\"margin-bottom: 10px; padding: 0 10px 0 0; overflow:hidden;\">\n" +
    "          <!-- Hospitality Selection -->\n" +
    "        <div class=\"col-md-3 col-sm-3 no-pad-lft\">\n" +
    "\n" +
    "          <div class=\"input-group\" style=\"width: 100%\">\n" +
    "            <select class=\"input\"\n" +
    "              ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"event.setHospitality\"\n" +
    "              data-placeholder=\"Select Hospitality\">\n" +
    "              <option value=\"\"></option>\n" +
    "              <option\n" +
    "                ng-repeat=\"option in hospitality\"\n" +
    "                ng-if=\"notSelected(option._id)\"\n" +
    "                value=\"{{ option }}\">{{ option.name }}</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-3 col-sm-3 no-pad-lft\" ng-repeat=\"_hosp in event.hospitality\">\n" +
    "          <div class=\"input-group\" style=\"\">\n" +
    "\n" +
    "            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"_hosp._id\"\n" +
    "              data-placeholder=\"Select Hospitality\">\n" +
    "              <option value=\"\"></option>\n" +
    "              <option\n" +
    "                ng-repeat=\"option in hospitality\"\n" +
    "                ng-if=\"notSelected(option._id, _hosp)\"\n" +
    "                value=\"{{ option._id }}\"\n" +
    "                ng-selected=\"{{ _hosp._id == option._id }}\">{{ option.name }}</option>\n" +
    "            </select>\n" +
    "\n" +
    "            <div class=\"input-group-btn\">\n" +
    "              <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"removeHospitality(_hosp)\"><i class=\"fa fa-times\"></i></button>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <button type=\"button\" class=\"btn bg-success lt pull-left col-sm-3\" ng-click=\"update()\">\n" +
    "          <span ng-if=\"!event.updating\">Update Hospitality</span>\n" +
    "          <span ng-if=\"event.updating\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "            lines: 17,\n" +
    "            length: 0,\n" +
    "            width: 4,\n" +
    "            radius: 4,\n" +
    "            corners: 1,\n" +
    "            rotate: 0,\n" +
    "            direction: 1,\n" +
    "            color: '#fff',\n" +
    "            speed: 1.2,\n" +
    "            trail: 36,\n" +
    "            shadow: false,\n" +
    "            hwaccel: false,\n" +
    "            className: 'spinner',\n" +
    "            zIndex: 2e9,\n" +
    "            top: '-5px',\n" +
    "            left: 'auto'\n" +
    "          }\"></span>\n" +
    "\n" +
    "        </button>\n" +
    "        <!-- !Hospitality Selection -->\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        {{ colCount = event.capacity.total_weight > 0 ? 7 : 6;\"\" }}\n" +
    "        <div class=\"col-md-12\" style=\"position: relative;\">\n" +
    "          <table class=\"table balloon\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th class=\"col-md-1\" style=\"text-align: center;\">\n" +
    "                  # <span class=\"hidden-sm\"> Guests</span>\n" +
    "                </th>\n" +
    "                <th ng-if=\"event.capacity.total_weight > 0\">Weight</th>\n" +
    "                <th class=\"col-md-2\" style=\"min-width: 100px;\">Balloon</th>\n" +
    "                <th class=\"col-md-2\" style=\"min-width: 100px;\">Pilot</th>\n" +
    "                <th class=\"col-md-3\" style=\"min-width: 100px;\">Crew</th>\n" +
    "                <th class=\"col-md-3\" style=\"min-width: 100px;\">Drivers</th>\n" +
    "                <th class=\"col-md-1\"></th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody ng-repeat=\"balloon in flights\">\n" +
    "\n" +
    "              <tr class=\"assignment\">\n" +
    "                <td\n" +
    "                  ng-click=\"balloon.edit_guests = (balloon.guests > 0) ? !balloon.edit_guests : false; balloon.edit_crew = false;\"\n" +
    "                  style=\"text-align: center\"\n" +
    "                  class=\"guestCount\"\n" +
    "                  ng-class=\"{ 'expanded' : balloon.edit_guests }\">\n" +
    "                  <span class=\"nowrap\">\n" +
    "                    {{ balloon.guests || 0 }} / {{ balloon.balloon.capacity }}\n" +
    "                  </span>\n" +
    "                </td>\n" +
    "                <!-- Weights -->\n" +
    "                <td ng-if=\"event.capacity.total_weight > 0\" ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-click=\"balloon.edit_crew = !balloon.edit_crew; balloon.edit_guests = false;\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\" class=\"text-center\">\n" +
    "                  {{ totalWeight(balloon) || 0 }}\n" +
    "                </td>\n" +
    "                <td ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-click=\"balloon.edit_crew = !balloon.edit_crew; balloon.edit_guests = false;\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\">{{ balloon.balloon.name }}</td>\n" +
    "                <td ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-click=\"balloon.edit_crew = !balloon.edit_crew; balloon.edit_guests = false;\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\">{{ balloon.pilot.name }}</td>\n" +
    "                <td ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-click=\"balloon.edit_crew = !balloon.edit_crew; balloon.edit_guests = false;\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\">\n" +
    "                  <div ng-repeat=\"chaser in balloon.crew.chasers\" style=\"display: inline-block;\">\n" +
    "                    {{ chaser.name }}<span ng-if=\"!$last\" style=\"white-space: pre-wrap;\">, </span>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-click=\"balloon.edit_crew = !balloon.edit_crew; balloon.edit_guests = false;\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\">\n" +
    "                  <div ng-repeat=\"driver in balloon.crew.drivers\" style=\"display: inline-block;\">\n" +
    "                    {{ driver.name }}<span ng-if=\"!$last\" style=\"white-space: pre-wrap;\">, </span>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td ui-event=\"{ 'mouseover' : 'balloon.hilite = true && !balloon.edit_crew', 'mouseout' : 'balloon.hilite = false' }\" ng-class=\"{ 'expanded' : balloon.edit_crew, 'active' : balloon.hilite }\">\n" +
    "\n" +
    "                  <button\n" +
    "                    class=\"btn btn-link pull-right ng-scope btn-lg\"\n" +
    "                    ng-click=\"flight.remove(balloon._id)\"\n" +
    "                    tooltip=\"Remove {{ balloon.balloon.name }}.\">\n" +
    "                      <i class=\"fa fa-trash-o\"></i>\n" +
    "                  </button>\n" +
    "\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "\n" +
    "              <tr ng-if=\"balloon.edit_crew || balloon.edit_guests\" class=\"edit\">\n" +
    "                <td ng-attr-colspan=\"{{ colCount }}\" class=\"\">\n" +
    "\n" +
    "                  <div class=\"row\" style=\"margin: 0; padding: 5px; overflow: visible;\">\n" +
    "\n" +
    "                    <div ng-if=\"balloon.edit_guests\">\n" +
    "\n" +
    "                      <div ng-repeat=\"booking in balloon.reservations\" class=\"col-md-4 col-sm-4\" style=\"margin-bottom: 2px; padding: 10px;\">\n" +
    "                        <strong style=\"padding: auto 10px;\">{{ bookingFlight(booking, balloon._id).count || 0 }}</strong>\n" +
    "                        {{ booking.last_name }}, {{ booking.first_name }}\n" +
    "                        <button type=\"button\" class=\"btn btn-light btn-xs\" ng-click=\"unassign(booking, balloon)\"><i class=\"fa fa-times\"></i></button>\n" +
    "                      </div>\n" +
    "\n" +
    "                    </div>\n" +
    "\n" +
    "                    <!-- Crew Assignment -->\n" +
    "                    <div ng-if=\"balloon.edit_crew\" style=\"position: relative;\">\n" +
    "\n" +
    "                      <ng-form name=\"updateBalloon\">\n" +
    "\n" +
    "                        <span ng-show=\"updateBalloon.$dirty\" class=\"text-white pull-right\" style=\"font-size: 0.7em; margin-top: -22px\">Make sure you hit the update button to save your changes to this flight.</span>\n" +
    "\n" +
    "                        <!-- Balloon -->\n" +
    "                        <div class=\"col-md-3 col-sm-3\" ng-init=\"balloon.balloon.origId = balloon.balloon._id\">\n" +
    "\n" +
    "                          <div class=\"input-group\" style=\"width: 100%\">\n" +
    "\n" +
    "                            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                              ng-model=\"balloon.balloon._id\"\n" +
    "                              ng-change=\"change(balloon, balloons, 'balloon')\"\n" +
    "                              ng-required=\"true\"\n" +
    "                              data-placeholder=\"Select Balloon\"\n" +
    "                              name=\"balloon\">\n" +
    "\n" +
    "                              <option value=\"\"></option>\n" +
    "                              <option\n" +
    "                                ng-repeat=\"option in balloons\"\n" +
    "                                ng-if=\"notSelected(option._id, balloon.balloon._id) && option.capacity >= balloon.guests\"\n" +
    "                                value=\"{{ option._id }}\"\n" +
    "                                ng-selected=\"{{ balloon.balloon._id == option._id }}\">{{ option.name }}</option>\n" +
    "\n" +
    "                            </select>\n" +
    "\n" +
    "                            <div class=\"input-group-btn\">\n" +
    "                              <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"balloon.balloon = null\"><i class=\"fa fa-times\"></i></button>\n" +
    "                            </div>\n" +
    "\n" +
    "                          </div>\n" +
    "\n" +
    "\n" +
    "                        </div>\n" +
    "                        <!-- !Balloon -->\n" +
    "\n" +
    "                        <!-- Pilot -->\n" +
    "                        <div class=\"col-md-3 col-sm-3 no-pad-lft\" ng-init=\"balloon.pilot.origId = balloon.pilot._id\">\n" +
    "\n" +
    "                          <div class=\"input-group\" style=\"width: 100%\">\n" +
    "\n" +
    "                            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                              ng-model=\"balloon.pilot._id\"\n" +
    "                              ng-change=\"change(balloon, pilots, 'pilot')\"\n" +
    "                              ng-required=\"true\"\n" +
    "                              data-placeholder=\"Select Pilot\"\n" +
    "                              name=\"Pilot\">\n" +
    "\n" +
    "                              <option value=\"\"></option>\n" +
    "                              <option\n" +
    "                                ng-repeat=\"option in pilots\"\n" +
    "                                ng-if=\"notSelected(option._id, balloon.pilot._id)\"\n" +
    "                                value=\"{{ option._id }}\"\n" +
    "                                ng-selected=\"{{ balloon.pilot._id == option._id }}\">{{ option.name }}</option>\n" +
    "\n" +
    "                            </select>\n" +
    "\n" +
    "                            <div class=\"input-group-btn\">\n" +
    "                              <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"balloon.pilot = null\"><i class=\"fa fa-times\"></i></button>\n" +
    "                            </div>\n" +
    "\n" +
    "                          </div>\n" +
    "\n" +
    "\n" +
    "                        </div>\n" +
    "\n" +
    "\n" +
    "                        <!-- !Pilot -->\n" +
    "\n" +
    "                        <!-- Crew -->\n" +
    "                        <div class=\"col-md-3 col-sm-3 no-pad-lft\">\n" +
    "\n" +
    "                          <!-- Add a new crew member to existing crew -->\n" +
    "                          <div class=\"input-group\" style=\"width: 100%; margin-bottom: 5px;\">\n" +
    "\n" +
    "                            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                              ng-model=\"balloon.chaser\" ng-click=\"addCrew(balloon)\"\n" +
    "                              data-placeholder=\"Add a Crew Member\">\n" +
    "\n" +
    "                              <option value=\"\"></option>\n" +
    "                              <option\n" +
    "                                ng-repeat=\"chaser in chasers\"\n" +
    "                                ng-if=\"notSelected(chaser._id)\"\n" +
    "                                value=\"{{ chaser._id }}\"\n" +
    "                                ng-selected=\"{{ flight.chaser == chaser._id }}\">{{ chaser.name }}</option>\n" +
    "\n" +
    "                            </select>\n" +
    "\n" +
    "                          </div>\n" +
    "\n" +
    "                          <div class=\"\" ng-repeat=\"chaser in balloon.crew.chasers\"\n" +
    "                            ng-init=\"chaser.origId = chaser._id\" style=\"margin-bottom: 5px;\">\n" +
    "\n" +
    "                            <div class=\"input-group\" style=\"width: 100%\">\n" +
    "\n" +
    "                              <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                                ng-model=\"chaser._id\"\n" +
    "                                ng-change=\"change(balloon, chasers, 'crew.chasers', $index)\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                data-placeholder=\"Select Crew\">\n" +
    "\n" +
    "                                <option value=\"\"></option>\n" +
    "                                <option\n" +
    "                                  ng-repeat=\"option in chasers\"\n" +
    "                                  ng-if=\"notSelected(option._id, chaser._id)\"\n" +
    "                                  value=\"{{ option._id }}\"\n" +
    "                                  ng-selected=\"{{ chaser._id == option._id }}\">{{ option.name }}</option>\n" +
    "\n" +
    "                              </select>\n" +
    "\n" +
    "                              <div class=\"input-group-btn\">\n" +
    "                                <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"removeCrew(balloon, $index)\"><i class=\"fa fa-times\"></i></button>\n" +
    "                              </div>\n" +
    "\n" +
    "                            </div>\n" +
    "\n" +
    "                          </div>\n" +
    "                        </div>\n" +
    "                        <!-- !Crew -->\n" +
    "\n" +
    "                        <!-- Driver -->\n" +
    "                        <div class=\"col-md-3 col-sm-3 no-pad-lft\">\n" +
    "\n" +
    "                          <!-- Add a new driver to existing drivers -->\n" +
    "                          <div class=\"input-group\" style=\"width: 100%; margin-bottom: 5px;\">\n" +
    "\n" +
    "                            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                              ng-model=\"balloon.driver\" ng-click=\"addDriver(balloon)\"\n" +
    "                              data-placeholder=\"Add a Driver\">\n" +
    "\n" +
    "                              <option value=\"\"></option>\n" +
    "                              <option\n" +
    "                                ng-repeat=\"driver in drivers\"\n" +
    "                                ng-if=\"notSelected(driver._id)\"\n" +
    "                                value=\"{{ driver._id }}\"\n" +
    "                                ng-selected=\"{{ flight.driver == driver._id }}\">{{ driver.name }}</option>\n" +
    "\n" +
    "                            </select>\n" +
    "\n" +
    "                          </div>\n" +
    "\n" +
    "                          <div class=\"\" ng-repeat=\"driver in balloon.crew.drivers\"\n" +
    "                            ng-init=\"driver.origId = driver._id\" style=\"margin-bottom: 5px;\">\n" +
    "\n" +
    "                            <div class=\"input-group\" style=\"width: 100%\">\n" +
    "\n" +
    "                              <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                                ng-model=\"driver._id\"\n" +
    "                                ng-change=\"change(balloon, drivers, 'crew.drivers', $index)\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                data-placeholder=\"Select Crew\">\n" +
    "\n" +
    "                                <option value=\"\"></option>\n" +
    "                                <option\n" +
    "                                  ng-repeat=\"option in drivers\"\n" +
    "                                  ng-if=\"notSelected(option._id, driver._id)\"\n" +
    "                                  value=\"{{ option._id }}\"\n" +
    "                                  ng-selected=\"{{ driver._id == option._id }}\">{{ option.name }}</option>\n" +
    "\n" +
    "                              </select>\n" +
    "\n" +
    "                              <div class=\"input-group-btn\">\n" +
    "                                <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"removeDriver(balloon, $index)\"><i class=\"fa fa-times\"></i></button>\n" +
    "                              </div>\n" +
    "\n" +
    "                            </div>\n" +
    "\n" +
    "                          </div>\n" +
    "                        </div>\n" +
    "                        <!-- !Driver -->\n" +
    "\n" +
    "                        <div ng-show=\"updateBalloon.$dirty\" class=\"col-md-2 tabs\" style=\"position: absolute; top: -108px; z-index: 1; right: 0px; padding: 0;\">\n" +
    "                          <button\n" +
    "                            class=\"btn btn-success btn-block\"\n" +
    "                            type=\"button\"\n" +
    "                            ng-click=\"updateFlight(balloon)\">\n" +
    "                            <i class=\"fa fa-plus\"></i> Update Flight\n" +
    "                          </button>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div ng-init=\"setForm(updateBalloon)\"></div>\n" +
    "\n" +
    "                      </ng-form>\n" +
    "\n" +
    "                    </div>\n" +
    "                    <!-- #Crew Assignment -->\n" +
    "\n" +
    "\n" +
    "                  </div>\n" +
    "\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "\n" +
    "            </tbody>\n" +
    "            <!-- #Balloon Form -->\n" +
    "            <tfoot>\n" +
    "              <tr class=\"bg-light\" ng-show=\"flight.showNew\">\n" +
    "                <td class=\"text-center\"><span class=\"nowrap\">--</span></td>\n" +
    "                <td style=\"vertical-align: top !important;\">\n" +
    "                  <div class=\"input-group\" style=\"width: 100%\">\n" +
    "                    <select class=\"input\" name=\"balloon\" ui-select2=\"{ width: '100%' }\" ng-model=\"flight.balloon\" ng-required=\"true\" data-placeholder=\"Select Balloon\" name=\"balloon\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"balloon in balloons\"\n" +
    "                        ng-if=\"notSelected(balloon._id, flight.balloon)\"\n" +
    "                        value=\"{{ balloon._id }}\"\n" +
    "                        ng-selected=\"{{ flight.balloon == balloon._id }}\">{{ balloon.name }}</option>\n" +
    "                    </select>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td style=\"vertical-align: top !important;\">\n" +
    "                  <div class=\"input-group\" style=\"width: 100%\">\n" +
    "                    <select class=\"input\" name=\"pilot\" ui-select2=\"{ width: '100%' }\" ng-model=\"flight.pilot\" data-placeholder=\"Select Pilot\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"pilot in pilots\"\n" +
    "                        ng-if=\"notSelected(pilot._id, flight.pilot)\"\n" +
    "                        value=\"{{ pilot._id }}\"\n" +
    "                        ng-selected=\"{{ flight.pilot == pilot._id }}\">{{ pilot.name }}</option>\n" +
    "                    </select>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td style=\"vertical-align: top !important;\">\n" +
    "\n" +
    "                  <!-- Chase Selection -->\n" +
    "                  <div class=\"input-group\" style=\"width: 100%\">\n" +
    "                    <select class=\"input\" ui-select2=\"{ width: '100%' }\" name=\"addChaser\" ng-model=\"flight.chaser\" data-placeholder=\"Select Chaser\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"chaser in chasers\"\n" +
    "                        ng-if=\"notSelected(chaser._id)\"\n" +
    "                        value=\"{{ chaser._id }}\"\n" +
    "                        ng-selected=\"{{ flight.chaser == chaser._id }}\">{{ chaser.name }}</option>\n" +
    "                    </select>\n" +
    "                  </div>\n" +
    "\n" +
    "                  <div class=\"input-group\" style=\"margin-top: 5px;\" ng-repeat=\"_chaser in flight.crew.chasers\">\n" +
    "\n" +
    "                    <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                      name=\"chaser[{{$index}}]\"\n" +
    "                      ng-model=\"flight.crew.chasers[$index]\"\n" +
    "                      data-placeholder=\"Select Chaser\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"chaser in chasers\"\n" +
    "                        ng-if=\"notSelected(chaser._id, _chaser)\"\n" +
    "                        value=\"{{ chaser._id }}\"\n" +
    "                        ng-selected=\"{{ flight.crew.chasers[$index] == chaser._id }}\">{{ chaser.name }}</option>\n" +
    "                    </select>\n" +
    "\n" +
    "                    <div class=\"input-group-btn\">\n" +
    "                      <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"flight.crew.remove('chasers', _chaser)\"><i class=\"fa fa-times\"></i></button>\n" +
    "                    </div>\n" +
    "\n" +
    "                  </div>\n" +
    "                  <!-- !Chase Selection -->\n" +
    "\n" +
    "\n" +
    "                </td>\n" +
    "                <td style=\"vertical-align: top !important;\">\n" +
    "\n" +
    "                  <!-- Driver Selection -->\n" +
    "                  <div class=\"input-group\" style=\"width: 100%\">\n" +
    "                    <select class=\"input\" name=\"addDriver\" ui-select2=\"{ width: '100%' }\" ng-model=\"flight.driver\" data-placeholder=\"Select Driver\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"driver in drivers\"\n" +
    "                        ng-if=\"notSelected(driver._id)\"\n" +
    "                        value=\"{{ driver._id }}\"\n" +
    "                        ng-selected=\"{{ flight.driver == driver._id }}\">{{ driver.name }}</option>\n" +
    "                    </select>\n" +
    "                  </div>\n" +
    "\n" +
    "                  <div class=\"input-group\" style=\"width: 100%; margin-top: 5px\" ng-repeat=\"_driver in flight.crew.drivers\">\n" +
    "\n" +
    "                    <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                      name=\"driver[{{$index}}]\"\n" +
    "                      ng-model=\"flight.crew.drivers[$index]\"\n" +
    "                      data-placeholder=\"Select Driver\">\n" +
    "                      <option value=\"\"></option>\n" +
    "                      <option\n" +
    "                        ng-repeat=\"driver in drivers\"\n" +
    "                        ng-if=\"notSelected(driver._id, _driver)\"\n" +
    "                        value=\"{{ driver._id }}\"\n" +
    "                        ng-selected=\"{{ flight.crew.drivers[$index] == driver._id }}\">{{ driver.name }}</option>\n" +
    "                    </select>\n" +
    "\n" +
    "                    <div class=\"input-group-btn\">\n" +
    "                      <button class=\"btn btn-icon bg-light lter\" type=\"button\" ng-click=\"flight.crew.remove('drivers', _driver)\"><i class=\"fa fa-times\"></i></button>\n" +
    "                    </div>\n" +
    "\n" +
    "                  </div>\n" +
    "\n" +
    "                  <!-- !Driver Selection -->\n" +
    "\n" +
    "\n" +
    "                </td>\n" +
    "                <td ng-attr-colspan=\"{{ colCount - 3 }}\" style=\"vertical-align: top !important;\">\n" +
    "\n" +
    "                  <div class=\"btn-group pull-right nowrap\">\n" +
    "\n" +
    "                    <button\n" +
    "                      ng-disabled=\"!newBalloon.$valid\"\n" +
    "                      class=\"btn btn-success\"\n" +
    "                      type=\"button\"\n" +
    "                      ng-click=\"flight.save()\">\n" +
    "                      <i class=\"fa fa-plus\"></i>\n" +
    "                      <span class=\"hidden-sm\">Save</span>\n" +
    "                    </button>\n" +
    "\n" +
    "                    <button\n" +
    "                      class=\"btn btn-danger\"\n" +
    "                      type=\"button\"\n" +
    "                      ng-click=\"flight.reset()\">\n" +
    "                      <i class=\"fa fa-times\"></i>\n" +
    "                    </button>\n" +
    "\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td ng-attr-colspan=\"{{ colCount }}\">\n" +
    "                  <button type=\"button\" class=\"btn btn-block btn-xs btn-link\" style=\"color: #0198d4\" ng-click=\"flight.showNew = !flight.showNew\">\n" +
    "                    <span ng-if=\"flight.showNew\">Hide Form</span>\n" +
    "                    <span ng-if=\"!flight.showNew\"><i class=\"fa fa-plus\"></i> Add Balloon</span>\n" +
    "                  </button>\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "            </tfoot>\n" +
    "          </table>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </form>\n" +
    "\n" +
    "\n" +
    "    <table class=\"table table-striped\" style=\"margin-top: 50px;\">\n" +
    "      <thead>\n" +
    "        <tr>\n" +
    "          <th>Zone</th>\n" +
    "          <th class=\"hidden-sm\">Hotel</th>\n" +
    "          <th>Package</th>\n" +
    "          <th style=\"text-align: center;\">Driver</th>\n" +
    "          <th>Guest Name</th>\n" +
    "          <th>\n" +
    "            <span class=\"hidden-sm\">Guest Count</span>\n" +
    "            <span class=\"visible-sm\">#</span>\n" +
    "          </th>\n" +
    "          <th>Balloon</th>\n" +
    "          <th class=\"hidden-sm\"></th>\n" +
    "        </tr>\n" +
    "      </thead>\n" +
    "      <tbody>\n" +
    "        <tr ng-repeat=\"booking in reservations\" class=\"animated slideInRight\" ng-if=\"booking.remainingGuests > 0 && booking.status == 'active'\" ng-init=\"booking.guest_count = booking.adults + booking.children\">\n" +
    "          <td>{{ booking.accommodations.hotel.zone.name || '-' }}</td>\n" +
    "          <td class=\"hidden-sm\">\n" +
    "            <span ng-if=\"booking.accommodations.hotel.name !== 'Other'\">{{ booking.accommodations.hotel.name }}</span>\n" +
    "            <em ng-if=\"booking.accommodations.hotel.name === 'Other'\">{{ booking.accommodations.other }}</em>\n" +
    "          </td>\n" +
    "          <td>{{ booking.package.name }}</td>\n" +
    "          <td style=\"text-align: center\" tooltip=\"awaiting pickup functionality\" tooltip-append-to-body=\"true\">[ driver ]</td>\n" +
    "          <td>\n" +
    "            <a ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"btn btn-link\">{{ booking.last_name }}, {{ booking.first_name }}</a>\n" +
    "          </td>\n" +
    "          <td style=\"text-align: center;\">{{ booking.remainingGuests }}</td>\n" +
    "          <td>\n" +
    "\n" +
    "            <select class=\"input\"\n" +
    "              ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"booking._flight\"\n" +
    "              ng-required=\"true\"\n" +
    "              data-placeholder=\"Select Balloon\"\n" +
    "              ng-change=\"assign(booking)\"\n" +
    "              style=\"min-width: 100px;\"\n" +
    "              name=\"balloon\">\n" +
    "\n" +
    "              <option value=\"\"></option>\n" +
    "              <option\n" +
    "                ng-if=\"flight.balloon.capacity - flight.guests != 0\"\n" +
    "                ng-repeat=\"flight in flights\"\n" +
    "                value=\"{{ flight._id }}\"\n" +
    "                ng-selected=\"{{ booking.balloon == flight.balloon._id }}\">{{ flight.balloon.name }}</option>\n" +
    "\n" +
    "            </select>\n" +
    "\n" +
    "          </td>\n" +
    "          <td class=\"hidden-sm\">\n" +
    "            <div class=\"pull-right\">\n" +
    "              <button type=\"button\" class=\"rebook btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Rebook for another day\">\n" +
    "                <i class=\"fa fa-share\"></i>\n" +
    "              </button>\n" +
    "              <button type=\"button\" class=\"cancel btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Cancel this Booking\">\n" +
    "                <i class=\"fa fa-times\"></i>\n" +
    "              </button>\n" +
    "              <button type=\"button\" class=\"instructions btn btn-link lt\" style=\"\"\n" +
    "                ng-disabled=\"!buildTip(booking)\"\n" +
    "                ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\"\n" +
    "                data-tooltip-html-unsafe=\"{{ buildTip(booking) }}\"\n" +
    "                tooltip-trigger=\"mouseenter\"\n" +
    "                tooltip-placement=\"left\"\n" +
    "                tooltip-append-to-body=\"false\">\n" +
    "                <i class=\"fa fa-info\"></i>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </tbody>\n" +
    "    </table>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/day/bookings", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/day/bookings",
    "<table class=\"reservations table table-hover table-condensed half-fade\"\n" +
    "  ng-class=\"{ 'out': dayWorking, 'in': !dayWorking }\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>#</th>\n" +
    "      <th><input type=\"text\" ng-model=\"bookingsearch.$\" placeholder=\"Contact\"></th>\n" +
    "      <th style=\"text-align: center;\">Guests</th>\n" +
    "      <th ng-if=\"!isPast\">Package</th>\n" +
    "      <th ng-class=\"{ 'hide': responsive.screen_size === 'sm' }\">Hotel</th>\n" +
    "      <th ng-if=\"isPast\">Status</th>\n" +
    "      <!-- Only shown in the past -->\n" +
    "      <th ng-if=\"isPast\">Rating</th>\n" +
    "      <!-- Only shown in the past -->\n" +
    "      <th style=\"max-width: 100px; text-align: center;\" ng-hide=\"isPast\">Pickup</th>\n" +
    "      <th ng-hide=\"isPast\">Phone Number</th>\n" +
    "      <th ng-class=\"{ 'hide': responsive.screen_size === 'sm' }\" class=\"text-right\">\n" +
    "\n" +
    "        <label for=\"showCancelled\" class=\"checkbox\">\n" +
    "          <input class=\"hide\" type=\"checkbox\" id=\"showCancelled\" ng-model=\"showCancelled\">\n" +
    "          <i class=\"fa\" ng-class=\"{ 'fa-toggle-off': !showCancelled, 'fa-toggle-on': showCancelled }\"></i>\n" +
    "          <span ng-if=\"!showCancelled\">Show</span>\n" +
    "          <span ng-if=\"showCancelled\">Hide</span> Cancelled\n" +
    "        </label>\n" +
    "\n" +
    "      </th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "\n" +
    "    <tr ng-repeat=\"booking in bookings | filter:bookingsearch | orderBy:'last_name'\" class=\"active waiting\"\n" +
    "      ng-class=\"{ 'warning' : booking.legacy, 'working': booking.working, 'is-past': isPast }\"\n" +
    "      ng-hide=\"(!showCancelled && booking.status == 'cancelled') || booking.hide\" ng-if=\"booking.status === 'waiting'\"\n" +
    "      ng-include=\"'booking.html'\"></tr>\n" +
    "\n" +
    "    <!-- Active/Pending bookings -->\n" +
    "    <tr ng-repeat=\"booking in bookings | filter:bookingsearch | orderBy:'last_name'\" class=\"\"\n" +
    "      ng-class=\"{ 'warning' : booking.legacy, 'working': booking.working, 'is-past': isPast }\"\n" +
    "      ng-hide=\"(!showCancelled && booking.status == 'cancelled') || booking.hide\"\n" +
    "      ng-if=\"booking.status === 'active' || booking.status === 'pending'\" ng-include=\"'booking.html'\"></tr>\n" +
    "\n" +
    "    <!-- Cancelled Bookings -->\n" +
    "    <tr ng-repeat=\"booking in bookings | filter:bookingsearch | orderBy:'last_name'\" class=\"\"\n" +
    "      ng-class=\"{ 'warning' : booking.legacy, 'working': booking.working, 'is-past': isPast, 'active cancelled' : booking.status == 'cancelled', 'ngFadeIn': booking.notify }\"\n" +
    "      ng-hide=\"(!showCancelled && booking.status == 'cancelled') || booking.hide\" ng-if=\"booking.status === 'cancelled'\"\n" +
    "      ng-include=\"'booking.html'\"></tr>\n" +
    "\n" +
    "\n" +
    "    <tr ng-repeat=\"(i, trace) in event.trace\" class=\"active rebooked\"\n" +
    "      ng-class=\"{'is-past': isPast, 'cancelled' : trace.booking.status == 'cancelled'}\"\n" +
    "      ng-if=\"trace.booking.company == user.activeCompany()._id\">\n" +
    "      <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + trace.booking.confirmation })\"\n" +
    "        class=\"conf point\">\n" +
    "        <div ng-if=\"trace.booking.status != 'active' || trace.booking.status != 'cancelled'\">\n" +
    "          <span class=\"lter label\"\n" +
    "            ng-class=\"{ 'bg-success' : trace.booking.status == 'active', 'text-muted': isPast, 'bg-danger': trace.booking.status == 'cancelled', 'text-muted': isPast, 'text-em': true }\"\n" +
    "            ng-if=\"!trace.booking.legacy\">{{ user.activeCompany().nickname }}{{ trace.booking.confirmation }}</span>\n" +
    "          <span class=\"lter label\"\n" +
    "            ng-class=\"{ 'bg-success' : trace.booking.status == 'active', 'text-muted': isPast, 'bg-danger': trace.booking.status == 'cancelled', 'text-muted': isPast, 'text-em': true }\"\n" +
    "            ng-if=\"trace.booking.legacy\">{{ trace.booking.legacy }}</span>\n" +
    "        </div>\n" +
    "        <span class=\"lter label bg-warning\" ng-class=\"{ 'text-em': true }\"\n" +
    "          ng-if=\"trace.booking.status == 'pending'\">Pending</span>\n" +
    "        <span class=\"lter label bg-default\" ng-class=\"{ 'text-em': true }\" ng-if=\"trace.booking.status == 'failed'\"\n" +
    "          tooltip=\"Payment failed\">Failed</span>\n" +
    "      </td>\n" +
    "      <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + trace.booking.confirmation })\"\n" +
    "        class=\"point\">\n" +
    "        <a ng-if=\"!booking.group\" ng-class=\"{ 'text-em': true }\" class=\"btn btn-link\">{{ trace.booking.last_name }}, {{\n" +
    "          trace.booking.first_name }}</a>\n" +
    "        <a ng-if=\"trace.booking.group\" ng-class=\"{ 'text-em': true }\" class=\"btn btn-link\">{{ trace.booking.group_name\n" +
    "          }}</a>\n" +
    "        <div class=\"pull-right\" style=\"margin: 6px 0\">\n" +
    "          <span class=\"label lter bg-success label-sm\" ng-show=\"trace.booking.vip\">VIP</span>\n" +
    "          <span class=\"label lter bg-info label-sm\" ng-show=\"trace.booking.group\">Group</span>\n" +
    "          <span class=\"label lter bg-warning label-sm\" ng-show=\"trace.booking.hotel\">Hotel</span>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "      <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + trace.booking.confirmation })\"\n" +
    "        class=\"text-center point\"><span class=\"\" ng-class=\"{ 'text-em': true }\">{{ trace.count }}</span></td>\n" +
    "      <td class=\"point\"\n" +
    "        ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + trace.booking.confirmation })\"\n" +
    "        ng-attr-colspan=\"{{ isPast ? 1 : 2 }}\">&nbsp;</td>\n" +
    "      <td ng-attr-colspan=\"{{ isPast ? 4 : 3 }}\" class=\"point\"\n" +
    "        ui-sref=\"day({ tab: 'bookings', day: (trace.booking.day | readTime:'MM-DD-YY') })\">Rebooked to {{\n" +
    "        trace.booking.day | readTime:'MM/DD/YYYY'}}</td>\n" +
    "    </tr>\n" +
    "\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "\n" +
    "<script type=\"text/ng-template\" id=\"booking.html\">\n" +
    "\n" +
    "  <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" class=\"point conf\">\n" +
    "    <div style=\"right: 100%; width: 50px; padding: 5px 5px 5px 0;\" class=\"pos-abt text-right\">\n" +
    "      <span class=\"text-info ngFadeIn\" ng-if=\"booking.notify\">\n" +
    "          <i class=\"fa fa-circle\"></i>\n" +
    "        </span>\n" +
    "      <span class=\"ngFadeInOut\" ng-if=\"viewing(booking).length\" data-tooltip=\"{{ listViewing(booking) }}\" tooltip-trigger=\"mouseenter\"\n" +
    "        tooltip-placement=\"right\" tooltip-append-to-body=\"true\">\n" +
    "          <i class=\"fa fa-eye\"></i>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div ng-if=\"booking.status == 'active' || booking.status == 'cancelled' || booking.status == 'waiting'\">\n" +
    "      <span class=\"label\" ng-class=\"{ 'label-success' : booking.status == 'active', 'label-danger': booking.status == 'cancelled', 'label-default': booking.status === 'waiting'}\"\n" +
    "        ng-if=\"!booking.legacy\">{{ user.activeCompany().nickname }}{{ booking.confirmation }}</span>\n" +
    "      <span class=\"label\" ng-class=\"{ 'label-success' : booking.status == 'active', 'label-danger': booking.status == 'cancelled'}\"\n" +
    "        ng-if=\"booking.legacy\">{{ booking.legacy }}</span>\n" +
    "    </div>\n" +
    "    <span class=\"label label-warning\" ng-if=\"booking.status == 'pending'\">Pending</span>\n" +
    "    <span class=\"label label-default\" ng-if=\"booking.status == 'failed'\" tooltip=\"Payment failed\">Failed</span>\n" +
    "\n" +
    "  </td>\n" +
    "  <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" class=\"point\">\n" +
    "    <a ng-if=\"!booking.group\" class=\"btn btn-link\">{{ booking.last_name }}, {{ booking.first_name }}</a>\n" +
    "    <a ng-if=\"booking.group\" class=\"btn btn-link\">{{ booking.group_name }}</a>\n" +
    "    <div class=\"pull-right label-group\" style=\"margin: 6px 0\">\n" +
    "      <span class=\"label lter bg-success label-sm\" ng-if=\"booking.vip\">VIP</span>\n" +
    "      <span class=\"label lter bg-info label-sm\" ng-if=\"booking.group\">Group</span>\n" +
    "      <span class=\"label lter bg-warning label-sm\" ng-if=\"booking.hotel\">Hotel</span>\n" +
    "    </div>\n" +
    "  </td>\n" +
    "  <td style=\"text-align: center;\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\"\n" +
    "    class=\"point\">{{ booking.adults + booking.children }}</td>\n" +
    "\n" +
    "  <td ng-if=\"!isPast\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" class=\"point\">{{ booking.package.name }}</td>\n" +
    "\n" +
    "  <!-- #Hotel -->\n" +
    "  <td class=\"point\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" ng-class=\"{ 'hide': responsive.screen_size === 'sm' }\">\n" +
    "    <span ng-if=\"booking.accommodations.hotel.name !== 'Other'\">{{ booking.accommodations.hotel.name }}</span>\n" +
    "    <em ng-if=\"booking.accommodations.other !== ''\">{{ booking.accommodations.other }}</em>\n" +
    "  </td>\n" +
    "  <!-- Only showing hotels in today or future -->\n" +
    "\n" +
    "  <td ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" class=\"point\" ng-if=\"isPast || booking.status == 'cancelled'\"\n" +
    "    class=\"upper point\" ng-attr-colspan=\"{{ !isPast ? 2 : 1 }}\">\n" +
    "    {{ paymentCount = countPaymentTypes(booking.cart.payments);'' }}\n" +
    "    <span ng-if=\"booking.status !== 'cancelled' && booking.cart.balance > 0\" class=\"text-danger\">\n" +
    "        Balance Due - {{ booking.cart.balance | currency }}\n" +
    "      </span>\n" +
    "    <span ng-if=\"booking.status !== 'cancelled' && booking.cart.balance <= 0 \">\n" +
    "        Paid in Full\n" +
    "        <span ng-if=\"paymentCount.total === 1\"> -\n" +
    "          <strong ng-if=\"paymentCount.cards.count > 0\">\n" +
    "            {{ booking.cart.payments.cards[0].name }} {{ booking.cart.payments.cards[0].masked }}\n" +
    "          </strong>\n" +
    "          <strong ng-if=\"paymentCount.billto.count\">{{booking.cart.payments.bill_to[0].name}}</strong>\n" +
    "          <strong ng-if=\"paymentCount.cash.count\">Cash</strong>\n" +
    "          <strong ng-if=\"paymentCount.gifts.count\">PrePaid {{ booking.cart.payments.prepayments[0].name }}</strong>\n" +
    "        </span>\n" +
    "    <span ng-if=\"paymentCount.total > 1\">\n" +
    "          - <strong>Multiple</strong>\n" +
    "        </span>\n" +
    "    <span> - {{ booking.cart.total | currency }}</span>\n" +
    "    </span>\n" +
    "    <span ng-if=\"booking.status == 'cancelled' && !cancelledAction(booking)\">Cancelled</span>\n" +
    "    <span ng-if=\"booking.status == 'cancelled' && cancelledAction(booking)\">Cancelled on {{ cancelledAction(booking).date | readTime: 'detailed' || '--' }}</span>\n" +
    "  </td>\n" +
    "\n" +
    "  <td ng-if=\"isPast\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\" class=\"point\"\n" +
    "    ng-init=\"rating = averageRating(booking)\">\n" +
    "    <rating ng-show=\"rating > 0\" ng-model=\"rating\" readonly=\"true\" max=\"5\" state-on=\"'fa-dot-circle-o'\" state-off=\"'fa-circle-o'\"></rating>\n" +
    "  </td>\n" +
    "\n" +
    "  <td style=\"text-align: center; white-space: nowrap\" ng-hide=\"isPast || booking.status == 'cancelled'\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\"\n" +
    "    class=\"point\">\n" +
    "    <a ng-if=\"booking.needs_pickup\" href=\"\">\n" +
    "        {{ booking.pickup.time | readTime: 'h:mm a':true }}\n" +
    "      </a>\n" +
    "    <a ng-if=\"!booking.needs_pickup\" href=\"\">-</a>\n" +
    "  </td>\n" +
    "  <td ng-hide=\"isPast || booking.status == 'cancelled'\" ui-sref=\"editBooking({ confirmation: user.activeCompany().nickname + booking.confirmation })\"\n" +
    "    class=\"point\">\n" +
    "    <a ng-attr-href=\"tel:{{booking.phone}}\">{{ booking.phone | phone }}</a>\n" +
    "  </td>\n" +
    "  <td ng-init=\"booking.rebook = false;\" ng-class=\"{ 'hide': responsive.screen_size === 'sm' }\">\n" +
    "    <div class=\"pull-right\" style=\"position: relative; overflow: visible;\">\n" +
    "\n" +
    "      <div class=\"panel animated fadeInOut enterUp\" ng-if=\"booking.rebook\" style=\"width: 220px; position: absolute; top: -130px; left: -100px; z-index: 999;\"\n" +
    "        tabindex=\"0\">\n" +
    "\n" +
    "        <h5 class=\"panel-heading\">Move to a New Day</h5>\n" +
    "        <div class=\"panel-body\">\n" +
    "\n" +
    "          <div class=\"input-group input-group-lg\">\n" +
    "\n" +
    "            <input type=\"text\" class=\"text-center form-control input-lg\" auto-focus date-entry=\"\" ng-model-options=\"{ 'debounce' : 500 }\"\n" +
    "              ui-event=\"{ 'blur': 'changeDate($event, booking)', 'keypress': 'changeDate($event, booking)' }\" ng-model=\"booking.rebook_day\"\n" +
    "            />\n" +
    "\n" +
    "            <span class=\"input-group-btn\">\n" +
    "                <!-- rebook -->\n" +
    "                <button class=\"btn bg-info\"\n" +
    "                  style=\"position: relative; z-index: 1000\"\n" +
    "                  type=\"button\" ng-click=\"changeDate($event, booking)\"><i class=\"fa fa-check\"></i></button>\n" +
    "              </span>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <button type=\"button\" ng-if=\"booking.status == 'pending'\" class=\"rebook btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\"\n" +
    "        tooltip=\"Approve\" ng-click=\"activate(booking)\">\n" +
    "          <i class=\"fa fa-check\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "      <button type=\"button\" ng-show=\"booking.status !== 'pending'\" class=\"rebook btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\"\n" +
    "        ng-click=\"rebook(booking)\">\n" +
    "          <i class=\"fa fa-share\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "      <button type=\"button\" class=\"cancel btn btn-link lt\" style=\"\" ng-if=\"booking.status !== 'cancelled'\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\"\n" +
    "        tooltip=\"Cancel this Booking\" ng-click=\"cancel(booking)\">\n" +
    "          <i class=\"fa fa-times\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "      <button ng-if=\"!isPast\" type=\"button\" ng-if=\"booking.status !== 'pending'\" class=\"instructions btn btn-link lt\" style=\"\"\n" +
    "        ng-disabled=\"!buildTip(booking)\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" data-tooltip-html-unsafe=\"{{ buildTip(booking) }}\"\n" +
    "        tooltip-trigger=\"mouseenter\" tooltip-placement=\"left\" tooltip-append-to-body=\"false\">\n" +
    "          <i class=\"fa fa-info\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "      <button class=\"instructions btn btn-link lt\" ng-show=\"isPast\" type=\"button\" ng-click=\"sendReceipt(booking)\">\n" +
    "          {{ thisSpinner = spinnerConf; ''; thisSpinner.color = '#717171'; '' }}\n" +
    "          <i class=\"fa fa-check\" ng-show=\"booking.sent_receipt\"></i>\n" +
    "          <i class=\"fa fa-envelope\" ng-show=\"!booking.sending_receipt && !booking.sent_receipt\"></i>\n" +
    "          <span ng-if=\"booking.sending_receipt\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"thisSpinner\"></span>\n" +
    "        </button>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </td>\n" +
    "\n" +
    "</script>\n" +
    "");
}]);

angular.module("views/day/day", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/day/day",
    "<header class=\"day clearfix\" ng-init=\"showCal = false; toggleIds = false;\">\n" +
    "  {{ isPast = (day | ago) > 0 || (day | readTime:'MM-DD-YY') == (today | readTime:'MM-DD-YY');\"\" }}\n" +
    "  <h2 class=\"pull-left\" style=\"margin-bottom: 20px;\" ng-dblclick=\"toggleIds = !toggleIds\">\n" +
    "    <span ng-show=\"toggleIds\">{{ event._id }}</span>\n" +
    "    <span ng-show=\"!toggleIds\" class=\"noselect\">\n" +
    "      <span ng-switch=\"state.name\">\n" +
    "        <span ng-switch-when=\"day.bookings|day.legacy\" ng-switch-when-separator=\"|\">Bookings</span>\n" +
    "        <span ng-switch-when=\"day.pickups\">Pickups</span>\n" +
    "        <span ng-switch-when=\"day.balloons\">Balloons</span>\n" +
    "      </span>:\n" +
    "      <small style=\"margin-left: 10px;\">\n" +
    "        <span ng-click=\"changeDay(state, -1)\" style=\"cursor: pointer; position: relative; top: -3px;\">&lt;</span>\n" +
    "        <span class=\"dateSelect\"\n" +
    "          style=\"margin: 0 10px; display: inline-block; max-width: 330px; text-align: center; cursor: pointer;\"\n" +
    "          ng-click=\"showCal = !showCal\" ng-class=\"{ 'working': dayWorking }\">\n" +
    "          <span class=\"text-center\" ng-if=\"{ 'hide': responsive.screen_size === 'sm'}\"\n" +
    "            style=\"width: 310px; display: inline-block\">\n" +
    "            {{ day | readTime:'detailed' }}\n" +
    "          </span>\n" +
    "          <span ng-if=\"response.screen_size === 'xs'\">{{ day | readTime:'ddd, MMM. Do YYYY' }}</span>\n" +
    "        </span>\n" +
    "        <span ng-click=\"changeDay(state, 1)\" style=\"cursor: pointer; position: relative; top: -3px;\">&gt;</span>\n" +
    "      </small>\n" +
    "    </span>\n" +
    "  </h2>\n" +
    "\n" +
    "  <div class=\"dropdown-menu\" ng-if=\"showCal\" style=\"display: block; left: 200px; top: 50px;\">\n" +
    "    <datepicker show-weeks=\"false\" ng-model=\"dateSelect\" ng-change=\"changeDay(state.tab, dateSelect)\" format-day=\"dd\"\n" +
    "      format-month=\"MM\" format-year=\"yyyy\"></datepicker>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- <button type=\"button\" class=\"pull-right btn bg-light\" ng-if=\"showAdmin() && !isPast\" ng-click=\"import(day)\">Import<span class=\"hidden-sm\"> {{day}}</span></button> -->\n" +
    "\n" +
    "  <div ng-controller=\"reservationsCtrl\">\n" +
    "    <button type=\"button\" class=\"pull-right btn bg-light\" ng-if=\"showAdmin() || user.hasGroup('Daily')\"\n" +
    "      ng-click=\"cleanup(day)\">Cache Cleanup</button>\n" +
    "  </div>\n" +
    "  <a class=\"pull-right btn bg-light\" ng-if=\"user.can('daily sales', 'Reports') && isPast\"\n" +
    "    ng-attr-href=\"reports/sales/{{ day }}\">Sales Report</a>\n" +
    "\n" +
    "  <cancel day=\"date\" class=\"pull-right\">\n" +
    "    <button type=\"button\" then=\"location.reload()\" class=\"cancel btn bg-danger\">\n" +
    "      Cancel Flights\n" +
    "    </button>\n" +
    "  </cancel>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<div ng-controller=\"eventsCtrl\" ng-init=\"newNote = false;\"\n" +
    "  style=\"position: relative; z-index: 1; padding-bottom: 15px;\">\n" +
    "\n" +
    "  <div class=\"btn-group\">\n" +
    "    {{ hiddenCount = (event.notes | arrayFilter:'val.hide === true' | arrayCount);'' }}\n" +
    "    <button type=\"button\" class=\"btn bg-light\" ng-click=\"newNote = !newNote\"><i class=\"fa fa-sticky-note\"></i> Add\n" +
    "      Note</button>\n" +
    "    <button type=\"button\" class=\"btn bg-light\" ng-show=\"hiddenCount !== 0\" ng-click=\"showHidden = !showHidden\">Show ({{\n" +
    "      hiddenCount }}) hidden notes</button>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"\" ng-show=\"newNote || event.notes.length\" style=\"margin-bottom: 0; margin-top: 10px;\">\n" +
    "\n" +
    "    <ul class=\"list-unstyled\">\n" +
    "\n" +
    "      <li class=\"\" ng-repeat=\"note in event.notes\" ng-show=\"!note.hide || showHidden\">\n" +
    "        <div class=\"alert alert-danger\" style=\"margin-bottom: 5px; padding: 5px 10px; display: inline-block\"\n" +
    "          ng-class=\"{ 'alert-lt': note.hide }\">\n" +
    "          <strong>\n" +
    "            <button type=\"button\" ng-click=\"hideNote(note)\" class=\"btn btn-link btn-xs\">\n" +
    "              <i class=\"fa fa-times text-danger\" style=\"float: left;\"></i>\n" +
    "            </button>\n" +
    "            {{ note.user.name }}:\n" +
    "          </strong>\n" +
    "          <span>{{ note.body | nl2br }}</span>\n" +
    "        </div>\n" +
    "      </li>\n" +
    "\n" +
    "      <li class=\"alert alert-danger\" ng-show=\"newNote\">\n" +
    "        <span class=\"input-group\">\n" +
    "          <textarea id=\"\" rows=\"1\" class=\"form-control\" ng-model=\"note\"></textarea>\n" +
    "          <span class=\"input-group-btn\">\n" +
    "            <button class=\"btn bg-light btn-sm\" type=\"button\" ng-click=\"addNote(note, event)\">Send!</button>\n" +
    "          </span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "\n" +
    "    </ul>\n" +
    "\n" +
    "\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<section class=\"pos-rlt\" ng-init=\"editCapacity = false;\">\n" +
    "\n" +
    "  <div class=\"label-group reservations\" ng-click=\"editCapacity = !editCapacity\">\n" +
    "    <span class=\"label label-success\">{{ event.capacity.remaining }}</span>\n" +
    "    <span class=\"label label-danger\">{{ event.capacity.booked }}</span>\n" +
    "    <span ng-if=\"event.capacity.weight > 0\" class=\"label bg-light\">{{ event.capacity.weight }} lbs</span>\n" +
    "  </div>\n" +
    "\n" +
    "  <form class=\"input-group\" ng-if=\"editCapacity\" style=\"width: 90px; float: right;margin-right: 10px;margin-top: 4px;\">\n" +
    "    <input class=\"form-control input-sm\" ng-model=\"event.capacity.total\" ng-change=\"updateCapacity(event)\" type=\"number\"\n" +
    "      min=\"{{ event.capacity.booked }}\" required />\n" +
    "\n" +
    "    <div class=\"input-group-btn\">\n" +
    "      <button type=\"submit\" class=\"btn bg-success btn-sm\" ng-click=\"updateCapacity(event, true)\">\n" +
    "        <i class=\"fa fa-check\"></i>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </form>\n" +
    "\n" +
    "  <div class=\"tabbable\">\n" +
    "    <ul class=\"nav nav-tabs\">\n" +
    "      <li ng-class=\"{ 'active': state.name === 'day.bookings' || state.name === 'day.legacy' }\">\n" +
    "        <a ui-sref=\"day.bookings({ day: state.day })\">Reservations</a>\n" +
    "      </li>\n" +
    "      <li ng-class=\"{ 'active': state.name === 'day.pickups' }\">\n" +
    "        <a ui-sref=\"day.pickups({ day: state.day })\">Pickups</a>\n" +
    "      </li>\n" +
    "      <li ng-class=\"{ 'active': state.name === 'day.balloons' }\">\n" +
    "        <a ui-sref=\"day.balloons({ day: state.day })\">Balloons</a>\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a ng-href=\"https://checkin.dev.rezflow.io/tips/{{ state.day | readTime:'YYYY-MM-DD' }}\">Enter Tips</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <div class=\"tab-content\">\n" +
    "      <ui-view name=\"day\"></ui-view>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>\n" +
    "\n" +
    "");
}]);

angular.module("views/day/pickups", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/day/pickups",
    "<table class=\"bookings table table-hover table-condensed\" ng-init=\"predicate='pickup.time'; reverse = false;\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th ng-click=\"predicate = 'accommodations.hotel.zone.name'; reverse = !reverse\" class=\"point\">Zone\n" +
    "        <span ng-if=\"predicate == 'accommodations.hotel.zone.name'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      <th style=\"width: 90px;\" ng-click=\"predicate = 'pickup.time'; reverse = !reverse\" class=\"point\">Time\n" +
    "        <span ng-if=\"predicate == 'pickup.time'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      <th ng-click=\"predicate = 'accommodations.hotel.name'; reverse = !reverse\" class=\"point\">Hotel\n" +
    "        <span ng-if=\"predicate == 'accommodations.hotel.name'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      </th>\n" +
    "      <th ng-click=\"predicate = 'name'; reverse = !reverse\" class=\"point\">Guest Name\n" +
    "        <span ng-if=\"predicate == 'name'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      <th style=\"width: 250px;\" class=\"point\" ng-click=\"predicate = 'pickup.drivers[0].name'; reverse = !reverse\">Driver\n" +
    "        <span ng-if=\"predicate == 'pickup.drivers[0].name'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      <th style=\"width: 250px;\" class=\"point\">Balloon</th>\n" +
    "      <th ng-click=\"predicate = 'count'; reverse = !reverse\" class=\"point\">#<span class=\"hidden-sm\"> Guests</span>\n" +
    "        <span ng-if=\"predicate == 'count'\"><i class=\"fa\" ng-class=\"{ 'fa-caret-down' : reverse == false, 'fa-caret-up' : reverse == true }\"></i></span></th>\n" +
    "      <th>Phone Number</th>\n" +
    "      <th style=\"width: 85px;\"></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr\n" +
    "      ng-repeat=\"booking in bookings | orderBy:predicate:reverse\"\n" +
    "      ng-init=\"booking.editable = false; booking.count = (booking.adults + booking.children); booking.name = (booking.group) ? booking.group_name : booking.last_name\"\n" +
    "      ng-class=\"{ 'info' : booking.editable }\"\n" +
    "      ng-if=\"booking.status === 'active'\">\n" +
    "      <td ng-click=\"booking.editable = !booking.editable\">{{ booking.accommodations.hotel.zone.name || \"-\" }}</td>\n" +
    "      <td class=\"text-center\" ng-init=\"booking.pickup._time = getTime(booking.pickup.time, 'hh:mm A'); booking.pickup.time = booking.pickup._time;\">\n" +
    "        <div ng-click=\"booking.editable = !booking.editable\">\n" +
    "          <span ng-show=\"!booking.editable\">{{ booking.pickup._time }}</span>\n" +
    "        </div>\n" +
    "        <div class=\"input-group\" ng-show=\"booking.editable\" ng-click=\"booking.editable = true\">\n" +
    "          <input type=\"text\"\n" +
    "            class=\"form-control\"\n" +
    "            ng-model=\"booking.pickup._time\"\n" +
    "            ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "            placeholder=\"Pickup Time\"\n" +
    "            time=\"{ hours: 1, minutes: 5 }\" />\n" +
    "        </div>\n" +
    "      </td>\n" +
    "      <td ng-click=\"booking.editable = !booking.editable\">\n" +
    "        {{booking.pickup.time}} {{ booking.accommodations.hotel.name }}\n" +
    "      </td>\n" +
    "      <td ng-click=\"booking.editable = !booking.editable\">\n" +
    "        <span ng-if=\"!booking.group\">{{ booking.last_name }}, {{ booking.first_name }}</span>\n" +
    "        <span ng-if=\"booking.group\">{{ booking.group_name }}</span>\n" +
    "      </td>\n" +
    "      <td>\n" +
    "\n" +
    "        <div ng-if=\"!booking.editable\" ng-click=\"booking.editable = !booking.editable\">\n" +
    "          <span ng-if=\"booking.pickup.drivers.length == 0\">-</span>\n" +
    "          <span ng-repeat=\"driver in booking.pickup.drivers\">{{ driver.name }}<span ng-show=\"!$last\">, </span></span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"booking.editable\">\n" +
    "          <!-- Add a new driver to existing drivers -->\n" +
    "          <div class=\"input-group\" style=\"width: 100%;\">\n" +
    "\n" +
    "            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"booking.newDriver\" ng-change=\"addDriver(booking);\"\n" +
    "              data-placeholder=\"Add a Driver\">\n" +
    "\n" +
    "              <option value=\"\"></option>\n" +
    "              <option\n" +
    "                ng-repeat=\"driver in drivers\"\n" +
    "                ng-if=\"notAssigned(option, booking)\"\n" +
    "                value=\"{{ driver }}\">{{ driver.name }}</option>\n" +
    "\n" +
    "            </select>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"\" ng-repeat=\"driver in booking.pickup.drivers\"\n" +
    "            ng-init=\"driver.origId = driver._id\" style=\"margin-top: 5px;\">\n" +
    "\n" +
    "            <div class=\"input-group\" style=\"width: 100%\">\n" +
    "\n" +
    "              <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "                ng-model=\"driver._id\"\n" +
    "                ng-required=\"true\"\n" +
    "                data-placeholder=\"Select Crew\">\n" +
    "\n" +
    "                <option value=\"\"></option>\n" +
    "                <option\n" +
    "                  ng-repeat=\"option in drivers\"\n" +
    "                  value=\"{{ option._id }}\"\n" +
    "                  ng-selected=\"{{ driver._id == option._id }}\">{{ option.name }}</option>\n" +
    "\n" +
    "              </select>\n" +
    "\n" +
    "              <div class=\"input-group-btn\">\n" +
    "                <button class=\"btn btn-sm bg-light lter\" type=\"button\" ng-click=\"booking.pickup.drivers.splice($index, 1)\"><i class=\"fa fa-times\"></i></button>\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </td>\n" +
    "      <td>\n" +
    "        <!-- Balloon -->\n" +
    "        <div ng-if=\"!booking.editable\" ng-click=\"booking.editable = !booking.editable\">\n" +
    "          <span ng-if=\"booking.flight.length == 0\">-</span>\n" +
    "          <span ng-repeat=\"flight in booking.flight\">{{ flight.flight.balloon.name }}<span ng-show=\"!$last\">, </span></span>\n" +
    "        </div>\n" +
    "        <!-- Balloon Editable -->\n" +
    "        <div ng-if=\"booking.editable\">\n" +
    "          <!-- Assign booking to a flight -->\n" +
    "          <div class=\"input-group\" style=\"width: 100%;\">\n" +
    "\n" +
    "            <select class=\"input\" ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"booking.tmpFlight\" ng-change=\"assignFlight(booking);\"\n" +
    "              data-placeholder=\"Assign a Flight\">\n" +
    "\n" +
    "              <option value=\"\"></option>\n" +
    "              <option\n" +
    "                ng-repeat=\"flight in flights\"\n" +
    "                value=\"{{ flight }}\">{{ flight.balloon.name }}</option>\n" +
    "\n" +
    "            </select>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "      <td class=\"text-center\" ng-click=\"booking.editable = !booking.editable\">\n" +
    "        {{ booking.adults + booking.children }}\n" +
    "      </td>\n" +
    "      <td ng-click=\"booking.editable = !booking.editable\">{{ booking.phone }}</td>\n" +
    "      <td>\n" +
    "        <div class=\"pull-right\">\n" +
    "          <button ng-if=\"booking.editable\" ng-click=\"update(booking)\" type=\"button\" class=\"btn bg-success lt\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Update Pickup\">\n" +
    "            <i class=\"fa fa-check\"></i>\n" +
    "          </button>\n" +
    "          <button type=\"button\" class=\"instructions btn btn-link lt\" style=\"\"\n" +
    "            ng-disabled=\"!buildTip(booking)\"\n" +
    "            ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\"\n" +
    "            data-tooltip-html-unsafe=\"{{ buildTip(booking) }}\"\n" +
    "            tooltip-trigger=\"mouseenter\"\n" +
    "            tooltip-placement=\"left\"\n" +
    "            tooltip-append-to-body=\"false\">\n" +
    "            <i class=\"fa fa-info\"></i>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("views/flights/edit", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/flights/edit",
    "<div class=\"row\">\n" +
    "  <form class=\"col-md-8\" name=\"editFlight\" ng-submit=\"update(flight)\">\n" +
    "    <h2>{{ flight.balloon.name }} <small>Flown on {{ flight.event.date | readTime:'detailed':true}}</small>\n" +
    "    <button type=\"submit\" ng-disabled=\"editFlight.$invalid\" class=\"btn btn-success pull-right\">Save Flight\n" +
    "      <span ng-if=\"flight.working\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\" spin=\"spinnerConf\"></span>\n" +
    "    </button></h2>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <h4>Stats</h4>\n" +
    "\n" +
    "      <section class=\"row\">\n" +
    "\n" +
    "        <div class=\"form-group col-md-4\">\n" +
    "          <label for=\"time\">Flight Time</label>\n" +
    "          <input type=\"text\" id=\"time\" class=\"form-control input-lg\" ng-model=\"flight.time\" ui-mask=\"9hr 99min\"  ui-mask-placeholder ui-mask-placeholder-char=\"_\" required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-4\">\n" +
    "          <label for=\"launch\">Launch Site</label>\n" +
    "          <ui-select id=\"launch\" ng-model=\"flight.launch\" class=\"input-lg\" style=\"width: 100%\" required>\n" +
    "            <ui-select-match placeholder=\"Launch Site is\">{{$select.selected.name}}</ui-select-match>\n" +
    "            <ui-select-choices repeat=\"site.name as site in getLaunchSites()\">\n" +
    "                {{ site.name }}\n" +
    "            </ui-select-choices>\n" +
    "          </ui-select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-4\">\n" +
    "          <label for=\"time\">Landing Site</label>\n" +
    "          <input type=\"text\" id=\"landing\" class=\"form-control input-lg\" ng-model=\"flight.landing\" required />\n" +
    "        </div>\n" +
    "\n" +
    "      </section>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-controller=\"filesCtrl\" ng-if=\"!(flight.event.date | momentjs).isAfter(today)\">\n" +
    "\n" +
    "      <h4>Photo Message</h4>\n" +
    "\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <div class=\"form-group\">\n" +
    "          <textarea ng-model=\"flight.photos.message\" class=\"form-control\"></textarea>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <h4 class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "          Manage Photos\n" +
    "          <div class=\"pull-right col-md-4\">\n" +
    "            <div class=\"input-group\">\n" +
    "              <input type=\"text\" class=\"form-control\" disabled=\"true\" style=\"cursor: text\" ng-attr-value=\"{{location.origin}}/photos/{{flight._id}}\" />\n" +
    "              <div class=\"input-group-btn\">\n" +
    "                <a class=\"btn bg-light dk\" href=\"{{location.origin}}/photos/{{flight._id}}\" target=\"_blank\"><i class=\"fa fa-link\"></i></a>\n" +
    "                <button type=\"button\" style=\"margin-left: -5px;\" tooltip=\"copy\" copy=\"{{location.origin}}/photos/{{flight._id}}\" class=\"btn bg-light dk\">\n" +
    "                  <i class=\"fa fa-clipboard ngFadeIn\" ng-show=\"!success\"></i>\n" +
    "                  <i class=\"fa fa-check ngFadeIn\" ng-show=\"success\"></i>\n" +
    "                </button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </h4>\n" +
    "\n" +
    "      <!-- <ul class=\"list-unstyled\" style=\"overflow: auto;\"> -->\n" +
    "      <div class=\"row\" ng-init=\"tiles = photoTile(4)\" style=\"margin-top: 20px\">\n" +
    "\n" +
    "        <div ng-repeat=\"tile in tiles track by $index\">\n" +
    "          <div ng-repeat=\"f in tile\" style=\"margin-bottom: 10px;\" class=\"col-md-3\" ng-if=\"!f.removed && !f.hidden\">\n" +
    "\n" +
    "            <div class=\"thumbnail\" ui-event=\"{ mouseenter : 'hovered[$index] = true', mouseleave: 'hovered[$index] = false' }\" style=\"min-height: 140px;\">\n" +
    "\n" +
    "              <div class=\"hover animated fadeInOut\" ng-if=\"f.thumbnail\" ng-show=\"hovered[$index]\">\n" +
    "                <div class=\"valign\">\n" +
    "                  <div class=\"actions\">\n" +
    "                    <button type=\"button\" class=\"btn-link text-lg\" ng-click=\"removeFile(f)\">\n" +
    "                      <i ng-show=\"!f.working\" class=\"fa fa-times text-white\"></i>\n" +
    "                      <span ng-if=\"f.working\" style=\"display: inline-block;top: -12px;margin-left: 0px; position: relative;margin: 0 10px;\" spin=\"spinnerConf\"></span>\n" +
    "                    </button>\n" +
    "                    <a ng-href=\"{{ f.path }}\" target=\"_blank\" class=\"btn-link text-lg\"><i class=\"fa fa-file-image-o text-white\"></i></a>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "\n" +
    "              <a href=\"\" ng-if=\"f.thumbnail\" ng-href=\"{{f.path}}\">\n" +
    "                <img ng-src=\"{{ f.thumbnail }}\" class=\"img-responsive\" />\n" +
    "              </a>\n" +
    "\n" +
    "              <div ng-if=\"!f.thumbnail\" class=\"valign\" style=\"line-height: 160px; background: #ccc;\">\n" +
    "                <div class=\"actions\">\n" +
    "                  <span style=\"display: inline-block; top: -8px; margin-left: 10px; margin-right: 10px; position: relative;\" spin=\"spinnerConf\"></span>\n" +
    "                  <strong>Thumbnail Generating</strong>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "          </div>        </div>\n" +
    "\n" +
    "        <div ng-repeat=\"f in files\" style=\"margin-bottom: 10px;\" ng-class=\"\" ng-if=\"!f.removed\">\n" +
    "\n" +
    "          <div class=\"clearfix\" ng-if=\"$index % 4 == 0\"></div>\n" +
    "\n" +
    "          <div class=\"col-md-3\">\n" +
    "\n" +
    "            <div class=\"thumbnail\" ui-event=\"{ mouseenter : 'hovered[$index] = true', mouseleave: 'hovered[$index] = false' }\">\n" +
    "\n" +
    "              <div class=\"hover animated fadeInOut\" style=\"z-index: 1\" ng-show=\"hovered[$index]\">\n" +
    "                <div class=\"\">\n" +
    "                  <div class=\"actions\">\n" +
    "                    <button type=\"button\" class=\"btn-link text-lg pull-right\" style=\"margin: 10px 20px;\" ng-click=\"cancelUpload(f)\">\n" +
    "                      <i ng-show=\"!f.working\" class=\"fa fa-times text-white\"></i>\n" +
    "                    </button>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"upload-progress\" ng-show=\"f.progress < 100 || !f.result\">\n" +
    "                <div class=\"valign\">\n" +
    "                  <span>{{ f.progress }}%</span>\n" +
    "                </div>\n" +
    "                <div class=\"bar\" ng-attr-style=\"width: {{ 100 - f.progress }}%\"></div>\n" +
    "              </div>\n" +
    "\n" +
    "              <img ngf-src=\"f\" class=\"img-responsive\" />\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <!-- </ul> -->\n" +
    "\n" +
    "      <section class=\"col-md-12\">\n" +
    "        <button class=\"btn bg-info lt\" type=\"file\"\n" +
    "          ngf-select=\"getSignature($files, { scope: $parent.flight, flight: $parent.flight._id }, $parent.flight.photos.files)\"\n" +
    "          ngf-multiple=\"true\"\n" +
    "          accept=\"image/*\"\n" +
    "          ngf-accept=\"'image/*'\">Choose Photos <i class=\"fa fa-cloud-upload\"></i></button>\n" +
    "\n" +
    "        <button ng-show=\"files.length\" class=\"btn bg-danger lt\" ng-click=\"cancelAll(files)\">Abort remaining Uploads <i class=\"fa fa-ban\"></i></button>\n" +
    "      </section>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "      <h4>\n" +
    "        <span>Guests ({{ totalGuests(flight) }})</span>\n" +
    "      </h4>\n" +
    "\n" +
    "      <section class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "\n" +
    "          <table class=\"table\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th>Guest</th>\n" +
    "                <th>#</th>\n" +
    "                <th style=\"width: 50px;\">Photos</th>\n" +
    "                <!-- <th>Survey</th>\n" +
    "                <th>TA</th> -->\n" +
    "                <th style=\"width: 105px;\" class=\"text-center\">Rate</th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "              <tr ng-repeat=\"booking in flight.reservations\" ng-controller=\"PricingDirectiveHelper\">\n" +
    "                <td>\n" +
    "                  <span ng-if=\"booking.group\">{{ booking.group_name }}</span>\n" +
    "                  <span ng-if=\"!booking.group\">\n" +
    "                    {{ booking.first_name }} {{ booking.last_name }}\n" +
    "                  </span>\n" +
    "                </td>\n" +
    "                <td>{{ booking.adults + (booking.children || 0) }}</td>\n" +
    "                <td class=\"text-center text-success\">\n" +
    "                  <i class=\"fa fa-check\" ng-if=\"::hasPhotos()\"></i>\n" +
    "                </td>\n" +
    "                <td class=\"text-center\">\n" +
    "                  <button type=\"button\" ng-click=\"updateImpression(booking, flight._id, true)\" class=\"btn btn-link btn-xs\"><i class=\"fa fa-thumbs-up\" ng-class=\"{ 'text-muted lt' : findFlight(booking).happy === false || findFlight(booking).happy === null }\"></i></button>\n" +
    "                  <button type=\"button\" ng-click=\"updateImpression(booking, flight._id, false)\" class=\"btn btn-link btn-xs\"><i class=\"fa fa-thumbs-down\" ng-class=\"{ 'text-muted lt' : findFlight(booking).happy === true || findFlight(booking).happy === null }\"></i></button>\n" +
    "                </td>\n" +
    "                <!-- <td>?</td>\n" +
    "                <td>?</td> -->\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "\n" +
    "        </div>\n" +
    "      </section>\n" +
    "\n" +
    "      <section class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <span class=\"text-muted\">Photo Emails</span>\n" +
    "            <div class=\"input-group\">\n" +
    "              <input type=\"text\" disabled class=\"form-control\" ng-attr-value=\"{{someoneHasPhotos(flight,true).join(', ')}}\">\n" +
    "              <div class=\"input-group-btn\">\n" +
    "                <button type=\"button\" style=\"margin-left: -5px;\" tooltip=\"copy\" copy=\"{{someoneHasPhotos(flight,true).join(', ')}}\" class=\"btn bg-light dk\">\n" +
    "                  <i class=\"fa fa-clipboard ngFadeIn\" ng-show=\"!success\"></i>\n" +
    "                  <i class=\"fa fa-check ngFadeIn\" ng-show=\"success\"></i>\n" +
    "                </button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "      </section>\n" +
    "\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/flights/photos", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/flights/photos",
    "<div class=\"container\">\n" +
    "\n" +
    "  <div class=\"col-md-12 text-center\" style=\"margin-top: 20px;\">\n" +
    "    <a ng-attr-href=\"{{flight.company.web}}\">\n" +
    "      <img alt=\"\" ng-src=\"{{flight.company.logo.path}}\" />\n" +
    "    </a>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "\n" +
    "    <h2 class=\"col-md-12\">In-Flight Photos: <small>{{ flight.event.date | readTime:'detailed':true }}</small> <a ng-attr-href=\"{{::archiveLink()}}\" class=\"href btn bg-light pull-right\"><i class=\"fa fa-arrow-circle-o-down\"></i> Download ZIP</a></h2>\n" +
    "    <hr>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\" ng-init=\"columns = photoTile(4)\">\n" +
    "    <div class=\"col-md-3\" ng-repeat=\"col in columns\">\n" +
    "\n" +
    "      <ul class=\"list-unstyled\" style=\"overflow: auto;\">\n" +
    "\n" +
    "        <li ng-repeat=\"f in col\" style=\"margin-bottom: 10px;\">\n" +
    "          <div class=\"thumbnail\">\n" +
    "            <a href=\"\" ng-href=\"{{ f.path }}\">\n" +
    "              <img ng-src=\"{{thumb( f.path )}}\" class=\"img-responsive\" />\n" +
    "            </a>\n" +
    "          </div>\n" +
    "        </li>\n" +
    "\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <hr>\n" +
    "\n" +
    "  <div class=\"text-center\" style=\"margin-bottom: 30px;\">\n" +
    "    <span>{{ flight.company.phone | tel }} | {{ flight.company.email }}</span><br />\n" +
    "    <span>Copyright &copy; {{ 'today' | readTime:'YYYY' }} {{ flight.company.name }}</span>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/gifts", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/gifts",
    "<section id=\"content\" class=\"m-t-lg wrapper-md animated fadeInDown\">  \n" +
    "\n" +
    "  <div class=\"row m-n\">\n" +
    "    <div class=\"col-md-8 col-md-offset-2 m-t-lg\">\n" +
    "      <section class=\"panel\">\n" +
    "\n" +
    "        <header class=\"panel-heading text-center bg-dark\">\n" +
    "          <h3>Create a Gift</h3>\n" +
    "        </header>\n" +
    "        \n" +
    "        <form class=\"panel-body\" name=\"gifts\">\n" +
    "\n" +
    "          <div class=\"row bg-light\" style=\"margin-top: -16px; padding-top: 15px; margin-bottom: 15px;\">\n" +
    "            \n" +
    "            <div class=\"form-group col-md-4\">\n" +
    "\n" +
    "              <select class=\"input-lg\" ui-select2=\"{ width: '100%' }\" ng-model=\"gift.type\" data-placeholder=\"Select Gift Type\" required>\n" +
    "                <option value=\"\"></option>\n" +
    "                <option value=\"card\">Gift Card</option>\n" +
    "                <option value=\"certificate\">Gift Certificate</option>\n" +
    "                <option value=\"promo\">Promotion</option>\n" +
    "              </select>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "            <div class=\"form-group col-md-6\">\n" +
    "              <div class=\"input-group input-group-lg\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  name=\"code\"\n" +
    "                  ng-model=\"gift.code\" \n" +
    "                  placeholder=\"{{ codePlaceholder }}\"\n" +
    "                  ui-mask=\"{{ codeMask }}\"\n" +
    "                  class=\"form-control\" \n" +
    "                  ui-validate=\"'code($value)'\"\n" +
    "                  required>\n" +
    "\n" +
    "                <label class=\"input-group-addon\">\n" +
    "                  <input style=\"display: block; margin-top: -2px;\" type=\"checkbox\" ng-model=\"gift.preexisting\" tooltip=\"Pre-Existing Purchase?\">\n" +
    "                </label>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"\" ng-if=\"gifts.code.$error.validator\" style=\"margin-top: 5px;\">\n" +
    "                <div ng-if=\"gift.type == 'promo'\" class=\"alert alert-danger alert-block\" style=\"margin-bottom: 0px;\">A Promotion code must begin with <strong>P - </strong> to be valid.</div>\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-2\">\n" +
    "              <span class=\"label label-success\" style=\"display: inline-block; width: 100%; font-size: 1.2em; padding: 14px 0px;\">Active</span>\n" +
    "            </div>\n" +
    "            \n" +
    "          </div>\n" +
    "            \n" +
    "          <fieldset class=\"row\" ng-if=\"!gift.preexisting\">\n" +
    "            \n" +
    "            <legend style=\"width: 97%; margin: 0px 15px 15px; padding-bottom: 7px;\">Payment Information</legend>\n" +
    "\n" +
    "            <div class=\"col-md-6\">\n" +
    "              \n" +
    "              <div class=\"form-group\">\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.card.number\" \n" +
    "                  placeholder=\"Credit Card Number\" \n" +
    "                  ng-required=\"!gift.preexisting\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "              </div>\n" +
    "              \n" +
    "              <div class=\"row\">\n" +
    "                \n" +
    "                <div class=\"form-group col-md-6\">\n" +
    "                  <select class=\"input-lg\" ui-select2=\"{ width: '100%' }\" ng-model=\"gift.card.exp.month\" data-placeholder=\"Card Expiration Month\">\n" +
    "                    <option value=\"\"></option>\n" +
    "                    <option value=\"01\">01 - January</option>\n" +
    "                    <option value=\"02\">02 - February</option>\n" +
    "                    <option value=\"03\">03 - March</option>\n" +
    "                    <option value=\"04\">04 - April</option>\n" +
    "                    <option value=\"05\">05 - May</option>\n" +
    "                    <option value=\"06\">06 - June</option>\n" +
    "                    <option value=\"07\">07 - July</option>\n" +
    "                    <option value=\"08\">08 - August</option>\n" +
    "                    <option value=\"09\">09 - September</option>\n" +
    "                    <option value=\"10\">10 - October</option>\n" +
    "                    <option value=\"11\">11 - November</option>\n" +
    "                    <option value=\"12\">12 - December</option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-group col-md-6\">\n" +
    "                  <select class=\"input-lg\" ui-select2=\"{ width: '100%' }\" ng-model=\"gift.card.exp.year\" data-placeholder=\"Card Expiration Year\">\n" +
    "                    <option value=\"\"></option>\n" +
    "                    <option value=\"{{year}}\" ng-repeat=\"year in years\">{{ year }}</option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "                \n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.purchaser.address.line_one\" \n" +
    "                  placeholder=\"Billing Address (Street 1)\" \n" +
    "                  ng-required=\"!gift.preexisting\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.purchaser.address.line_two\" \n" +
    "                  placeholder=\"Billing Address (Street 2)\" \n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "  \n" +
    "              <div class=\"row\">\n" +
    "                \n" +
    "                <div class=\"form-group col-md-4\">\n" +
    "\n" +
    "                  <input type=\"text\"\n" +
    "                    ng-model=\"gift.contact.purchaser.address.postal\" \n" +
    "                    placeholder=\"Zip Code\" \n" +
    "                    ng-required=\"!gift.preexisting\"\n" +
    "                    class=\"form-control input-lg\">\n" +
    "\n" +
    "                </div>\n" +
    "                \n" +
    "                <div class=\"form-group col-md-8\">\n" +
    "\n" +
    "                  <input type=\"email\"\n" +
    "                    ng-model=\"gift.contact.purchaser.email\" \n" +
    "                    placeholder=\"Email Address\" \n" +
    "                    ng-required=\"!gift.preexisting\"\n" +
    "                    class=\"form-control input-lg\">\n" +
    "\n" +
    "                </div>\n" +
    "                \n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-6\">\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "                \n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.amount\" \n" +
    "                  placeholder=\"Payment Amount\" \n" +
    "                  ng-required=\"!gift.preexisting\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "                \n" +
    "                <textarea \n" +
    "                  style=\"height: 220px;\"\n" +
    "                  placeholder=\"Payment Description\"\n" +
    "                  class=\"form-control input-lg\"></textarea>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "          </fieldset>\n" +
    "\n" +
    "          <fieldset class=\"row\">\n" +
    "            \n" +
    "            <legend style=\"width: 97%; margin: 0px 15px 15px; padding-bottom: 7px;\">Shipping Information</legend>\n" +
    "\n" +
    "            <!-- Purchaser Information -->\n" +
    "            <div class=\"col-md-6\">\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <div class=\"input-group input-group-lg\">\n" +
    "\n" +
    "                  <label class=\"input-group-addon\" tooltip=\"Send to Purchaser?\"><input name=\"sendTo\" style=\"display: block;\" type=\"radio\" ng-model=\"gift.sendTo\" value=\"purchaser\"></label>\n" +
    "\n" +
    "                  <input type=\"text\"\n" +
    "                    ng-model=\"gift.contact.purchaser.name\" \n" +
    "                    placeholder=\"Purchaser Name\" \n" +
    "                    class=\"form-control\" required>\n" +
    "\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.purchaser.phone\" \n" +
    "                  placeholder=\"Phone Number\" \n" +
    "                  class=\"form-control input-lg\" required>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.line_one\" \n" +
    "                  placeholder=\"Shipping Address (Street 1)\" \n" +
    "                  ng-required=\"gift.sendTo == 'purchaser'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.line_two\" \n" +
    "                  placeholder=\"Shipping Address (Street 2)\" \n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group col-md-8\" style=\"padding-left: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.city\" \n" +
    "                  placeholder=\"City\" \n" +
    "                  ng-required=\"gift.sendTo == 'purchaser'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group col-md-4\" style=\"padding: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.state\" \n" +
    "                  placeholder=\"State\" \n" +
    "                  ng-required=\"gift.sendTo == 'purchaser'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "            <!-- !Purchaser Information -->\n" +
    "\n" +
    "            <!-- Recipient Information -->\n" +
    "            <div class=\"col-md-6\">\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <div class=\"input-group input-group-lg\">\n" +
    "\n" +
    "                  <label class=\"input-group-addon\" tooltip=\"Send to Recipient\"><input name=\"sendTo\" style=\"display: block;\" type=\"radio\" ng-model=\"gift.sendTo\" value=\"recipient\"></label>\n" +
    "\n" +
    "                  <input type=\"text\"\n" +
    "                    ng-model=\"gift.contact.recipient.name\" \n" +
    "                    placeholder=\"Recipient Name\" \n" +
    "                    class=\"form-control\" required>\n" +
    "\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.line_one\" \n" +
    "                  placeholder=\"Shipping Address (Street 1)\" \n" +
    "                  ng-required=\"gift.sendTo == 'recipient'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.line_two\" \n" +
    "                  placeholder=\"Shipping Address (Street 2)\" \n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group col-md-8\" style=\"padding-left: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.city\" \n" +
    "                  placeholder=\"City\" \n" +
    "                  ng-required=\"gift.sendTo == 'recipient'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group col-md-4\" style=\"padding: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  ng-model=\"gift.contact.shipping.address.state\" \n" +
    "                  placeholder=\"State\" \n" +
    "                  ng-required=\"gift.sendTo == 'recipient'\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "            <!-- !Recipient Information -->\n" +
    "\n" +
    "          </fieldset>\n" +
    "          \n" +
    "          <hr>\n" +
    "\n" +
    "          <div class=\"row\">\n" +
    "            \n" +
    "            <div class=\"col-md-4\">\n" +
    "              <span tooltip=\"Date Created\" class=\"label bg-light label-block label-lg\">{{ gift.created || today | readTime:'detailed'}}</span>\n" +
    "            </div>\n" +
    "            \n" +
    "            <div class=\"col-md-4 form-group\">\n" +
    "              \n" +
    "              <div class=\"input-group input-group-lg\">\n" +
    "                \n" +
    "                <input type=\"text\"\n" +
    "                  datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                  datepicker-options=\"dateOptions\"\n" +
    "                  show-weeks=\"false\"\n" +
    "                  ng-model=\"gift.sent\"\n" +
    "                  placeholder=\"Date Sent\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "                \n" +
    "                <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "                  <button type=\"button\" class=\"btn bg-light dk\" ng-click=\"gift.sent = (today | readTime:'MM/DD/YYYY')\">\n" +
    "                    <i class=\"fa fa-clock-o\"></i>\n" +
    "                  </button>\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "            <div class=\"col-md-4 form-group\">\n" +
    "              \n" +
    "              <div class=\"input-group input-group-lg\">\n" +
    "                \n" +
    "                <input type=\"text\"\n" +
    "                  datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                  datepicker-options=\"dateOptions\"\n" +
    "                  show-weeks=\"false\"\n" +
    "                  ng-model=\"gift.expiration\"\n" +
    "                  placeholder=\"Expiration Date\"\n" +
    "                  class=\"form-control\">\n" +
    "                \n" +
    "                <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "                  <button type=\"button\" class=\"btn bg-light dk\" ng-click=\"gift.expiration = (today | readTime:'MM/DD/YYYY')\">\n" +
    "                    <i class=\"fa fa-clock-o\"></i>\n" +
    "                  </button>\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\" style=\"margin-top: 15px;\">\n" +
    "            \n" +
    "            <div class=\"col-md-4 form-group\">\n" +
    "              \n" +
    "              <div class=\"input-group input-group-lg\">\n" +
    "                \n" +
    "                <input type=\"text\"\n" +
    "                  datepicker-popup=\"MM/dd/yyyy\"\n" +
    "                  datepicker-options=\"dateOptions\"\n" +
    "                  show-weeks=\"false\"\n" +
    "                  ng-model=\"gift.redeemed\"\n" +
    "                  placeholder=\"Date Redeemed\"\n" +
    "                  class=\"form-control \">\n" +
    "                \n" +
    "                <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "                  <button type=\"button\" class=\"btn bg-light dk\" ng-click=\"gift.redeemed = (today | readTime:'MM/DD/YYYY')\">\n" +
    "                    <i class=\"fa fa-clock-o\"></i>\n" +
    "                  </button>\n" +
    "                </div>\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-4\">\n" +
    "\n" +
    "              <input type=\"text\"\n" +
    "                ng-model=\"gift.booking\"\n" +
    "                placeholder=\"Confirmation #\"\n" +
    "                class=\"form-control input-lg\">\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-4\">\n" +
    "\n" +
    "              <span class=\"label label-info label-lg label-block\">{{ user.name }}</span>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </form>\n" +
    "\n" +
    "      </section>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("views/gifts/form", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/gifts/form",
    "<header class=\"clearfix\" style=\"max-width: 1200px;\">\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <h2 class=\"col-md-9\">\n" +
    "      <span ng-show=\"!bookings._id\" style=\"float: left;\">\n" +
    "        Prepaid Purchase:\n" +
    "        <small ng-if=\"!gift._id\">Create</small>\n" +
    "        <small ng-if=\"gift._id\">{{ gift.code }}</small>\n" +
    "      </span>\n" +
    "    </h2>\n" +
    "\n" +
    "    <div class=\"pull-right btn-group\">\n" +
    "      <button class=\"btn bg-danger btn-lg\" ui-sref=\"gifts({ page: trans.from.page || 1 })\" style=\"padding: 10px 30px;\">Close</button>\n" +
    "      <button class=\"btn bg-success btn-lg\" style=\"padding: 10px 30px;\" type=\"button\" ng-click=\"submit()\" ng-disabled=\"!giftForm.$valid || saving || amountBalance() > 0\">\n" +
    "        <span ng-if=\"!saving\">Save</span>\n" +
    "        <span ng-if=\"saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "          lines: 17,\n" +
    "          length: 0,\n" +
    "          width: 4,\n" +
    "          radius: 4,\n" +
    "          corners: 1,\n" +
    "          rotate: 0,\n" +
    "          direction: 1,\n" +
    "          color: '#fff',\n" +
    "          speed: 1.2,\n" +
    "          trail: 36,\n" +
    "          shadow: false,\n" +
    "          hwaccel: false,\n" +
    "          className: 'spinner',\n" +
    "          zIndex: 2e9,\n" +
    "          top: '-5px',\n" +
    "          left: 'auto'\n" +
    "        }\"></span>\n" +
    "\n" +
    "      </button>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</header>\n" +
    "\n" +
    "<!-- <pre ng-repeat=\"(key, field) in giftForm\" ng-if=\"giftForm[key].$invalid\">{{ key }}: {{ giftForm[key].$valid | json }}</pre> -->\n" +
    "\n" +
    "<section class=\"\" id=\"giftForm\" style=\"margin-top: 40px;\">\n" +
    "\n" +
    "  <form name=\"giftForm\">\n" +
    "    <!-- Certificate Specific -->\n" +
    "    <div class=\"row bg-light lt\" style=\"margin-top: -16px; padding-top: 15px; margin-bottom: 15px; border: 1px solid #e8eaed\">\n" +
    "\n" +
    "      <div class=\"row col-md-12\">\n" +
    "        <div class=\"form-group col-md-4\">\n" +
    "\n" +
    "          <select class=\"input-lg\" name=\"giftType\" ui-select2=\"{ width: '100%' }\" ng-model=\"gift.type\" data-placeholder=\"Select Gift Type\" required>\n" +
    "            <option value=\"\"></option>\n" +
    "            <option value=\"card\" ng-select=\"{{ gift.type == 'card' }}\">Gift Card</option>\n" +
    "            <option value=\"promo\" ng-select=\"{{ gift.type == 'promo' }}\">Promotional</option>\n" +
    "            <option value=\"donation\" ng-select=\"{{ gift.type == 'donation' }}\">Donation</option>\n" +
    "            <option value=\"zola\" ng-select=\"{{ gift.type == 'zola' }}\">Zola</option>\n" +
    "            <option value=\"certificate\" ng-select=\"{{ gift.type == 'certificate' }}\">Gift Certificate</option>\n" +
    "          </select>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-6\">\n" +
    "\n" +
    "          <div class=\"input-group input-group-lg\" style=\"width: 100%\">\n" +
    "\n" +
    "            <input type=\"text\"\n" +
    "              id=\"giftCodeInput\"\n" +
    "              name=\"code\"\n" +
    "              ng-model=\"gift.code\"\n" +
    "              placeholder=\"{{ codePlaceholder }}\"\n" +
    "              ui-mask=\"{{ codeMask }}\"\n" +
    "              class=\"form-control\"\n" +
    "              ui-validate=\"'validate.code($value)'\"\n" +
    "              required>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"\" ng-if=\"gifts.code.$error.validator\" style=\"margin-top: 5px;\">\n" +
    "            <div ng-if=\"gift.type == 'promo'\" class=\"alert alert-danger alert-block\" style=\"margin-bottom: 0px;\">A Promotion code must begin with <strong>P - </strong> to be valid.</div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-2\">\n" +
    "          <span class=\"label\"\n" +
    "            ng-class=\"{ 'label-success' : gift.state == 'Active', 'label-warning' : gift.state == 'Pending', 'label-danger' : gift.state == 'Expired', 'label-info' : gift.state == 'Redeemed' }\"\n" +
    "            style=\"display: inline-block; width: 100%; font-size: 1.2em; padding: 14px 0px;\">{{ gift.state }}</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row col-md-12\" style=\"padding-bottom: 10px;\">\n" +
    "\n" +
    "        <div class=\"col-md-8\">\n" +
    "\n" +
    "          <label class=\"radio-inline\" ng-class=\"{ 'selected' : gift.electronic == 'true'}\">\n" +
    "            <input type=\"radio\" name=\"electronic\" ng-model=\"gift.electronic\" value=\"true\" /> eDelivery\n" +
    "          </label>\n" +
    "          <label class=\"radio-inline\" ng-class=\"{ 'selected' : gift.electronic == 'false'}\">\n" +
    "            <input type=\"radio\" name=\"electronic\" ng-model=\"gift.electronic\" value=\"false\" /> Traditional\n" +
    "          </label>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-4\">\n" +
    "          <label class=\"checkbox-inline\" style=\"cursor: pointer;\" tooltip=\"Pre-Existing Purchase?\">\n" +
    "            <input type=\"checkbox\" ng-model=\"gift.preexisting\"> PreExisting\n" +
    "          </label>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Certificate Specific -->\n" +
    "    <hr style=\"margin-top: 0; margin-bottom: 2px;\" class=\"invisible\" />\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"helvetica\" style=\"font-weight: 200; font-size: 16px;\">\n" +
    "        <div class=\"col-md-3\" ng-repeat=\"(key, price) in user.activeCompany().prepaids.prices\">\n" +
    "          <label class=\"radio-inline\" ng-class=\"{ 'selected' : gift.amount == price}\">\n" +
    "            <input type=\"radio\" name=\"amount\" ng-model=\"gift.amount\" ng-value=\"{{ price }}\" /> {{ price | currency }}\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-3 form-group\">\n" +
    "          <label class=\"radio-inline input-field\" for=\"manual\" style=\"width: 100%;\">\n" +
    "            <input id=\"manual\"  type=\"radio\" name=\"amount\" ng-model=\"gift.fauxAmount\" ng-value=\"true\" ng-click=\"focus('#fauxValue')\" />\n" +
    "            <input id=\"fauxValue\" name=\"otherAmount\" style=\"margin-top: -7px;\" type=\"number\" class=\"form-control\" placeholder=\"Other Amount\" ng-model=\"gift.fauxValue\" />\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"\" style=\"margin: 0 0 13px 0\" />\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-3\">\n" +
    "\n" +
    "        <label style=\"margin-right: 10px;\">SEND GIFT TO:</label>\n" +
    "        <label class=\"radio-inline\" ng-class=\"{ 'selected' : gift.sendTo == 'purchaser'}\">\n" +
    "          <input name=\"sendTo\" type=\"radio\" ng-model=\"gift.sendTo\" value=\"purchaser\"> Purchaser\n" +
    "        </label>\n" +
    "        <label class=\"radio-inline\" ng-class=\"{ 'selected' : gift.sendTo == 'recipient'}\">\n" +
    "          <input name=\"sendTo\" type=\"radio\" ng-model=\"gift.sendTo\" value=\"recipient\"> Recipient\n" +
    "        </label>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"invisible\" style=\"margin: 0 0 15px 0\" />\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <!-- Purchaser Information -->\n" +
    "      <div class=\"col-md-6\">\n" +
    "\n" +
    "        <strong>From:</strong>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserName\"\n" +
    "            ng-model=\"gift.contact.purchaser.name\"\n" +
    "            placeholder=\"Purchaser Name\"\n" +
    "            class=\"form-control input-lg\" ng-required=\"!gift.preexisting\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <input type=\"email\"\n" +
    "            ng-model=\"gift.contact.purchaser.email\"\n" +
    "            name=\"billingEmail\"\n" +
    "            placeholder=\"Purchaser Email\"\n" +
    "            class=\"form-control input-lg\" ng-required=\"true\" />\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            ng-model=\"gift.contact.purchaser.phone\"\n" +
    "            class=\"hide\">\n" +
    "\n" +
    "          <!-- The above field is the actual phone number to be submitted.\n" +
    "               The api only accepts numbers, so special characters must be purged.\n" +
    "               The purge happens in angular `$watch` -->\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserPhone\"\n" +
    "            ng-model=\"gift.contact.purchaser.phoneFaux\"\n" +
    "            placeholder=\"Phone Number\"\n" +
    "            class=\"form-control input-lg\" ng-required=\"!gift.preexisting && electronic == 'false'\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserShippingAddress\"\n" +
    "            ng-model=\"gift.contact.purchaser.shipping_address.line_one\"\n" +
    "            ng-disabled=\"gift.sendTo == 'recipient'\"\n" +
    "            placeholder=\"Shipping Address (Street 1)\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'purchaser'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserShippingAddaress2\"\n" +
    "            ng-model=\"gift.contact.purchaser.shipping_address.line_two\"\n" +
    "            ng-disabled=\"gift.sendTo == 'recipient'\"\n" +
    "            placeholder=\"Shipping Address (Street 2)\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-5\" style=\"padding: 0;\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserShippingAddressCity\"\n" +
    "            ng-model=\"gift.contact.purchaser.shipping_address.city\"\n" +
    "            ng-disabled=\"gift.sendTo == 'recipient'\"\n" +
    "            placeholder=\"City\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'purchaser'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-4\" style=\"\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserShippingAddressState\"\n" +
    "            ng-model=\"gift.contact.purchaser.shipping_address.state\"\n" +
    "            ng-disabled=\"gift.sendTo == 'recipient'\"\n" +
    "            placeholder=\"State\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'purchaser'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-3\" style=\"padding: 0;\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"PurchaserShippingAddressPostal\"\n" +
    "            ng-model=\"gift.contact.purchaser.shipping_address.postal\"\n" +
    "            ng-disabled=\"gift.sendTo == 'recipient'\"\n" +
    "            placeholder=\"Zip\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'purchaser'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Purchaser Information -->\n" +
    "\n" +
    "      <!-- Recipient Information -->\n" +
    "      <div class=\"col-md-6\">\n" +
    "\n" +
    "        <strong>To:</strong>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientName\"\n" +
    "            ng-model=\"gift.contact.recipient.name\"\n" +
    "            placeholder=\"Recipient Name\"\n" +
    "            class=\"form-control input-lg\" ng-required=\"eToRecipient() || gift.sendTo == 'recipient'\"/>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientEmail\"\n" +
    "            ng-model=\"gift.contact.recipient.email\"\n" +
    "            placeholder=\"Recipient Email\"\n" +
    "            class=\"form-control input-lg\" ng-required=\"eToRecipient()\"/>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientShippingAddress\"\n" +
    "            ng-model=\"gift.contact.recipient.shipping_address.line_one\"\n" +
    "            ng-disabled=\"gift.sendTo == 'purchaser'\"\n" +
    "            placeholder=\"Shipping Address (Street 1)\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'recipient'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientShippingAddress2\"\n" +
    "            ng-model=\"gift.contact.recipient.shipping_address.line_two\"\n" +
    "            ng-disabled=\"gift.sendTo == 'purchaser'\"\n" +
    "            placeholder=\"Shipping Address (Street 2)\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-5\" style=\"padding: 0;\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientShippingAddressCity\"\n" +
    "            ng-model=\"gift.contact.recipient.shipping_address.city\"\n" +
    "            ng-disabled=\"gift.sendTo == 'purchaser'\"\n" +
    "            placeholder=\"City\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'recipient'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-4\" style=\"\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientShippingAddressState\"\n" +
    "            ng-model=\"gift.contact.recipient.shipping_address.state\"\n" +
    "            ng-disabled=\"gift.sendTo == 'purchaser'\"\n" +
    "            placeholder=\"State\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'recipient'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group col-md-3\" style=\"padding: 0;\" ng-if=\"!isElectronic()\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RecipientShippingAddressPostal\"\n" +
    "            ng-model=\"gift.contact.recipient.shipping_address.postal\"\n" +
    "            ng-disabled=\"gift.sendTo == 'purchaser'\"\n" +
    "            placeholder=\"Zip\"\n" +
    "            ng-required=\"!isElectronic() && !gift.preexisting && gift.sendTo == 'recipient'\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <textarea\n" +
    "            name=\"RecipientMessage\"\n" +
    "            style=\"height: 45px;\"\n" +
    "            placeholder=\"Custom message for recipient\"\n" +
    "            ng-model=\"gift.notes\"\n" +
    "            class=\"form-control input-lg\"></textarea>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <!-- !Recipient Information -->\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"invisible\" />\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"col-md-6 helvetica\" style=\"color: #175778;\">\n" +
    "\n" +
    "        <h4\n" +
    "          style=\"padding: 0; margin: 0; float: left;font-size: 28px; font-weight: 200;\"\n" +
    "          ng-show=\"!isElectronic() && gift.type == 'card'\">Total: {{ gift.amountFloat + 2.5 | currency }}</h4>\n" +
    "        <h4\n" +
    "          style=\"padding: 0; margin: 0; float: left;font-size: 28px; font-weight: 200;\"\n" +
    "          ng-show=\"isElectronic() || gift.type != 'card'\">Total: {{ gift.amountFloat | currency }}</h4>\n" +
    "\n" +
    "        <ul class=\"list-unstyled\" ng-if=\"!isElectronic() && gift.type == 'card'\" style=\"font-size: 1.1em; float: left; margin-left: 10px; font-size: 14px;\">\n" +
    "          <li><strong>Gift</strong>: {{ gift.amountFloat | currency }}</li>\n" +
    "          <li><strong>Shipping & Handling</strong>: $2.50</li>\n" +
    "        </ul>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-6\">\n" +
    "\n" +
    "        <div class=\"form-group\" style=\"padding-left: 110px;\">\n" +
    "\n" +
    "          <label for=\"DiscountAmount\" style=\"margin-left: -110px; margin-top: 2px;\">Apply Discount</label>\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            style=\"margin-top: -35px;\"\n" +
    "            name=\"DiscountAmount\"\n" +
    "            id=\"DiscountAmount\"\n" +
    "            ng-model=\"gift.discount\"\n" +
    "            placeholder=\"ex. $15 or 15%\"\n" +
    "            ui-validate=\"{ 'discount' : 'validate.discount($value)' }\"\n" +
    "            class=\"form-control input-lg\" />\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"invisible\" />\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"col-md-6\">\n" +
    "        <div class=\"form-group\">\n" +
    "\n" +
    "          <textarea\n" +
    "            name=\"PaymentDescription\"\n" +
    "            style=\"height: 99px;\"\n" +
    "            placeholder=\"Payment Description\"\n" +
    "            ng-model=\"gift.description\"\n" +
    "            class=\"form-control input-lg\"></textarea>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-6\">\n" +
    "\n" +
    "        <!-- Credit Card Entry -->\n" +
    "\n" +
    "        <div class=\"row\" ng-init=\"showCardEntry = !gift.cards || gift.cards.length == 0\">\n" +
    "\n" +
    "          <div class=\"row cards\" ng-class=\"{ last : $last }\" ng-hide=\"gift.cards.length == 0\" ng-repeat=\"card in gift.cards\">\n" +
    "\n" +
    "            <input name=\"Card[{{ $index }}].ID\" type=\"text\" class=\"hide\" ng-model=\"card.id\" />\n" +
    "\n" +
    "            <div class=\"col-md-7\" style=\"padding-right: 0;\">\n" +
    "              <div class=\"label label-block label-lg bg-light lter\" style=\"padding: 12px;\">\n" +
    "                {{ card.type }} - {{ card.masked }}\n" +
    "                <span ng-if=\"card.charges.length > 0\" class=\"label label-success pull-right\">{{ card.totalCharges() | currency }}</span>\n" +
    "                <span ng-if=\"card.charges.length == 0\" class=\"label label-danger pull-right\">Failed</span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-3 input-group\">\n" +
    "              <label class=\"input-group-addon\" style=\"cursor: pointer;\">$</label>\n" +
    "              <input type=\"text\" class=\"form-control input-lg\" ng-model=\"card.amount\" placeholder=\"0.00\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-2 col-xs-12\" style=\"padding-left: 0;\">\n" +
    "              <button\n" +
    "                style=\"font-size: 1.1em;\"\n" +
    "                type=\"button\"\n" +
    "                ng-click=\"card.charge(gift.customerId)\"\n" +
    "                ng-disabled=\"!card.amount || card.amount == 0 || card.amount > amountBalance()\"\n" +
    "                class=\"btn btn-lg bg-success lter btn-block\">\n" +
    "\n" +
    "                <span ng-if=\"!card.charging\">Charge</span>\n" +
    "                <span ng-if=\"card.charging\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "                  lines: 17,\n" +
    "                  length: 0,\n" +
    "                  width: 4,\n" +
    "                  radius: 4,\n" +
    "                  corners: 1,\n" +
    "                  rotate: 0,\n" +
    "                  direction: 1,\n" +
    "                  color: '#fff',\n" +
    "                  speed: 1.2,\n" +
    "                  trail: 36,\n" +
    "                  shadow: false,\n" +
    "                  hwaccel: false,\n" +
    "                  className: 'spinner',\n" +
    "                  zIndex: 2e9,\n" +
    "                  top: '-5px',\n" +
    "                  left: 'auto'\n" +
    "                }\"></span>\n" +
    "\n" +
    "              </button>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div ng-show=\"showCardEntry\">\n" +
    "\n" +
    "            <div class=\"row\" style=\"\">\n" +
    "              <div class=\"col-md-7 col-xs-10 input-group\" style=\"position: relative; padding-right: 0;\" >\n" +
    "                <span class=\"label label-danger\" style=\"position: absolute; top: -17px;\">{{ errors.number.message }}</span>\n" +
    "                <input ng-class=\"{ 'ng-invalid': errors.number }\" type=\"text\" name=\"cardNumber\" class=\"form-control input-lg\" ng-model=\"gift.cardEntry.number\" placeholder=\"Credit Card Number\" />\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"input-group col-md-3\" style=\"\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  style=\"text-align: center; font-size: 1.1em;\"\n" +
    "                  name=\"cardExpiration\"\n" +
    "                  ng-model=\"gift.cardEntry.expiration\"\n" +
    "                  ui-mask=\"99/99\"\n" +
    "                  ui-validate=\"'validate.expiration($value)'\"\n" +
    "                  ng-required=\"false\"\n" +
    "                  class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"input-group col-md-2\" style=\"padding-left: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  style=\"text-align: center;\"\n" +
    "                  name=\"cardCVV\"\n" +
    "                  ng-model=\"gift.cardEntry.cvv\"\n" +
    "                  placeholder=\"CVV\"\n" +
    "                  class=\"form-control input-lg lightPadd\">\n" +
    "\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" style=\"margin-top: 10px;\">\n" +
    "              <div class=\"form-group col-md-5\" style=\"padding-right: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  name=\"billingAddress\"\n" +
    "                  ng-model=\"gift.contact.purchaser.billing_address.line_one\"\n" +
    "                  placeholder=\"Billing Address (Street 1)\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"form-group col-md-2\" style=\"padding-right: 0;\">\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  name=\"billingZip\"\n" +
    "                  ng-model=\"gift.contact.purchaser.billing_address.postal\"\n" +
    "                  placeholder=\"Zip\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"input-group col-md-3\">\n" +
    "\n" +
    "                <label class=\"input-group-addon\" style=\"cursor: pointer;\">$</label>\n" +
    "\n" +
    "                <input type=\"text\"\n" +
    "                  name=\"chargeAmount\"\n" +
    "                  ng-model=\"gift.cardEntry.amount\"\n" +
    "                  class=\"form-control input-lg\">\n" +
    "\n" +
    "              </div>\n" +
    "\n" +
    "              <div class=\"col-md-2 col-xs-12\" style=\"padding-left: 0;\">\n" +
    "                <button\n" +
    "                  style=\"font-size: 1.1em;\"\n" +
    "                  type=\"button\"\n" +
    "                  ng-click=\"gift.cardEntry.charging = true; checkCard()\"\n" +
    "                  ng-disabled=\"gift.cardEntry.amount > amountBalance() || (!giftForm.cardNumber.$valid || !giftForm.cardExpiration.$valid || gift.amountFloat <= 0)\"\n" +
    "                  class=\"btn btn-lg bg-success lter btn-block\">\n" +
    "\n" +
    "                  <span ng-if=\"!gift.cardEntry.charging\">Charge</span>\n" +
    "                  <span ng-if=\"gift.cardEntry.charging\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "                    lines: 17,\n" +
    "                    length: 0,\n" +
    "                    width: 4,\n" +
    "                    radius: 4,\n" +
    "                    corners: 1,\n" +
    "                    rotate: 0,\n" +
    "                    direction: 1,\n" +
    "                    color: '#fff',\n" +
    "                    speed: 1.2,\n" +
    "                    trail: 36,\n" +
    "                    shadow: false,\n" +
    "                    hwaccel: false,\n" +
    "                    className: 'spinner',\n" +
    "                    zIndex: 2e9,\n" +
    "                    top: '-5px',\n" +
    "                    left: 'auto'\n" +
    "                  }\"></span>\n" +
    "\n" +
    "                </button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <button type=\"button\" ng-hide=\"!gift.cards || gift.cards.length == 0\" class=\"btn btn-block btn-link\" ng-click=\"showCardEntry = !showCardEntry\"><i class=\"fa fa-plus\"></i> Add Card</button>\n" +
    "\n" +
    "        </div>\n" +
    "        <!-- !Credit Card Entry -->\n" +
    "\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"invisible\">\n" +
    "\n" +
    "    <!-- Meta Info (dates) -->\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"\" ng-class=\"{ 'col-md-3' : isElectronic(), 'col-md-4' : !isElectronic() }\">\n" +
    "        <span tooltip=\"Date Created\" class=\"label bg-light lter label-block label-lg\" style=\"font-weight: normal;\">{{ gift.created || today | readTime:'detailed':true }}</span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'col-md-3' : isElectronic(), 'col-md-4' : !isElectronic() }\">\n" +
    "\n" +
    "        <div class=\"input-group input-group-lg\" tooltip=\"Sent Gift\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"SentDate\"\n" +
    "            datepicker-popup=\"MM/dd/yyyy\"\n" +
    "            datepicker-options=\"dateOptions\"\n" +
    "            show-weeks=\"false\"\n" +
    "            ng-model=\"gift.sent\"\n" +
    "            ng-disabled=\"gift.electronic == 'true'\"\n" +
    "            placeholder=\"Date Sent\"\n" +
    "            class=\"form-control input-lg\">\n" +
    "\n" +
    "          <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "            <button type=\"button\"\n" +
    "							class=\"btn bg-light lter\"\n" +
    "							ng-disabled=\"gift.electronic == 'true'\"\n" +
    "							ng-click=\"gift.sent = (today | readTime:'MM/DD/YYYY':true)\">\n" +
    "              <i class=\"fa fa-clock-o\"></i>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\" ng-if=\"isElectronic()\" ng-class=\"{ 'col-md-3' : isElectronic(), 'col-md-4' : !isElectronic() }\">\n" +
    "\n" +
    "        <div class=\"input-group input-group-lg\" tooltip=\"Send eVoucher On\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"SendOnDate\"\n" +
    "            datepicker-popup=\"MM/dd/yyyy\"\n" +
    "            datepicker-options=\"dateOptions\"\n" +
    "            show-weeks=\"false\"\n" +
    "            ng-model=\"gift.send_on\"\n" +
    "            placeholder=\"Send eVoucher on\"\n" +
    "            class=\"form-control input-lg\"\n" +
    "            ng-required=\"isElectronic()\">\n" +
    "\n" +
    "          <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "            <button type=\"button\" class=\"btn bg-light lter\" ng-click=\"gift.send_on = (today | readTime:'MM/DD/YYYY':true)\">\n" +
    "              <i class=\"fa fa-clock-o\"></i>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'col-md-3' : isElectronic(), 'col-md-4' : !isElectronic() }\">\n" +
    "\n" +
    "        <div class=\"input-group input-group-lg\" tooltip=\"Gift Expiration\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"ExpirationDate\"\n" +
    "            datepicker-popup=\"MM/dd/yyyy\"\n" +
    "            datepicker-options=\"dateOptions\"\n" +
    "            show-weeks=\"false\"\n" +
    "            ng-model=\"gift.expiration\"\n" +
    "            placeholder=\"Expiration Date\"\n" +
    "            class=\"form-control\">\n" +
    "\n" +
    "          <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "            <button type=\"button\" class=\"btn bg-light lter\" ng-click=\"gift.expiration = (today | readTime:'MM/DD/YYYY')\">\n" +
    "              <i class=\"fa fa-clock-o\"></i>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" style=\"margin-top: 15px;\">\n" +
    "\n" +
    "      <div class=\"col-md-4 form-group\">\n" +
    "\n" +
    "        <div class=\"input-group input-group-lg\" tooltip=\"Redeemed?\">\n" +
    "\n" +
    "          <input type=\"text\"\n" +
    "            name=\"RedeemedDate\"\n" +
    "            datepicker-popup=\"MM/dd/yyyy\"\n" +
    "            datepicker-options=\"dateOptions\"\n" +
    "            show-weeks=\"false\"\n" +
    "            ng-model=\"gift.redeemed\"\n" +
    "            placeholder=\"Date Redeemed\"\n" +
    "            class=\"form-control \">\n" +
    "\n" +
    "          <div class=\"input-group-btn\" tooltip=\"Set to Today\">\n" +
    "            <button type=\"button\" class=\"btn bg-light lter\" ng-click=\"gift.redeemed = (today | readTime:'MM/DD/YYYY')\">\n" +
    "              <i class=\"fa fa-clock-o\"></i>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-4\">\n" +
    "        \n" +
    "        <div class=\"input-group input-group-lg\">\n" +
    "          <input type=\"text\"\n" +
    "            name=\"confirmationNumber\"\n" +
    "            ng-model=\"gift.manual\"\n" +
    "            placeholder=\"Confirmation #\"\n" +
    "            ng-required=\"gift.redeemed\"\n" +
    "            class=\"form-control input-lg\" />\n" +
    "\n" +
    "          <div class=\"input-group-btn\">\n" +
    "            <a target=\"_blank\" ng-disabled=\"!gift.booking\" class=\"btn bg-light lter\" ng-href=\"/booking/{{gift.booking.confirmation}}\">\n" +
    "              <i class=\"fa fa-link\"></i>\n" +
    "            </a>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-4\">\n" +
    "\n" +
    "        <span class=\"label bg-light lter label-block label-lg\" style=\"font-weight: normal;\">{{ gift.agent.name || user.name || 'Online Form' }}</span>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- !Meta Info (dates) -->\n" +
    "\n" +
    "    <div class=\"row\" style=\"\">\n" +
    "\n" +
    "      <div ng-if=\"!giftForm.$valid || errors || amountBalance() > 0\" class=\"alert alert-block alert-danger\">\n" +
    "\n" +
    "        <h5>Form Errors</h5>\n" +
    "\n" +
    "        <ul class=\"list list-unstyled\">\n" +
    "          <li ng-if=\"giftForm.giftType.$invalid\">Select a <code>Gift Type</code>.</li>\n" +
    "          <li ng-if=\"giftForm.code.$invalid\"><code>Gift Code</code> field is empty or invalid.</li>\n" +
    "          <li ng-if=\"!gift.amount || giftForm.amount.$invalid\">You must specify an <code>amount</code> for the gift.</li>\n" +
    "        </ul>\n" +
    "\n" +
    "        <!-- These errors only show up if gift isn't preexisting -->\n" +
    "        <ul class=\"list list-unstyled\" ng-if=\"!gift.preexisting\">\n" +
    "\n" +
    "          <li ng-if=\"amountBalance() > 0\">A <code>Balance</code> of {{ amountBalance() | currency }} remains to be paid.</li>\n" +
    "\n" +
    "          <li ng-if=\"giftForm.electronic.$invalid\">Gift needs to be either <code>electronic</code> or <code>traditional</code>.</li>\n" +
    "          <li ng-if=\"gift.cards.length == 0 && amountBalance() > 0\">No <code>Credit Cards</code> have been entered.</li>\n" +
    "          <li ng-if=\"giftForm.PurchaserName.$invalid\"><code>Purchaser Name</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.RecipientName.$invalid\"><code>Recipient Name</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.sendTo.$invalid\">Please specify who to <code>send to</code></li>\n" +
    "          <li ng-if=\"giftForm.billingEmail.$invalid\"><code>Purchaser Email</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.PurchaserPhone.$invalid\"><code>Purchaser Phone Number</code> is required</li>\n" +
    "\n" +
    "          <li ng-if=\"giftForm.PurchaserShippingAddress.$invalid\"><code>Purchaser Shipping Address</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.PurchaserShippingAddressCity.$invalid\"><code>Purchaser Shipping City</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.PurchaserShippingAddressState.$invalid\"><code>Purchaser Shipping State</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.PurchaserShippingAddressPostal.$invalid\"><code>Purchaser Shipping Zip Code</code> is required</li>\n" +
    "\n" +
    "          <li ng-if=\"giftForm.RecipientShippingAddress.$invalid\"><code>Recipient Shipping Address</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.RecipientShippingAddressCity.$invalid\"><code>Recipient Shipping City</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.RecipientShippingAddressState.$invalid\"><code>Recipient Shipping State</code> is required</li>\n" +
    "          <li ng-if=\"giftForm.RecipientShippingAddressPostal.$invalid\"><code>Recipient Shipping Zip Code</code> is required</li>\n" +
    "\n" +
    "          <li ng-if=\"giftForm.SendOnDate.$invalid\">You must specify a <code>Send eVoucher On</code> date for electronic prepaids.</li>\n" +
    "        </ul>\n" +
    "\n" +
    "        <ul class=\"list list-unstyled\">\n" +
    "          <li ng-repeat=\"(code, error) in errors\"><code>{{ code }}</code>{{ error }}</li>\n" +
    "        </ul>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "  </form>\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("views/gifts/list", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/gifts/list",
    "<header class=\"gifts clearfix\">\n" +
    "\n" +
    "  <h2 class=\"\" style=\"margin-bottom: 20px;\">\n" +
    "    <span class=\"pull-left\" style=\"margin-right: 20px;\">Existing Gifts</span> \n" +
    "    <input style=\"float: left;display: inline-block;width: 300px;\" class=\"form-control\" type=\"text\" placeholder=\"Code Search\" class=\"searchHeader\" style=\"margin-top: -12px\" ng-model=\"q\" ui-event=\"{ 'keydown' : 'byInput($event);' }\"/>\n" +
    "    \n" +
    "  </h2>\n" +
    "\n" +
    "  <div class=\"pull-right\" style=\"width: 300px;\">\n" +
    "    <div class=\"checkbox pull-right\" style=\"margin: 6px 20px;\">\n" +
    "      <label>\n" +
    "        <input type=\"checkbox\" ng-model=\"useNew\"> Use New\n" +
    "      </label>\n" +
    "    </div>\n" +
    "    <a ng-if=\"!useNew\" ui-sref=\"giftsCreate()\" class=\"btn bg-success pull-right\" style=\"color: #fff\" ng-if=\"user.can('add', 'Prepayments')\"><i class=\"fa fa-plus\"></i> New Prepaid</a>\n" +
    "    <a ng-if=\"useNew\" ui-sref=\"newPrepayment({ type: 'gift' })\" class=\"btn bg-success pull-right\" style=\"color: #fff\" ng-if=\"user.can('add', 'Prepayments')\"><i class=\"fa fa-plus\"></i> New Prepaid</a>\n" +
    "  </div>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<table class=\"table table-hover table-condensed\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><input type=\"text\" ng-model=\"giftsearch.$\" placeholder=\"Gift Code\"></th>\n" +
    "      <th>Amount</th>\n" +
    "      <th>From</th>\n" +
    "      <th>Phone</th>\n" +
    "      <th>Email</th>\n" +
    "      <th>To</th>\n" +
    "      <th></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-if=\"gifts.count == 0\">\n" +
    "      <td colspan=\"7\" style=\"padding: 5px;\"><div class=\"alert alert-block alert-info\" style=\"text-align: center\">No Gift Certificates.</div></td>\n" +
    "    </tr>\n" +
    "    <tr ng-repeat=\"(key, gift) in gifts.results | orderBy:'-created' | filter:giftsearch\" ng-init=\"getState(gift)\" ng-hide=\"gift.removed\">\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\">\n" +
    "        <span class=\"label label-block label-md\" style=\"font-size: 1em;\"\n" +
    "          ng-class=\"{ 'label-success' : gift.state == 'Active', 'label-warning' : gift.state == 'Pending', 'label-danger' : gift.state == 'Expired', 'label-info' : gift.state == 'Redeemed' }\">\n" +
    "          <span ng-show=\"gift.state != 'Pending'\">{{ gift.code | card }}</span>\n" +
    "          <span ng-show=\"gift.state == 'Pending'\">Pending</span>\n" +
    "        </span>\n" +
    "      </td>\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\">{{ gift.amount | currency }}</td>\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\">{{ gift.contact.purchaser.name }}</td>\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\"><span style=\"white-space: nowrap\">{{ gift.contact.purchaser.phone | phone }}</span></td>\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\">{{ gift.contact.purchaser.email }}</td>\n" +
    "      <td style=\"cursor: pointer;\" ng-click=\"go(gift._id)\">{{ gift.contact.recipient.name }}</td>\n" +
    "      <td>\n" +
    "        <div class=\"btn-group\" style=\"min-width: 120px\">\n" +
    "          <button class=\"book btn btn-link\" ui-sref=\"booking({ action: 'add', day: (date | readTime:'MM-DD-YY'), gift: '/' + gift._id })\"  tooltip=\"Create a booking\" tooltip-append-to-body=\"true\"><i class=\"fa fa-share\"></i></button>\n" +
    "\n" +
    "          <button class=\"delete btn btn-link\" ng-click=\"removeConfirm(gift)\" tooltip=\"Delete Gift (permanent)\" tooltip-append-to-body=\"true\"><i class=\"fa fa-times\"></i></button>\n" +
    "\n" +
    "          <button ng-if=\"gift.electronic\" class=\"send btn btn-link\" ng-click=\"resend(gift)\" ng-class=\"{ 'lter' : gift.isSent, 'lt' : !gift.isSent }\" tooltip=\"Send Voucher\" tooltip-append-to-body=\"true\">\n" +
    "            <i ng-if=\"!gift.sending && !gift.isSent\" class=\"fa fa-envelope\"></i>\n" +
    "            <i ng-if=\"!gift.sending && gift.isSent\" class=\"fa fa-check\"></i>\n" +
    "            <span ng-if=\"gift.sending\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "              lines: 17,\n" +
    "              length: 0,\n" +
    "              width: 4,\n" +
    "              radius: 4,\n" +
    "              corners: 1,\n" +
    "              rotate: 0,\n" +
    "              direction: 1,\n" +
    "              color: '#fff',\n" +
    "              speed: 1.2,\n" +
    "              trail: 36,\n" +
    "              shadow: false,\n" +
    "              hwaccel: false,\n" +
    "              className: 'spinner',\n" +
    "              zIndex: 2e9,\n" +
    "              top: '-5px',\n" +
    "              left: 'auto'\n" +
    "            }\"></span>\n" +
    "\n" +
    "          </button>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "  <button type=\"button\" ng-disabled=\"state.page == 1 || state.name == 'allGifts'\" ui-sref=\"gifts({ page: (state.page - 1)})\" class=\"col-md-3 btn bg-light lt\">Previous Gifts</button>\n" +
    "  <div class=\"col-md-6\">\n" +
    "    <button type=\"button\" ng-show=\"state.name != 'allGifts'\" ui-sref=\"allGifts()\" class=\"col-md-6 btn-block btn btn-link\" tooltip=\"Takes a bit to load\">All Prepaids</button>\n" +
    "    <button type=\"button\" ng-show=\"state.name == 'allGifts'\" ui-sref=\"gifts({ page: 1 })\" class=\"col-md-6 btn-block btn btn-link\">First 50 Prepaids</button>\n" +
    "  </div>\n" +
    "  <button type=\"button\" ng-disabled=\"state.name == 'allGifts'\" ui-sref=\"gifts({ page: (state.page + 1)})\" class=\"col-md-3 btn bg-light lt\">Next Gifts</button>\n" +
    "</div>");
}]);

angular.module("views/home", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/home",
    "");
}]);

angular.module("views/login", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/login",
    "<section id=\"content\" class=\"m-t-lg wrapper-md\">\n" +
    "\n" +
    "  <div class=\"row m-n\">\n" +
    "    <div class=\"col-md-3 m-t-lg\" style=\"position: absolute; left: 50%; margin-left: -14%; margin-top: 10%\">\n" +
    "      <section>\n" +
    "        \n" +
    "        <div style=\"text-align: center;margin-bottom: 30px;\">\n" +
    "          <img src=\"./assets/images/logo.png\" alt=\"\" style=\"width: 150px;\">\n" +
    "        </div>\n" +
    "\n" +
    "        <header class=\"\" style=\"margin-bottom: 20px;\">\n" +
    "          <h2 style=\"text-transform: none;\">Log Into My Account</h2>\n" +
    "        </header>\n" +
    "\n" +
    "        <form id=\"loginForm\" name=\"login\" ng-submit=\"auth(user)\">\n" +
    "          \n" +
    "          <div class=\"alert alert-success alert-block\" ng-if=\"msg.success\">{{ msg.success }}</div>\n" +
    "\n" +
    "          <div ng-if=\"error && error === 'User not found.'\" class=\"alert alert-danger\" class=\"invalid-email\">\n" +
    "             No account was found for the email address.  Please try again or create an account\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"alert alert-danger\" ng-if=\"error && error === 'Password Mismatch'\" class=\"invalid-password\">\n" +
    "             Your password appears to be invalid.  Please try again.\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\" ng-class=\"{ 'has-error' : error == 'User not found.' }\">\n" +
    "\n" +
    "            <input type=\"email\"\n" +
    "              ng-model=\"user.email\" \n" +
    "              placeholder=\"Email Address\" \n" +
    "              class=\"form-control input-lg\" required>\n" +
    "\n" +
    "            <span ng-if=\"error && error == 'User not found.'\" class=\"help-block\">{{ error.message }}</span>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\" ng-class=\"{ 'has-error' : error == 'Password Mismatch' }\">\n" +
    "\n" +
    "            <input type=\"password\"\n" +
    "              ng-model=\"user.password\" \n" +
    "              id=\"inputPassword\" \n" +
    "              placeholder=\"Password\"\n" +
    "              class=\"form-control input-lg\" required>\n" +
    "              \n" +
    "              <span ng-if=\"error && error == 'Password Mismatch'\" class=\"help-block\">{{ error.message }}</span>\n" +
    "\n" +
    "          </div>\n" +
    "          \n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "              <button type=\"submit\" class=\"btn bg-info dker btn-lg\" ng-click=\"auth(user)\">Log In </button>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6\">\n" +
    "              <button type=\"button\" style=\"font-weight: normal; text-align: right; padding: 0; color: #4e5b68\" class=\"btn btn-link pull-right\" ng-click=\"changePwd(user.email)\">Forgot Password?</button><br>\n" +
    "              <a href=\"/register\" style=\"font-weight: normal; text-align: right; padding: 0; color: #4e5b68\" class=\"btn btn-link pull-right\">Don't have an account?</a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </form> \n" +
    "      </section>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("views/notifications", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/notifications",
    "<div class=\"row\">\n" +
    "\n" +
    "  <h2 class=\"clearfix\" style=\"margin-bottom: 20px;\">\n" +
    "    <span class=\"pull-left\" style=\"margin-right: 20px;\">Notifications</span>\n" +
    "  </h2>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "  \n" +
    "      <header class=\"clearfix\">\n" +
    "  \n" +
    "        <h4 class=\"\" style=\"margin-bottom: 20px; overflow: hidden;\">\n" +
    "          <span class=\"pull-left\" style=\"margin-right: 20px;\">Pending Bookings</span>\n" +
    "        </h4>\n" +
    "  \n" +
    "      </header>\n" +
    "  \n" +
    "      <table class=\"reservations table table-hover table-condensed\" ng-controller=\"reservationsCtrl\">\n" +
    "        <thead>\n" +
    "          <tr>\n" +
    "            <th style=\"width: 140px;\">#</th>\n" +
    "            <th>Contact</th>\n" +
    "            <th style=\"text-align: center;\">Guests</th>\n" +
    "            <th>Package</th>\n" +
    "            <th>Hotel</th>\n" +
    "            <th style=\"max-width: 100px; text-align: center;\">Pickup</th>\n" +
    "            <th>Phone Number</th>\n" +
    "            <th>{{ reservations }}</th>\n" +
    "          </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "          <tr ng-repeat=\"booking in bookings | orderBy:'day'\" class=\"\" ng-init=\"booking.unread = (booking.trace | arrayFilter:'val.reason === \\'open\\' && !val.ignore' | arrayCount) <= 0\" ng-class=\"{ 'warning' : booking.legacy, 'danger': booking.unread }\" ng-hide=\"booking.status != 'pending'\">\n" +
    "            <td ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true)})\" class=\"point\">\n" +
    "              <span class=\"label\"\n" +
    "                ng-class=\"{ 'label-success' : dateDiff(booking.day) >= 8, 'label-warning' : (dateDiff(booking.day) < 8 && dateDiff(booking.day) >= 3), 'label-danger': dateDiff(booking.day) <= 2 }\"\n" +
    "               ng-if=\"booking.status == 'pending'\">{{ booking.day | readTime: 'MM/DD':true}}</span>\n" +
    "            </td>\n" +
    "            <td ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true)})\" class=\"point\">\n" +
    "              <span title=\"Booking contains heavy guest\" ng-if=\"isHeavy(booking)\"><i class=\"fa fa-anchor\" style=\"margin-right: 5px; margin-left: 10px;\"></i></span>\n" +
    "              <a ng-if=\"!booking.group\" class=\"btn btn-link\">{{ booking.last_name }}, {{ booking.first_name }}</a>\n" +
    "              <a ng-if=\"booking.group\" class=\"btn btn-link\">{{ booking.group_name }}</a>\n" +
    "              <div class=\"pull-right\" style=\"margin: 6px 0\">\n" +
    "                <span class=\"label lter bg-success label-sm\" ng-show=\"booking.vip\">VIP</span>\n" +
    "                <span class=\"label lter bg-info label-sm\" ng-show=\"booking.group\">Group</span>\n" +
    "                <span class=\"label lter bg-warning label-sm\" ng-show=\"booking.hotel\">Hotel</span>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "            <td style=\"text-align: center;\" ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true) })\" class=\"point\">{{ booking.adults + booking.children }}</td>\n" +
    "            <td ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true)})\" class=\"point\">{{ booking.package.name }}</td>\n" +
    "            <td ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true)})\" class=\"point\">\n" +
    "              <span ng-if=\"booking.accommodations.hotel.name !== 'Other'\">{{ booking.accommodations.hotel.name }}</span>\n" +
    "              <em ng-if=\"booking.accommodations.hotel.name === 'Other'\">{{ booking.accommodations.other }}</em>\n" +
    "            </td>\n" +
    "            <td style=\"text-align: center;\" ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true) })\" class=\"point\">\n" +
    "              <a ng-if=\"booking.needs_pickup\" href=\"\">{{ booking.pickup.time | readTime: 'h:mm a' }}</a>\n" +
    "              <a ng-if=\"!booking.needs_pickup\" href=\"\">-</a>\n" +
    "            </td>\n" +
    "            <td ui-sref=\"day.bookings({ day: (booking.day | readTime: 'MM-DD-YY':true)})\" class=\"point\"><span tooltip=\"Working on format\">{{ booking.phone | tel }}</span></td>\n" +
    "            <td>\n" +
    "              <div class=\"pull-right btn-group\">\n" +
    "                <button type=\"button\" ng-if=\"!booking.unread\" class=\"instructions btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" ng-click=\"unread(booking)\">\n" +
    "                  <i class=\"fa fa-eye-slash\" aria-hidden=\"true\"></i>\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"cancel btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" ng-click=\"cancel(booking)\">\n" +
    "                  <i class=\"fa fa-times\"></i>\n" +
    "                </button>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </tbody>\n" +
    "      </table>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "  <div class=\"col-md-12\"\n" +
    "    ng-controller=\"BookedOnline\" ng-include src=\"'comp/reservations/booked_online/template'\">\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/overrides/daterangepicker", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/overrides/daterangepicker",
    "<div class=\"daterangepicker dropdown-menu\">\n" +
    "    <div class=\"calendar left\">\n" +
    "        <div class=\"daterangepicker_input\">\n" +
    "          <input class=\"input-mini\" type=\"text\" name=\"daterangepicker_start\" value=\"\" />\n" +
    "          <i class=\"fa fa-calendar\"></i>\n" +
    "          <div class=\"calendar-time\">\n" +
    "            <div></div>\n" +
    "            <i class=\"fa fa-clock-o\"></i>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"calendar-table\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"calendar right\">\n" +
    "        <div class=\"daterangepicker_input\">\n" +
    "          <input class=\"input-mini\" type=\"text\" name=\"daterangepicker_end\" value=\"\" />\n" +
    "          <i class=\"fa fa-calendar\"></i>\n" +
    "          <div class=\"calendar-time\">\n" +
    "            <div></div>\n" +
    "            <i class=\"fa fa-clock-o\"></i>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"calendar-table\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"ranges\">\n" +
    "        <div class=\"range_inputs\">\n" +
    "            <button class=\"applyBtn\" disabled=\"disabled\" type=\"button\"></button>\n" +
    "            <button class=\"cancelBtn\" type=\"button\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/pricing/discount", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/discount",
    "<div class=\"form-group col-md-6 col-sm-6\" style=\"padding-left: 0\">\n" +
    "\n" +
    "  <div class=\"input-group input-group-lg\">\n" +
    "\n" +
    "    <label class=\"input-group-addon\" for=\"packageDiscountName\" style=\"cursor: pointer;\">Name</label>\n" +
    "\n" +
    "    <input type=\"text\"\n" +
    "      name=\"packageDiscountName\"\n" +
    "      id=\"packageDiscountName\"\n" +
    "      ng-model=\"discount.name\"\n" +
    "      class=\"form-control\">\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"form-group col-md-6 col-sm-6\" style=\"padding-right: 0;\">\n" +
    "\n" +
    "  <div class=\"input-group input-group-lg\">\n" +
    "    <label class=\"input-group-addon\" for=\"packageDiscount\" style=\"cursor: pointer;\" tooltip=\"End with a % symbol for percentage\">Discount</label>\n" +
    "    <input type=\"text\"\n" +
    "      id=\"packageDiscount\"\n" +
    "      ng-model=\"discount._value\"\n" +
    "      class=\"form-control\"\n" +
    "      ng-class=\"{ 'ng-invalid': invalidDiscount }\" />\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/pricing/editRetail", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/editRetail",
    "  <!-- Product Item Count -->\n" +
    "  <div class=\"form-group col-md-3 col-sm-3\">\n" +
    "\n" +
    "    <div class=\"input-group\">\n" +
    "    <label class=\"input-group-addon\" for=\"itemCount\" style=\"cursor: pointer;\">#</label>\n" +
    "    <input type=\"number\"\n" +
    "      id=\"itemCount\"\n" +
    "      min=\"1\"\n" +
    "      ng-model=\"item.count\"\n" +
    "      class=\"form-control\">\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "  <!-- !Product Item Count -->\n" +
    "\n" +
    "  <!-- Product Item Cost -->\n" +
    "  <div class=\"form-group col-md-4 col-sm-4\">\n" +
    "\n" +
    "    <div class=\"input-group\">\n" +
    "    <label class=\"input-group-addon\" for=\"itemCost\" style=\"cursor: pointer;\">$</label>\n" +
    "    <input type=\"number\"\n" +
    "      min=\"0\"\n" +
    "      id=\"itemCost\"\n" +
    "      ng-model=\"item.value\"\n" +
    "      disabled=\"true\"\n" +
    "      class=\"form-control\">\n" +
    "    <label class=\"input-group-addon\" for=\"itemCost\" style=\"cursor: pointer;\">each</label>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "  <!-- !Product Item Cost -->\n" +
    "\n" +
    "  <!-- Product Item discount -->\n" +
    "  <div class=\"form-group col-md-5 col-sm-5\">\n" +
    "\n" +
    "    <div class=\"input-group\">\n" +
    "    <label class=\"input-group-addon\" for=\"isDiscounted\" style=\"cursor: pointer; padding: 8px 10px 9px;\">Item Discount</label>\n" +
    "    <input type=\"text\"\n" +
    "      ng-if=\"item.isdiscounted\"\n" +
    "      min=\"0\"\n" +
    "      id=\"itemDiscount\"\n" +
    "      ng-model=\"item.discount\"\n" +
    "      ng-change=\"applyDiscount()\"\n" +
    "      class=\"form-control\">\n" +
    "    <label class=\"input-group-addon\" for=\"itemDiscount\" style=\"cursor: pointer;\">\n" +
    "      <input type=\"checkbox\" class=\"checkbox\" ng-model=\"item.isdiscounted\" id=\"isDiscounted\">\n" +
    "    </label>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "  <!-- !Product Item discount -->\n" +
    "");
}]);

angular.module("views/pricing/modal", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/modal",
    "<div class=\"modal-header\">\n" +
    "<a ng-click=\"cancel()\" class=\"btn btn-text pull-right\" style=\"margin: -12px -14px\"><i class=\"fa fa-times\"></i></a>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"!editing\">Add to Cart</h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"item.isDiscount\">Modify Cart Discount Value</h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"item.isOtherPayment\">Modify {{ item.partner.name || item.type }} Payment</h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"item.isCash\">Modify Cash Payment</h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"editing && !item.isCreditCard\">{{ item.product.name }}</h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"item.isCreditCard && !item.isGift\">\n" +
    "     Charge - {{ item.card.type }}: {{ item.card.masked }} <button class=\"btn-link btn\" type=\"button\" ng-click=\"item.card.sync(item, confirm)\"><i class=\"fa fa-refresh\"></i></button>\n" +
    "  </h3>\n" +
    "  <h3 style=\"margin-top: 8px;\" ng-if=\"item.isGift\">\n" +
    "    Prepayment\n" +
    "    <span ng-if=\"item.contact.recipient.send_to\">for</span>\n" +
    "    <span ng-if=\"!item.contact.recipient.send_to\">from</span> {{ item.contact.recipient.send_to ? item.contact.recipient.name : item.contact.purchaser.name }}</h3>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "  <div ng-if=\"!editing\">\n" +
    "    <tabset class=\"tabbable\">\n" +
    "      <!-- Retail Item Tab -->\n" +
    "      <tab heading=\"Retail Item\" select=\"activeTab('retail')\">\n" +
    "        <div class=\"bg-light\" style=\"padding: 10px;\" ng-include=\"'views/pricing/retail'\"></div>\n" +
    "        <hr>\n" +
    "        <div ng-include=\"'views/pricing/editRetail'\"></div>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!-- Payment Options -->\n" +
    "      <tab heading=\"Payment\" select=\"activeTab('payment')\">\n" +
    "        <div class=\"row\">\n" +
    "\n" +
    "          <div class=\"form-group\" ng-class=\"{'col-md-4' : item.option == 'other', 'col-md-8' : item.option != 'other', 'col-md-12' : item.option == 'gift'}\">\n" +
    "\n" +
    "            <select ui-select2=\"{ width: '100%' }\"\n" +
    "              ng-model=\"item.option\"\n" +
    "              data-placeholder=\"Select Method\"\n" +
    "              required>\n" +
    "              <option value=\"\">Choose Method</option>\n" +
    "              <option value=\"cash\">Cash</option>\n" +
    "              <option value=\"other\">Bill To</option>\n" +
    "              <option value=\"gift\">PrePaid</option>\n" +
    "            </select>\n" +
    "\n" +
    "          </div>\n" +
    "          <div ng-if=\"item.option !== 'gift'\">\n" +
    "\n" +
    "            <div ng-model=\"contactsCtrl\" class=\"form-group col-md-4\" ng-show=\"item.option === 'other'\" ng-init=\"getPartners()\">\n" +
    "\n" +
    "              <select ui-select2=\"{ width: '100%' }\"\n" +
    "                ng-model=\"item.partner\"\n" +
    "                data-placeholder=\"Select a Partner\">\n" +
    "                <option value=\"\">Select a Partner</option>\n" +
    "                <option\n" +
    "                  ng-repeat=\"partner in partners | orderBy: 'name'\"\n" +
    "                  value=\"{{ partner }}\">{{ partner.name }}</option>\n" +
    "              </select>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group col-md-4\" ng-if=\"item.option == 'other'\">\n" +
    "              {{ item.amount = item.amount || parent;'' }}\n" +
    "              <input type=\"text\" ng-model=\"item.type\" class=\"form-control\" placeholder=\"Reference\" />\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group col-md-4 pull-right\">\n" +
    "              <input type=\"text\" ng-model=\"item.amount\" class=\"form-control\" placeholder=\"ex. $100.00\" ng-disabled=\"!item.option\" />\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div ng-if=\"item.option == 'gift'\" class=\"col-md-12\" style=\"overflow: hidden;\">\n" +
    "\n" +
    "            <div class=\"input-group\">\n" +
    "              <label class=\"input-group-addon\" for=\"itemCode\" style=\"cursor: pointer;\" >Gift Code</label>\n" +
    "              <input type=\"text\" id=\"itemCode\" ng-model=\"code\" class=\"form-control\" placeholder=\"ex. 6352\" ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 }}\" ng-change=\"findGift(code)\"/>\n" +
    "              <span class=\"input-group-btn\">\n" +
    "                <button class=\"btn btn-default\" type=\"button\" ng-click=\"findGift(code)\" tooltip=\"Find matching gifts\"><i class=\"fa fa-search\"></i></button>\n" +
    "              </span>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" ng-show=\"gifts.length > 0\">\n" +
    "              <hr />\n" +
    "              <div class=\"col-md-12\" style=\"height: 122px; overflow-y: scroll;\">\n" +
    "                <table class=\"col-md-12 table table-condensed table-striped\">\n" +
    "                  <thead>\n" +
    "                    <tr>\n" +
    "                      <th style=\"width: 22px;\"></th>\n" +
    "                      <th>Code</th>\n" +
    "                      <th>Value</th>\n" +
    "                      <th>Recipient</th>\n" +
    "                    </tr>\n" +
    "                  </thead>\n" +
    "                  <tbody>\n" +
    "                    <tr ng-repeat=\"g in gifts\" ng-click=\"selectGift(g)\">\n" +
    "                      <td><input type=\"radio\" name=\"itemCode\" ng-model=\"item.code\" ng-value=\"g.code\" ng-disabled=\"g.redeemed\"/></td>\n" +
    "                      <td ng-class=\"{ 'disabled text-muted' : g.redeemed }\">{{ g.code }}</td>\n" +
    "                      <td ng-class=\"{ 'disabled text-muted' : g.redeemed }\">{{ g.balance | currency }}</td>\n" +
    "                      <td ng-class=\"{ 'disabled text-muted' : g.redeemed }\">{{ g.contact.recipient.name }}</td>\n" +
    "                    </tr>\n" +
    "                  </tbody>\n" +
    "                </table>\n" +
    "\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </tab>\n" +
    "\n" +
    "      <!-- Discounts Tab -->\n" +
    "      <tab heading=\"Cart Discount\" select=\"activeTab('discount')\" disabled=\"parent == 0\">\n" +
    "        <div class=\"row\" style=\"margin: 0;\" ng-include=\"'views/pricing/discount'\"></div>\n" +
    "      </tab>\n" +
    "\n" +
    "    </tabset>\n" +
    "\n" +
    "  </div>\n" +
    "    <!-- Edits -->\n" +
    "\n" +
    "  <div ng-if=\"editing\">\n" +
    "\n" +
    "    <div ng-if=\"item.isCash\">\n" +
    "\n" +
    "      <div class=\"form-group col-md-6\" ng-if=\"item.isOtherPayment && !item.partner._id\">\n" +
    "        <input ng-if=\"item.type\" type=\"text\" ng-model=\"item.type\" class=\"form-control\" placeholder=\"eg. Bill To Bel Abri\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"input-group\" ng-class=\"{'col-md-6' : item.isOtherPayment }\">\n" +
    "        <div class=\"input-group-addon\">Amount</div>\n" +
    "        <input type=\"text\" ng-model=\"item.amount\" class=\"form-control\" placeholder=\"eg. $100.00\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"item.isOtherPayment || item.partner\">\n" +
    "\n" +
    "      <div class=\"form-group col-md-4 select2-bootstrap\">\n" +
    "\n" +
    "        <ui-select\n" +
    "          class=\"form-control\"\n" +
    "          ng-model=\"item.partner\">\n" +
    "          <ui-select-match placeholder=\"Select a Partner\">\n" +
    "            <span ng-bind-html=\"$select.selected.name\"></span>\n" +
    "          </ui-select-match>\n" +
    "          <ui-select-choices\n" +
    "            repeat=\"partner in partners | orderBy:'name' | filter: $select.search\" ng-hide=\"\">\n" +
    "            {{ partner.name }}\n" +
    "          </ui-select-choices>\n" +
    "        </ui-select>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-4\">\n" +
    "        {{ item.amount = item.amount || parent;'' }}\n" +
    "        <input type=\"text\" ng-model=\"item.type\" class=\"form-control\" placeholder=\"Reference\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-4 pull-right\">\n" +
    "        <input type=\"text\" ng-model=\"item.amount\" class=\"form-control\" placeholder=\"ex. $100.00\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Edit Discount -->\n" +
    "    <div ng-show=\"item.isDiscount\" class=\"row\" style=\"margin: 0;\" ng-include=\"'views/pricing/discount'\"></div>\n" +
    "\n" +
    "    <!-- Edit Line Item -->\n" +
    "    <div ng-show=\"item.isLineItem && (selected || editing)\" class=\"row\" ng-include=\"'views/pricing/editRetail'\"></div>\n" +
    "\n" +
    "    <!-- Edit/Refund Payment -->\n" +
    "    <div ng-if=\"item.isCreditCard && !item.isGift\" ng-include=\"'views/pricing/payment'\"></div>\n" +
    "\n" +
    "    <!-- Remove Prepaid -->\n" +
    "    <div ng-show=\"editing && item.isGift\">\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "          Prepaid <strong></strong>{{ item.code }}</strong> valued at {{ item.amount | currency }}\n" +
    "          <a ng-click=\"remove(item)\" class=\"btn bg-danger pull-right\">Remove</a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Show Values -->\n" +
    "  <div class=\"row\" ng-show=\"!item.isCreditCard\">\n" +
    "    <h4 class=\"col-md-12\" ng-show=\"item.isDiscount || onTab == 'discount'\" style=\"text-align: right\">\n" +
    "      Discount Amount <span class=\"label bg-success\">{{ parent + discount.calculate(discount._value) | currency }}</span>\n" +
    "    </h4>\n" +
    "    <h4 class=\"col-md-12\" ng-if=\"item.isLineItem && onTab == 'retail'\" style=\"text-align: right\">\n" +
    "      {{ selected.name }} <span class=\"label bg-success\">{{ item.total | currency }}</span>\n" +
    "    </h4>\n" +
    "    <h4 class=\"col-md-12\" ng-if=\"item.isGift\" style=\"text-align: right\">\n" +
    "      Gift <code>{{ item.code }}</code> <span class=\"label bg-success\">{{ item.balance | currency }}</span>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<div class=\"modal-footer\" ng-show=\"!item.isCreditCard\">\n" +
    "\n" +
    "    <div class=\"btn-group\">\n" +
    "      <button class=\"btn btn-primary\" ng-click=\"confirm()\" ng-disabled=\"(onTab == 'payment' && (item.option && item.option == 'gift') && !item.code) || (onTab == 'discount' && invalidDiscount)\">OK</button>\n" +
    "      <button class=\"btn btn-warning\" ng-click=\"cancel()\">Cancel</button>\n" +
    "      <button ng-if=\"editing\" type=\"button\" class=\"btn btn-link\" ng-click=\"remove(item)\">Delete</button>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/pricing/panel", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/panel",
    "<div>\n" +
    "  <div class=\"row\" style=\"margin: 0;\">\n" +
    "\n" +
    "    <div class=\"col-md-12 clearfix\">\n" +
    "\n" +
    "      <header class=\"panel-heading bg-light\" style=\"text-align: center;\">\n" +
    "        <!-- <span style=\"display: inline-block; margin: 5px 9px -2px 0px;\">\n" +
    "          <i ng-if=\"!expanded\" class=\"fa fa-caret-right pull-left\"></i>\n" +
    "          <i ng-if=\"expanded\" class=\"fa fa-caret-down pull-left\"></i>\n" +
    "        </span> -->\n" +
    "        <h5 class=\"upper\">Pricing Table</h5>\n" +
    "        <button\n" +
    "            ng-click=\"addLineItem()\"\n" +
    "            type=\"button\" class=\"btn btn-link pull-right extra\" style=\"margin-top: -30px;\"><i class=\"fa fa-plus\"></i> Add Item</button>\n" +
    "      </header>\n" +
    "\n" +
    "      <section class=\"\" ng-show=\"expanded\" style=\"padding: 0; border: 2px solid #ebeef5;\">\n" +
    "        <table class=\"table table-noborders table-condensed table-hover\" style=\"margin-bottom: 0;\">\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "\n" +
    "              <th colspan=\"5\">Cart Items</th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "\n" +
    "\n" +
    "            <!-- VIP (non per-person pricing) -->\n" +
    "            <tr ng-if=\"!package.price.perperson && package\">\n" +
    "              <td style=\"text-align: center;\">{{ getPackageCost().total.count }}</td>\n" +
    "              <td>{{ package.name }}</td>\n" +
    "              <td>Tour Package</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ getPackageCost().total.price | currency }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ getPackageCost().total.price + (hotel.zone.price * getPackageCost().total.count) | currency }}</span>\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ getPackageCost().total.price | currency }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ getPackageCost().total.price + (hotel.zone.price * getPackageCost().total.count) | currency }}</span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "            <!-- Adult subtotal -->\n" +
    "            <tr ng-if=\"package.price.perperson && package && booking.adults > 0\">\n" +
    "              <td style=\"text-align: center;\">{{ getPackageCost().adults.count }}</td>\n" +
    "              <td>{{ package.name }}</td>\n" +
    "              <td>Tour Package</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ package.price.adult }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ (package.price.adult) + (booking.accommodations.hotel.zone.price) }}</span>\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ getPackageCost().adults.price | currency }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ getPackageCost().adults.price + (booking.accommodations.hotel.zone.price * getPackageCost().adults.count) | currency }}</span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "            <!-- Child subtotal -->\n" +
    "            <tr ng-if=\"package.price.perperson && package && booking.children > 0\">\n" +
    "              <td style=\"text-align: center;\">{{ getPackageCost().children.count }}</td>\n" +
    "              <td>{{ package.name }}</td>\n" +
    "              <td>Tour Package</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ package.price.child }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ (package.price.child + hotel.zone.price) }}</span>\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                <span ng-if=\"!booking.hotel\">{{ getPackageCost().children.price | currency }}</span>\n" +
    "                <span ng-if=\"booking.hotel\">{{ getPackageCost().children.price + (hotel.zone.price * getPackageCost().children.count) | currency }}</span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-repeat=\"item in getItems()\" ng-click=\"update(item, $index)\">\n" +
    "              <td style=\"text-align: center;\">{{ item.count }}</td>\n" +
    "              <td>{{ item.product.name }}</td>\n" +
    "              <td>Retail Item</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ item.value }}\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ item.total | currency }} {{ increment }}\n" +
    "                <span ng-if=\"item.isdiscounted\" class=\"label bg-light lter\" tooltip=\"Discounted {{ item.discount }}\"><i class=\"fa fa-info\"></i></span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-if=\"booking.needs_pickup && !booking.hotel && !booking.meta.free_pickup\">\n" +
    "              <td style=\"text-align: center;\">{{getPackageCost().total.count}}</td>\n" +
    "              <td>Pickup</td>\n" +
    "              <td>Guest Pickup</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ booking.accommodations.hotel.zone.price }}\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ booking.accommodations.hotel.zone.price * getPackageCost().total.count | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-click=\"update(discount, 0)\" ng-show=\"discount.total !== '' && discount.total < 0\">\n" +
    "              <td style=\"text-align: center;\">1</td>\n" +
    "              <td>Discount</td>\n" +
    "              <td>{{ discount.name }}</td>\n" +
    "              <td style=\"text-align: center;\">{{ discount._value }}</td>\n" +
    "              <td style=\"text-align: right;\"><span class=\"text-danger\">{{ discount.total | currency }}</span></td>\n" +
    "            </tr>\n" +
    "\n" +
    "          </tbody>\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "              <th colspan=\"5\">Payments</th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "\n" +
    "          <!-- Payments -->\n" +
    "          <tbody ng-repeat=\"item in charges track by $index\" style=\"border: none;\">\n" +
    "\n" +
    "            <tr ng-click=\"update(item, $index)\" class=\"point\" tooltip=\"Click to issue refunds.\">\n" +
    "              <td style=\"text-align: center;\"></td>\n" +
    "              <td>{{ item.card.type }}: {{ item.card.masked }}</td>\n" +
    "              <td>Payment</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ item.amount - (item.tip || 0) | currency:'' }}\n" +
    "                <span class=\"text-danger\" ng-show=\"item.refundTotal != 0\">({{ item.refundTotal }})</span>\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ item.balance - (item.tip || 0) | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-show=\"item.tip && item.tip > 0\">\n" +
    "              <td style=\"text-align: center;\"></td>\n" +
    "              <td></td>\n" +
    "              <td>Tip</td>\n" +
    "              <td style=\"text-align: center;\">{{ item.tip | currency:'':2 }}</td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ (item.tip || 0) | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "          </tbody>\n" +
    "\n" +
    "          <tbody>\n" +
    "            <tr ng-repeat=\"item in gift_payments\" ng-init=\"item.isGift = true;\" ng-click=\"update(item, $index)\" class=\"point\">\n" +
    "              <td style=\"text-align: center;\">1</td>\n" +
    "              <td>{{ item.code }}</td>\n" +
    "              <td>Prepayment</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ item.amount }}\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ item.amount | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-repeat=\"item in other_payments\" ng-click=\"update(item, $index)\" class=\"point\">\n" +
    "              <td style=\"text-align: center;\">1</td>\n" +
    "              <td>Bill To: <span ng-show=\"item.partner\">{{ item.partner.name }}</span> {{ item.type }}</td>\n" +
    "              <td>Payment</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ item.amount }}\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ item.amount | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr ng-repeat=\"item in cash_payments track by $index\" ng-click=\"update(item, $index)\" class=\"point\" ng-if=\"item !== 0\">\n" +
    "              <td style=\"text-align: center;\">1</td>\n" +
    "              <td>Cash</td>\n" +
    "              <td>Payment</td>\n" +
    "              <td style=\"text-align: center;\">\n" +
    "                {{ item }}\n" +
    "              </td>\n" +
    "              <td style=\"text-align: right;\">\n" +
    "                {{ item | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "\n" +
    "      </section>\n" +
    "\n" +
    "      <footer class=\"bg-light panel-footer upper\" style=\"text-align: center; overflow: auto\">\n" +
    "        <h5 class=\"col-md-6\">\n" +
    "          Subtotal: <span class=\"extra\" style=\"font-weight: normal;\">{{ getGrandTotal() + discount.total | currency }}</span>\n" +
    "        </h5>\n" +
    "        <h5 class=\"col-md-6\">\n" +
    "          Remaining Balance: <span class=\"extra\" style=\"font-weight: normal;\">{{ getGrandTotal() + discount.total - totalPayments + tip_total | currency }}</span>\n" +
    "        </h5>\n" +
    "      </footer>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/pricing/payment", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/payment",
    "<div class=\"row\">\n" +
    "  <div class=\"col-md-8\">\n" +
    "\n" +
    "    <h5>\n" +
    "      <span class=\"label bg-success\">{{ item.amount | currency }}</span>\n" +
    "      <span ng-show=\"item.showId\" ng-dblclick=\"item.showId = false\">\n" +
    "        Charge ID: {{ item.id }}\n" +
    "      </span>\n" +
    "      <span ng-show=\"!item.showId\" ng-dblclick=\"item.showId = true\">\n" +
    "        Charged on {{ item.date | readTime:'ddd, MMM. Do YYYY' }}\n" +
    "      </span>\n" +
    "    </h5>\n" +
    "\n" +
    "    <ul class=\"list-unstyled row\"\n" +
    "      style=\"margin: 5px 0 0 -8px; padding: 0 7px;\"\n" +
    "      ng-show=\"item.refunds.length > 0\">\n" +
    "      <li ng-repeat=\"refund in item.refunds\" style=\"margin: 2px 0\" class=\"\">\n" +
    "        <span class=\"label bg-danger\" style=\"\">{{ refund.amount | currency}}</span>\n" +
    "        Refunded on {{ refund.date | readTime:'dddd, MMM. Do YYYY' }}\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <h5 class=\"upper\" style=\"margin-top: 20px;\">Charge total: <span>{{ item.balance | currency }}</span></h5>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"form-group col-md-4\" style=\"margin-bottom: 5px; text-align: center;\">\n" +
    "\n" +
    "    <div class=\"bg-light\" style=\"padding: 10px 25px;\" ng-init=\"tipOnly = false; item.refundable = item.refundAmount\">\n" +
    "      <h6 class=\"upper\" style=\"margin: 0 0 10px 0; text-align: center;\">Refund</h6>\n" +
    "\n" +
    "      <label for=\"tipOnly\" class=\"checkbox\" ng-show=\"user.isAdmin()\">\n" +
    "        <input type=\"checkbox\" id=\"tipOnly\"\n" +
    "          ng-model=\"item.refundable\"\n" +
    "          ng-true-value=\"{{ item.tip || 0 }}\"\n" +
    "          ng-false-value=\"{{ item.refundAmount }}\"\n" +
    "          ng-disabled=\"!item.tip\"\n" +
    "          ng-change=\"tipOnly = !tipOnly\" /> Tip Only\n" +
    "      </label>\n" +
    "\n" +
    "      <div class=\"input-group\">\n" +
    "        <span class=\"input-group-addon\">$</span>\n" +
    "        <input type=\"text\"\n" +
    "          class=\"form-control\"\n" +
    "          placeholder=\"{{ item.balance | currency }}\"\n" +
    "          ng-disabled=\"item.balance == 0\"\n" +
    "          ng-model=\"item.refundable\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <button type=\"button\"\n" +
    "        class=\"btn btn-xs btn-info\"\n" +
    "        style=\"margin-top: 10px;\"\n" +
    "        ng-disabled=\"item.balance == 0\"\n" +
    "        ng-click=\"item.card.refund(item.id, item.refundable, item, confirm, 'reservation', tipOnly); \"\n" +
    "        tooltip=\"Refund entered amount\">Apply</button>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<!--   <li class=\"list-group-item\" style=\"\" ng-repeat=\"refund in item.refunds\">\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <h5 class=\"col-md-7\">\n" +
    "        <span class=\"label bg-success\">{{ charge.amount | currency }}</span>\n" +
    "        <span ng-class=\"{ 'strike' : charge.balance == 0 }\">Charged on {{ charge.date | readTime:'ddd, MMM. Do YYYY' }}</span>\n" +
    "      </h5>\n" +
    "      <strong class=\"col-md-2\" style=\"text-align: right; padding: 7px 0;\">Balance</strong>\n" +
    "    </div>\n" +
    "\n" +
    "  </li>\n" +
    " -->\n" +
    "");
}]);

angular.module("views/pricing/retail", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/pricing/retail",
    "  <div ng-repeat=\"products in selection\" style=\"padding: 5px 0px;\">\n" +
    "    <select ui-select2=\"{ width: '100%' }\" \n" +
    "    ng-model=\"product\" \n" +
    "    ng-change=\"push(product, $index)\"\n" +
    "    data-placeholder=\"Select Retail Item\" \n" +
    "    required>\n" +
    "    <option value=\"\"></option>\n" +
    "    <option ng-repeat=\"product in products\" value=\"{{ product }}\">{{ product.name }}</option>\n" +
    "    </select>\n" +
    "  </div>");
}]);

angular.module("views/reports", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports",
    "\n" +
    "<div class=\"row\">\n" +
    "  <ul class=\"list-group\" style=\"float: left; margin-right: 20px; z-index: 1; position: absolute; width: 150px;\">\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'itSheet'}\" ng-click=\"updateLocation('it-sheet')\">IT Sheet</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'pickupSheet'}\" ng-click=\"updateLocation('pickup-sheet')\">Pickups</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'salesSlip'}\" ng-click=\"updateLocation('sales-slip')\">Sales Slip</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'photos'}\" ng-click=\"updateLocation('photos')\">Photo Email List</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'glance'}\" ng-click=\"updateLocation('glance')\">At a Glance</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\"\n" +
    "      ng-class=\"{ 'active' : active == 'sales'}\"\n" +
    "      ng-click=\"updateLocation('sales', (today | readTime: 'MM-DD-YY'))\"\n" +
    "      ng-if=\"user.can('daily sales', 'Reports')\">\n" +
    "      Sales\n" +
    "    </li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'billTo'}\" ng-click=\"updateLocation('billTo')\" ng-if=\"user.can('daily sales', 'Reports')\">Accounts Receivable</li>\n" +
    "\n" +
    "		<li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'tips'}\" ng-click=\"updateLocation('tips')\" ng-if=\"user.can('daily sales', 'Reports')\">Tips</li>\n" +
    "\n" +
    "		<li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'commissions'}\" ng-click=\"updateLocation('commissions')\" ng-if=\"user.can('commissions', 'Reports')\">Commissions</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'merchandise'}\"\n" +
    "      ng-click=\"updateLocation('merchandise')\"\n" +
    "      ng-if=\"user.can('daily sales', 'Reports')\">Merchandise</li>\n" +
    "\n" +
    "    <li class=\"list-group-item point\" ng-class=\"{ 'active' : active == 'batch'}\"\n" +
    "      ng-click=\"updateLocation('batch', (today | readTime: 'MM-DD-YY'))\"\n" +
    "      ng-if=\"user.can('daily sales', 'Reports')\">Batch</li>\n" +
    "  </ul>\n" +
    "\n" +
    "  <section style=\"overflow: visible; padding-left: 185px;\"\n" +
    "    class=\"col-md-12 col-lg-12 col-xl-8\"\n" +
    "    id=\"reportView\" ng-show=\"isReport()\">\n" +
    "    <button ng-if=\"active\" type=\"button\" class=\"btn btn-default hidden-print pull-left\" style=\"margin-right: 20px;\" print=\"#reportView\">Print</button>\n" +
    "\n" +
    "    <h2 ng-show=\"active\" style=\"margin-top: 0; text-transform: none;\">{{ user.activeCompany().nickname || user.activeCompany().name }} - {{ title }} -\n" +
    "      <!-- forms dont print with content, this is to bypass that for dates. -->\n" +
    "      <span class=\"visible-print-inline reportDate\">\n" +
    "        {{ start = (datePicker.date.startDate | readTime:'MM/DD/YY'); \"\" }}\n" +
    "        {{ end = (datePicker.date.endDate | readTime:'MM/DD/YY'); \"\" }}\n" +
    "        <span class=\"start\">{{ start }}</span>\n" +
    "        <span class=\"end\" ng-if=\"start !== end && range\"> thru {{ end }}</span>\n" +
    "      </span>\n" +
    "\n" +
    "      <span class=\"dateSelect hidden-print\">\n" +
    "        <input ng-if=\"!range\" date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"datePicker.date.startDate\" options=\"datePicker.options\" />\n" +
    "        <input ng-if=\"range\" date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"datePicker.date\" options=\"datePicker.options\" />\n" +
    "      </span>\n" +
    "\n" +
    "    </h2>\n" +
    "\n" +
    "    <div class=\"row text-center animated fadeInOut\" ng-if=\"working\">\n" +
    "      <span style=\"display: inline-block;\" spin=\"{\n" +
    "        lines: 17,\n" +
    "        length: 0,\n" +
    "        width: 4,\n" +
    "        radius: 20,\n" +
    "        corners: 1,\n" +
    "        rotate: 0,\n" +
    "        direction: 1,\n" +
    "        color: '#333',\n" +
    "        speed: 1.2,\n" +
    "        trail: 36,\n" +
    "        shadow: false,\n" +
    "        hwaccel: false,\n" +
    "        className: 'spinner',\n" +
    "        zIndex: 2e9,\n" +
    "        top: '-5px',\n" +
    "        left: 'auto'\n" +
    "      }\"></span>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"active == 'itSheet'\" ng-include src=\"'views/reports/itsheet'\"></div>\n" +
    "    <div ng-if=\"active == 'pickupSheet'\" ng-include src=\"'views/reports/pickups'\"></div>\n" +
    "    <div ng-if=\"active == 'salesSlip'\" ng-include src=\"'views/reports/salesSlip'\"></div>\n" +
    "    <div ng-if=\"active == 'photos'\" ng-include src=\"'views/reports/email'\"></div>\n" +
    "    <div ng-if=\"active == 'glance'\" ng-include src=\"'views/reports/glance'\"></div>\n" +
    "    <div ng-if=\"user.can('daily sales', 'Reports') && active == 'tips'\"\n" +
    "        ng-include src=\"'views/reports/tips'\"></div>\n" +
    "    <div ng-if=\"user.can('commissions', 'Reports') && active == 'commissions'\"\n" +
    "      ng-include src=\"'views/reports/commissions'\"></div>\n" +
    "\n" +
    "    <div ng-if=\"user.can('daily sales', 'Reports') && active == 'billTo'\"\n" +
    "      ng-include src=\"'views/reports/billto'\"></div>\n" +
    "\n" +
    "    <div ng-if=\"user.can('daily sales', 'Reports') && active == 'sales'\"\n" +
    "      ng-include src=\"'views/reports/sales'\"></div>\n" +
    "\n" +
    "      <div ng-if=\"user.can('daily sales', 'Reports') && active == 'batch'\"\n" +
    "        ng-include src=\"'views/reports/batch'\"></div>\n" +
    "\n" +
    "    <div ng-if=\"user.can('daily sales', 'Reports') && active == 'merchandise'\"\n" +
    "        ng-include src=\"'views/reports/mdse'\"></div>\n" +
    "\n" +
    "  </section>\n" +
    "\n" +
    "  <section class=\"col-md-8\" ng-show=\"!isReport()\">\n" +
    "    <div class=\"bg-light panel\">\n" +
    "      <div class=\"panel-body\">Error: <strong>{{ state.report }}</strong> is not a valid report.</div>\n" +
    "    </div>\n" +
    "  </section>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/batch", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/batch",
    "<div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "  <!-- !! DEPRECATED !! -->\n" +
    "  <div class=\"col-lg-9 col-md-12\">\n" +
    "\n" +
    "    <div sales-report=\"data\" start=\"start\" end=\"end\">\n" +
    "      {{ stripeFees = report.fees(); '' }}\n" +
    "      {{ compile.deposits_refunded }}\n" +
    "      {{ deposit = data.is_batch ? data.credit_cards.total - data.fees.total :  (data.credit_cards.total || (compiled.debits.credit_card + compiled.debits.refunds) + data.fees.total);'' }}\n" +
    "      <h3 style=\"padding-left: 8px; margin-bottom: 20px;\">\n" +
    "        Balance: <span ng-class=\"{ 'text-danger': data.balance < 0 || compiled.balance < 0 }\">\n" +
    "          {{ data.balance || compiled.balance | currency }}\n" +
    "        </span>\n" +
    "        <div class=\"pull-right\" ng-if=\"!locked\" style=\"font-size: 13px; line-height: 1.5\">\n" +
    "          <div ng-if=\"data.stripe_balance < deposit\" class=\"checkbox-inline\" style=\"padding-left: 0; padding-right: 20px; margin-right: 10px;\">\n" +
    "            <label>\n" +
    "              skip funds transfer\n" +
    "              <input type=\"checkbox\" ng-model=\"data.ignore_transfer\" aria-label=\"do not transfer funds\" style=\"right: 0; top: 0;\">\n" +
    "            </label>\n" +
    "          </div>\n" +
    "          <button\n" +
    "            type=\"button\"\n" +
    "            ng-click=\"report.batch(data.ignore_transfer, updateBatchTable)\"\n" +
    "            class=\"btn btn-md bg-info\"\n" +
    "            style=\"min-width: 70px;\"\n" +
    "            ng-disabled=\"report.working || (!data.ignore_transfer && data.stripe_balance < deposit)\">\n" +
    "              <span ng-if=\"!report.working\">Batch</span>\n" +
    "              <span ng-if=\"report.working\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "                lines: 17,\n" +
    "                length: 0,\n" +
    "                width: 4,\n" +
    "                radius: 4,\n" +
    "                corners: 1,\n" +
    "                rotate: 0,\n" +
    "                direction: 1,\n" +
    "                color: '#fff',\n" +
    "                speed: 1.2,\n" +
    "                trail: 36,\n" +
    "                shadow: false,\n" +
    "                hwaccel: false,\n" +
    "                className: 'spinner',\n" +
    "                zIndex: 2e9,\n" +
    "                top: '-5px',\n" +
    "                left: 'auto'\n" +
    "              }\"></span>\n" +
    "          </button>\n" +
    "          <button type=\"button\" class=\"btn bg-danger\" ng-click=\"clearSales()\">Clear Cache</button>\n" +
    "        </div>\n" +
    "\n" +
    "      </h3>\n" +
    "\n" +
    "      {{ compiled.fees }}\n" +
    "      <div class=\"col-md-6 no-pad\" style=\"margin-bottom: 20px;\">\n" +
    "        <table class=\"table table-borderless table-condensed\">\n" +
    "          <tbody>\n" +
    "            <tr>\n" +
    "              <td style=\"width: 50%\"><strong class=\"upper\">Stripe Balance</strong></td>\n" +
    "              <td style=\"width: 50%\">\n" +
    "                <span>{{ data.stripe_balance || 0 | currency }}</span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "              <td style=\"width: 50%\"><strong class=\"upper\">Total CC Deposit</strong></td>\n" +
    "              <td style=\"width: 50%\">{{ deposit | currency }} {{ compiled.fees.total }}</td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "              <td style=\"width: 50%\"><strong class=\"upper\">Total Cash Deposit</strong></td>\n" +
    "              <td style=\"width: 50%\">\n" +
    "                <span ng-if=\"data.is_batch\">{{ data.cash.total || 0 | currency }}</span>\n" +
    "                <span ng-if=\"!data.is_batch\">{{ compiled.debits.cash || 0 | currency }}</span>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-bottom: 20px;\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "\n" +
    "          <table class=\"table\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th style=\"width: 25%\">Item</th>\n" +
    "                <th style=\"width: 25%\">Sales</th>\n" +
    "                <th style=\"width: 25%\">Refunds</th>\n" +
    "                <th style=\"width: 25%\">Total</th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "              <tr>\n" +
    "                <td><strong>Credit Cards</strong></td>\n" +
    "                <td>{{ data.credit_cards.sales || (compiled.debits.credit_card) || 0 | currency }}</td>\n" +
    "                <td>{{ data.credit_cards.refunds || (compiled.debits.refunds * -1) || 0 | currency }}</td>\n" +
    "                <td>{{ data.credit_cards.total || (compiled.debits.credit_card + compiled.debits.refunds) || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td><strong>Processing Fees</strong></td>\n" +
    "                <td>{{ data.fees.sales || (stripeFees.charged * -1) || 0 | currency }}</td>\n" +
    "                <td>{{ data.fees.refunds || stripeFees.refunded || 0 | currency }}</td>\n" +
    "                <td>{{ data.fees.total || (stripeFees.total * -1) || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td><strong>Cash</strong></td>\n" +
    "                <td>{{ data.cash.sales || compiled.debits.cash || 0 | currency }}</td>\n" +
    "                <td>{{ data.cash.refunds || 0 | currency }}</td>\n" +
    "                <td>{{ data.cash.total || compiled.debits.cash || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" style=\"margin-bottom: 20px;\">\n" +
    "\n" +
    "        <div class=\"col-md-6 no-pad-rt\">\n" +
    "\n" +
    "          <table class=\"table table-borderless-top\">\n" +
    "            <tbody>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">A/R</td>\n" +
    "                <td>{{ data.sales.ar || compiled.debits.ar || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Deposits Redeemed</td>\n" +
    "                <td>{{ data.sales.deposits_redeemed || compiled.debits.deposits_redeemed || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">GC Redeemed</td>\n" +
    "                <td>{{ data.sales.gifts_redeemed || compiled.debits.gifts_redeemed || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Discounts</td>\n" +
    "                <td>{{ data.sales.discounts || compiled.debits.discounts || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Flights</td>\n" +
    "                <td>{{ data.sales.flights || compiled.credits.flights || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Tips</td>\n" +
    "                <td>{{ data.sales.tips || compiled.credits.tips || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">MDSE</td>\n" +
    "                <td>{{ data.sales.mdse || compiled.credits.mdse || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Pick-Ups</td>\n" +
    "                <td>{{ data.sales.pickups || compiled.credits.pickup || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">GC Sold</td>\n" +
    "                <td>{{ data.sales.gifts_sold || compiled.credits.gifts || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "                <td style=\"width: 50%; font-weight: bold;\">Deposits Received</td>\n" +
    "                <td>{{ data.sales.deposits_received || compiled.credits.deposits_received || 0 | currency }}</td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"col-md-6\">\n" +
    "          <h3>Previous Batches</h3>\n" +
    "          <table class=\"table\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th style=\"width: 25%\">Range</th>\n" +
    "                <th style=\"width: 25%\">Batched</th>\n" +
    "                <th style=\"width: 25%\">Amount</th>\n" +
    "                <th style=\"width: 25%\" class=\"text-center\">Transfer</th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "              <tr><td colspan=\"4\">\n" +
    "                <a href=\"\" ng-click=\"goToDate(today)\" class=\"btn block btn-link bg-light\">Next Batch</a>\n" +
    "              </td></tr>\n" +
    "              <tr ng-repeat=\"batch in batches | orderBy: 'end': true\">\n" +
    "                <td>\n" +
    "                  <a\n" +
    "                    ng-click=\"goToDate(batch.start, batch.end)\"\n" +
    "                    href=\"#\" class=\"btn btn-link btn-sm\">\n" +
    "                    <strong>{{ batch.start | readTime: 'MM-DD-YY':true }}</strong> thru <strong>{{ batch.end | readTime: 'MM-DD-YY':true }}</strong>\n" +
    "                  </a>\n" +
    "                </td>\n" +
    "                <td><span class=\"nowrap\">{{ batch.created | readTime: 'MM-DD-YY' }}</span></td>\n" +
    "                <td>\n" +
    "                  <span ng-class=\"{ 'text-muted': batch.transfer === 'ignored'}\">{{ batch.credit_cards.total - batch.fees.total | currency }}</span>\n" +
    "                </td>\n" +
    "                <td class=\"text-center\">\n" +
    "                  <span ng-if=\"batch.transfer === 'ignored'\">--</span>\n" +
    "                  <a ng-if=\"batch.transfer !== 'ignored'\"\n" +
    "                    class=\"btn btn-link\"\n" +
    "                    target=\"_blank\"\n" +
    "                    ng-href=\"https://dashboard.stripe.com/transfers/{{ batch.transfer }}\">View Transfer</a>\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "          </table>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/billto", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/billto",
    "<div class=\"col-md-12\" ng-init=\"showPartner = false;\">\n" +
    "  <div sales-report=\"data\" start=\"start\" end=\"end\">\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "\n" +
    "      <div class=\"btn-group\">\n" +
    "\n" +
    "        <button type=\"button\"\n" +
    "          class=\"btn bg-light\"\n" +
    "          ng-click=\"setFilter('all', 'paid')\"\n" +
    "          ng-class=\"{ 'active': filter.billTo.paid == 'all' }\">All</button>\n" +
    "        <button type=\"button\"\n" +
    "          class=\"btn bg-light\"\n" +
    "          ng-click=\"setFilter('paid', 'paid')\"\n" +
    "          ng-class=\"{ 'active': filter.billTo.paid == 'paid' }\">Paid</button>\n" +
    "        <button type=\"button\"\n" +
    "          class=\"btn bg-light\"\n" +
    "          ng-click=\"setFilter('unpaid', 'paid')\"\n" +
    "          ng-class=\"{ 'active': filter.billTo.paid == 'unpaid' }\">Unpaid</button>\n" +
    "        <button type=\"button\"\n" +
    "          class=\"btn bg-light\"\n" +
    "          ng-click=\"setFilter('cancelled', 'paid')\"\n" +
    "          ng-class=\"{ 'active': filter.billTo.paid == 'cancelled' }\">Cancelled</button>\n" +
    "        <button ng-if=\"showPartner\" type=\"button\"\n" +
    "          class=\"btn bg-light\"\n" +
    "          ng-click=\"$parent.showPartner = false;\">Clear Partner Filter</button>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <button type=\"button\" class=\"btn bg-danger\" ng-click=\"clearSales()\">Clear Cache</button>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-repeat=\"(key, group) in bill_to_grouped\" ng-init=\"show[key] = true\" ng-show=\"!showPartner || showPartner == key\">\n" +
    "      <h3>\n" +
    "        <button class=\"btn btn-link\" ng-click=\"show[key] = !show[key]\">\n" +
    "          <i class=\"fa\" ng-class=\"{ 'fa-caret-down': show[key], 'fa-caret-right': !show[key] }\"></i>\n" +
    "        </button>\n" +
    "        {{ partner = group[0].partner ? group[0].partner.name : 'Unlinked';'' }}\n" +
    "        <span class=\"point\" ng-click=\"$parent.showPartner = key\">{{ partner }}</span>\n" +
    "      </h3>\n" +
    "\n" +
    "      <table class=\"table\">\n" +
    "        <thead>\n" +
    "          <tr>\n" +
    "            <th style=\"width: 10%\">#</th>\n" +
    "            <th style=\"width: 10%\">Date</th>\n" +
    "            <th style=\"width: 30%\">Guest</th>\n" +
    "            <th style=\"width: 30%\">Account</th>\n" +
    "            <th style=\"width: 10%\">Amount Due</th>\n" +
    "            <th style=\"width: 10%\" class=\"text-center\">Paid</th>\n" +
    "          </tr>\n" +
    "        </thead>\n" +
    "        <tbody ng-show=\"!show[key]\">\n" +
    "          <tr class=\"active\">\n" +
    "            <td colspan=\"6\" class=\"text-center\"><em>{{ group.length }} items hidden</em></td>\n" +
    "          </tr>\n" +
    "        </tbody>\n" +
    "        <tbody ng-show=\"show[key]\">\n" +
    "          <tr ng-repeat=\"charge in group | orderBy: 'date'\"\n" +
    "              ng-init=\"booking = data[charge.reference.model][charge.reference._id]\"\n" +
    "              ng-if=\"showBooking(filter, charge)\">\n" +
    "            <td>\n" +
    "              <span ng-class=\"{ 'strike': charge.booking_status === 'cancelled'}\">\n" +
    "                {{ user.activeCompany().nickname }}{{ booking.confirmation}}\n" +
    "              </span>\n" +
    "            </td>\n" +
    "            <td>{{ charge.date | readTime: 'MM-DD-YY':true }}</td>\n" +
    "            <td>\n" +
    "              <span ng-if=\"charge.reference.model === 'Prepayment'\">\n" +
    "                {{ charge.reference.name.first + ', ' + charge.reference.name.last }}\n" +
    "              </span>\n" +
    "              <a ng-if=\"charge.reference.model === 'Reservation'\" ng-href=\"/booking/{{booking.confirmation}}\">\n" +
    "                {{ booking.group_name || booking.last_name + ', ' + booking.first_name }}\n" +
    "              </a>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <span ng-show=\"charge.partner\">{{ charge.partner.name }}</span> {{ charge.type }}\n" +
    "            </td>\n" +
    "            <td>{{ charge.amount | currency }}</td>\n" +
    "            <td>\n" +
    "              <label class=\"block text-center\">\n" +
    "                <input type=\"checkbox\" ng-model=\"charge.paid\" ng-change=\"updateBillTo(charge)\"/>\n" +
    "              </label>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </tbody>\n" +
    "        <tfoot>\n" +
    "          <tr>\n" +
    "            <td></td>\n" +
    "            <td></td>\n" +
    "            <td></td>\n" +
    "            <td></td>\n" +
    "            <td><strong>{{ totalAR(group, filter.billTo.paid) | currency }}</strong></td>\n" +
    "            <td></td>\n" +
    "          </tr>\n" +
    "        </tfoot>\n" +
    "      </table>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/commissions", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/commissions",
    "<div class=\"\" style=\"margin-top: 20px; margin-bottom: 20px;\">\n" +
    "\n" +
    "	<ul class=\"list-group col-md-2 hidden-print\">\n" +
    "		<li ng-show=\"objectKeys(data.concierges.people).length\" class=\"list-group-item point\" ng-click=\"data.selected = 'partner'\" ng-class=\"{ 'active': data.selected === 'partner' }\">\n" +
    "			Travel Agents\n" +
    "		</li>\n" +
    "		<li ng-show=\"objectKeys(data.concierges.people).length\" class=\"list-group-item point\" ng-click=\"data.selected = 'concierge'\" ng-class=\"{ 'active': data.selected === 'concierge' }\">\n" +
    "			Concierge\n" +
    "		</li>\n" +
    "		<li ng-repeat=\"agent in data.agents.people\" class=\"list-group-item point\" ng-click=\"data.selected = agent._id\" ng-class=\"{ 'active': data.selected === agent._id }\">\n" +
    "			{{ agent.name }}\n" +
    "		</li>\n" +
    "	</ul>\n" +
    "\n" +
    "	<div class=\"col-lg-8 col-md-10\" style=\"max-width: 900px;\" ng-show=\"data.selected\">\n" +
    "\n" +
    "		{{ bookings = data.selected === 'concierge' ? data.concierges.bookings || [] : data.agents.bookings[data.selected] || [];\"\" }}\n" +
    "\n" +
    "		<!-- NOTE: Agent Loop -->\n" +
    "		<div ng-if=\"data.selected !== 'concierge' && data.selected !== 'partner'\">\n" +
    "			<h3>\n" +
    "				{{ data.agents.people[data.selected].name }} <small class=\"extra\">{{ bookings.length }} Bookings</small>\n" +
    "			</h3>\n" +
    "			<div ng-include=\"'bookings'\"></div>\n" +
    "		</div>\n" +
    "\n" +
    "    <!-- NOTE: Partner Loop -->\n" +
    "		<div ng-if=\"data.selected === 'partner'\">\n" +
    "			<h3>Travel Agents</h3>\n" +
    "			<div ng-repeat=\"(con, bookings) in data.partners.bookings\">\n" +
    "				{{ concierge = data.partners.people[con];\"\" }}\n" +
    "				{{ concierge.paid_flights = [];\"\" }}\n" +
    "				{{ bookingTotals = calculatePackageTotal(bookings);\"\" }}\n" +
    "				<div ng-include=\"'bookings'\"></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "    <!-- NOTE: Concierge Loop -->\n" +
    "		<div ng-if=\"data.selected === 'concierge'\">\n" +
    "			<h3>Concierges</h3>\n" +
    "			<div ng-repeat=\"(con, bookings) in data.concierges.bookings\">\n" +
    "				{{ concierge = data.concierges.people[con];\"\" }}\n" +
    "				{{ concierge.paid_flights = [];\"\" }}\n" +
    "				{{ bookingTotals = calculatePackageTotal(bookings);\"\" }}\n" +
    "				<div ng-include=\"'bookings'\"></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<script type=\"text/ng-template\" id=\"bookings\">\n" +
    "\n" +
    "			{{ isConcierge = data.selected === 'concierge' || data.selected === 'partner';\"\" }}\n" +
    "			{{ amount = toNumber(concierge && concierge.meta.commission_amount);\"\" }}\n" +
    "\n" +
    "			<div ng-if=\"isConcierge\"><h4>{{ concierge.name }} <small>{{ concierge.hotel.name }}</small></h4></div>\n" +
    "\n" +
    "			<table class=\"table table-striped\">\n" +
    "				<thead>\n" +
    "					<tr>\n" +
    "						<th ng-if=\"isConcierge\">Flight Date</th>\n" +
    "						<th class=\"text-center\">Confirmation</th>\n" +
    "						<th>Guest</th>\n" +
    "						<th class=\"text-center\">Booked</th>\n" +
    "						<th class=\"text-center\">Flown</th>\n" +
    "						<th class=\"text-center\" style=\"min-width: 125px;\" ng-if=\"!isConcierge\">Commissionable</th>\n" +
    "						<th class=\"text-center\" style=\"min-width: 125px;\">Status</th>\n" +
    "						<th ng-if=\"isConcierge\" class=\"text-center\" style=\"min-width: 95px;\">Commission</th>\n" +
    "					</tr>\n" +
    "				</thead>\n" +
    "\n" +
    "				<tbody>\n" +
    "					<tr ng-repeat=\"booking in bookings\" ng-init=\"booking.daysAgo = (booking.day | readTime:'MM-DD-YY':true | ago:'days'); vipPricing = user.activeCompany().vipPrices;\" ng-controller=\"PricingDirectiveHelper\">\n" +
    "						{{ booking.daysAgo = booking.day;\"\" }}\n" +
    "						<td ng-if=\"isConcierge\">{{ booking.day | readTime:'MMM D, YYYY':true }}</td>\n" +
    "						<td class=\"text-center\">\n" +
    "							{{ packageCost = getGrandTotal() + discount.total;\"\" }}\n" +
    "							{{ balanceRemaining = packageCost - totalPayments + tip_total;\"\" }}\n" +
    "							<span ng-if=\"!booking.legacy\">\n" +
    "								{{ user.activeCompany().nickname }}{{ booking.confirmation }}\n" +
    "							</span>\n" +
    "							<span ng-if=\"booking.legacy\">{{ booking.legacy }}</span>\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<a ng-href=\"/booking/{{ user.activeCompany().nickname }}{{booking.confirmation}}\">\n" +
    "							  <span ng-if=\"booking.group_name\">{{ booking.group_name }}</span>\n" +
    "							  <span ng-if=\"!booking.group_name\">{{ booking.last_name }}, {{ booking.first_name }}</span>\n" +
    "							</a>\n" +
    "						</td>\n" +
    "						<td class=\"text-center\">\n" +
    "							<span>{{ booking.adults + (booking.children || 0) }}</span>\n" +
    "						</td>\n" +
    "						<td class=\"text-center\">\n" +
    "							<span ng-if=\"booking.daysAgo >= 0 && booking.status === 'active'\">Yes</span>\n" +
    "							<span ng-if=\"booking.daysAgo < 0 || booking.status !== 'active'\">No</span>\n" +
    "						</td>\n" +
    "						<td class=\"text-center\" ng-if=\"!isConcierge\">\n" +
    "							{{ booking.commissionable = balanceRemaining <= 0 ? getPackageCost().total.price + discount.total : 0; \"\" }}\n" +
    "							{{ booking.commissionable | currency }}\n" +
    "						</td>\n" +
    "						<td class=\"text-center\">\n" +
    "							<span ng-if=\"booking.status === 'active'\">\n" +
    "								<span ng-if=\"balanceRemaining <= 0\" class=\"label label-sm label-block bg-success\">\n" +
    "									{{ booking.paid_value = packageCost;\"\" }}\n" +
    "									Paid In Full\n" +
    "								</span>\n" +
    "								<span ng-if=\"balanceRemaining > 0\" class=\"label label-sm label-block bg-danger\">{{ balanceRemaining | currency }}</span>\n" +
    "							</span>\n" +
    "							<span ng-if=\"booking.status === 'cancelled'\" class=\"label label-sm label-block bg-light\">Cancelled</span>\n" +
    "							<span ng-if=\"booking.status === 'failed'\" class=\"label label-sm label-block bg-light\">Failed</span>\n" +
    "							<span ng-if=\"booking.status === 'pending'\" class=\"label label-sm label-block bg-warning\">Pending</span>\n" +
    "						</td>\n" +
    "						<td ng-if=\"isConcierge\" class=\"text-center\">\n" +
    "							<span ng-if=\"balanceRemaining <= 0 && booking.status === 'active'\">\n" +
    "								<span ng-if=\"!amount.percent\">{{ amount.number * ((booking.adults || 0) + (booking.children ||0)) | currency }}</span>\n" +
    "								<span ng-if=\"amount.percent\">{{ amount.number * 100 }}%</span>\n" +
    "							</span>\n" +
    "							<span ng-if=\"balanceRemaining > 0 || booking.status !== 'active'\">{{ 0 | currency }}</span>\n" +
    "						</td>\n" +
    "					</tr>\n" +
    "				</tbody>\n" +
    "\n" +
    "				<tfoot>\n" +
    "					<tr>\n" +
    "						<td>\n" +
    "							{{ toBePaid = updateFlightValue(bookings);\"\" }}\n" +
    "							Totals\n" +
    "						</td>\n" +
    "						<td></td>\n" +
    "						<td></td>\n" +
    "						<td class=\"text-center text-strong\">{{ bookingTotals.guest_count }}</td>\n" +
    "						<td class=\"text-center\">\n" +
    "							<span ng-if=\"!isConcierge\">{{ toBePaid.commissionable | currency }}</span>\n" +
    "						</td>\n" +
    "						<td></td>\n" +
    "						<td class=\"text-center\" ng-if=\"isConcierge\">\n" +
    "							<span ng-if=\"amount.percent\">{{ toBePaid.total * amount.number | currency }}</span>\n" +
    "							<span ng-if=\"!amount.percent\">{{ toBePaid.count * amount.number | currency }}</span>\n" +
    "						</td>\n" +
    "					</tr>\n" +
    "				</tfoot>\n" +
    "			</table>\n" +
    "		</script>\n" +
    "\n" +
    "	</div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/email", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/email",
    "<div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "  \n" +
    "  <table class=\"table table-bordered table-striped\" ng-init=\"booking.running = {};\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th>#</th>\n" +
    "        <th>Name</th>\n" +
    "        <th>Email</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"(key, booking) in data.reservations | orderBy: 'last_name'\" ng-show=\"booking.status == 'active'\">\n" +
    "        <td>{{ $index + 1 }}</td>\n" +
    "        <td>{{ booking.group_name || booking.first_name + ' ' + booking.last_name }}</td>\n" +
    "        <td>{{ booking.email }}</td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/glance", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/glance",
    "<div class=\"row\" style=\"margin-top: 20px; margin-bottom: 20px;\">\n" +
    "\n" +
    "  <table class=\"table table-condensed table-striped\" style=\"width: 200px\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th style=\"width: 90px;\">Date</th>\n" +
    "        <th>Guests</th>\n" +
    "        <th ng-repeat=\"(name, count) in data.extra_columns\"><span class=\"nowrap\">{{ name }}</span></th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"(key, day) in data.days | orderBy: 'date'\">\n" +
    "        <td>{{ day.date | readTime:'MM/DD/YYYY':false }}</td>\n" +
    "        <td>{{ day.capacity.booked }}</td>\n" +
    "        <td ng-repeat=\"(name, count) in data.extra_columns\">{{ day.reportable[name] || 0 }}</td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "    <tfoot>\n" +
    "      <tr style=\"font-weight: bold;\">\n" +
    "        <td>Total</td>\n" +
    "        <td>{{ data.total }}</td>\n" +
    "        <td ng-repeat=\"(name, count) in data.extra_columns\">{{ count || 0 }}</td>\n" +
    "      </tr>\n" +
    "    </tfoot>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/itsheet", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/itsheet",
    "<div class=\"row\" style=\"margin-top: 20px; margin-bottom: 20px;\">\n" +
    "  <div class=\"col-md-3 col-xs-3 text-center no-pad-lft\">\n" +
    "    <h4>Total Scheduled:</h4>\n" +
    "    <span style=\"margin-top: 7px; display: inline-block\">{{ data.event.capacity.booked }}\n" +
    "      <span ng-if=\"data.event.capacity.total_weight > 0\"> / {{ data.event.capacity.total_weight }} lbs</span></span>\n" +
    "  </div>\n" +
    "  <div class=\"col-md-3 col-xs-3 text-center\">\n" +
    "    <h4>Total Flown</h4>\n" +
    "    <input type=\"text\" class=\"form-control\">\n" +
    "  </div>\n" +
    "  <div class=\"col-md-3 col-xs-3 text-center\">\n" +
    "    <h4>Picnic:</h4>\n" +
    "    <span style=\"margin-top: 7px; display: inline-block\"><span ng-repeat=\"person in data.event.hospitality\">{{ person.name }}<span ng-if=\"!$last\">, </span></span></span>\n" +
    "  </div>\n" +
    "  <div class=\"col-md-3 col-xs-3 text-center no-pad-rt\">\n" +
    "    <h4>Launch Site:</h4>\n" +
    "    <input type=\"text\" class=\"form-control\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "  <table class=\"table table-condensed\" style=\"border-bottom: 1px solid #ddd\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th>Balloon</th>\n" +
    "        <th>Pilot</th>\n" +
    "        <th>Crew</th>\n" +
    "        <th>Driver</th>\n" +
    "        <th class=\"text-center\" style=\"width: 100px;\">Total</th>\n" +
    "        <th class=\"text-center\" style=\"width: 100px;\">Landing</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"(key, flight) in data.flights\" style=\"\">\n" +
    "        <td>{{ flight.balloon.initials || flight.balloon.name }}</td>\n" +
    "        <td>{{ flight.pilot.name }}</td>\n" +
    "        <td>\n" +
    "          <span ng-repeat=\"(key, crew) in flight.crew.chasers\">{{ crew.nickname || crew.name }}<span ng-if=\"!$last\">, </span></span>\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          <span ng-repeat=\"(key, crew) in flight.crew.drivers\">{{ crew.nickname || crew.name }}<span ng-if=\"!$last\">, </span></span>\n" +
    "        </td>\n" +
    "        <td style=\"border: 1px solid #ddd;\"></td>\n" +
    "        <td style=\"border: 1px solid #ddd;\"></td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "  <table class=\"table table-condensed table-striped\" style=\"border-bottom: 1px solid #ddd\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th class=\"text-center\">#</th>\n" +
    "        <th>Balloon</th>\n" +
    "        <th class=\"text-center\">Pax</th>\n" +
    "        <th>Name</th>\n" +
    "        <th>\n" +
    "          <span ng-if=\"user.activeCompany()._id == '55072a1085b826730790f458'\">Weights</span>\n" +
    "          <span ng-if=\"user.activeCompany()._id == '54ecdc7759f44829081dc807'\">Pickup</span>\n" +
    "        </th>\n" +
    "        <th>Package</th>\n" +
    "        <th>Phone</th>\n" +
    "        <th>Memo</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"(key, booking) in data.reservations | orderBy: 'last_name'\" ng-show=\"booking.status == 'active'\">\n" +
    "        <td class=\"text-center\">{{ $index + 1 }}</td>\n" +
    "        <td style=\"border: 1px solid #dddddd\">\n" +
    "          <span ng-repeat=\"(key, flight) in booking.flight\">{{ getFlight(flight).balloon.initials || getFlight(flight).balloon.name }}<span ng-if=\"!$last\">, </span>\n" +
    "          </span>\n" +
    "        </td>\n" +
    "        <td class=\"text-center\">{{ booking.adults + (booking.children || 0) }}</td>\n" +
    "        <td>\n" +
    "          <span ng-if=\"!booking.group\">{{ booking.last_name }}, {{ booking.first_name }}</span>\n" +
    "          <span ng-if=\"booking.group\">{{ booking.group_name }}</span>\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          <span ng-if=\"user.activeCompany()._id == '55072a1085b826730790f458'\">{{booking.meta.weights.join(', ')}}</span>\n" +
    "          <div style=\"display: block\" class=\"text-center\" ng-if=\"user.activeCompany()._id == '54ecdc7759f44829081dc807'\">\n" +
    "            <span ng-if=\"booking.needs_pickup\">Yes</span>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          {{ booking.package.name }}\n" +
    "          <span ng-if=\"booking.vip || booking.group || booking.hotel || booking.meta.no_brunch\">\n" +
    "            <span ng-if=\"booking.vip\"> - VIP</span>\n" +
    "            <span ng-if=\"booking.group\"> - GROUP</span>\n" +
    "            <span ng-if=\"booking.hotel\"> - HOTEL</span>\n" +
    "            <span ng-if=\"booking.meta.no_brunch\"> - NO BRUNCH</span>\n" +
    "          </span>\n" +
    "        </td>\n" +
    "        <td>{{ booking.phone }}</td>\n" +
    "        <td>{{ booking.notes.memo }}</td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/mdse", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/mdse",
    "<div sales-report=\"data\" start=\"start\" end=\"end\">\n" +
    "  <button type=\"button\" class=\"pull-right btn bg-danger\" ng-click=\"clearSales()\">Clear Cache</button>\n" +
    "\n" +
    "  <table class=\"table\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th>Item</th>\n" +
    "        <th ng-show=\"objectKeys(compiled.mdse.days).length <= 7\"\n" +
    "          ng-repeat=\"(day, refs) in compiled.mdse.days\">{{ day }}</th>\n" +
    "        <th>TTL QTY</th>\n" +
    "        <th>TTL VALUE</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"itemName in objectKeys(compiled.mdse.items)\">\n" +
    "        <td>{{ itemName }}</td>\n" +
    "        <td ng-show=\"objectKeys(compiled.mdse.days).length <= 7\"\n" +
    "          ng-repeat=\"(day, refs) in compiled.mdse.days\">\n" +
    "            {{ compiled.mdse.items[itemName].days[day].count || 0 }}\n" +
    "          </td>\n" +
    "        <td>{{ compiled.mdse.items[itemName].count }}</td>\n" +
    "        <td>{{ compiled.mdse.items[itemName].total | currency }}</td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "    <tfoot>\n" +
    "      <tr class=\"active\">\n" +
    "        <td><strong>Total</strong></td>\n" +
    "        <td ng-show=\"objectKeys(compiled.mdse.days).length <= 7\" ng-repeat=\"(day, refs) in compiled.mdse.days\"></td>\n" +
    "        <td></td>\n" +
    "        <td><strong>{{ compiled.mdse.total | currency }}</strong></td>\n" +
    "      </tr>\n" +
    "    </tfoot>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/oldSales", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/oldSales",
    "<div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "  {{ dayCount = objectKeys(data.days).length;\"\" }}\n" +
    "  <div ng-class=\"{ 'col-md-9' : dayCount > 1 && dayCount <= 7, 'col-md-6': dayCount === 1 || dayCount > 7 }\" id=\"salesReport\">\n" +
    "    <table class=\"table\" ng-if=\"dayCount > 1\">\n" +
    "      <thead>\n" +
    "        <tr>\n" +
    "          <th>Items</th>\n" +
    "          <th ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            <a ng-href=\"/reports/sales/{{ day | date:'MM-dd-yy' }}\" class=\"\">{{ day | date:'MM/dd/yy' }}</a>\n" +
    "          </th>\n" +
    "          <th class=\"text-right\">Total</th>\n" +
    "        </tr>\n" +
    "      </thead>\n" +
    "      <tbody>\n" +
    "        <!-- NOTE: All Card Charges; gifts, deposits, payments -->\n" +
    "        <tr ng-if=\"data.charges || data.deposits\">\n" +
    "          {{ cardCharges = aggregateSales(ignoreBillTo, data.charges, data.deposits);\"\" }}\n" +
    "          <td>Payment - Credit Card <span class=\"count\">({{ cardCharges.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ cardCharges[day] = aggregateSales(ignoreBillTo, details.charges, details.deposits);\"\" }}\n" +
    "            {{ cardCharges[day].total | currency }}\n" +
    "            <span ng-if=\"cardCharges[day].count > 0\">({{ cardCharges[day].count }})</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ cardCharges.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Cash Payments -->\n" +
    "        <tr ng-if=\"data.cash\">\n" +
    "          {{ cashCharges = aggregateSales(data.cash);\"\" }}\n" +
    "          <td>Payment - Cash <span class=\"count\">({{ cashCharges.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ cashCharges[day] = aggregateSales(details.cash);\"\" }}\n" +
    "            {{ cashCharges[day].total | currency }}\n" +
    "            <span ng-if=\"cashCharges[day].count > 0\">({{ cashCharges[day].count }})</span>\n" +
    "\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ cashCharges.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Bill To Payments -->\n" +
    "        <tr ng-if=\"data.bill_to\">\n" +
    "          {{ billToDeposits = onlyBillToDeposits(data.deposits);\"\" }}\n" +
    "          {{ billTo = aggregateSales(data.bill_to, billToDeposits);\"\" }}\n" +
    "          <td>Payment - Bill To <span class=\"count\">({{ billTo.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ billTo[day] = aggregateSales(details.bill_to);\"\" }}\n" +
    "            {{ billTo[day].total | currency }}\n" +
    "            <span ng-if=\"billTo[day].count > 0\">({{ billTo[day].count }})</span>\n" +
    "\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ billTo.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Redeemed Deposits -->\n" +
    "        <tr ng-if=\"data.redeemed_deposits\">\n" +
    "          {{ redeemedDeposits = aggregateSales(data.redeemed_deposits);\"\" }}\n" +
    "          <td>Payment - Deposits Redeemed <span class=\"count\">({{ redeemedDeposits.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ redeemedDeposits[day] = aggregateSales(details.redeemed_deposits);\"\" }}\n" +
    "            {{ redeemedDeposits[day].total | currency }}\n" +
    "            <span ng-if=\"redeemedDeposits[day].count > 0\">({{ redeemedDeposits[day].count }})</span>\n" +
    "\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ redeemedDeposits.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Flight Purchases -->\n" +
    "        <tr ng-if=\"data.reservations\">\n" +
    "          {{ packagePurchases = calculatePackageTotal(data.reservations);\"\" }}\n" +
    "          <td>Purchase - Balloon Flights <span class=\"count\">({{ packagePurchases.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ packagePurchases[day] = calculatePackageTotal(details.reservations);\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': packagePurchases[day].count > 0 }\">{{ -packagePurchases[day].total | currency }}</span>\n" +
    "            <span ng-if=\"packagePurchases[day].count > 0\">({{ packagePurchases[day].count }})</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': packagePurchases.count > 0 }\">{{ -packagePurchases.total | currency }}</span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Line Item Purchases -->\n" +
    "        <!-- Aggregate for All items (useful when calculate balance, ignore otherwise) -->\n" +
    "        {{ lineItemGrouped = aggregateSales(data.line_items, false);\"\" }}\n" +
    "        {{ lineItemsContainer = {};\"\" }}\n" +
    "        <tr ng-repeat=\"(name, items) in data.line_items\" ng-init=\"itemRange[name] = aggregateSales(items, false)\">\n" +
    "          <!-- Aggregate for a specific line item accross all days -->\n" +
    "          <td>Purchase - {{ name }} <span class=\"count\">({{ itemRange[name].count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ dayItem[name] = aggregateSales(details.line_items[name], false);\"\" }}\n" +
    "            {{ lineItemsContainer[day] = (lineItemsContainer[day] || 0) + dayItem[name].total;\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': dayItem[name].total < 0 }\">\n" +
    "              {{ dayItem[name].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"dayItem[name].count > 0\">({{ dayItem[name].count }})</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': itemRange[name].total < 0 }\">{{ itemRange[name].total | currency }}</span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Gift Purchases -->\n" +
    "        <tr ng-if=\"data.prepayments\">\n" +
    "          {{ prepaymentPurchases = aggregateSales(data.prepayments, false);\"\" }}\n" +
    "          <td>Purchase - Gifts <span class=\"count\">({{ prepaymentPurchases.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ prepaymentPurchases[day] = aggregateSales(details.prepayments, false);\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': prepaymentPurchases[day].total < 0 }\">\n" +
    "              {{ prepaymentPurchases[day].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"prepaymentPurchases[day].count > 0\">\n" +
    "              ({{ prepaymentPurchases[day].count }})\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger':prepaymentPurchases.total < 0 }\">\n" +
    "              {{ prepaymentPurchases.total | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <tr>\n" +
    "          <td ng-attr-colspan=\"{{ dayCount + 2 }}\">&nbsp;</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Tips Payable -->\n" +
    "        <tr>\n" +
    "          {{ tips = aggregateTips(data.charges);\"\" }}\n" +
    "          <td>Tips Payable <span class=\"count\">({{ tips.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ tips[day] = aggregateTips(details.charges);\"\"}}\n" +
    "            <span ng-class=\"{ 'text-danger': tips[day].total < 0 }\">\n" +
    "              {{ tips[day].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"tips[day].count > 0\">\n" +
    "              ({{ tips[day].count }})\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span class=\"text-danger\">{{ tips.total | currency }}</span>\n" +
    "          </td>\n" +
    "\n" +
    "        </tr>\n" +
    "\n" +
    "        <tr>\n" +
    "          <td ng-attr-colspan=\"{{ dayCount + 2 }}\">&nbsp;</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Gifts Redeemed -->\n" +
    "        <tr>\n" +
    "          {{ gifts_Redeemed = aggregateSales(data.gifts_redeemed);\"\" }}\n" +
    "          {{ giftTotals = {};\"\" }}\n" +
    "          <td>Gift Cards Redeemed <span class=\"count\">({{ gifts_Redeemed.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ giftTotals[day] = aggregateSales(details.gifts_redeemed);\"\"}}\n" +
    "            <span ng-class=\"{ 'text-danger': giftTotals[day].total < 0 }\">\n" +
    "              {{ giftTotals[day].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"giftTotals[day].count > 0\">\n" +
    "              ({{ giftTotals[day].count }})\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span>{{ gifts_Redeemed.total | currency }}</span>\n" +
    "          </td>\n" +
    "\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Deposits Recieved -->\n" +
    "        <tr>\n" +
    "          {{ deposits_received = aggregateSales(data.deposits, false);\"\" }}\n" +
    "          <td>Deposits Received <span class=\"count\">({{ deposits_received.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ deposits_received[day] = aggregateSales(details.deposits, false);\"\"}}\n" +
    "            <span ng-class=\"{ 'text-danger': deposits_received[day].total < 0 }\">\n" +
    "              {{ deposits_received[day].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"deposits_received[day].count > 0\">\n" +
    "              ({{ deposits_received[day].count }})\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': deposits_received.total < 0 }\">\n" +
    "              {{ deposits_received.total | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Discounts -->\n" +
    "        <tr>\n" +
    "          {{ totalDiscounts = aggregateSales(data.discounts);\"\" }}\n" +
    "          <td>Discounts <span class=\"count\">({{ totalDiscounts.count }})</span></td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ totalDiscounts[day] = aggregateSales(details.discounts);\"\"}}\n" +
    "            <span ng-class=\"{ 'text-danger': totalDiscounts[day].total < 0 }\">\n" +
    "              {{ totalDiscounts[day].total | currency }}\n" +
    "            </span>\n" +
    "            <span ng-if=\"totalDiscounts[day].count > 0\">\n" +
    "              ({{ totalDiscounts[day].count }})\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': totalDiscounts.total < 0 }\">\n" +
    "              {{ totalDiscounts.total | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "\n" +
    "        </tr>\n" +
    "\n" +
    "        <tr>\n" +
    "          <td ng-attr-colspan=\"{{ dayCount + 2 }}\">&nbsp;</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <tr>\n" +
    "          {{ totalBalance = ((cardCharges.total + cashCharges.total + billTo.total + redeemedDeposits.total + lineItemGrouped.total + prepaymentPurchases.total + gifts_Redeemed.total + deposits_received.total + totalDiscounts.total) - packagePurchases.total) + tips.total;\"\" }}\n" +
    "          <td>Balance</td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ dayTotal = ((cardCharges[day].total + cashCharges[day].total + billTo[day].total + redeemedDeposits[day].total + lineItemsContainer[day] + prepaymentPurchases[day].total + giftTotals[day].total + deposits_received[day].total + totalDiscounts[day].total) - packagePurchases[day].total) + tips[day].total;\"\" }}\n" +
    "\n" +
    "            <span ng-class=\"{ 'text-danger': dayTotal < 0 }\">\n" +
    "              {{ dayTotal | currency }}\n" +
    "            </span>\n" +
    "\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': totalBalance < 0 }\">\n" +
    "              {{ totalBalance | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "      </tbody>\n" +
    "      <thead>\n" +
    "        <tr>\n" +
    "          <th ng-attr-colspan=\"{{ dayCount + 2 }}\">\n" +
    "            <h4 style=\"margin-bottom: 0;\">Credit Card Settlement Calculator</h4>\n" +
    "          </th>\n" +
    "        </tr>\n" +
    "      </thead>\n" +
    "      <tbody>\n" +
    "        <!-- NOTE: Total Payments Recieved -->\n" +
    "        <tr>\n" +
    "          {{ recieved = cardCharges.total;\"\" }}\n" +
    "          <td>Payments Recieved</td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ cardCharges[day] = aggregateSales(details.charges, details.deposits);\"\" }}\n" +
    "            <span>{{ cardCharges[day].total | currency }}</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ recieved | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Refunds -->\n" +
    "        <tr>\n" +
    "          {{ refunds = aggregateSales(data.refunds, false);\"\" }}\n" +
    "          <td>\n" +
    "            Refunds\n" +
    "            <span class=\"count\">({{ refunds.count }})</span>\n" +
    "          </td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ refunds[day] = aggregateSales(details.refunds, false);\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': refunds[day].total < 0 }\">\n" +
    "              {{ refunds[day].total | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': refunds.total < 0 }\">\n" +
    "              {{ refunds.total | currency }}\n" +
    "            </span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Processing Fees -->\n" +
    "        <tr>\n" +
    "          {{ fees = aggregateSales(data.fees, false);\"\" }}\n" +
    "          <td>Processing Fees</td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ fees[day] = aggregateSales(details.fees, false);\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': fees[day].total < 0 }\">{{ fees[day].total | currency }}</span>\n" +
    "          </td>\n" +
    "          <td ng-class=\"{ 'text-danger': fees.total < 0 }\" class=\"text-right\">{{ fees.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "        <!-- NOTE: Settlement Total -->\n" +
    "        <tr>\n" +
    "          <td>Settlement Amount</td>\n" +
    "          <td ng-repeat=\"(day, details) in data.days\" ng-if=\"dayCount <= 7\">\n" +
    "            {{ settlement[day] = cardCharges[day].total + fees[day].total;\"\" }}\n" +
    "            <span ng-class=\"{ 'text-danger': settlement[day] < 0 }\">{{ settlement[day] | currency }}</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">{{ recieved + refunds.total + fees.total | currency }}</td>\n" +
    "        </tr>\n" +
    "\n" +
    "      </tbody>\n" +
    "\n" +
    "    </table>\n" +
    "\n" +
    "    <script type=\"text/ng-template\" id=\"partial\">\n" +
    "      {{ model = data[item.model] ? data[item.model][item.reference] : item;\"\" }}\n" +
    "      {{ name = model.contact.purchaser.name || model.group_name || model.first_name + \" \" + model.last_name;\"\" }}\n" +
    "\n" +
    "      <a ng-href=\"/booking/{{ model.confirmation }}\" class=\"btn bg-light btn-xs inline\" ng-if=\"model.confirmation\">{{ name }}</a>\n" +
    "\n" +
    "      <span ng-if=\"!model.confirmation\">{{ name }}</span>\n" +
    "\n" +
    "      <strong ng-if=\"item.type\"> - {{ item.type }}</strong>\n" +
    "\n" +
    "      <span class=\"pull-right\">\n" +
    "        <strong>\n" +
    "          <span ng-if=\"item.package\">{{ item.package.name }} - </span>\n" +
    "					<span ng-if=\"item.vip\">VIP - </span>\n" +
    "          <span ng-if=\"item.card\">\n" +
    "            <span ng-if=\"item.card !== 'bill_to'\">{{ item.card }} - </span>\n" +
    "            {{ item.masked }} -\n" +
    "          </span>\n" +
    "        </strong>\n" +
    "        {{ amount = item.amount || item.product.total * -1 || item.value * -1 || (calculatePackageCost(item) * -1);\"\" }}\n" +
    "        {{ amount = item.negative ? amount * -1 : amount;\"\" }}\n" +
    "        <span ng-class=\"{ 'text-danger': amount < 0 }\">{{ amount || 0 | currency }}</span>\n" +
    "      </span>\n" +
    "\n" +
    "    </script>\n" +
    "\n" +
    "    <div ng-if=\"dayCount === 1\">\n" +
    "      <div class=\"row\">\n" +
    "        <h4 class=\"col-md-12\">Items\n" +
    "          <a ng-href=\"/day/bookings/{{ state.start }}\" class=\"btn btn-xs bg-light pull-right  hidden-print\">View Day</a>\n" +
    "        </h4>\n" +
    "      </div>\n" +
    "\n" +
    "    <ul class=\"list-unstyled sales-report\">\n" +
    "\n" +
    "      <!-- NOTE: All Card Charges; gifts, deposits, payments -->\n" +
    "      <li>\n" +
    "        {{ cardCharges = aggregateSales(ignoreBillTo, data.charges, data.deposits);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!cardCharges.count\" ng-click=\"showCharges = !showCharges\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showCharges\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showCharges\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Payment - Credit Card\n" +
    "          <span class=\"count\">({{ cardCharges.count }})</span>\n" +
    "        </span> <span class=\"pull-right\">{{ cardCharges.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"cardCharges.count > 0 && showCharges\">\n" +
    "  				<ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.charges\" ng-if=\"item.card !== 'bill_to'\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "            <li ng-repeat=\"item in data.deposits\" ng-if=\"item.card !== 'bill_to'\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "  				</ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Cash Payments -->\n" +
    "      <li>\n" +
    "        {{ cashCharges = aggregateSales(data.cash);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!cashCharges.count\" ng-click=\"showCash = !showCash\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showCash\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showCash\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Payment - Cash\n" +
    "          <span class=\"count\">({{ cashCharges.count }})</span>\n" +
    "        </span> <span class=\"pull-right\">{{ cashCharges.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"cashCharges.count > 0 && showCash\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.cash\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Bill To Payments -->\n" +
    "      <li>\n" +
    "        {{ billToDeposits = onlyBillToDeposits(data.deposits);\"\" }}\n" +
    "        {{ billTo = aggregateSales(data.bill_to, billToDeposits);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!billTo.count\" ng-click=\"showBill = !showBill\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showBill\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showBill\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Payment - Bill To\n" +
    "          <span class=\"count\">({{ billTo.count }})</span>\n" +
    "        </span> <span class=\"pull-right\">{{ billTo.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"billTo.count > 0 && showBill\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.bill_to\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "            <li ng-repeat=\"item in billToDeposits\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Redeemed Deposits -->\n" +
    "      <li>\n" +
    "        {{ redeemedDeposits = aggregateSales(data.redeemed_deposits);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!redeemedDeposits.count\" ng-click=\"showRedeemedDeposits = !showRedeemedDeposits\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showRedeemedDeposits\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showRedeemedDeposits\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Payment - Deposits Redeemed\n" +
    "          <span class=\"count\">({{ redeemedDeposits.count }})</span>\n" +
    "        </span> <span class=\"pull-right\">{{ redeemedDeposits.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"redeemedDeposits.count > 0 && showRedeemedDeposits\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.redeemed_deposits\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Flight Purchases -->\n" +
    "      <li>\n" +
    "        {{ packagePurchases = calculatePackageTotal(data.reservations);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!packagePurchases.count\" ng-click=\"showFlights = !showFlights\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showFlights\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showFlights\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Purchase - Balloon Flights\n" +
    "          <span class=\"count\">({{ packagePurchases.count }})</span>\n" +
    "        </span> <span class=\"pull-right\" ng-class=\"{ 'text-danger': -packagePurchases.total < 0 }\">{{ -packagePurchases.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"packagePurchases.count > 0 && showFlights\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.reservations\" ng-if=\"!item.hide && item.status === 'active'\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Line Item Purchases -->\n" +
    "      {{ lineItemGrouped = aggregateSales(data.line_items, false);\"\" }}\n" +
    "      <li ng-repeat=\"(name, items) in data.line_items\">\n" +
    "        {{ lineItemPurchases = aggregateSales(items, false);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!lineItemPurchases.count\" ng-click=\"items.showMe = !items.showMe\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!items.showMe\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"items.showMe\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Purchase - {{ name }}\n" +
    "          <span class=\"count\">({{ lineItemPurchases.count }})</span>\n" +
    "        </span> <span class=\"pull-right\" ng-class=\"{ 'text-danger': lineItemPurchases.total !== 0 }\">{{ lineItemPurchases.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"lineItemPurchases.count > 0 && items.showMe\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in items\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Gift Purchases -->\n" +
    "      <li>\n" +
    "        {{ prepaymentPurchases = aggregateSales(data.prepayments, false);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!prepaymentPurchases.count\" ng-click=\"showGifts = !showGifts\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showGifts\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showGifts\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "        <span>\n" +
    "          Purchase - Gifts\n" +
    "          <span class=\"count\">({{ prepaymentPurchases.count }})</span>\n" +
    "        </span>\n" +
    "        <span class=\"pull-right\" ng-class=\"{ 'text-danger' : prepaymentPurchases.total < 0}\">\n" +
    "          {{ prepaymentPurchases.total | currency }}\n" +
    "        </span>\n" +
    "\n" +
    "        <div ng-if=\"prepaymentPurchases.count > 0 && showGifts\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"item in data.prepayments\">\n" +
    "              {{ item.negative = true;\"\" }}\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "      <li>&nbsp;</li>\n" +
    "      <!-- NOTE: Tips Payable -->\n" +
    "      <li>\n" +
    "        {{ tips = aggregateTips(data.charges);\"\" }}\n" +
    "				<button class=\"btn btn-xs btn-link\" ng-disabled=\"!tips.count\" ng-click=\"showTips = !showTips\">\n" +
    "					<i class=\"fa fa-plus\" ng-show=\"!showTips\"></i>\n" +
    "					<i class=\"fa fa-minus\" ng-show=\"showTips\"></i>\n" +
    "				</button>\n" +
    "        <span>Tips Payable</span>\n" +
    "        <span class=\"pull-right\" ng-class=\"{ 'text-danger': tips.total < 0 }\">\n" +
    "          {{ tips.total | currency }}\n" +
    "        </span>\n" +
    "\n" +
    "				<div ng-if=\"tips.count > 0 && showTips\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"(name, amount) in tips.pilots\">\n" +
    "              <span>{{ name }}</span> <span class=\"pull-right text-danger\">{{ amount | currency }}</span>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "      <li>&nbsp;</li>\n" +
    "\n" +
    "      <!-- NOTE: Gifts Redeemed -->\n" +
    "      <li>\n" +
    "        {{ giftsRedeemed = aggregateSales(data.gifts_redeemed);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!giftsRedeemed.count\" ng-click=\"showGiftRedemptions = !showGiftRedemptions\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showGiftRedemptions\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showGiftRedemptions\"></i>\n" +
    "        </button>\n" +
    "        <span>\n" +
    "          Gift Cards Redeemed\n" +
    "          <span class=\"count\">({{ giftsRedeemed.count }})</span>\n" +
    "        </span>\n" +
    "        <span class=\"pull-right\">{{ giftsRedeemed.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"giftsRedeemed.count > 0 && showGiftRedemptions\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"(name, item) in data.gifts_redeemed\">\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Deposits Recieved -->\n" +
    "      <li>\n" +
    "        {{ deposits = aggregateSales(data.deposits, false);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!deposits.count\" ng-click=\"showDesposits = !showDesposits\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showDesposits\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showDesposits\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "        <span>\n" +
    "          Deposits Received\n" +
    "          <span class=\"count\">({{ deposits.count }})</span>\n" +
    "        </span>\n" +
    "        <span class=\"pull-right\" ng-class=\"{\n" +
    "          'text-danger': deposits.total < 0\n" +
    "        }\">{{ deposits.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"deposits.count > 0 && showDesposits\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"(name, placeholder) in data.deposits\">\n" +
    "              {{ item = clone(placeholder); item.negative = true;\"\" }}\n" +
    "              <div ng-include=\"'partial'\"></div>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "\n" +
    "      <!-- NOTE: Discounts -->\n" +
    "      <li>\n" +
    "        {{ discounts = aggregateSales(data.discounts, true);\"\" }}\n" +
    "        <button class=\"btn btn-xs btn-link\" ng-disabled=\"!discounts.count\" ng-click=\"showDiscounts = !showDiscounts\">\n" +
    "          <i class=\"fa fa-plus\" ng-show=\"!showDiscounts\"></i>\n" +
    "          <i class=\"fa fa-minus\" ng-show=\"showDiscounts\"></i>\n" +
    "        </button>\n" +
    "\n" +
    "        <span>\n" +
    "          Discounts\n" +
    "          <span class=\"count\">({{ discounts.count }})</span>\n" +
    "        </span>\n" +
    "        <span class=\"pull-right\" ng-class=\"{\n" +
    "          'text-danger': discounts.total < 0\n" +
    "        }\">{{ discounts.total | currency }}</span>\n" +
    "\n" +
    "        <div ng-if=\"discounts.count > 0 && showDiscounts\">\n" +
    "          <ul class=\"list-unstyled\">\n" +
    "            <li ng-repeat=\"(name, item) in data.discounts\">\n" +
    "              {{ product = aggregateSales(item, true);\"\" }}\n" +
    "              {{ name }}\n" +
    "              <span class=\"count\">({{ product.count }})</span>\n" +
    "              <span class=\"pull-right\">{{ product.total | currency }}</span>\n" +
    "              <!-- <div ng-include=\"'partial'\"></div> -->\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "\n" +
    "      </li>\n" +
    "      <li>&nbsp;</li>\n" +
    "\n" +
    "      <!-- NOTE: Balance for the Range -->\n" +
    "      <li>\n" +
    "        {{ balance = ((cardCharges.total + cashCharges.total + billTo.total + redeemedDeposits.total + lineItemGrouped.total + prepaymentPurchases.total + giftsRedeemed.total + deposits.total + discounts.total) - packagePurchases.total) + tips.total;\"\" }}\n" +
    "        <span>Balance</span>\n" +
    "        <span class=\"pull-right\"\n" +
    "          ng-class=\"{ 'text-danger': balance < 0 }\">\n" +
    "          {{ balance | currency }}\n" +
    "        </span>\n" +
    "      </li>\n" +
    "\n" +
    "    </ul>\n" +
    "\n" +
    "      <h4>Credit Card Settlement Calculator</h4>\n" +
    "      <ul class=\"list-unstyled\">\n" +
    "\n" +
    "        <!-- NOTE: Total Payments Recieved -->\n" +
    "        <li>\n" +
    "          {{ recieved = cardCharges.total;\"\" }}\n" +
    "          <span>Payments Recieved</span>\n" +
    "          <span class=\"pull-right\">{{ recieved | currency }}</span>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- NOTE: Refunds -->\n" +
    "        <li>\n" +
    "          {{ refunds = aggregateSales(data.refunds, false);\"\" }}\n" +
    "          <button class=\"btn btn-xs btn-link\" ng-disabled=\"!refunds.count\" ng-click=\"showRefunds = !showRefunds\">\n" +
    "            <i class=\"fa fa-plus\" ng-show=\"!showRefunds\"></i>\n" +
    "            <i class=\"fa fa-minus\" ng-show=\"showRefunds\"></i>\n" +
    "          </button>\n" +
    "\n" +
    "          <span>\n" +
    "            Refunds\n" +
    "            <span class=\"count\">({{ refunds.count }})</span>\n" +
    "          </span>\n" +
    "          <span class=\"pull-right\" ng-class=\"{ 'text-danger' : refunds.total < 0 }\">{{ refunds.total | currency }}</span>\n" +
    "\n" +
    "          <div ng-if=\"billTo.count > 0 && showRefunds\">\n" +
    "            <ul class=\"list-unstyled\">\n" +
    "              <li ng-repeat=\"item in data.refunds\">\n" +
    "                {{ item.negative = true;\"\" }}\n" +
    "                <div ng-include=\"'partial'\"></div>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </div>\n" +
    "\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- NOTE: Refunds -->\n" +
    "        <li>\n" +
    "          {{ fees = aggregateSales(data.fees, false);\"\" }}\n" +
    "          <span>\n" +
    "            Processing Fees\n" +
    "          </span>\n" +
    "          <span class=\"pull-right\" ng-class=\"{ 'text-danger': fees.total < 0 }\">\n" +
    "            {{ fees.total | currency }}\n" +
    "          </span>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- NOTE: Settlement Total -->\n" +
    "        <li>\n" +
    "          <span>Settlement Amount</span>\n" +
    "          {{ settlement = recieved + refunds.total + fees.total;\"\" }}\n" +
    "          <span class=\"pull-right\" ng-class=\"{ 'text-danger': settlement < 0 }\">\n" +
    "            {{ settlement | currency }}\n" +
    "          </span>\n" +
    "        </li>\n" +
    "\n" +
    "      </ul>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<pre class=\"clearfix hide\">{{ data.deposits | json }}</pre>\n" +
    "");
}]);

angular.module("views/reports/pickups", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/pickups",
    "<div class=\"\" style=\"margin-top: 20px; margin-bottom: 20px;\" ng-repeat=\"(key, driver) in data.meta.drivers\" ng-if=\"driver.reservations.length > 0\">\n" +
    "\n" +
    "  <h5 class=\"upper\">Driver: {{ driver.name }} ({{ driver.reservations.length }}) - {{ driver.flight.balloon.name }}</h5>\n" +
    "\n" +
    "  <table class=\"table table-condensed\" style=\"border-bottom: 1px solid #ddd\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th width=\"25%\">Name</th>\n" +
    "        <th width=\"5%\" class=\"text-center\">PAX</th>\n" +
    "        <th width=\"8%\">Time</th>\n" +
    "        <th width=\"28%\">Location</th>\n" +
    "        <th width=\"16.5%\">Phone</th>\n" +
    "        <th width=\"16.5%\">Returned By</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody ng-repeat=\"(key, booking) in driver.reservations | orderBy: 'pickup.time'\" ng-if=\"booking.status == 'active'\">\n" +
    "      <tr>\n" +
    "        <td>\n" +
    "          {{ ::addToAssigned(booking._id) }}\n" +
    "          <span ng-if=\"!booking.group\">{{ booking.last_name + ', ' + booking.first_name }}</span>\n" +
    "          <span ng-if=\"booking.group\">{{ booking.group_name }}</span>\n" +
    "        </td>\n" +
    "        <td class=\"text-center\">{{ booking.adults + (booking.children || 0)}}</td>\n" +
    "        <td>{{ booking.pickup.time | readTime: 'hh:mm a':true }}</td>\n" +
    "        <td>{{ booking.accommodations.hotel.name }}</td>\n" +
    "        <td><a ng-href=\"tel:{{booking.phone}}\">{{ booking.phone | phone }}</a></td>\n" +
    "        <td></td>\n" +
    "      </tr>\n" +
    "      <tr ng-show=\"booking.pickup.notes\">\n" +
    "        <td colspan=\"6\" class=\"active\">\n" +
    "          <div style=\"padding: 0px 15px;\">\n" +
    "            <strong>Notes for Driver:</strong> {{ booking.pickup.notes }}\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"\" style=\"margin-top: 20px; margin-bottom: 20px;\">\n" +
    "\n" +
    "  <h5 class=\"upper\">Unassigned</h5>\n" +
    "\n" +
    "  <table class=\"table table-condensed\" style=\"border-bottom: 1px solid #ddd\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th width=\"16.5%\">Name</th>\n" +
    "        <th width=\"16.5%\">PAX</th>\n" +
    "        <th width=\"16.5%\">Time</th>\n" +
    "        <th width=\"16.5%\">Location</th>\n" +
    "        <th width=\"16.5%\">Phone</th>\n" +
    "        <th width=\"16.5%\">Returned By</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"(key, booking) in data.bookings | orderBy: 'pickup.time'\" ng-if=\"booking.status == 'active' && !isAssigned(booking._id)\">\n" +
    "        <td>\n" +
    "          <span ng-if=\"!booking.group\">{{ booking.last_name + ', ' + booking.first_name }}</span>\n" +
    "          <span ng-if=\"booking.group\">{{ booking.group_name }}</span>\n" +
    "        </td>\n" +
    "        <td>{{ booking.adults + (booking.children || 0)}}</td>\n" +
    "        <td>{{ booking.pickup.time | readTime: 'hh:mm a':true }}</td>\n" +
    "        <td>{{ booking.accommodations.hotel.name }}</td>\n" +
    "        <td>{{ booking.phone }}</td>\n" +
    "        <td></td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/sales", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/sales",
    "<!-- !! DEPRECATED -->\n" +
    "\n" +
    "<div class=\"row\" style=\"margin-top: 20px;\">\n" +
    "\n" +
    "  <div sales-report=\"data\" start=\"start\" end=\"end\">\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "\n" +
    "      {{ stripeFees = salesReport.calcFees(days); '' }}\n" +
    "\n" +
    "      <h3 class=\"heads-up\">\n" +
    "        {{ fees }}\n" +
    "        <span class=\"amount\" ng-class=\"{'text-danger': stripeFees.total < 0}\">{{ fees.charged - fees.refunded | currency }}</span>\n" +
    "        <span class=\"small clear\">Processing Fees</span>\n" +
    "      </h3>\n" +
    "\n" +
    "      <h3 class=\"heads-up\">\n" +
    "        {{ compiled.debits.refund }}\n" +
    "        <span class=\"amount\">{{ compiled.debits.credit_card + stripeFees.total + compiled.debits.refunds | currency }}</span>\n" +
    "        <span class=\"small clear\">Credit Card Deposit</span>\n" +
    "      </h3>\n" +
    "\n" +
    "      <h3 class=\"heads-up\">\n" +
    "        <span class=\"amount\">{{ compiled.debits.cash | currency }}</span>\n" +
    "        <span class=\"small clear\">Cash Deposit</span>\n" +
    "      </h3>\n" +
    "\n" +
    "      <h3 class=\"heads-up\">\n" +
    "        <span class=\"amount\">\n" +
    "          <span>{{ compiled.balance | currency }}</span>\n" +
    "        </span>\n" +
    "        <span class=\"small clear\">Balance</span>\n" +
    "      </h3>\n" +
    "\n" +
    "      <button type=\"button\" class=\"pull-right btn bg-danger\" ng-click=\"clearSales()\">Clear Cache</button>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <table class=\"table\" ng-init=\"saleOrder = 'sort.last'; saleRev = false\">\n" +
    "          <thead>\n" +
    "            <th>#</th>\n" +
    "            <th class=\"point\" ng-click=\"saleOrder = 'sort.last'; saleRev = !saleRev\">\n" +
    "              Customer\n" +
    "            </th>\n" +
    "            <th class=\"point\" ng-click=\"saleOrder = 'reference.day'; saleRev = !saleRev\">\n" +
    "              Date\n" +
    "            </th>\n" +
    "            <th>Flights</th>\n" +
    "            <th>Tips</th>\n" +
    "            <th>MDSE</th>\n" +
    "            <th>Pickup</th>\n" +
    "            <th>Sold G.C.</th>\n" +
    "            <th>Deposits Received</th>\n" +
    "            <!-- <th>A/R Received</th> -->\n" +
    "            <!-- <th>Refunds</th> -->\n" +
    "            <th>Total Credits</th>\n" +
    "            <th>Total Debits</th>\n" +
    "            <th>Balance</th>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr\n" +
    "              ng-repeat=\"guest in compiled.guests | orderBy: saleOrder:saleRev\"\n" +
    "              ng-if=\"guest.report.credits.available()\">\n" +
    "              <td>\n" +
    "                <a ng-if=\"guest.reference.reference_model === 'Reservation'\"\n" +
    "                  ng-href=\"/booking/{{guest.reference.confirmation}}\"\n" +
    "                  ng-class=\"{'strike': guest.reference.status === 'cancelled'}\">\n" +
    "                  {{ user.activeCompany().nickname }}{{ guest.reference.confirmation }}\n" +
    "                </a>\n" +
    "                <span ng-if=\"guest.reference.reference_model === 'Prepayment'\">\n" +
    "                  {{ guest.reference.code }}\n" +
    "                </span>\n" +
    "              </td>\n" +
    "              <td>\n" +
    "                <span ng-if=\"guest.reference.reference_model === 'Prepayment'\">\n" +
    "                  {{ guest.sort.first + ', ' + guest.sort.last }}\n" +
    "                </span>\n" +
    "                <a ng-if=\"guest.reference.reference_model === 'Reservation'\" ng-href=\"/booking/{{guest.reference.confirmation}}\">\n" +
    "                  {{ guest.reference.group_name || guest.reference.last_name + ', ' + guest.reference.first_name }}\n" +
    "                </a>\n" +
    "              </td>\n" +
    "              <td>{{ guest.reference.day || guest.reference.date || guest.reference.created | readTime:'MM/DD/YY':(guest.reference === 'prepayment' ? true : false) }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.flights == 0, 'text-danger' : guest.report.credits.flights < 0 }\">\n" +
    "                {{ guest.report.credits.flights | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.tips == 0, 'text-danger' : guest.report.credits.tips < 0 }\">\n" +
    "                {{ guest.report.credits.tips | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.mdse == 0, 'text-danger' : guest.report.credits.mdse < 0 }\">\n" +
    "                {{ guest.report.credits.mdse | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.pickup == 0, 'text-danger' : guest.report.credits.pickup < 0 }\">\n" +
    "                {{ guest.report.credits.pickup | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.gifts == 0, 'text-danger' : guest.report.credits.gifts < 0 }\">\n" +
    "                {{ guest.report.credits.gifts | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.deposits_received == 0, 'text-danger' : guest.report.credits.deposits_received < 0 }\">\n" +
    "                {{ guest.report.credits.deposits_received | currency }}\n" +
    "              </td>\n" +
    "              <!-- <td ng-class=\"{ 'text-muted' : guest.report.credits.ar_received == 0, 'text-danger' : guest.report.credits.ar_received < 0 }\">\n" +
    "                {{ guest.report.credits.ar_received | currency }}\n" +
    "              </td> -->\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.credits.total == 0, 'text-danger' : guest.report.credits.total < 0 }\">\n" +
    "                {{ guest.report.credits.total | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.debits.total == 0, 'text-danger' : guest.report.debits.total < 0 }\">\n" +
    "                {{ guest.report.debits.total | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : guest.report.balance == 0, 'text-danger' : guest.report.balance != 0 }\">\n" +
    "                {{ guest.report.balance | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "          <tfoot>\n" +
    "            <tr style=\"font-weight: bold;\">\n" +
    "              <td colspan=\"3\"></td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.flights == 0, 'text-danger' : compiled.credits.flights < 0 }\">\n" +
    "                {{ compiled.credits.flights | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.tips == 0, 'text-danger' : compiled.credits.tips < 0 }\">\n" +
    "                {{ compiled.credits.tips | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.mdse == 0, 'text-danger' : compiled.credits.mdse < 0 }\">\n" +
    "                {{ compiled.credits.mdse | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.pickup == 0, 'text-danger' : compiled.credits.pickup < 0 }\">\n" +
    "                {{ compiled.credits.pickup | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.gifts == 0, 'text-danger' : compiled.credits.gifts < 0 }\">\n" +
    "                {{ compiled.credits.gifts | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.deposits_received == 0, 'text-danger' : compiled.credits.deposits_received < 0 }\">\n" +
    "                {{ compiled.credits.deposits_received | currency }}\n" +
    "              </td>\n" +
    "              <!-- <td ng-class=\"{ 'text-muted' : compiled.credits.ar_received == 0, 'text-danger' : compiled.credits.ar_received < 0 }\">\n" +
    "                {{ compiled.credits.ar_received | currency }}\n" +
    "              </td> -->\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.credits.total == 0, 'text-danger' : compiled.credits.total < 0 }\">\n" +
    "                {{ compiled.credits.total | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.debits.total == 0, 'text-danger' : compiled.debits.total < 0 }\">\n" +
    "                {{ compiled.debits.total | currency }}\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted' : compiled.balance == 0, 'text-danger' : compiled.balance != 0 }\">\n" +
    "                {{ compiled.balance | currency }}\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tfoot>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <div class=\"checkbox pull-right\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"expanded\"> Expand\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <table class=\"table\" ng-init=\"orderCharges = 'sort.last'; reverse = false\">\n" +
    "          <thead>\n" +
    "            <th>#</th>\n" +
    "            <th class=\"point\" ng-click=\"orderCharges = 'sort.last'; reverse = !reverse\">Customer</th>\n" +
    "            <th class=\"point\" ng-click=\"orderCharges = 'reference.day'; reverse = !reverse\">\n" +
    "              <span ng-if=\"!expanded\">Date</span>\n" +
    "              <span ng-if=\"expanded\">Charge Date</span>\n" +
    "            </th>\n" +
    "            <th>Credit Card</th>\n" +
    "            <th>Cash</th>\n" +
    "            <th>GC Redeemed</th>\n" +
    "            <th>Deposits Redeemed</th>\n" +
    "            <th>A/R</th>\n" +
    "            <th>Discounts</th>\n" +
    "            <th>Refunds</th>\n" +
    "            <th>Total Debits</th>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr sales-report-guest\n" +
    "              ng-repeat=\"guest in compiled.guests | orderBy: orderCharges:reverse\" ng-hide=\"expanded\"\n" +
    "              ng-if=\"guest.report.debits.available()\">\n" +
    "              <td>\n" +
    "                <a ng-if=\"guest.reference.reference_model === 'Reservation'\"\n" +
    "                  ng-href=\"/booking/{{guest.reference.confirmation}}\"\n" +
    "                  ng-class=\"{'strike': guest.reference.status === 'cancelled'}\">\n" +
    "                  {{ user.activeCompany().nickname }}{{ guest.reference.confirmation }}\n" +
    "                </a>\n" +
    "                <span ng-if=\"guest.reference.reference_model === 'Prepayment'\">\n" +
    "                  {{ guest.reference.code }}\n" +
    "                </span>\n" +
    "              </td>\n" +
    "              <td>\n" +
    "                <span ng-if=\"guest.reference.reference_model === 'Prepayment'\">\n" +
    "                  {{ guest.sort.first + ', ' + guest.sort.last }}\n" +
    "                </span>\n" +
    "                <a ng-if=\"guest.reference.reference_model === 'Reservation'\" ng-href=\"/booking/{{guest.reference.confirmation}}\">\n" +
    "                  {{ guest.reference.group_name || guest.reference.last_name + ', ' + guest.reference.first_name }}\n" +
    "                </a>\n" +
    "              </td>\n" +
    "              <td>{{ guest.reference.day || guest.reference.created | readTime:'MM/DD/YY':(guest.reference === 'prepayment' ? true : false) }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.credit_card.total == 0 }\">{{ guest.report.debits.credit_card.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.cash.total == 0 }\">{{ guest.report.debits.cash.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.gifts_redeemed.total == 0 }\">{{ guest.report.debits.gifts_redeemed.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.deposits_redeemed.total == 0 }\">{{ guest.report.debits.deposits_redeemed.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.ar.total == 0 }\">{{ guest.report.debits.ar.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.discounts.total == 0 }\">{{ guest.report.debits.discounts.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.refunds.total == 0, 'text-danger': guest.report.debits.refunds.total !== 0 }\">{{ guest.report.debits.refunds.total | currency }}</td>\n" +
    "              <td ng-class=\"{ 'text-muted': guest.report.debits.total == 0 }\">{{ guest.report.debits.total | currency }}</td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "          <tfoot>\n" +
    "            <tr>\n" +
    "              <td>&nbsp;</td>\n" +
    "              <td>&nbsp;</td>\n" +
    "              <td>&nbsp;</td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.credit_card === 0 }\">\n" +
    "                <strong>{{ compiled.debits.credit_card | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.cash === 0 }\">\n" +
    "                <strong>{{ compiled.debits.cash | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.gifts_redeemed === 0 }\">\n" +
    "                <strong>{{ compiled.debits.gifts_redeemed | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.deposits_redeemed === 0 }\">\n" +
    "                <strong>{{ compiled.debits.deposits_redeemed | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.ar === 0 }\">\n" +
    "                <strong>{{ compiled.debits.ar | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.discounts === 0 }\">\n" +
    "                <strong>{{ compiled.debits.discounts | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.refunds === 0, 'text-danger': compiled.debits.refunds !== 0 }\">\n" +
    "                <strong>{{ compiled.debits.refunds | currency }}</strong>\n" +
    "              </td>\n" +
    "              <td ng-class=\"{ 'text-muted': compiled.debits.total === 0 }\">\n" +
    "                <strong>{{ compiled.debits.total | currency }}</strong>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tfoot>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/salesSlip", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/salesSlip",
    "<div class=\"row\" style=\"margin-top: 20px; margin-bottom: 20px;\"\n" +
    "  ng-repeat=\"(key, booking) in data\"\n" +
    "  ng-controller=\"PricingDirectiveHelper\"\n" +
    "  ng-if=\"booking.status == 'active'\"\n" +
    "  ng-init=\"prepPrice(booking)\">\n" +
    "\n" +
    "  <h5 class=\"upper\">\n" +
    "    <span ng-if=\"!booking.group\">{{ booking.first_name }} {{ booking.last_name }} </span>\n" +
    "    <span ng-if=\"booking.group\">{{ booking.group_name }} </span>\n" +
    "    <small>{{ day }}</small>\n" +
    "  </h5>\n" +
    "\n" +
    "  <table class=\"table table-bordered table-striped\" ng-init=\"booking.running = {};\" ng-controller=\"PricingDirectiveHelper\" style=\"width: 99%;\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th style=\"width: 30%;\">Description</th>\n" +
    "        <th style=\"width: 10%\">Qty</th>\n" +
    "        <th style=\"width: 20%\">Price</th>\n" +
    "        <th style=\"width: 20%\">Unit Total</th>\n" +
    "        <th style=\"width: 20%\">Total</th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody ng-init=\"rows = countRows(booking)\">\n" +
    "      <tr ng-init=\"booking.running['a1'] = booking.pricing.package_cost\">\n" +
    "        <td>{{ package.name }}</td>\n" +
    "        <td>{{ booking.adults + (booking.children || 0) }}</td>\n" +
    "        <td>\n" +
    "          {{ booking.pricing.package_cost / (booking.adults + (booking.children || 0)) | currency }}\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          {{ booking.pricing.package_cost | currency }}\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          {{ booking.pricing.package_cost | currency }}\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "      <tr ng-repeat=\"item in booking.pricing.items\"\n" +
    "        ng-init=\"booking.running['b' + $index] = item.running\"\n" +
    "        ng-if=\"!booking.hotel || (booking.hotel && item.product.name !== 'Hotel Pickup')\">\n" +
    "        <td>{{ item.product.name }}</td>\n" +
    "        <td>{{ item.count }}</td>\n" +
    "        <td>{{ item.value - (item.discount / item.count || 0) | currency }}</td>\n" +
    "        <td>{{ item.total | currency }}</td>\n" +
    "        <td>{{ item.running | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-if=\"discount.total\" ng-init=\"booking.running['c0'] = lastObject(booking.running) + discount.total\">\n" +
    "        <td>{{ discount.name }}</td>\n" +
    "        <td>1</td>\n" +
    "        <td>{{ discount.value }}</td>\n" +
    "        <td>{{ discount.total | currency }}</td>\n" +
    "        <td>{{ booking.running['c0'] | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-if=\"booking.pricing.other_payments.cash.length > 0\" ng-init=\"booking.running['d0'] = lastObject(booking.running) - booking.pricing.Cash()\">\n" +
    "        <td>Cash</td>\n" +
    "        <td>{{ booking.pricing.other_payments.cash.length }}</td>\n" +
    "        <td>{{ -booking.pricing.Cash() | currency }}</td>\n" +
    "        <td>{{ -booking.pricing.Cash() | currency }}</td>\n" +
    "        <td>{{ booking.running['d0'] | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-repeat=\"(key, gift) in booking.pricing.other_payments.gifts\" ng-init=\"booking.running['e' + $index] = lastObject(booking.running) - gift.amount\">\n" +
    "        <td>Gift: {{ gift.code }}</td>\n" +
    "        <td>1</td>\n" +
    "        <td>{{ -gift.amount | currency }}</td>\n" +
    "        <td>{{ -gift.amount | currency }}</td>\n" +
    "        <td>{{ booking.running['e' + $index] | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-if=\"charges.length > 0\" ng-repeat=\"(key, charge) in booking.pricing.charges\" ng-init=\"booking.running['f' + $index] = lastObject(booking.running) - charge.balance\">\n" +
    "        <td>{{ charge.card.type }}: {{ charge.card.masked }}</td>\n" +
    "        <td>1</td>\n" +
    "        <td>{{ -charge.balance | currency }}</td>\n" +
    "        <td>{{ -charge.balance | currency }}</td>\n" +
    "        <td>{{ booking.running['f' + $index] | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-if=\"booking.pricing.other_payments.other.length > 0\"\n" +
    "         ng-repeat=\"(key, charge) in booking.pricing.other_payments.other\"\n" +
    "         ng-init=\"booking.running['g' + $index] = lastObject(booking.running) - charge.amount\">\n" +
    "        <td>{{ charge.type }}</td>\n" +
    "        <td>1</td>\n" +
    "        <td>{{ -charge.amount | currency }}</td>\n" +
    "        <td>{{ -charge.amount | currency }}</td>\n" +
    "        <td>{{ booking.running['g' + $index] | currency }}</td>\n" +
    "      </tr>\n" +
    "      <tr ng-repeat=\"(key, value) in blanks(rows, 4)\">\n" +
    "        <td>&nbsp;</td>\n" +
    "        <td></td>\n" +
    "        <td></td>\n" +
    "        <td></td>\n" +
    "        <td></td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "    <tfoot>\n" +
    "      <tr>\n" +
    "        <td colspan=\"4\">\n" +
    "          <strong class=\"pull-left\" ng-if=\"booking.pricing.cards.length == 0\">No Card</strong>\n" +
    "          <span class=\"pull-left\" ng-if=\"booking.pricing.cards.length > 0\" ng-init=\"card = booking.pricing.cards[0]\">\n" +
    "            <strong ng-if=\"card.status != 'invalid'\">{{ card.type }} - {{ card.masked }}</strong>\n" +
    "            <strong ng-if=\"card.status == 'invalid'\">Invalid Card</strong>\n" +
    "          </span>\n" +
    "          <strong class=\"pull-right\">Total:</strong>\n" +
    "        </td>\n" +
    "        <td></td>\n" +
    "      </tr>\n" +
    "    </tfoot>\n" +
    "  </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/reports/tips", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/reports/tips",
    "<div class=\"row\">\n" +
    "  {{ dayCount = objectKeys(days).length;\"\" }}\n" +
    "\n" +
    "  <div ng-class=\"{ 'col-md-9' : dayCount > 1 && dayCount <= 7, 'col-md-6': dayCount === 1 || dayCount > 7 }\" id=\"tipsReport\" sales-report=\"data\" start=\"start\" end=\"end\">\n" +
    "    <table class=\"table\">\n" +
    "      <thead>\n" +
    "        <tr>\n" +
    "          <th>Pilot</th>\n" +
    "          <th ng-repeat=\"(day, details) in days\">\n" +
    "            <a ng-href=\"/reports/sales/{{ day | readTime:'MM-DD-YY' }}\" class=\"\">{{ day | date:'MM/dd/yy' }}</a>\n" +
    "          </th>\n" +
    "          <th class=\"text-right\">Pilot Total</th>\n" +
    "        </tr>\n" +
    "      </thead>\n" +
    "      <tbody>\n" +
    "\n" +
    "        <tr ng-repeat=\"(name, amount) in compiled.tips.pilots\">\n" +
    "          <td>{{ name }}</td>\n" +
    "          <td ng-repeat=\"(day, details) in days\">\n" +
    "            <span ng-class=\"{ 'text-danger': compiled.tips.pilots[name][day] < 0 }\">\n" +
    "              {{ compiled.tips.pilots[name][(day | readTime: 'MM-DD-YY')] || 0 | currency }}</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': tips.pilots[name] < 0 }\">{{ compiled.tips.pilots[name].total | currency }}</span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "      </tbody>\n" +
    "      <tfoot>\n" +
    "\n" +
    "        <tr>\n" +
    "          <td><strong>Totals by Day</strong></td>\n" +
    "          <td ng-repeat=\"(day, details) in days\">\n" +
    "            <span ng-class=\"{ 'text-danger': compiled.tips.days[(day | readTime: 'MM-DD-YY')] < 0 }\">{{ compiled.tips.days[(day | readTime: 'MM-DD-YY')] || 0 | currency }}</span>\n" +
    "          </td>\n" +
    "          <td class=\"text-right\">\n" +
    "            <span ng-class=\"{ 'text-danger': compiled.credits.tips < 0 }\">{{ compiled.credits.tips | currency }}</span>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "\n" +
    "      </tfoot>\n" +
    "\n" +
    "    </table>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/search", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/search",
    "<header class=\"clearfix\" style=\"margin-bottom: 20px;\">\n" +
    "  <h2 class=\"noselect\" style=\"margin-bottom: 2px;\">Search Results <small>{{ bookings.count }} found</small></h2>\n" +
    "  <span ng-show=\"bookings.count > 100\" class=\"text-muted\">Showing 100 items per page</span>\n" +
    "</header>\n" +
    "\n" +
    "<section class=\"pos-rlt\">\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "    <button type=\"button\" ng-disabled=\"state.page == 1\" ui-sref=\"search({ page: 1 * state.page - 1 })\" class=\"col-md-3 btn bg-light lt\">Previous</button>\n" +
    "    <button type=\"button\" ng-disabled=\"bookings.count - ( 1 * state.page * 100 ) < 100\" ui-sref=\"search({ page: 1 * state.page + 1 })\" class=\"col-md-3 btn bg-light lt pull-right\">Next</button>\n" +
    "  </div>\n" +
    "\n" +
    "  <hr class=\"invisible\" />\n" +
    "\n" +
    "  <table class=\"reservations table table-hover table-condensed\">\n" +
    "    <thead>\n" +
    "      <tr>\n" +
    "        <th>#</th>\n" +
    "        <th class=\"text-center\" style=\"width: 120px;\">Booked For</th>\n" +
    "        <th>Contact</th>\n" +
    "        <th style=\"text-align: center;\">Guests</th>\n" +
    "        <th>Package</th>\n" +
    "        <th>Hotel</th>\n" +
    "        <th style=\"max-width: 100px; text-align: center;\">Pickup</th>\n" +
    "        <th>Phone Number</th>\n" +
    "        <th style=\"width: 125px;\"></th>\n" +
    "      </tr>\n" +
    "    </thead>\n" +
    "    <tbody>\n" +
    "      <tr ng-repeat=\"booking in bookings\" class=\"animated slideInRight\" ng-class=\"{ 'warning' : booking.legacy }\">\n" +
    "        <td ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">\n" +
    "          <div ng-if=\"booking.status == 'active'\">\n" +
    "            <span class=\"label label-success\" ng-if=\"!booking.legacy\">{{ user.activeCompany().nickname }}{{ booking.confirmation }}</span>\n" +
    "            <span class=\"label label-success\" ng-if=\"booking.legacy\">{{ booking.legacy }}</span>\n" +
    "          </div>\n" +
    "          <span class=\"label label-warning\" ng-if=\"booking.status == 'pending'\">Pending</span>\n" +
    "          <span class=\"label label-danger\" ng-if=\"booking.status == 'cancelled'\">{{ user.activeCompany().nickname }}{{ booking.confirmation }}</span>\n" +
    "        </td>\n" +
    "        <td class=\"text-center\">\n" +
    "          {{ booking.event.date | readTime:'MM/DD/YYYY':true }}\n" +
    "        </td>\n" +
    "        <td ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">\n" +
    "          <a ng-if=\"!booking.group\" class=\"btn btn-link\">{{ booking.last_name }}, {{ booking.first_name }}</a>\n" +
    "          <a ng-if=\"booking.group\" class=\"btn btn-link\">{{ booking.group_name }}</a>\n" +
    "          <div class=\"pull-right\" style=\"margin: 6px 0\">\n" +
    "            <span class=\"label lter bg-success label-sm\" ng-show=\"booking.vip\">VIP</span>\n" +
    "            <span class=\"label lter bg-info label-sm\" ng-show=\"booking.group\">Group</span>\n" +
    "            <span class=\"label lter bg-warning label-sm\" ng-show=\"booking.hotel\">Hotel</span>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "        <td style=\"text-align: center;\" ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">{{ booking.adults + booking.children }}</td>\n" +
    "        <td ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">{{ booking.package.name }}</td>\n" +
    "        <td ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">\n" +
    "          <span ng-if=\"booking.accommodations.hotel.name !== 'Other'\" style=\"max-width: 145px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;\">{{ booking.accommodations.hotel.name }}</span>\n" +
    "          <em ng-if=\"booking.accommodations.hotel.name === 'Other'\">{{ booking.accommodations.other }}</em>\n" +
    "        </td>\n" +
    "        <td style=\"text-align: center;\" ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\">\n" +
    "          <a ng-if=\"booking.needs_pickup\" href=\"\">{{ booking.pickup.time | readTime: 'h:mm a' }}</a>\n" +
    "          <a ng-if=\"!booking.needs_pickup\" href=\"\">-</a>\n" +
    "        </td>\n" +
    "        <td ui-sref=\"editBooking({ confirmation: 'NV' + booking.confirmation })\" class=\"point\"><span tooltip=\"Working on format\">{{ booking.phone }}</span></td>\n" +
    "        <td>\n" +
    "          <div class=\"pull-right\">\n" +
    "\n" +
    "            <button type=\"button\" ng-if=\"booking.status == 'pending'\" class=\"rebook btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Approve\" ng-click=\"activate(booking)\">\n" +
    "              <i class=\"fa fa-check\"></i>\n" +
    "            </button>\n" +
    "\n" +
    "            <button type=\"button\" ng-if=\"booking.status !== 'pending'\" class=\"rebook btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Rebook for another day\">\n" +
    "              <i class=\"fa fa-share\"></i>\n" +
    "            </button>\n" +
    "\n" +
    "            <button type=\"button\" class=\"cancel btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Cancel this Booking\" ng-click=\"cancel(booking)\">\n" +
    "              <i class=\"fa fa-times\"></i>\n" +
    "            </button>\n" +
    "\n" +
    "            <button type=\"button\" ng-if=\"booking.status !== 'pending'\" class=\"instructions btn btn-link lt\" style=\"\" \n" +
    "              ng-disabled=\"!buildTip(booking)\" \n" +
    "              ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" \n" +
    "              data-tooltip-html-unsafe=\"{{ buildTip(booking) }}\"\n" +
    "              tooltip-trigger=\"mouseenter\"\n" +
    "              tooltip-placement=\"left\" \n" +
    "              tooltip-append-to-body=\"false\">\n" +
    "              <i class=\"fa fa-info\"></i>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </tbody>\n" +
    "  </table>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "    <button type=\"button\" ng-disabled=\"state.page == 1\" ui-sref=\"search({ page: 1 * state.page - 1 })\" class=\"col-md-3 btn bg-light lt\">Previous</button>\n" +
    "    <button type=\"button\" ng-disabled=\"bookings.count - ( 1 * state.page * 100 ) < 100\" ui-sref=\"search({ page: 1 * state.page + 1 })\" class=\"col-md-3 btn bg-light lt pull-right\">Next</button>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("views/settings/admin", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/admin",
    "<header class=\"clearfix\" style=\"margin: 10px 0 20px;\">\n" +
    "\n" +
    "  <h2 class=\"pull-left\" style=\"margin: 0\" ng-init=\"showID = false\">\n" +
    "    <span>Settings:</span> <small ng-click=\"showID = !showID\">\n" +
    "      <span ng-if=\"!showID\">{{ company.name }}</span>\n" +
    "      <span ng-if=\"showID\">{{ company._id }}</span>\n" +
    "    </small>\n" +
    "  </h2>\n" +
    "\n" +
    "</header>\n" +
    "\n" +
    "<section class=\"row\" id=\"Admin\">\n" +
    "\n" +
    "  <div class=\"tabbable col-md-10\">\n" +
    "    <ul class=\"nav nav-tabs\" style=\"margin-bottom: 20px;\">\n" +
    "      <li ng-if=\"user.can('company', 'Admin')\" ng-class=\"{'active' : !tab || tab === 'company'}\" ng-click=\"setTab('company')\">\n" +
    "        <a href=\"\">Company</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('company', 'Admin')\" ng-class=\"{'active' : tab === 'merchant'}\" ng-click=\"setTab('merchant')\">\n" +
    "        <a href=\"\">Merchant</a>\n" +
    "      </li>\n" +
    "      <li ng-class=\"{ 'active': tab === 'bundles'}\" ng-click=\"setTab('bundles')\">\n" +
    "        <a href=\"\">Bundles</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('balloons', 'Admin') && company.admin.resources.enabled\" ng-class=\"{'active' : tab === 'balloons'}\" ng-click=\"setTab('balloons')\">\n" +
    "        <a href=\"\">{{ company.admin.resources.name }}</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('packages', 'Admin') && company.admin.packages.enabled\" ng-class=\"{'active' : tab === 'packages'}\" ng-click=\"setTab('packages')\">\n" +
    "        <a href=\"\">{{ company.admin.packages.name }}</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('products', 'Admin') && company.admin.products.enabled\" ng-class=\"{'active' : tab === 'products'}\" ng-click=\"setTab('products')\">\n" +
    "        <a href=\"\">{{ company.admin.products.name }}</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('zones', 'Admin') && company.admin.zones.enabled\"\" ng-class=\"{'active' : tab === 'zones'}\" ng-click=\"setTab('zones')\">\n" +
    "        <a href=\"\">{{ company.admin.zones.name }}</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('cancellations', 'Admin') && company.admin.cancellations.enabled\" ng-class=\"{'active' : tab === 'cancellations'}\" ng-click=\"setTab('cancellations')\">\n" +
    "        <a href=\"\">{{ company.admin.cancellations.name }}</a>\n" +
    "      </li>\n" +
    "      <li ng-if=\"user.can('company', 'Admin')\" ng-class=\"{'active' : tab === 'emails'}\" ng-click=\"setTab('emails')\">\n" +
    "        <a href=\"\">Emails</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <div id=\"adminBody\">\n" +
    "  \n" +
    "      <div ng-if=\"user.can('company', 'Admin') && !tab || tab === 'company'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/company'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('company', 'Admin') && tab === 'merchant'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/merchant'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('balloons', 'Admin') && company.admin.resources.enabled && tab === 'balloons'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/resources'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"tab === 'bundles'\">\n" +
    "        <bundle-list></bundle-list>\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-if=\"user.can('packages', 'Admin') && company.admin.packages.enabled && tab === 'packages'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/packages'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('products', 'Admin') && company.admin.products.enabled && tab === 'products'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/products'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('zones', 'Admin') && company.admin.zones.enabled && tab === 'zones'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/zones'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('cancellations', 'Admin') && company.admin.cancellations.enabled && tab === 'cancellations'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/cancellations'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "      <div ng-if=\"user.can('company', 'Admin') && tab === 'emails'\">\n" +
    "        <div ng-include=\"'views/settings/tabs/emailTemplates'\"></div>\n" +
    "      </div>\n" +
    "  \n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</section>\n" +
    "");
}]);

angular.module("views/settings/dash", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/dash",
    "<div class=\"col-md-12\">\n" +
    "\n" +
    "  <div class=\"pilots\" ng-if=\"user.type.pilot\">\n" +
    "\n" +
    "    <header class=\"clearfix\" style=\"margin: 10px 0 20px;\">\n" +
    "      <h2 class=\"pull-left\" style=\"margin: 0\">\n" +
    "      <span>Dashboard</span>\n" +
    "      </h2>\n" +
    "    </header>\n" +
    "\n" +
    "    <label class=\"checkbox point\" ng-init=\"onlyPhotos = false\" style=\"float:  right; position: absolute; right: 0; top: 0;\">\n" +
    "      <i class=\"fa\" ng-class=\"{ 'fa-toggle-off': !onlyPhotos, 'fa-toggle-on text-success': onlyPhotos } \"></i> Only Show Flights With Photos\n" +
    "      <input type=\"checkbox\" class=\"hide\" ng-model=\"onlyPhotos\" />\n" +
    "    </label>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-12\">\n" +
    "\n" +
    "        \n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-12\">\n" +
    "        <table class=\"table\">\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "              <th>Flight Date</th>\n" +
    "              <th>Status</th>\n" +
    "              <th class=\"text-center\">Guests</th>\n" +
    "              <th>Balloon</th>\n" +
    "              <th>Launch</th>\n" +
    "              <th style=\"width: 50px\" class=\"text-center\">Photos</th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr>\n" +
    "              <td colspan=\"6\">\n" +
    "                <nav>\n" +
    "                  {{ Page = pagination(flights.pagination); ''}}\n" +
    "                  <ul class=\"pagination\" style=\"margin: 5px 0;\">\n" +
    "                    <li ng-class=\"{ 'disabled' : flights.pagination.current === 1 }\">\n" +
    "                      <a ng-if=\"flights.pagination.current !== 1\" \n" +
    "                        href=\"#\" ng-click=\"flightPage(flights.pagination.current - 1)\" \n" +
    "                        aria-label=\"Previous\">&laquo;</a>\n" +
    "                      <span class=\"text-muted\" ng-if=\"flights.pagination.current === 1\">&laquo;</span>\n" +
    "                    </li>\n" +
    "                    <li class=\"pull-left\">\n" +
    "                      <div>\n" +
    "                        <input\n" +
    "                          style=\"max-width: 142px; border: 1px solid #ddd !important; border-left: 0px !important\"\n" +
    "                          date-range-picker\n" +
    "                          class=\"form-control date-picker plain\"\n" +
    "                          type=\"text\"\n" +
    "                          ng-model=\"calendar.date\"\n" +
    "                          placeholder=\"Filter by Date\"\n" +
    "                          options=\"calendar.options\" />\n" +
    "                      </div>\n" +
    "                    </li>\n" +
    "                    <li ng-repeat=\"page in Page.pages\" \n" +
    "                      ng-class=\"{ 'active' : Page.current === page }\">\n" +
    "                      <a ng-click=\"flightPage(page)\" href=\"#\">{{ page }}</a>\n" +
    "                    </li>\n" +
    "                    <li class=\"disabled\">\n" +
    "                      <a href=\"#\">\n" +
    "                        {{ pageCount = perPage * flights.pagination.current;'' }}\n" +
    "                        {{ pageCount <= flights.pagination.count ? pageCount : flights.pagination.count }} of {{ flights.pagination.count }}</a>\n" +
    "                    </li>\n" +
    "                    <li ng-class=\"{ 'disabled' : flights.pagination.current === flights.pagination.pages.length }\">\n" +
    "                      <a ng-if=\"flights.pagination.current !== flights.pagination.pages.length\" \n" +
    "                        href=\"#\" \n" +
    "                        ng-click=\"flightPage(flights.pagination.current + 1)\" \n" +
    "                        aria-label=\"Next\">&raquo;</a>\n" +
    "                      <span ng-if=\"flights.pagination.current === flights.pagination.pages.length\">&raquo;</span>\n" +
    "                    </li>\n" +
    "                  </ul>\n" +
    "                </nav>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat=\"flight in flights.flights | orderBy:'-event.date'\" ui-sref=\"flight({ id: flight._id })\" ng-if=\"!onlyPhotos || (onlyPhotos && someoneHasPhotos(flight))\">\n" +
    "              <td class=\"point\">{{ flight.event.date | readTime:'MM-DD-YY':true }}</td>\n" +
    "              <td class=\"point\">--</td>\n" +
    "              <td class=\"point text-center\">{{ totalGuests(flight) || 0 }}</td>\n" +
    "              <td class=\"point\">{{ flight.balloon.name }}</td>\n" +
    "              <td class=\"point\">{{ flight.launch }}</td>\n" +
    "              <td class=\"text-success point text-center\"><i class=\"fa fa-check\" ng-if=\"someoneHasPhotos(flight)\"></i></td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <hr>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\" ng-controller=\"bugsController\">\n" +
    "  <div class=\"col-md-12\">\n" +
    "    <h3>Bug Handling <button type=\"button\" class=\"btn btn-success\" ng-click=\"openBugModal()\"><i class=\"fa fa-plus\"></i> Report</button></h3>\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"alert alert-block alert-info col-md-6\">\n" +
    "      <strong>NOTICE:</strong>\n" +
    "      <p>In this area you can report any issue you have to ensure they find their way into the queue, however them being added here doesn't guarantee that they'll be addressed immediately.</p>\n" +
    "      <p>To help ensure that critical annoyances are addressed as swiftly as possible we've added in a <strong>voting</strong> feature. The more votes a bug or change has the higher it is in the queue, and therefore the sooner it will be address.</p>\n" +
    "      <p><strong class=\"text-danger\">All bugs need to be verified!</strong> This means that bugs will also have a <em>seconded</em> feature. If a bug hasn't been <em>seconded</em> then it will remain in pending, so please make sure your description of the bug is clear enough for someone else to duplicate and <strong>second</strong> it.</p>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-6\">\n" +
    "      <h3>Completed Bugs</h3>\n" +
    "      <ul>\n" +
    "      <li><em>Stay tuned ...</em></li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"col-md-6\">\n" +
    "    <h3>Verified</h3>\n" +
    "    <ul>\n" +
    "      <li ng-repeat=\"bug in verified()\">\n" +
    "      <span class=\"actions\">\n" +
    "        <a href=\"\" ng-disabled=\"alreadyVoted(bug) || bug.user._id === user._id\" class=\"btn btn-link btn-xs\" ng-click=\"vote(bug)\">\n" +
    "        <i class=\"fa fa-edit\" ng-show=\"bug.user._id === user._id\"></i>\n" +
    "        <i class=\"fa fa-thumbs-up\" ng-show=\"bug.user._id !== user._id\" ng-class=\"{ 'text-success' : alreadyVoted(bug), 'text-muted' : !alreadyVoted(bug) }\"></i></a>\n" +
    "      </span>\n" +
    "      <button class=\"btn btn-link btn-sm\" ng-click=\"openBugModal(bug)\">\n" +
    "        [\n" +
    "        <span class=\"text-info\">{{bug.user.name}}</span> /\n" +
    "        <span ng-repeat=\"user in bug.seconded\">\n" +
    "        <span class=\"text-success\">{{ user.name }}</span>\n" +
    "        <span ng-show=\"!$last\"> / </span>\n" +
    "        </span>\n" +
    "       ] {{ bug.description }}\n" +
    "      </button>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-6\">\n" +
    "    <h3>Pending <small class=\"extra\" style=\"font-size: 0.7em\">Help out, follow the description to duplicate and verify.</small></h3>\n" +
    "    <ul>\n" +
    "      <li ng-repeat=\"bug in pending()\">\n" +
    "      <span class=\"actions\">\n" +
    "        <a href=\"\" class=\"btn btn-link btn-xs\" ng-click=\"second(bug)\" ng-disabled=\"bug.user._id === user._id\"><i class=\"fa fa-thumb-tack\"></i></a>\n" +
    "      </span>\n" +
    "      <button class=\"btn btn-link btn-sm\" ng-click=\"openBugModal(bug)\">\n" +
    "        <span>\n" +
    "        [ <span class=\"text-info\">{{bug.user.name}}</span> ] {{ bug.description }}\n" +
    "        </span>\n" +
    "      </button>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("views/settings/forms/balloons", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/forms/balloons",
    "<header class=\"clearfix\">\n" +
    "  <h2 class=\"\">\n" +
    "    <span ng-if=\"balloon._id\">\n" +
    "      Editing Balloon:\n" +
    "      <small>{{ balloon.name }}</small>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-if=\"!balloon._id\">\n" +
    "      New Balloon\n" +
    "    </span>\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "      <button ng-if=\"!balloon._id\" class=\"btn bg-success btn-block\" ng-click=\"saveBalloon(balloon)\">\n" +
    "        Save Balloon\n" +
    "      </button>\n" +
    "      <button ng-if=\"balloon._id\" class=\"btn bg-success btn-block\" ng-click=\"updateBalloon(balloon)\">\n" +
    "        Save Changes\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </h2>\n" +
    "</header>\n" +
    "\n" +
    "<hr class=\"invisible\">\n" +
    "\n" +
    "<form action=\"\" name=\"BalloonForm\">\n" +
    "    \n" +
    "  <fieldset class=\"col-md-4 no-pad-lft\">\n" +
    "    \n" +
    "    <div class=\"form-group col-md-8 no-pad\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-4 no-pad-rt\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.initials\" placeholder=\"Initials\" type=\"text\" />\n" +
    "    </div>\n" +
    "      \n" +
    "\n" +
    "    <div class=\"clearfix\">\n" +
    "      <div class=\"form-group col-md-12 no-pad\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"balloon.make\" placeholder=\"Make\" type=\"text\" required />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  \n" +
    "    <div class=\"row\">\n" +
    "      \n" +
    "      <div class=\"form-group col-md-6\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"balloon.model\" placeholder=\"Model\" type=\"text\" required />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-6 no-pad-lft\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"balloon.code\" placeholder=\"Balloon ID\" type=\"text\" required />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  \n" +
    "    <div class=\"col-md-12 no-pad\">\n" +
    "      <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"balloon.heavy\" /> Accommodates heavy passengers\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-4 no-pad-lft\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.minimum\" placeholder=\"Minimum Capacity\" type=\"number\" required />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-4 no-pad\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.capacity\" placeholder=\"Maximum Capacity\" type=\"number\" required />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-4 no-pad-rt\">\n" +
    "\n" +
    "      <select id=\"balloonSize\" class=\"input-lg\" ui-select2=\"{ width: '100%' }\" \n" +
    "        ng-model=\"balloon.size\" data-placeholder=\"Select Balloon Size\" required>\n" +
    "        <option value=\"\">Size</option>\n" +
    "        <option value=\"AX7\">AX7</option>\n" +
    "        <option value=\"AX8\">AX8</option>\n" +
    "        <option value=\"AX9\">AX9</option>\n" +
    "        <option value=\"AX10\">AX10</option>\n" +
    "        <option value=\"AX11\">AX11</option>\n" +
    "        <option value=\"AX12\">AX12</option>\n" +
    "      </select>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "  <fieldset class=\"col-md-4\">\n" +
    "\n" +
    "    <div class=\"form-group col-md-12 no-pad\">\n" +
    "\n" +
    "      <select id=\"balloonPilot\" class=\"input-lg\" ui-select2=\"{ width: '100%' }\" \n" +
    "        ng-model=\"balloon.pilot\" data-placeholder=\"Default Pilot\">\n" +
    "        <option value=\"\"></option>\n" +
    "        <option \n" +
    "          ng-repeat=\"pilot in pilots\" \n" +
    "          value=\"{{ pilot._id }}\" \n" +
    "          ng-selected=\"{{ balloon.pilot == pilot._id }}\">{{ pilot.name }}</option>\n" +
    "      </select>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6 no-pad\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.crew.drivers\" placeholder=\"Minimum Capacity\" type=\"number\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6 no-pad-rt\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"balloon.crew.chasers\" placeholder=\"Maximum Capacity\" type=\"number\" />\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "</form>");
}]);

angular.module("views/settings/forms/packages", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/forms/packages",
    "<header class=\"clearfix\">\n" +
    "  <h2 class=\"\">\n" +
    "    <span ng-if=\"package._id\">\n" +
    "      Editing Package:\n" +
    "      <small>{{ package.name }}</small>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-if=\"!package._id\">\n" +
    "      New Package\n" +
    "    </span>\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "      <a ui-sref=\"admin({ tab: 'packages' })\" class=\"btn btn-danger\">\n" +
    "        Close\n" +
    "      </a>\n" +
    "      <button ng-if=\"!package._id\" class=\"btn bg-success\" ng-click=\"savePackage(package)\">\n" +
    "        Save Package\n" +
    "      </button>\n" +
    "      <button ng-if=\"package._id\" class=\"btn bg-success\" ng-click=\"updatePackage(package)\">\n" +
    "        Save Changes\n" +
    "        <span ng-if=\"saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "          lines: 17,\n" +
    "          length: 0,\n" +
    "          width: 4,\n" +
    "          radius: 4,\n" +
    "          corners: 1,\n" +
    "          rotate: 0,\n" +
    "          direction: 1,\n" +
    "          color: '#fff',\n" +
    "          speed: 1.2,\n" +
    "          trail: 36,\n" +
    "          shadow: false,\n" +
    "          hwaccel: false,\n" +
    "          className: 'spinner',\n" +
    "          zIndex: 2e9,\n" +
    "          top: '-5px',\n" +
    "          left: 'auto'\n" +
    "        }\"></span>\n" +
    "\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </h2>\n" +
    "</header>\n" +
    "\n" +
    "<hr class=\"invisible\">\n" +
    "\n" +
    "<form action=\"\" name=\"PackageForm\">\n" +
    "\n" +
    "  <fieldset class=\"col-md-4 no-pad-lft\">\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-3 no-pad\">\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.active\" /> Active\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-3 no-pad\">\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.public\" /> Public Package\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.require_approval\" ng-disabled=\"!package.public\"/> Require Approval\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-3 no-pad\">\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.adults\" /> Adult Only Package\n" +
    "          </label>\n" +
    "        </div>\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.free_pickup\" /> Free Pickup\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-3 no-pad\">\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"package.require_weights\" /> Weights Required\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"form-group col-md-12 no-pad\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"package.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <h5 class=\"col-md-12 no-pad\">Standard Pricing</h5>\n" +
    "      <div class=\"form-group col-md-6 no-pad-lft\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"package.price.adult\" placeholder=\"Adult Price\" type=\"number\" ng-required=\"package.price.perperson\"\n" +
    "        />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group col-md-6 no-pad\">\n" +
    "        <input class=\"form-control input-lg\" ng-model=\"package.price.child\" placeholder=\"Child Price\" type=\"number\" ng-disabled=\"package.adults\"\n" +
    "          ng-required=\"package.price.perperson && !package.adults\" />\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <h5 class=\"col-md-12 no-pad\">VIP Pricing</h5>\n" +
    "      <div class=\"row\" ng-repeat=\"(i, vip) in package.vipPricing | orderBy: 'max'\">\n" +
    "        <div class=\"col-md-4\">\n" +
    "          <input type=\"number\" class=\"form-control input-xs\" ng-model=\"vip.min\" />\n" +
    "        </div>\n" +
    "        <div class=\"col-md-4\">\n" +
    "          <input type=\"number\" class=\"form-control input-xs\" ng-model=\"vip.max\" />\n" +
    "        </div>\n" +
    "        <div class=\"col-md-4\">\n" +
    "          <div class=\"input-group\">\n" +
    "            <input type=\"number\" class=\"form-control input-xs\" ng-model=\"vip.price\" />\n" +
    "            <div class=\"input-group-btn\">\n" +
    "              <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn bg-light btn-icon\"\n" +
    "                ng-click=\"removeVip(vip)\">\n" +
    "                <i class=\"fa fa-minus\"></i>\n" +
    "              </button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <ng-form name=\"vipForm\">\n" +
    "          <hr>\n" +
    "          <div class=\"col-md-4\"><input class=\"form-control input-xs\" ng-model=\"vipPrice.min\" placeholder=\"from\" type=\"number\" ng-min=\"(lastVip().max || 0) + 1\" /></div>\n" +
    "          <div class=\"col-md-4\"><input class=\"form-control input-xs\" ng-model=\"vipPrice.max\" placeholder=\"to\" type=\"number\" ng-min=\"(vipPrice.min || 0) + 1\"/></div>\n" +
    "          <div class=\"col-md-4\">\n" +
    "            <div class=\"input-group\">\n" +
    "              <input class=\"form-control\" ng-model=\"vipPrice.price\" placeholder=\"0.00\" type=\"number\" />\n" +
    "              <div class=\"input-group-btn\">\n" +
    "                <button\n" +
    "                  type=\"button\"\n" +
    "                  class=\"btn bg-light btn-icon\"\n" +
    "                  ng-disabled=\"vipForm.$invalid\"\n" +
    "                  ng-click=\"vipPrice.add()\">\n" +
    "                  <i class=\"fa fa-plus\"></i>\n" +
    "                </button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </ng-form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    \n" +
    "    <div class=\"row ngFadeIn\" ng-show=\"package.public\">\n" +
    "      <hr class=\"clearfix\" /> \n" +
    "      {{ adults = package.adults ? 'data-children=\"0\" data-locked=\"children\" class' : 'class';'' }}\n" +
    "      \n" +
    "      <flight-package package=\"package\"></flight-package>\n" +
    "\n" +
    "      <hr>\n" +
    "\n" +
    "      <h4 class=\"clearfix\">Required Script <small>Add before the closing body tag</small>\n" +
    "        <button type=\"button\" class=\"btn btn-xs bg-light pull-right\" copy=\"#WidgetScript\">\n" +
    "          <i class=\"fa fa-clipboard ngFadeIn\" ng-show=\"!success\"></i>\n" +
    "          <i class=\"fa fa-check ngFadeIn\" ng-show=\"success\"></i>\n" +
    "        </button>\n" +
    "      </h4>\n" +
    "      <pre><code decode=\"true\" id=\"WidgetScript\" class=\"html\">\n" +
    "         &lt;script src=\"//{{ location.host }}/widget.js\"&gt;&lt;/script&gt;\n" +
    "      </code></pre>\n" +
    "\n" +
    "      <h4 class=\"clearfix\">Popup Form\n" +
    "        <button type=\"button\" class=\"btn btn-xs bg-light pull-right\" copy=\"#PopupWidget\">\n" +
    "          <i class=\"fa fa-clipboard ngFadeIn\" ng-show=\"!success\"></i>\n" +
    "          <i class=\"fa fa-check ngFadeIn\" ng-show=\"success\"></i>\n" +
    "        </button>\n" +
    "      </h4>\n" +
    "      <pre><code id=\"PopupWidget\" class=\"html\">\n" +
    "        <rezflow-popup package=\"{{package._id}}\" header=\"Book a {{ package.name }} Flight\" {{adults}}>\n" +
    "          <button type=\"button\">Book Now</button>\n" +
    "        </rezflow-popup>\n" +
    "      </code></pre>\n" +
    "\n" +
    "      <h4>Inline Form\n" +
    "        <button type=\"button\" class=\"btn btn-xs bg-light pull-right\" copy=\"#InlineWidget\">\n" +
    "          <i class=\"fa fa-clipboard ngFadeIn\" ng-show=\"!success\"></i>\n" +
    "          <i class=\"fa fa-check ngFadeIn\" ng-show=\"success\"></i>\n" +
    "        </button> \n" +
    "      </h4>\n" +
    "      <pre><code id=\"InlineWidget\">\n" +
    "        <rezflow-inline package=\"{{package._id}}\"{{adults}}></rezflow-inline>\n" +
    "      </code></pre>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "  <fieldset class=\"col-md-7 no-pad-rt\" ng-init=\"activeTemplate = 'general'\">\n" +
    "\n" +
    "    <div class=\"btn-group\">\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'general'\" uncheckable>General</label>\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'pickup'\" uncheckable>Pickup</label>\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'vip'\" uncheckable>VIP</label>\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'pickup_vip'\" uncheckable>VIP with Pickup</label>\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'group'\" uncheckable>Group</label>\n" +
    "      <label class=\"btn btn-info\" ng-model=\"activeTemplate\" btn-radio=\"'pickup_group'\" uncheckable>Group with Pickup</label>\n" +
    "    </div>\n" +
    "\n" +
    "    <hr class=\"invisible\" style=\"margin-bottom: 0\" />\n" +
    "\n" +
    "    <div ng-show=\"activeTemplate == 'general'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.general\"></div>\n" +
    "\n" +
    "    <div ng-show=\"activeTemplate == 'pickup'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.pickup\"></div>\n" +
    "\n" +
    "    <div ng-show=\"activeTemplate == 'vip'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.vip\"></div>\n" +
    "\n" +
    "    <div ng-show=\"activeTemplate == 'pickup_vip'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.pickup_vip\"></div>\n" +
    "    <div ng-show=\"activeTemplate == 'group'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.group\"></div>\n" +
    "    <div ng-show=\"activeTemplate == 'pickup_group'\" style=\"padding: 10px;\" class=\"panel\" hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" ng-model=\"package.templates.pickup_group\"></div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/settings/forms/product", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/forms/product",
    "<header class=\"clearfix\">\n" +
    "  <h2 class=\"\">\n" +
    "    <span ng-if=\"product._id\">\n" +
    "      Editing Product:\n" +
    "      <small>{{ product.name }}</small>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-if=\"!product._id\">\n" +
    "      New Product\n" +
    "    </span>\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "      <button ng-if=\"!product._id\" class=\"btn bg-success btn-block\" ng-click=\"saveProduct(product)\">\n" +
    "        Save Product\n" +
    "      </button>\n" +
    "      <button ng-if=\"product._id\" class=\"btn bg-success btn-block\" ng-click=\"updateProduct(product)\">\n" +
    "        Save Changes\n" +
    "        <span ng-if=\"saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"spinnerConf\"></span>\n" +
    "\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </h2>\n" +
    "</header>\n" +
    "\n" +
    "<hr class=\"invisible\">\n" +
    "\n" +
    "<form action=\"\" name=\"ProductForm\">\n" +
    "\n" +
    "  <fieldset class=\"col-md-4 no-pad-lft\">\n" +
    "\n" +
    "    <div class=\"col-md-3 no-pad\">\n" +
    "      <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"product.independent\" /> Independent\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-2 no-pad\">\n" +
    "      <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"product.public\" /> Public\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-3 no-pad\">\n" +
    "      <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"product.taxable\" /> Taxable\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-4 no-pad\">\n" +
    "      <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"product.reportable\" /> On \"At a Glance\"\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-12 no-pad\" style=\"overflow: auto;\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"product.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-12 no-pad\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"product.value\" placeholder=\"Price\" type=\"text\" required />\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "  <fieldset class=\"col-md-4\">\n" +
    "    <h5>Choose Parent Items</h5>\n" +
    "    <div class=\"col-md-12 no-pad\">\n" +
    "\n" +
    "      <div ng-repeat=\"node in product.parents\" style=\"margin-bottom: 10px;\">\n" +
    "        <select\n" +
    "          class=\"input-lg\"\n" +
    "          ui-select2=\"{ width: '100%' }\"\n" +
    "          ng-model=\"node._id\"\n" +
    "          ng-change=\"setParent($index)\"\n" +
    "          data-placeholder=\"Select Retail Item\">\n" +
    "          <option value=\"\"></option>\n" +
    "          <option\n" +
    "            ng-repeat=\"product in getProducts(node)\"\n" +
    "            value=\"{{ product._id }}\"\n" +
    "            ng-selected=\"{{ product._id == node._id }}\">{{ product.name }}</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div style=\"margin-bottom: 10px;\" ng-show=\"product.siblings.length > 0\">\n" +
    "\n" +
    "        <select\n" +
    "          class=\"input-lg\"\n" +
    "          ui-select2=\"{ width: '100%' }\"\n" +
    "          ng-model=\"sibling._id\"\n" +
    "          data-placeholder=\"Select Retail Item\">\n" +
    "          <option value=\"\"></option>\n" +
    "          <option\n" +
    "            ng-repeat=\"option in product.siblings\"\n" +
    "            ng-if=\"option._id != product._id\"\n" +
    "            value=\"{{ option._id }}\">{{ option.name }}</option>\n" +
    "        </select>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div style=\"margin-bottom: 10px;\" ng-show=\"!product._id && product.parents.length == 0\">\n" +
    "\n" +
    "        <select\n" +
    "          class=\"input-lg\"\n" +
    "          ui-select2=\"{ width: '100%' }\"\n" +
    "          ng-model=\"sibling._id\"\n" +
    "          data-placeholder=\"Select Retail Item\">\n" +
    "          <option value=\"\"></option>\n" +
    "          <option\n" +
    "            ng-repeat=\"option in product.products\"\n" +
    "            ng-if=\"option._id != product._id\"\n" +
    "            value=\"{{ option._id }}\">{{ option.name }}</option>\n" +
    "        </select>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/settings/forms/template", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/forms/template",
    "<div class=\"modal-header\">\n" +
    "  <h3 class=\"modal-title\">\n" +
    "    <span ng-if=\"!template._id\">Create a new Template</span>\n" +
    "    <span ng-if=\"template._id\">Update {{ template.name }}</span>\n" +
    "  </h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "  \n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"col-md-12 form-group\">\n" +
    "      <input type=\"text\" class=\"form-control\" ng-model=\"template.name\" placeholder=\"Name\">\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"form-group col-md-6\">\n" +
    "      <ui-select ng-model=\"template.model\" style=\"width: 100%\">\n" +
    "        <ui-select-match placeholder=\"Template used with...\">{{$select.selected.name}}</ui-select-match>\n" +
    "        <ui-select-choices repeat=\"model.model as model in models\">\n" +
    "            {{ model.name }}\n" +
    "        </ui-select-choices>\n" +
    "      </ui-select>\n" +
    "    </div>\n" +
    "    \n" +
    "    <div class=\"form-group col-md-6 no-pad-lft\">\n" +
    "      <ui-select ng-model=\"template.type\" style=\"width: 100%\">\n" +
    "        <ui-select-match placeholder=\"Template is a\">{{$select.selected.name}}</ui-select-match>\n" +
    "        <ui-select-choices repeat=\"type.value as type in types[template.model]\">\n" +
    "            {{ type.name }}\n" +
    "        </ui-select-choices>\n" +
    "      </ui-select>\n" +
    "    </div>\n" +
    "    \n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"form-group\">\n" +
    "    <ui-select ng-model=\"template.tags\" multiple tagging tagging-label=\"(custom 'new' label)\" style=\"width: 100%\">\n" +
    "      <ui-select-match placeholder=\"Tags\">{{ $item }}</ui-select-match>\n" +
    "      <ui-select-choices repeat=\"tag in tags\">\n" +
    "          {{ tag }}\n" +
    "      </ui-select-choices>\n" +
    "    </ui-select>\n" +
    "  </div>\n" +
    "\n" +
    "  <label for=\"isFile\" class=\"\">\n" +
    "    <input class=\"hide\" type=\"checkbox\" id=\"isFile\" ng-model=\"template.file\">\n" +
    "    <i class=\"fa\" ng-class=\"{ 'fa-toggle-off': !template.file, 'fa-toggle-on text-success': template.file }\"></i> Upload Body\n" +
    "  </label>\n" +
    "\n" +
    "  <div ng-controller=\"filesCtrl\" class=\"input-group\" ng-if=\"template.file\">\n" +
    "    <input type=\"text\" class=\"form-control\" placeholder=\"HTML or Text File\" ng-model=\"template.body\">\n" +
    "    <span class=\"input-group-btn\">\n" +
    "      <button class=\"btn bg-info lt\" type=\"file\"\n" +
    "        ngf-select ng-model=\"files\"\n" +
    "        ngf-change=\"upload($files, 'template.body')\"\n" +
    "        ngf-multiple=\"false\"\n" +
    "        ngf-accept=\"'text/*'\"><i class=\"fa fa-cloud-upload\"></i></button>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-if=\"!template.file\" style=\"position: relative\">\n" +
    "    <div style=\"padding: 10px; width: 100%; height: 100px;\" \n" +
    "      class=\"panel\" \n" +
    "      hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" \n" +
    "      ng-model=\"template.body\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <label class=\"col-md-12 no-pad\">Data <span class=\"text-muted\">These items will be available in your template as variables.</span></label>\n" +
    "  \n" +
    "  <div class=\"row\" ng-init=\"template.__data = {}\">\n" +
    "    \n" +
    "    <div class=\"form-group col-md-3\">\n" +
    "      <input type=\"text\" id=\"newDataKey\" class=\"form-control\" placeholder=\"Key\" ng-model=\"template.__data.key\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"input-group col-md-9 no-pad-lft\" ng-controller=\"filesCtrl\" >\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Value\" ng-model=\"template.__data.value\">\n" +
    "      <span class=\"input-group-btn\">\n" +
    "        <button class=\"btn bg-info lt\" type=\"file\"\n" +
    "          ngf-select ng-model=\"files\"\n" +
    "          ngf-change=\"upload($files, 'template.__data.value');\"\n" +
    "          ngf-multiple=\"false\"\n" +
    "          accept=\"image/*\"\n" +
    "          ngf-accept=\"'image/*'\"><i class=\"fa fa-cloud-upload\"></i></button>\n" +
    "        <button class=\"btn bg-success lt\" ng-click=\"addData(template.__data)\" tooltip=\"Add data variable\"><i class=\"fa fa-plus\"></i></button>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\">\n" +
    "\n" +
    "    <div class=\"form-group col-md-3\">\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Subject\"  disabled=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-9 no-pad-lft\">\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Value\" ng-model=\"template.subject\" required />\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row\" ng-repeat=\"(key, value) in template._data\">\n" +
    "\n" +
    "    <div class=\"form-group col-md-3\">\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Key\" ng-model=\"value.key\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-9 no-pad-lft\">\n" +
    "      <input type=\"text\" class=\"form-control\" placeholder=\"Value\" ng-model=\"value.value\">\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button class=\"btn btn-primary\" ng-click=\"ok(template)\">OK</button>\n" +
    "  <button class=\"btn btn-warning\" ng-click=\"cancel()\">Cancel</button>\n" +
    "</div>");
}]);

angular.module("views/settings/forms/zones", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/forms/zones",
    "<header class=\"clearfix\">\n" +
    "  <h2 class=\"\">\n" +
    "    <span ng-if=\"zone._id\">\n" +
    "      Editing Zone:\n" +
    "      <small>{{ zone.name }}</small>\n" +
    "    </span>\n" +
    "\n" +
    "    <span ng-if=\"!zone._id\">\n" +
    "      New Zone\n" +
    "    </span>\n" +
    "\n" +
    "    <div class=\"pull-right\">\n" +
    "      <button ng-if=\"!zone._id\" class=\"btn bg-success btn-block\" ng-click=\"saveZone(zone)\">\n" +
    "        Save Zone\n" +
    "      </button>\n" +
    "      <button ng-if=\"zone._id\" class=\"btn bg-success btn-block\" ng-click=\"updateZone(zone)\">\n" +
    "        Save Changes\n" +
    "        <span ng-if=\"saving\" style=\"display: inline-block; top: -8px; position: relative;\" spin=\"{\n" +
    "          lines: 17,\n" +
    "          length: 0,\n" +
    "          width: 4,\n" +
    "          radius: 4,\n" +
    "          corners: 1,\n" +
    "          rotate: 0,\n" +
    "          direction: 1,\n" +
    "          color: '#fff',\n" +
    "          speed: 1.2,\n" +
    "          trail: 36,\n" +
    "          shadow: false,\n" +
    "          hwaccel: false,\n" +
    "          className: 'spinner',\n" +
    "          zIndex: 2e9,\n" +
    "          top: '-5px',\n" +
    "          left: 'auto'\n" +
    "        }\"></span>\n" +
    "\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "  </h2>\n" +
    "</header>\n" +
    "\n" +
    "<hr class=\"invisible\">\n" +
    "\n" +
    "<form action=\"\" name=\"PackageForm\">\n" +
    "    \n" +
    "  <fieldset class=\"col-md-4 no-pad-lft\">\n" +
    "\n" +
    "    <div class=\"form-group col-md-12 no-pad\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"zone.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "    </div>\n" +
    "      \n" +
    "    <div class=\"form-group col-md-6 no-pad-lft\" tooltip=\"Pickup Price\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"zone.price\" placeholder=\"Zone Price\" type=\"number\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6 no-pad\" tooltip=\"Time Offset\">\n" +
    "      <input class=\"form-control input-lg\" ng-model=\"zone.time\" placeholder=\"Time Offset\" type=\"number\" />\n" +
    "    </div>\n" +
    "\n" +
    "  </fieldset>\n" +
    "\n" +
    "</form>");
}]);

angular.module("views/settings/me", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/me",
    "<div class=\"row\">\n" +
    "\n" +
    "  <form name=\"userForm\" class=\"col-md-4\">\n" +
    "\n" +
    "    \n" +
    "    <div class=\"row\" style=\"margin-bottom: 10px;\">\n" +
    "      <h3 class=\"pull-left\">Update Your Info</h3>\n" +
    "      <button type=\"submit\" class=\"btn bg-success pull-right\" ng-click=\"user.update()\" style=\"margin: 10px;\">\n" +
    "        Update\n" +
    "        <span ng-if=\"user.saving\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\" spin=\"{\n" +
    "          lines: 17,\n" +
    "          length: 0,\n" +
    "          width: 4,\n" +
    "          radius: 4,\n" +
    "          corners: 1,\n" +
    "          rotate: 0,\n" +
    "          direction: 1,\n" +
    "          color: '#fff',\n" +
    "          speed: 1.2,\n" +
    "          trail: 36,\n" +
    "          shadow: false,\n" +
    "          hwaccel: false,\n" +
    "          className: 'spinner',\n" +
    "          zIndex: 2e9,\n" +
    "          top: '-5px',\n" +
    "          left: 'auto'\n" +
    "        }\"></span>\n" +
    "\n" +
    "      </button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <!-- Contact Column -->\n" +
    "      <div class=\"col-md-12 no-pad\">\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"user.name\" placeholder=\"Name\" type=\"text\" required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"user.address.street\" placeholder=\"Street Address\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "\n" +
    "          <div class=\"form-group col-md-8 no-pad-rt\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.address.city\" placeholder=\"City\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.address.postal\" placeholder=\"Zipcode\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"form-group col-md-8 no-pad-rt\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.email\" placeholder=\"Email Address\" type=\"email\" required />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.pin\" placeholder=\"Mobile Pin\" type=\"text\" ng-pattern=\"/^[0-9]{4}|''$/\"\n" +
    "            />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group\">\n" +
    "          <input class=\"form-control input-lg\" ng-model=\"user.phone\" placeholder=\"Phone Number\" type=\"text\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\" style=\"margin-bottom: 15px;\">\n" +
    "\n" +
    "          <div class=\"form-group col-md-8 no-pad-rt\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.role\" placeholder=\"Role\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4\">\n" +
    "            <input class=\"form-control input-lg\" ng-model=\"user.birthday\" placeholder=\"Birthday\" type=\"text\" />\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </form>\n" +
    "\n" +
    "  <div class=\"col-md-4\" ng-init=\"getTrace()\" ng-if=\"user.admin\">\n" +
    "    <h3>User Trace</h3>\n" +
    "    <ul class=\"list-group\">\n" +
    "      <li class=\"list-group-item col-md-12\" ng-repeat=\"trace in userLocations | orderBy:'time' track by trace.user._id\" ng-if=\"trace.user._id !== user._id\">\n" +
    "        <span class=\"col-md-1 label label-default\" style=\"margin-top: 3px\">{{ trace.company.nickname }}</span>\n" +
    "        <span class=\"col-md-11\">\n" +
    "          <span style=\"margin-right: 10px\">{{ (trace.time | momentjs:true).fromNow() }}</span>\n" +
    "          <strong>{{ trace.user.name }}</strong>\n" +
    "          <span>\n" +
    "            <a style=\"margin-top: -2px;\" class=\"btn btn-xs btn-link\" ng-href=\"{{ trace.from }}\">{{ trace.from | replace:httpReg:'' }}</a>\n" +
    "            <em>/</em>\n" +
    "            <a style=\"margin-top: -2px;\" class=\"btn btn-xs btn-link\" ng-href=\"{{ trace.to }}\">{{ trace.to | replace:httpReg:'' }}</a>\n" +
    "          </span>\n" +
    "        </span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("views/settings/tabs/cancellations", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/cancellations",
    "<div class=\"btn-group new\">\n" +
    "  \n" +
    "  <button type=\"submit\" class=\"btn bg-warning\" ng-if=\"selected._id\" ng-click=\"updateCancellation(selected)\">\n" +
    "    Update {{ selected.name }}\n" +
    "    <span ng-if=\"selected.saving\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#fff',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "  </button>\n" +
    "\n" +
    "  <button type=\"button\" class=\"btn bg-success\" ng-click=\"newCancellation()\"><i class=\"fa fa-plus\"></i> New Cancellation</button>\n" +
    "  <button type=\"button\" class=\"btn bg-info\" ng-if=\"!selected._id\" ng-click=\"saveCancellation(selected)\" ng-disabled=\"!selected.name\">\n" +
    "    Save Cancellation\n" +
    "    <span ng-if=\"selected.saving\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#fff',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "\n" +
    "  </button>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"col-md-8\">\n" +
    "  \n" +
    "  <div class=\"row\">\n" +
    "    <div ng-if=\"!selected\" class=\"col-md-12\">\n" +
    "      <span class=\"block alert alert-info\">Please select an existing cancellation (to the right) or choose \"+ New Cancellation\" above</span>\n" +
    "    </div>\n" +
    "    <div ng-if=\"selected\" class=\"col-md-12\">\n" +
    "      <div class=\"form-group col-md-6 no-pad\">\n" +
    "        <input type=\"text\" class=\"form-control input-lg\" ng-model=\"selected.name\" />\n" +
    "      </div>\n" +
    "      <label for=\"selected_{{_id}}\" class=\"checkbox pull-right\" style=\"margin-top: 15px;\">\n" +
    "        <input type=\"checkbox\" id=\"selected_{{_id}}\" ng-checked=\"!selected.template\" ng-model=\"selected.dontSend\" /> Don't Send a Cancellation Email\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-repeat=\"cancellation in company.cancellations\" \n" +
    "    style=\"padding: 10px;\" \n" +
    "    class=\"panel\" \n" +
    "    hallo=\"{ toolbar: 'halloToolbarFixed', plugins: { 'halloformat': { 'bold' : true }, 'halloheadings': {}, 'halloreundo': {}, 'hallolists': {}, 'halloindicator': {} } }\" \n" +
    "    ng-model=\"cancellation.template\" \n" +
    "    ng-show=\"selected && selected._id == cancellation._id\"></div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "<ul class=\"col-md-4 list-unstyled list-group no-pad-rt\">\n" +
    "\n" +
    "  <li ng-repeat=\"cancellation in company.cancellations\" class=\"list-group-item point\" ng-if=\"!cancellation.removed\" style=\"padding: 0;\">\n" +
    "    \n" +
    "    <a ng-click=\"editTemplate(cancellation)\" style=\"display: block;margin-right: 40px;padding: 10px;\">{{ cancellation.name || \"Pending Creation\" }}</a>\n" +
    "\n" +
    "    <a ng-if=\"!cancellation.saving\" ng-click=\"removeCancellation(cancellation)\" class=\"btn btn-link\" style=\"float: right;margin-top: -36px;\">\n" +
    "      <i class=\"fa fa-times\"></i>\n" +
    "    </a>\n" +
    "\n" +
    "    <span ng-if=\"cancellation.saving\" style=\"float: right;margin-top: -23px;margin-right: 15px;\" spin=\"{\n" +
    "      lines: 17,\n" +
    "      length: 0,\n" +
    "      width: 4,\n" +
    "      radius: 4,\n" +
    "      corners: 1,\n" +
    "      rotate: 0,\n" +
    "      direction: 1,\n" +
    "      color: '#ddd',\n" +
    "      speed: 1.2,\n" +
    "      trail: 36,\n" +
    "      shadow: false,\n" +
    "      hwaccel: false,\n" +
    "      className: 'spinner',\n" +
    "      zIndex: 2e9,\n" +
    "      top: '-5px',\n" +
    "      left: 'auto'\n" +
    "    }\"></span>\n" +
    "\n" +
    "\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("views/settings/tabs/company", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/company",
    "<form name=\"CompanySettings\" class=\"row\" ng-submit=\"updateCompany(company)\" ng-init=\"devices = company.devices;\">\n" +
    "\n" +
    "  <button type=\"submit\" class=\"btn bg-success new animated infinite\">\n" +
    "    Update Company\n" +
    "    <span ng-if=\"company.saving\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\"\n" +
    "      ng-class=\"{ 'pulse' : CompanySettings.$dirty }\" spin=\"spinnerConf\"></span>\n" +
    "\n" +
    "  </button>\n" +
    "\n" +
    "  <div class=\"col-md-5 no-pad-lft\">\n" +
    "\n" +
    "    <div class=\"col-md-12\" ng-controller=\"DepartureTimes\" ng-include src=\"'comp/company/departure/template'\"></div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6 no-pad-rt\">\n" +
    "      <input name=\"name\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Name\" ng-model=\"company.name\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-2\">\n" +
    "      <input name=\"tax\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Tax Rate\" ng-model=\"company.tax_rate\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"no-pad-lft form-group col-md-4\" tooltip=\"Default Daily Capacity\">\n" +
    "      <input name=\"capacity\" type=\"number\" class=\"form-control input-lg\" placeholder=\"Default Capacity\"\n" +
    "        ng-model=\"company.capacity\" ng-required=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-12 form-group\" style=\"overflow: auto\">\n" +
    "      <input name=\"name\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Web Address\" ng-model=\"company.web\"\n" +
    "        tooltip=\"Public/Marketing Website\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6\">\n" +
    "      <input name=\"nickname\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Nickname\"\n" +
    "        ng-model=\"company.nickname\">\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-6 no-pad-lft\">\n" +
    "      <input name=\"phone\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Phone Number\" ng-model=\"company.phone\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-12\" style=\"overflow: auto;\">\n" +
    "      <input name=\"email\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Email\" ng-model=\"company.email\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-12\">\n" +
    "      <input name=\"street\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Street Address\"\n" +
    "        ng-model=\"company.address.street\" ng-required=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"form-group col-md-6\">\n" +
    "      <input name=\"city\" type=\"text\" class=\"form-control input-lg\" placeholder=\"City\" ng-model=\"company.address.city\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-2 no-pad\">\n" +
    "      <input name=\"state\" type=\"text\" class=\"form-control input-lg\" placeholder=\"State\" ng-model=\"company.address.state\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "    <div class=\"form-group col-md-4\">\n" +
    "      <input name=\"postal\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Zip\" ng-model=\"company.address.postal\"\n" +
    "        ng-required=\"true\">\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class=\"col-md-12\" style=\"overflow: auto;\">\n" +
    "      <div class=\"well\" style=\"overflow: auto;\">\n" +
    "        <ul class=\"list-unstyled\">\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.resources.enabled\" />\n" +
    "                <span ng-show=\"!edit.resources\">{{ company.admin.resources.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "              <div class=\"no-pad-lft form-group col-md-10\" ng-show=\"edit.resources\"\n" +
    "                style=\"margin-bottom: 0; margin-top: -5px;\">\n" +
    "                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"company.admin.resources.name\">\n" +
    "              </div>\n" +
    "\n" +
    "              <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"edit.resources = !edit.resources;\">\n" +
    "                <span ng-if=\"!edit.resources\">Edit</span>\n" +
    "                <span ng-if=\"edit.resources\">Set</span>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.packages.enabled\" />\n" +
    "                <span ng-show=\"!edit.packages\">{{ company.admin.packages.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "              <div class=\"no-pad-lft form-group col-md-10\" ng-show=\"edit.packages\"\n" +
    "                style=\"margin-bottom: 0; margin-top: -5px;\">\n" +
    "                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"company.admin.packages.name\">\n" +
    "              </div>\n" +
    "\n" +
    "              <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"edit.packages = !edit.packages;\">\n" +
    "                <span ng-if=\"!edit.packages\">Edit</span>\n" +
    "                <span ng-if=\"edit.packages\">Set</span>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.products.enabled\" />\n" +
    "                <span ng-show=\"!edit.products\">{{ company.admin.products.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "              <div class=\"no-pad-lft form-group col-md-10\" ng-show=\"edit.products\"\n" +
    "                style=\"margin-bottom: 0; margin-top: -5px;\">\n" +
    "                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"company.admin.products.name\">\n" +
    "              </div>\n" +
    "\n" +
    "              <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"edit.products = !edit.products;\">\n" +
    "                <span ng-if=\"!edit.products\">Edit</span>\n" +
    "                <span ng-if=\"edit.products\">Set</span>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.zones.enabled\" />\n" +
    "                <span ng-show=\"!edit.zones\">{{ company.admin.zones.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "              <div class=\"no-pad-lft form-group col-md-10\" ng-show=\"edit.zones\"\n" +
    "                style=\"margin-bottom: 0; margin-top: -5px;\">\n" +
    "                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"company.admin.zones.name\">\n" +
    "              </div>\n" +
    "\n" +
    "              <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"edit.zones = !edit.zones;\">\n" +
    "                <span ng-if=\"!edit.zones\">Edit</span>\n" +
    "                <span ng-if=\"edit.zones\">Set</span>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.cancellations.enabled\" />\n" +
    "                <span ng-show=\"!edit.cancellations\">{{ company.admin.cancellations.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "              <div class=\"no-pad-lft form-group col-md-10\" ng-show=\"edit.cancellations\"\n" +
    "                style=\"margin-bottom: 0; margin-top: -5px;\">\n" +
    "                <input type=\"text\" class=\"form-control input-sm\" ng-model=\"company.admin.cancellations.name\">\n" +
    "              </div>\n" +
    "\n" +
    "              <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"edit.cancellations = !edit.cancellations;\">\n" +
    "                <span ng-if=\"!edit.cancellations\">Edit</span>\n" +
    "                <span ng-if=\"edit.cancellations\">Set</span>\n" +
    "              </button>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "          <li class=\"col-md-12 no-pad\">\n" +
    "            <div class=\"checkbox\">\n" +
    "\n" +
    "              <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"company.admin.mobile.enabled\" />\n" +
    "                <span ng-show=\"!edit.mobile\">{{ company.admin.mobile.name }}</span>\n" +
    "              </label>\n" +
    "\n" +
    "            </div>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"col-md-6\">\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "\n" +
    "      <div class=\"col-md-8\">\n" +
    "        <white-list company=\"company\"></white-list>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-4\">\n" +
    "        <h5>Color Scheme</h5>\n" +
    "        <button type=\"button\" class=\"btn bg-light col-md-12\"\n" +
    "          ng-click=\"user.activeCompany().scheme = 'default'; company.scheme = 'default'\">Default</button>\n" +
    "        <button type=\"button\" class=\"btn bg-danger col-md-12\"\n" +
    "          ng-click=\"user.activeCompany().scheme = 'red'; company.scheme = 'red'\">Red</button>\n" +
    "        <button type=\"button\" class=\"btn bg-warning col-md-12\"\n" +
    "          ng-click=\"user.activeCompany().scheme = 'orange'; company.scheme = 'orange'\">Orange</button>\n" +
    "        <button type=\"button\" class=\"btn bg-info col-md-12\"\n" +
    "          ng-click=\"user.activeCompany().scheme = 'blue'; company.scheme = 'blue'\">Blue</button>\n" +
    "        <button type=\"button\" class=\"btn bg-success col-md-12\"\n" +
    "          ng-click=\"user.activeCompany().scheme = 'green'; company.scheme = 'green'\">Green</button>\n" +
    "        <input type=\"text\" ng-model=\"company.scheme\" class=\"hide\" />\n" +
    "\n" +
    "      </div>\n" +
    "      <hr>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "      <section class=\"col-md-4\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-md-12\">\n" +
    "            <div class=\"form-group\">\n" +
    "              <input type=\"text\" class=\"form-control\" placeholder=\"Company Homepage\" ng-model=\"company.homepage\">\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"col-md-12\">\n" +
    "            <referrals company=\"company\"></referrals>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </section>\n" +
    "\n" +
    "      <div class=\"col-md-8\">\n" +
    "\n" +
    "        <section>\n" +
    "\n" +
    "          <h5>Outgoing Email Headers/Images</h5>\n" +
    "\n" +
    "          <div class=\"\" style=\"margin-bottom: 10px;\" ng-repeat=\"(key, header) in company.headers\"\n" +
    "            tooltip=\"{{ key }} header image\">\n" +
    "\n" +
    "            <div ng-controller=\"filesCtrl\" class=\"input-group\">\n" +
    "\n" +
    "              <input type=\"text\" class=\"form-control\" ng-model=\"header.path\">\n" +
    "              <span class=\"input-group-btn\">\n" +
    "                <button class=\"btn bg-info lt\" type=\"file\" ngf-select ng-model=\"files\"\n" +
    "                  ngf-change=\"upload($files, company.headers[key])\" ngf-multiple=\"false\" accept=\"image/*\"\n" +
    "                  ngf-accept=\"'image/*'\"><i class=\"fa fa-cloud-upload\"></i></button>\n" +
    "              </span>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <div ng-controller=\"filesCtrl\" class=\"input-group\" tooltip=\"Company Logo\">\n" +
    "\n" +
    "            <input type=\"text\" class=\"form-control\" ng-model=\"company.logo.path\">\n" +
    "\n" +
    "            <span class=\"input-group-btn\">\n" +
    "              <button class=\"btn bg-info lt\" type=\"file\" ngf-select ng-model=\"files\"\n" +
    "                ngf-change=\"upload($files, company.logo)\" ngf-multiple=\"false\" accept=\"image/*\"\n" +
    "                ngf-accept=\"'image/*'\"><i class=\"fa fa-cloud-upload\"></i></button>\n" +
    "            </span>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "        </section>\n" +
    "\n" +
    "        <section>\n" +
    "          <div class=\"row\" style=\"margin-top: 10px;\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "              <h5>Default Prepaid Prices</h5>\n" +
    "              <div class=\"form-group col-md-4\" ng-repeat=\"price in company.prepaids.prices\"\n" +
    "                ng-class=\"{ 'no-pad' : !$first && !$last, 'no-pad-lft' : $first, 'no-pad-rt' : $last }\">\n" +
    "                <input name=\"price{{price.value}}\" type=\"number\" class=\"form-control\" placeholder=\"0.00\"\n" +
    "                  ng-model=\"price.value\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "              <h5>Smart Waiver ID</h5>\n" +
    "              <div class=\"form-group col-md-12\"\n" +
    "                ng-class=\"{ 'no-pad' : !$first && !$last, 'no-pad-lft' : $first, 'no-pad-rt' : $last }\">\n" +
    "                <input class=\"form-control\" type=\"text\" name=\"waiverId\" ng-model=\"company.meta.waiverId\"\n" +
    "                  placeholder=\"Waiver ID\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "              <h5>Public Gift Form URL</h5>\n" +
    "              <div class=\"form-group col-md-12\"\n" +
    "                ng-class=\"{ 'no-pad' : !$first && !$last, 'no-pad-lft' : $first, 'no-pad-rt' : $last }\">\n" +
    "                <input class=\"form-control\" ng-attr-value=\"https://beta.rezflow.com/p/gift?id={{ company._id }}\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "              <h5>Prepaid Confirmation Send Copy <small>If empty then no confirmation will be sent to your company\n" +
    "                  address</small></h5>\n" +
    "              <div class=\"form-group col-md-12\"\n" +
    "                ng-class=\"{ 'no-pad' : !$first && !$last, 'no-pad-lft' : $first, 'no-pad-rt' : $last }\">\n" +
    "                <input name=\"prepaidBCC\" type=\"email\" class=\"form-control\" placeholder=\"bcc@email.com\"\n" +
    "                  ng-model=\"company.prepaids.bcc\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </section>\n" +
    "\n" +
    "        <section>\n" +
    "\n" +
    "          <h5>RezFlow App Details</h5>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <input type=\"text\" class=\"form-control\" ng-model=\"company.mobile.checkout_image\"\n" +
    "              placeholder=\"Thank You Image\" tooltip=\"Thank You/Checkout Image\" />\n" +
    "          </div>\n" +
    "\n" +
    "          <table class=\"table\" ng-controller=\"usersCtrl\">\n" +
    "            <thead>\n" +
    "              <tr>\n" +
    "                <th>Device</th>\n" +
    "                <th>Username/Email</th>\n" +
    "                <th style=\"width: 81px;\"></th>\n" +
    "              </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "              <tr ng-repeat=\"user in devices\" ng-hide=\"user.removed\">\n" +
    "                <td ui-sref=\"employeeEdit({ id: user._id })\">{{ user.name }}</td>\n" +
    "                <td ui-sref=\"employeeEdit({ id: user._id })\">{{ user.email }}</td>\n" +
    "                <td>\n" +
    "\n" +
    "                  <div class=\"btn-group pull-right\">\n" +
    "\n" +
    "                    <button class=\"btn btn-link btn-sm\" type=\"button\" ng-if=\"user.active\" ng-click=\"toggleActive(user)\">\n" +
    "                      <i class=\"fa fa-check text-success\"></i>\n" +
    "                    </button>\n" +
    "\n" +
    "                    <button class=\"btn btn-link btn-sm\" type=\"button\" ng-if=\"!user.active\"\n" +
    "                      ng-click=\"toggleActive(user)\">\n" +
    "                      <i class=\"fa fa-times text-danger\"></i>\n" +
    "                    </button>\n" +
    "\n" +
    "                    <button class=\"btn btn-link btn-sm\" type=\"button\" ng-click=\"remove(user, true)\">\n" +
    "                      <i class=\"fa fa-trash text-danger\"></i>\n" +
    "                    </button>\n" +
    "\n" +
    "                  </div>\n" +
    "\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "            </tbody>\n" +
    "            <tfoot>\n" +
    "              <tr>\n" +
    "                <td colspan=\"3\"><button class=\"btn btn-success btn-sm pull-right\" type=\"button\"\n" +
    "                    ng-click=\"newAppUser()\"><i class=\"fa fa-plus\"></i></button></td>\n" +
    "              </tr>\n" +
    "            </tfoot>\n" +
    "          </table>\n" +
    "        </section>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <section class=\"form-horizontal\">\n" +
    "      <h5>Google Tracking Code</h5>\n" +
    "      <div class=\"form-group\">\n" +
    "        <input type=\"text\" ng-model=\"company.meta.public_header\" class=\"form-control\" placeholder=\"google tracking\">\n" +
    "      </div>\n" +
    "    </section>\n" +
    "\n" +
    "\n" +
    "    <section class=\"form-horizontal\">\n" +
    "      <h5>SMS Description</h5>\n" +
    "      <div class=\"form-group\">\n" +
    "        <textarea ng-model=\"company.description\" class=\"form-control\" rows=\"15\" placeholder=\"SMS description variable\">\n" +
    "        </textarea>\n" +
    "      </div>\n" +
    "    </section>\n" +
    "\n" +
    "    <section class=\"form-horizontal\">\n" +
    "\n" +
    "      <h5 style=\"margin-bottom: 30px;\">Cardflight Keys and Tokens</h5>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <label class=\"control-label col-sm-4\" for=\"CardflightTestKey\">Test Key</label>\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <input type=\"text\" class=\"form-control\" id=\"CardflightTestKey\" ng-model=\"company.cardflight.test.key\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <label class=\"control-label col-sm-4\" for=\"CardflightTestToken\">Test Account</label>\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <input type=\"text\" class=\"form-control\" id=\"CardflightTestToken\" ng-model=\"company.cardflight.test.token\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <label class=\"control-label col-sm-4\" for=\"CardflightProdKey\">Production Key</label>\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <input type=\"text\" class=\"form-control\" id=\"CardflightProdKey\" ng-model=\"company.cardflight.production.key\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"form-group\">\n" +
    "        <label class=\"control-label col-sm-4\" for=\"CardflightProdToken\">Production Account</label>\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <input type=\"text\" class=\"form-control\" id=\"CardflightProdToken\"\n" +
    "            ng-model=\"company.cardflight.production.token\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </section>\n" +
    "\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/settings/tabs/emailTemplates", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/emailTemplates",
    "<div ng-controller=\"templateCtrl\">\n" +
    "  <button type=\"button\" class=\"btn btn-info\" ng-click=\"edit()\">\n" +
    "    <i class=\"fa fa-plus\"></i> New Template</button>\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "      <table class=\"table\">\n" +
    "        <thead>\n" +
    "          <tr>\n" +
    "            <th></th>\n" +
    "            <th>Name</th>\n" +
    "            <th>Type</th>\n" +
    "            <th>Tags</th>\n" +
    "            <th></th>\n" +
    "          </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "          <tr ng-repeat=\"(key, template) in templates\" ng-if=\"!template.removed\">\n" +
    "            <td>\n" +
    "              <div ng-if=\"template.type == 'confirmation' && template.model == 'Reservation'\">\n" +
    "                <input type=\"checkbox\" ng-model=\"template.default\" ng-change=\"resetReservationConf(template)\" />\n" +
    "              </div>\n" +
    "            </td>\n" +
    "            <td ng-click=\"edit(template)\">{{ template.name }}</td>\n" +
    "            <td ng-click=\"edit(template)\">{{ template.type }}</td>\n" +
    "            <td ng-click=\"edit(template)\">\n" +
    "              <span ng-repeat=\"(key, tag) in template.tags\">{{ tag }}\n" +
    "                <span ng-if=\"!$last\">,</span>\n" +
    "              </span>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <button type=\"button\" class=\"btn bg-danger btn-xs\" ng-click=\"remove(template)\">\n" +
    "                <i class=\"fa fa-times\"></i>\n" +
    "              </button>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </tbody>\n" +
    "      </table>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("views/settings/tabs/merchant", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/merchant",
    "<form name=\"MerchantSettings\" class=\"row\" ng-submit=\"updateCompany(company, true)\">\n" +
    "\n" +
    "  <button type=\"submit\" class=\"btn bg-success new animated infinite\" ng-class=\"{ 'pulse' : MerchantSettings.$dirty }\" ng-disabled=\"company.saving\">\n" +
    "    Update Company\n" +
    "    <span ng-if=\"company.saving\" style=\"display: inline-block; top: -8px; margin-left: 10px; position: relative;\" spin=\"spinnerConf\"></span>\n" +
    "  </button>\n" +
    "\n" +
    "  <h3 class=\"col-md-12\" style=\"margin-top: 0; margin-bottom: 25px;\">\n" +
    "    <i class=\"fa\" ng-class=\"{\n" +
    "      'fa-check-circle text-success' : company.account.stripe.transfers_enabled,\n" +
    "      'fa-times-circle text-danger' : !company.account.stripe.transfers_enabled\n" +
    "    }\"></i>\n" +
    "    Merchant Account <span ng-if=\"!company.account.stripe.transfers_enabled\">is Not </span>Ready to Accept Charges\n" +
    "  </h3>\n" +
    "\n" +
    "  <pre class=\"hide\" ng-if=\"company.verification.fields_needed.length > 0\">{{ company.verification.fields_needed | json }}</pre>\n" +
    "\n" +
    "  <div class=\"col-md-12\" ng-if=\"company.account.id\">\n" +
    "\n" +
    "    <div class=\"col-md-4 no-pad-rt\">\n" +
    "\n" +
    "      <div ng-init=\"company.account.stripe.legal_entity.type = 'company'\">\n" +
    "\n" +
    "        <div ng-if=\"company.verification.fields_needed.length > 0\">\n" +
    "          <h4 class=\"text-danger\">Verification Needed</h4>\n" +
    "          <h6>Please provide the following information to begin taking payment.</h6>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"!company.verification.fields_needed.length > 0\">\n" +
    "          <h4 class=\"\">Update Merchant Information</h4>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-8 form-group no-pad\">\n" +
    "          <input name=\"business_name\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Business Name\"\n" +
    "            ng-model=\"company.account.stripe.business_name\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-4 form-group no-pad-rt\">\n" +
    "          <input name=\"support_phone\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Support Number\"\n" +
    "            ng-model=\"company.account.stripe.support_phone\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-12 form-group no-pad\" style=\"overflow:auto\">\n" +
    "          <input name=\"tax_id\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Tax ID\"\n" +
    "            ng-model=\"company.account.stripe.legal_entity.business_tax_id\" ng-required=\"exists(company.verification.legal_entity.business_tax_id)\">\n" +
    "        </div>\n" +
    "\n" +
    "        <h5>Charge Statement Descriptor</h5>\n" +
    "\n" +
    "        <div class=\"col-md-12 form-group no-pad\" style=\"overflow:auto\">\n" +
    "          <input name=\"statement_descriptor\" type=\"text\" class=\"form-control input-lg\" tooltip=\"To be displayed on your customer's credit card statement\" placeholder=\"Statement Descriptor\"\n" +
    "            max-length=\"22\"\n" +
    "            ng-model=\"company.account.stripe.statement_descriptor\" ng-value=\"company.nickname + ' Booking Charge.'\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\" style=\"overflow: auto;border: 1px solid transparent;\">\n" +
    "\n" +
    "          <div class=\"col-md-12\" style=\"margin-bottom: 15px;\">\n" +
    "\n" +
    "            <h4>Decline Charges when</h4>\n" +
    "            <label class=\"checkbox-inline\">\n" +
    "              <input type=\"checkbox\" id=\"\" ng-model=\"company.account.stripe.decline_charge_on.avs_failure\"> AVS check fails\n" +
    "            </label>\n" +
    "            <label class=\"checkbox-inline\">\n" +
    "              <input type=\"checkbox\" id=\"\" ng-model=\"company.account.stripe.decline_charge_on.cvc_failure\"> CVV/CVC check fails\n" +
    "            </label>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-4\">\n" +
    "\n" +
    "      <h4>Account Principle</h4>\n" +
    "      <h6 ng-show=\"exists(company.verification.legal_entity)\">Primary Contact information</h6>\n" +
    "\n" +
    "      <div class=\"col-md-6 form-group no-pad\">\n" +
    "        <input name=\"first_name\" type=\"text\" class=\"form-control input-lg\" placeholder=\"First Name\"\n" +
    "          ng-model=\"company.account.stripe.legal_entity.first_name\" ng-required=\"exists(company.verification.legal_entity.first_name)\">\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"col-md-6 form-group no-pad-rt\">\n" +
    "        <input name=\"last_name\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Last Name\"\n" +
    "          ng-model=\"company.account.stripe.legal_entity.last_name\" ng-required=\"exists(company.verification.legal_entity.last_name)\">\n" +
    "      </div>\n" +
    "\n" +
    "      <h5>Principle DOB</h5>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "        <div class=\"col-md-8\">\n" +
    "\n" +
    "          <div class=\"col-md-4 form-group no-pad-lft\">\n" +
    "            <input name=\"dob.month\" type=\"number\" class=\"form-control input-lg\" placeholder=\"MM\" max-length=\"2\" ng-model=\"company.account.stripe.legal_entity.dob.month\" ng-required=\"exists(company.verification.legal_entity.dob)\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-4 form-group no-pad-lft\">\n" +
    "            <input name=\"dob.day\" type=\"number\" class=\"form-control input-lg\" placeholder=\"DD\" max-length=\"2\" ng-model=\"company.account.stripe.legal_entity.dob.day\" ng-required=\"exists(company.verification.legal_entity.dob)\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"col-md-4 form-group no-pad\">\n" +
    "            <input name=\"dob.year\" type=\"number\" class=\"form-control input-lg\" placeholder=\"YYYY\" max-length=\"4\" ng-model=\"company.account.stripe.legal_entity.dob.year\" ng-required=\"exists(company.verification.legal_entity.dob)\">\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-md-4 no-pad-lft\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <input\n" +
    "              ng-if=\"exists(company.verification.legal_entity.ssn_last_4)\"\n" +
    "              name=\"ssn4\" type=\"text\" class=\"form-control input-lg\" tooltip=\"Last 4 of SSN\" placeholder=\"SSN (last 4)\" max-length=\"4\" min-length=\"4\" ng-model=\"company.account.stripe.legal_entity.ssn_last_4\" ng-required=\"exists(company.verification.legal_entity.ssn_last_4)\">\n" +
    "\n" +
    "            <input\n" +
    "              ng-if=\"exists(company.verification.legal_entity.personal_id_number)\"\n" +
    "              name=\"ssn4\" type=\"text\" class=\"form-control input-lg\" tooltip=\"Full SSN\" placeholder=\"Full SSN\" min-length=\"9\" ng-model=\"company.account.stripe.legal_entity.personal_id_number\" ng-required=\"exists(company.verification.legal_entity.personal_id_number)\">\n" +
    "\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <h5>Principle Address</h5>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "\n" +
    "          <div class=\"form-group col-md-12\">\n" +
    "            <input name=\"address1\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Address: Line 1\" ng-model=\"company.account.stripe.legal_entity.address.line1\" ng-required=\"true\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-12\">\n" +
    "            <input name=\"address2\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Address: Line 2\" ng-model=\"company.account.stripe.legal_entity.address.line2\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4\">\n" +
    "            <input name=\"city\" type=\"text\" class=\"form-control input-lg\" placeholder=\"City\" ng-model=\"company.account.stripe.legal_entity.address.city\" ng-required=\"true\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4 no-pad\">\n" +
    "            <input name=\"state\" type=\"text\" class=\"form-control input-lg\" placeholder=\"State\" ng-model=\"company.account.stripe.legal_entity.address.state\" ng-required=\"true\">\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group col-md-4\">\n" +
    "            <input name=\"zip\" type=\"text\" class=\"form-control input-lg\" placeholder=\"Zipcode\" ng-model=\"company.account.stripe.legal_entity.address.postal_code\" ng-required=\"true\">\n" +
    "          </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <div class=\"checkbox col-md-12\" style=\"overflow: auto;\" ng-if=\"exists(company.verification.tos_acceptance)\">\n" +
    "        <label>\n" +
    "          <input type=\"checkbox\" ng-model=\"company.account.stripe.tos_acceptance.checked\" required /> I accept the merchant Terms of Service\n" +
    "        </label>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"col-md-4\">\n" +
    "      <h4>Bank Accounts</h4>\n" +
    "\n" +
    "      <ul class=\"list-group list-unstyled\">\n" +
    "\n" +
    "        <li class=\"list-group-item\" ng-repeat=\"(key, bank) in company.account.bank_accounts | orderBy:default_for_currency\" ng-class=\"{ 'bg-light' : bank.default_for_currency}\">\n" +
    "          <strong>{{ bank.bank_name}}</strong> ending in <strong>{{ bank.last4 }}</strong>\n" +
    "          <span class=\"pull-right upper\">\n" +
    "            {{ bank.currency }}\n" +
    "            <i class=\"fa fa-check-circle text-success\" ng-if=\"bank.default_for_currency\" tooltip=\"Default for {{ bank.currency }} transfers.\"></i>\n" +
    "          </span>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- Add new Button -->\n" +
    "        <li style=\"margin-top: 10px;\">\n" +
    "          <button type=\"button\" class=\"btn btn-block bg-light lt\" ng-click=\"addbank = !addbank\">\n" +
    "            <i class=\"fa fa-plus\"></i> Add Another\n" +
    "          </button>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- Add New Form -->\n" +
    "        <li class=\"\" style=\"margin-top: 5px; overflow: hidden;\">\n" +
    "\n" +
    "          <div ng-form=\"bankAccount\" id=\"bankAccount\" ng-show=\"addbank\" class=\"animated slideInOut enterDown\" event-capture tabindex=\"0\" ui-event=\"{ 'blur' : 'hideBank($event)' }\">\n" +
    "\n" +
    "            <div class=\"form-group no-pad-lft\">\n" +
    "              <input name=\"first_routing\" type=\"text\" placeholder=\"Routing Number\" class=\"form-control input-lg\" ng-model=\"bank_account.routing_number\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group no-pad\">\n" +
    "              <input name=\"new_account\" type=\"text\" placeholder=\"Account Number\" class=\"form-control input-lg\" ng-model=\"bank_account.account_number\">\n" +
    "            </div>\n" +
    "\n" +
    "            <button type=\"button\" class=\"bg-success btn btn-block\" ng-click=\"addBank(bank_account)\" ng-disabled=\"bankAccount.$invalid\"><i class=\"fa fa-check\"></i> Add Account</button>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "        </li>\n" +
    "\n" +
    "      </ul>\n" +
    "\n" +
    "      <div ng-show=\"exists(company.verification.bank_account)\">\n" +
    "\n" +
    "        <h6>Please provide a Bank Account</h6>\n" +
    "\n" +
    "        <div class=\"form-group no-pad-lft\">\n" +
    "          <input name=\"first_routing\" type=\"text\" placeholder=\"Routing Number\" class=\"form-control input-lg\" ng-model=\"company.account.stripe.bank_account.routing_number\" ng-required=\"exists(company.verification.bank_account)\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"form-group no-pad\">\n" +
    "          <input name=\"first_account\" type=\"text\" placeholder=\"Account Number\" class=\"form-control input-lg\" ng-model=\"company.account.stripe.bank_account.account_number\" ng-required=\"exists(company.verification.bank_account)\">\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"col-md-12\" ng-if=\"!company.account.id\">\n" +
    "    <h5 class=\"text-muted\">Your RezFlow account is missing a linked merchant account.</h5>\n" +
    "    <button type=\"button\" class=\"btn btn-lg btn-block bg-info\" ng-click=\"linkMerchant()\" ng-disabled=\"linking\">\n" +
    "      <span ng-if=\"linking\" style=\"display: inline-block; top: -8px; position: relative; margin-right: 10px;\" spin=\"spinnerConf\"></span>\n" +
    "        Click to Create a Merchant Account</button>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</form>\n" +
    "");
}]);

angular.module("views/settings/tabs/packages", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/packages",
    "<button type=\"button\" class=\"new btn bg-success\" ui-sref=\"editPackage({ id: 'new' })\"><i class=\"fa fa-plus\"></i> Add Package</button>\n" +
    "<table class=\"packages table table-hover table-condensed\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>Name</th>\n" +
    "      <th style=\"width: 45px;\" ng-init=\"showInactive = false\">\n" +
    "        <div class=\"checkbox\" style=\"margin-bottom: 15px; margin-top: 0;\">\n" +
    "          <label>\n" +
    "            <input type=\"checkbox\" ng-model=\"showInactive\" /> Inactive\n" +
    "          </label>\n" +
    "        </div>\n" +
    "      </th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"package in packages\" ng-show=\"!package.removed && ((showInactive && !package.active) || package.active) \">\n" +
    "      <td ui-sref=\"editPackage({ id: package._id })\">\n" +
    "        {{ package.name }} <span ng-if=\"!package.active\" class=\"label bg-light\">inactive</span>\n" +
    "        <div class=\"pull-right\">\n" +
    "          <span ng-if=\"package.adults\" class=\"label bg-info\">Adults Only</span>\n" +
    "          <span ng-if=\"package.free_pickup\" class=\"label bg-success\">Free Pickup</span>\n" +
    "          <span ng-if=\"package.require_weights\" class=\"label bg-warning\">Weight Required</span>\n" +
    "          <span ng-if=\"!package.public\" class=\"label bg-light\">Not Public</span>\n" +
    "        </div>\n" +
    "      </td>\n" +
    "      <td class=\"text-right\">\n" +
    "        <button type=\"button\" class=\"delete btn btn-link lt\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Remove this Package\" ng-click=\"removePackage(package)\">\n" +
    "          <i class=\"fa fa-times\"></i>\n" +
    "        </button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("views/settings/tabs/products", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/products",
    "<button type=\"button\" class=\"new btn bg-success\" ui-sref=\"editProduct({ id: 'new' })\"><i class=\"fa fa-plus\"></i> Add Product</button>\n" +
    "\n" +
    "<!-- Nested node template -->\n" +
    "<script type=\"text/ng-template\" id=\"nodes_renderer.html\">\n" +
    "  <div class=\"list-group-item bg-light lter col-md-12\" style=\"overflow: auto; padding: 0;\">\n" +
    "    <span ui-sref=\"editProduct({ id: node._id })\" style=\"padding: 10px !important;display: block;margin-right: 80px;\">{{ node.name }}</span>\n" +
    "    <div class=\"actions pull-right\" style=\"padding: 5px !important; margin-top: -40px;\">\n" +
    "\n" +
    "      <button type=\"button\" class=\"instructions btn btn-link btn-sm\" tooltip=\"Clone this Product (not ready)\" \n" +
    "        ng-click=\"\"\n" +
    "        tooltip-append-to-body=\"true\">\n" +
    "        <i class=\"fa fa-copy\"></i>\n" +
    "      </button>\n" +
    "\n" +
    "      <button type=\"button\" class=\"delete btn btn-link btn-sm\" tooltip=\"Remove this Product\" \n" +
    "        ng-click=\"removeProduct(node)\"\n" +
    "        tooltip-append-to-body=\"true\">\n" +
    "        <i class=\"fa fa-times\"></i>\n" +
    "      </button>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <ol class=\"list-unstyled\" style=\"margin-left: 15px;\">\n" +
    "    <li ng-repeat=\"node in node.children\" ng-include=\"'nodes_renderer.html'\" ng-show=\"!node.removed\"></li>\n" +
    "  </ol>\n" +
    "</script>\n" +
    "\n" +
    "<ol class=\"list-unstyled list-group\">\n" +
    "  <li ng-repeat=\"node in products\" style=\"margin-bottom: 10px;\" ng-include=\"'nodes_renderer.html'\" ng-show=\"!node.removed\"></li>\n" +
    "</ol>");
}]);

angular.module("views/settings/tabs/resources", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/resources",
    "<button type=\"button\" class=\"new btn bg-success\" ui-sref=\"editBalloon({ id: 'new' })\"><i class=\"fa fa-plus\"></i> Add Resource</button>\n" +
    "\n" +
    "<table class=\"balloons table table-hover table-condensed\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>Name</th>\n" +
    "      <th class=\"text-center\">Minimum</th>\n" +
    "      <th class=\"text-center\">Capacity</th>\n" +
    "      <th>Heavy?</th>\n" +
    "      <th>Pilot</th>\n" +
    "      <th style=\"width: 45px;\"></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "\n" +
    "    <tr ng-repeat=\"balloon in balloons\" ng-show=\"!balloon.removed\">\n" +
    "      <td ui-sref=\"editBalloon({ id: balloon._id })\">{{ balloon.name }}</td>\n" +
    "      <td ui-sref=\"editBalloon({ id: balloon._id })\" class=\"text-center\">{{ balloon.minimum }}</td>\n" +
    "      <td class=\"text-center\">{{ balloon.capacity }}</td>\n" +
    "      <td ui-sref=\"editBalloon({ id: balloon._id })\">\n" +
    "        <span class=\"label bg-success label-block label-sm\" ng-if=\"balloon.heavy\">Yes</span>\n" +
    "        <span class=\"label bg-danger label-block label-sm\" ng-if=\"!balloon.heavy\">No</span>\n" +
    "      </td>\n" +
    "      <td ui-sref=\"editBalloon({ id: balloon._id })\">{{ balloon.pilot.name || '--' }}</td>\n" +
    "      <td class=\"text-right\">\n" +
    "        <button type=\"button\" class=\"delete btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Remove this balloon\" ng-click=\"removeBalloon(balloon);\">\n" +
    "          <i class=\"fa fa-times\"></i>\n" +
    "        </button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "\n" +
    "  </tbody>\n" +
    "</table>");
}]);

angular.module("views/settings/tabs/zones", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("views/settings/tabs/zones",
    "<button type=\"button\" class=\"new btn bg-success\" ui-sref=\"editZone({ id: 'new' })\"><i class=\"fa fa-plus\"></i> Add Zone</button>\n" +
    "<table class=\"zones table table-hover table-condensed\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th>Zone</th>\n" +
    "      <th>Price</th>\n" +
    "      <th style=\"width: 45px;\"></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"zone in zones\" ng-show=\"!zone.removed\">\n" +
    "      <td ui-sref=\"editZone({ id: zone._id })\">{{ zone.name }}</td>\n" +
    "      <td ui-sref=\"editZone({ id: zone._id })\">{{ zone.price | currency }}</td>\n" +
    "      <td class=\"text-right\">\n" +
    "        <button type=\"button\" class=\"delete btn btn-link lt\" style=\"\" ng-class=\"{ 'btn-block' : responsive.screen_size == 'xs' }\" tooltip=\"Remove this Zone\" ng-click=\"removeZone(zone)\">\n" +
    "          <i class=\"fa fa-times\"></i>\n" +
    "        </button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);
